(() => {
    "use strict";

// ─── Silent warn: logs in dev, silent in prod ───
const __DEV = location.hostname === 'localhost' || location.hostname === '127.0.0.1' || location.search.includes('debug');
function _sw(ctx, e){ if(__DEV) console.warn(`[${ctx}]`, e); }
// Production-safe log: silenced in deployed builds (avoids 1-2ms per log on Firefox)
function _log(){ if(__DEV) console.log.apply(console, arguments); }

// --- MODE DE JEU (pour éviter de casser les rooms entre formats) ---
const GAME_MODE = "enfant";
try{document.body.classList.add('mode-enfant');}catch(e){} // "enfant" ou "complexe"
let roomModeMismatch = false;
/* ===================== STABILITÉ (debug + idempotence) ===================== */
const CLIENT_ID = (() => {
  try{
    const k = `bulle_clientId_${GAME_MODE}`;
    let v = localStorage.getItem(k);
    if(!v){
      v = (crypto && crypto.randomUUID) ? crypto.randomUUID() : (`cid_${Date.now()}_${Math.random().toString(16).slice(2)}`);
      localStorage.setItem(k, v);
    }
    return v;
  }catch(_e){
    return `cid_${Date.now()}_${Math.random().toString(16).slice(2)}`;
  }
})();

const __debug = {
  enabled: false,
  pendingWrites: 0,
  lastWriteReason: "",
  lastWriteAt: 0,
  lastError: "",
  lastAction: null,
};

function makeActionId(prefix="act"){
  return `${prefix}_${Date.now()}_${Math.random().toString(16).slice(2,8)}_${String(CLIENT_ID).slice(0,8)}`;
}

function ensureDebugOverlay(){
  try{
    if(document.getElementById("debugOverlay")) return;
    const ov = document.createElement("div");
    ov.id = "debugOverlay";
    ov.className = "debugOverlay";
    ov.style.display = "none";
    ov.innerHTML = `
      <div class="debugOverlay__row"><span class="debugOverlay__k">room</span><span id="dbgRoomCode" class="debugOverlay__v"></span></div>
      <div class="debugOverlay__row"><span class="debugOverlay__k">ver</span><span id="dbgRoomVer" class="debugOverlay__v"></span></div>
      <div class="debugOverlay__row"><span class="debugOverlay__k">slot</span><span id="dbgSlot" class="debugOverlay__v"></span></div>
      <div class="debugOverlay__row"><span class="debugOverlay__k">phase</span><span id="dbgPhase" class="debugOverlay__v"></span></div>
      <div class="debugOverlay__row"><span class="debugOverlay__k">pending</span><span id="dbgPending" class="debugOverlay__v"></span></div>
      <div class="debugOverlay__row"><span class="debugOverlay__k">last</span><span id="dbgLast" class="debugOverlay__v"></span></div>
      <div class="debugOverlay__row"><span class="debugOverlay__k">err</span><span id="dbgErr" class="debugOverlay__v"></span></div>
      <div class="debugOverlay__hint">🐞 Debug: appuie sur Setup puis "Debug" (ou ?debug=1)</div>
    `;
    document.body.appendChild(ov);
  }catch(_e){}
}

function updateDebugOverlay(){
  try{
    const ov = document.getElementById("debugOverlay");
    if(!ov || !__debug.enabled) return;
    const st = roomState || initialRoomState();
      try{ renderJournal(st); }catch(_e){}

      // ✅ SAFETY: if I'm resolving a pending effect, ensure no card modal remains on top.
      // The player must be able to tap targets on the board/zones.
      try{
        if(st && st.pendingEffect && typeof isMyPendingEffect === 'function' && isMyPendingEffect(st)){
          closeCardModal();
        }
      }catch(_e){}
    const slot = (typeof mySlotFromState === "function") ? (mySlotFromState(st) || "") : "";
    const phase = st?.phase || "";
    const last = __debug.lastWriteReason ? `${__debug.lastWriteReason} • ${new Date(__debug.lastWriteAt||0).toLocaleTimeString()}` : "";
    const err = __debug.lastError ? String(__debug.lastError).slice(0,120) : "";
    const lastAct = st?.meta?.lastAction ? `${st.meta.lastAction.type || ""}` : (__debug.lastAction ? `${__debug.lastAction.type || ""}` : "");
    const safe = (id, val)=>{ const el=document.getElementById(id); if(el) el.textContent = val ?? ""; };
    safe("dbgRoomCode", roomCodeActive || "");
    safe("dbgRoomVer", String(roomVersion ?? ""));
    safe("dbgSlot", slot);
    safe("dbgPhase", phase);
    safe("dbgPending", String(__debug.pendingWrites));
    safe("dbgLast", lastAct || last);
    safe("dbgErr", err);
  }catch(_e){}
}

function setDebugEnabled(v){
  __debug.enabled = !!v;
  ensureDebugOverlay();
  try{
    const ov = document.getElementById("debugOverlay");
    if(ov) ov.style.display = __debug.enabled ? "" : "none";
  }catch(_e){}
  try{
    const k = `bulle_debug_${GAME_MODE}`;
    localStorage.setItem(k, __debug.enabled ? "1" : "0");
  }catch(_e){}
  updateDebugOverlay();
}
/* ========================================================================== */
  // =====================================================================
  // ORGANISATION (CTRL+F)
  //   SECTION:CONFIG
  //   SECTION:DOM_UI
  //   SECTION:STATE
  //   SECTION:SUPABASE
  //   SECTION:UI_RENDER
  //   SECTION:ACTIONS
  // =====================================================================

  // Global error trap (avoid "all buttons dead")
  window.addEventListener("error", (ev)=>{
    try{ 
      console.error("❌ Erreur globale:", ev.error || ev.message);
      const errMsg = ev.error?.message || ev.message || "Erreur inconnue";
      console.error("Message:", errMsg);
      // Alert désactivée en production pour éviter les pop-ups intrusives
      // alert("Erreur JS: " + errMsg);
    }catch(e){
      console.error("Erreur dans le gestionnaire d'erreurs:", e);
    }
  });
  
  window.addEventListener("unhandledrejection", (ev)=>{
    try{ 
      console.error("❌ Promise rejetée:", ev.reason);
      const errMsg = ev.reason?.message || String(ev.reason) || "Promise rejetée";
      console.error("Message:", errMsg);
      // Alert désactivée en production pour éviter les pop-ups intrusives
      // alert("Promise rejetée: " + errMsg);
    }catch(e){
      console.error("Erreur dans le gestionnaire de promise:", e);
    }
  });
  // =====================================================================
  // SECTION:CONFIG
  // =====================================================================

  // ===== Config (proto -> ++) =====
  const CONFIG_DEFAULT = {
    supabaseUrl: "https://tsasdqexdvieojuzthms.supabase.co",
    supabaseAnonKey: "sb_publishable_aFCY9wDc03wFy1iBQjqcdg__PACewCD",
    channelPrefix: "room:bulle:",
    longPressMs: 650
  };
  const CONFIG_KEY = "bulle::config";

  // Auto-enregistrer la config par défaut (utile si Setup jamais ouvert)
  try{
    if(!storage.get(CONFIG_KEY)){
      storage.set(CONFIG_KEY, JSON.stringify(CONFIG_DEFAULT));
    }
  }catch(_e){}
  
// ===== AUTO GAME MODE (sécu) =====
// Sur Cloudflare Pages / tests, il arrive que GAME_MODE ne soit pas défini.
// On déduit un mode par défaut si l'URL/host indique "enfant".
try{
  if(typeof window.GAME_MODE === "undefined"){
    const host = (location && location.hostname) ? location.hostname : "";
    const path = (location && location.pathname) ? location.pathname : "";
    if(host.includes("enfant") || path.includes("enfant")){
      window.GAME_MODE = "enfant";
    }
  }
}catch(_e){}

const $ = (id) => document.getElementById(id);

  // Storage safe (content://, privacy modes can throw SecurityError)
  const storage = {
    get(k){
      try { return window.localStorage ? window.localStorage.getItem(k) : null; }
      catch(e){ return null; }
    },
    set(k,v){
      try { if(window.localStorage) window.localStorage.setItem(k, v); }
      catch(e){}
    },
    del(k){
      try { if(window.localStorage) window.localStorage.removeItem(k); }
      catch(e){}
    }
  };

  // Clone helper (structuredClone fallback for older browsers / webviews)
  function cloneState(obj){
    try{
      if(typeof structuredClone === "function") return structuredClone(obj);
    }catch(_){}
    // Fallback: OK because roomState is plain JSON (no functions, no Dates)
    return JSON.parse(JSON.stringify(obj));
  }

  const safeText = (el, txt) => { if(el) el.textContent = txt; };
  const now = () => Date.now();

  function escapeHtml(s){
    return (s ?? "").toString()
      .replaceAll("&","&amp;").replaceAll("<","&lt;").replaceAll(">","&gt;")
      .replaceAll('"',"&quot;").replaceAll("'","&#039;");
  }

  // Image src validation (avoid javascript: etc.)
  function safeImageSrc(url){
    if(url == null) return "";
    const s = String(url).trim();
    if(!s) return "";
    if(/^javascript:/i.test(s)) return "";
    // Allow data: images (optional)
    if(/^data:image\//i.test(s)) return s;
    // Allow http(s)
    if(/^https?:\/\//i.test(s)) return s;
    // Allow relative paths
    if(s.startsWith('/') || s.startsWith('./') || s.startsWith('../')) return s;
    if(/^[a-zA-Z0-9_\-./]+$/.test(s)) return s;
    return "";
  }

  function loadConfig(){
    try{
      const raw = storage.get(CONFIG_KEY);
      if(!raw) return { ...CONFIG_DEFAULT };
      const p = JSON.parse(raw);
      return {
        ...CONFIG_DEFAULT,
        supabaseUrl: typeof p.supabaseUrl === "string" ? p.supabaseUrl : CONFIG_DEFAULT.supabaseUrl,
        supabaseAnonKey: typeof p.supabaseAnonKey === "string" ? p.supabaseAnonKey : CONFIG_DEFAULT.supabaseAnonKey,
        channelPrefix: typeof p.channelPrefix === "string" ? p.channelPrefix : CONFIG_DEFAULT.channelPrefix,
        longPressMs: Number.isFinite(p.longPressMs) ? p.longPressMs : CONFIG_DEFAULT.longPressMs
      };
    }catch(_e){
      return { ...CONFIG_DEFAULT };
    }
  }
  function saveConfig(cfg){
    storage.set(CONFIG_KEY, JSON.stringify({
      supabaseUrl: cfg.supabaseUrl,
      supabaseAnonKey: cfg.supabaseAnonKey,
      channelPrefix: cfg.channelPrefix,
      longPressMs: cfg.longPressMs
    }));
  }

  let CONFIG = loadConfig();

  // Ensure config exists in localStorage even if user never opened/saved Setup.
  // This allows features like Cloud deck import to work out-of-the-box with defaults.
  try{
    if(!storage.get(CONFIG_KEY)){
      storage.set(CONFIG_KEY, JSON.stringify({
        supabaseUrl: CONFIG.supabaseUrl,
        supabaseAnonKey: CONFIG.supabaseAnonKey,
        channelPrefix: CONFIG.channelPrefix,
        longPressMs: CONFIG.longPressMs
      }));
    }
  }catch(_e){}
  // ===== Layout / viewport fixes =====
  const topBar = $("topBar");
  function setTopbarH(){
    if(!topBar) return;
    // Cap to avoid huge padding if layout glitches or browser zoom reports unexpected values
    const h = Math.ceil(topBar.getBoundingClientRect().height);
    const capped = Math.max(0, Math.min(h, 120));
    document.documentElement.style.setProperty("--topbarH", capped + "px");
  }
  function setAppHeight(){
    const vv = window.visualViewport;
    const h = vv ? Math.round(vv.height) : window.innerHeight;
    document.documentElement.style.setProperty("--appH", h + "px");
  }

  function setHandDockH(){
    const el = document.querySelector(".handDock");
    if(!el) return;
    const r = el.getBoundingClientRect();
    const h = Math.max(0, Math.round(r.height || 0));
    document.documentElement.style.setProperty("--handDockH", h + "px");
  }
  function refreshAll(){ setTopbarH(); setAppHeight(); setHandDockH(); }
  window.addEventListener("resize", refreshAll);
  if(window.visualViewport) window.visualViewport.addEventListener("resize", refreshAll);
  refreshAll();

  // Keep toast above the hand on mobile (PWA has no browser refresh UI)
  (function bindHandDockObserver(){
    const el = document.querySelector(".handDock");
    if(!el) return;
    if(window.ResizeObserver){
      const ro = new ResizeObserver(()=> setHandDockH());
      ro.observe(el);
    }
  })();
  
  // ===== Fullscreen & Modal Centering Management =====
  // 🔧 CORRECTION: Gestion du plein écran sur mobile pour éviter les décalages
  
  // Fonction pour demander le plein écran sur mobile
  function requestFullscreen() {
    if (!document.fullscreenElement && 
        !document.webkitFullscreenElement && 
        !document.mozFullScreenElement) {
      
      const elem = document.documentElement;
      
      try {
        if (elem.requestFullscreen) {
          elem.requestFullscreen().catch(err => {
            console.log('Fullscreen request failed:', err);
          });
        } else if (elem.webkitRequestFullscreen) {
          elem.webkitRequestFullscreen();
        } else if (elem.mozRequestFullScreen) {
          elem.mozRequestFullScreen();
        } else if (elem.msRequestFullscreen) {
          elem.msRequestFullscreen();
        }
      } catch (e) {
        console.log('Fullscreen not supported:', e);
      }
    }
  }
  
  // 🔧 CORRECTION: Fonction pour centrer le modal de carte
  function centerCardModal() {
    const modal = document.getElementById('cardModal');
    const modalContent = modal?.querySelector('.card-modal-content');
    
    if (!modal || !modalContent) return;
    
    // Force un reflow pour s'assurer que le modal est bien positionné
    modal.style.display = modal.classList.contains('open') ? 'flex' : 'none';
    
    // Sur mobile, s'assurer que le modal est centré même avec les barres système
    if (window.innerWidth <= 720) {
      const vh = window.visualViewport ? window.visualViewport.height : window.innerHeight;
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      
      // Ajuster la position pour compenser le scroll
      if (scrollTop > 0) {
        modal.style.top = '0';
        modal.style.transform = 'none';
      }
    }
  }
  
  // 🔧 CORRECTION: Demander le plein écran au premier tap sur mobile
  let fullscreenRequested = false;
  function handleFirstInteraction() {
    if (!fullscreenRequested && window.innerWidth <= 720) {
      fullscreenRequested = true;
      
      // Attendre un peu avant de demander le plein écran pour ne pas perturber l'utilisateur
      setTimeout(() => {
        requestFullscreen();
      }, 1000);
    }
  }
  
  // Attacher l'événement au premier clic/tap
  if (window.innerWidth <= 720) {
    document.addEventListener('touchstart', handleFirstInteraction, { once: true });
    document.addEventListener('click', handleFirstInteraction, { once: true });
  }
  
  // 🔧 CORRECTION: Recentrer le modal quand on change d'orientation
  window.addEventListener('orientationchange', () => {
    setTimeout(() => {
      refreshAll();
      centerCardModal();
    }, 100);
  });
  
  // Exposer les fonctions globalement
  window.requestFullscreen = requestFullscreen;
  window.centerCardModal = centerCardModal;

  // =====================================================================
  // SECTION:DOM_UI
  // =====================================================================

  // ===== Unified Panel =====
  const panelOverlay = $("panelOverlay");
  const panel = $("panel");
  const panelTitle = $("panelTitle");
  const panelClose = $("panelClose");
  const panelContext = $("panelContext");
  const viewSetup = $("panelSetup");
  const viewLog = $("panelLog");
  const viewActions = $("panelActions");
  const viewGame = $("panelGame");
  const viewHand = $("panelHand");
  const viewDeck = $("panelDeck");
  const viewClaim = $("panelClaim");
  const claimWinBtn = $("claimWinBtn");
  const claimNoBtn = $("claimNoBtn");
  const claimWinText = $("claimWinText");
  const handFloatingBtn = $("handFloatingBtn");
  const handFloatingCount = $("handFloatingCount");
const handCountLabel = $("handCountLabel");
  const handCardsContainer = $("handCardsContainer");
  const deckCardsContainer = $("deckCardsContainer");

  // -------------------------------------------------------------------
  // HARD FIX (reliable): ensure overlays are attached to <body>.
  // Why: if overlays end up inside a transformed/positioned wrapper, Chrome may
  // treat `position: fixed` as relative to that wrapper. Symptom: the panel is
  // "too low" and becomes usable only when zooming out.
  // We force-hoist overlays to <body> at runtime (idempotent).
  (function ensureOverlaysOnBody(){
    const ids = ["panelOverlay","zoneModal","cardModal"]; // keep in sync with index.html
    ids.forEach((id)=>{
      const el = document.getElementById(id);
      if(!el) return;
      if(el.parentElement !== document.body){
        try{
          document.body.appendChild(el);
        }catch(err){
          console.warn("Could not hoist overlay", id, err);
        }
      }
    });
  })();
  const deckSearchInput = $("deckSearchInput");
  const deckSearchHint = $("deckSearchHint");
  const deckSearchCount = $("deckSearchCount");

  function assertDom(){
    const required = ["panelOverlay","panel","panelTitle","panelClose","panelSetup","panelLog","panelActions","panelGame","logBtn","midBtn","setupBtn"];
    const missing = required.filter(id => !$(id));
    if(missing.length){
      console.error("DOM missing:", missing);
      // We do not throw here: keep the board usable.
    }
  }
  assertDom();

  const PANEL_VIEW = {SETUP:"setup", LOG:"log", GAME:"game", ACTIONS:"actions", HAND:"hand", DECK:"deck" , CLAIM:"claim" };
  window.PANEL_VIEW = PANEL_VIEW;  // Expose pour onclick
  // ===== Responsive score track placement =====
  // On mobile, the score track sits BETWEEN the two terrains to free space for the hand.
  // On larger screens, it returns above the hand cards.
  function __relocateScoreTrack(){
    try{
      const stf = $("scoreTrackFloating");
      if(!stf) return;
      const isMobile = (window.matchMedia && window.matchMedia("(max-width: 720px)").matches) || (window.innerWidth <= 720);
      const terrainStack = document.querySelector(".terrainStack");
      const handTop = document.querySelector(".handTopControls");
      const oppTerrain = $("oppTerrainZone");
      if(isMobile){
        if(terrainStack && oppTerrain && stf.parentElement !== terrainStack){
          oppTerrain.insertAdjacentElement("afterend", stf);
          stf.classList.add("scoreTrackBetween");
        }
      } else {
        if(handTop && stf.parentElement !== handTop){
          handTop.appendChild(stf);
          stf.classList.remove("scoreTrackBetween");
        }
      }
    }catch(_e){}
  }
  (function(){
    let t=null;
    const deb = ()=>{ try{ clearTimeout(t); }catch(_e){}; t=setTimeout(__relocateScoreTrack, 120); };
    window.addEventListener("resize", deb, {passive:true});
    document.addEventListener("DOMContentLoaded", ()=>{ setTimeout(__relocateScoreTrack, 50); });
    // also on visualViewport changes (mobile address bar)
    try{
      if(window.visualViewport){
        window.visualViewport.addEventListener("resize", deb, {passive:true});
        window.visualViewport.addEventListener("scroll", deb, {passive:true});
      }
    }catch(_e){}
    // first run
    setTimeout(__relocateScoreTrack, 0);
  })();

  // ===== Mobile UX: block native long-press image menu on cards =====
  // (Android Chrome: "ouvrir/télécharger/copier l'image")
  // We only block it on cards to avoid breaking normal page interactions.
  (function(){
    try{
      document.addEventListener('contextmenu', (e)=>{
        const t = e && e.target;
        if(!t || !t.closest) return;
        if(t.closest('.handCard') || t.closest('.card') || t.closest('.cardArt')){
          e.preventDefault();
        }
      }, {capture:true});

      // Also prevent image drag ghost on some browsers
      document.addEventListener('dragstart', (e)=>{
        const t = e && e.target;
        if(!t || !t.closest) return;
        if(t.closest('.handCard') || t.closest('.card') || t.closest('.cardArt')){
          e.preventDefault();
        }
      }, {capture:true});
    }catch(_e){}
  })();

  // ===== UI click shield =====
  // Empêche le "click-through" (un tap qui ouvre un panel mais déclenche aussi un bouton
  // situé dessous avant que l'overlay capture bien l'event, typiquement "Deck adversaire" sur mobile).
  let __uiShieldUntil = 0;
  function armUiShield(ms = 350){
    const now = (typeof performance !== 'undefined' && performance.now) ? performance.now() : Date.now();
    __uiShieldUntil = now + ms;
  }
  function uiShieldActive(){
    const now = (typeof performance !== 'undefined' && performance.now) ? performance.now() : Date.now();
    return now < __uiShieldUntil;
  }
  // expose pour openZoneModal (défini plus bas)
  window.__armUiShield = armUiShield;
  window.__uiShieldActive = uiShieldActive;

  // Arm shield for hand top buttons too (important on mobile)
  try{
    const ids = ["handDeckBtn","handVestiaireBtn","handStopBtn"];
    for(const id of ids){
      const el = $(id);
      if(!el) continue;
      el.addEventListener('pointerdown', (e)=>{
        try{ armUiShield(450); }catch(_e){}
        // prevent the same tap from hitting underlying elements
        try{ e.stopPropagation(); }catch(_e){}
      }, {passive:false});
    }

  // Hard-disable any interaction on the opponent deck button (prevents any residual click-through spam on mobile).
  try{
    const oppDeckBtn = $("oppDeckBtn");
    if(oppDeckBtn && oppDeckBtn.parentNode){
      const clone = oppDeckBtn.cloneNode(true);
      clone.onclick = null;
      clone.addEventListener('click', (e)=>{ try{ e.preventDefault(); e.stopPropagation(); }catch(_e){} }, {passive:false});
      clone.addEventListener('pointerdown', (e)=>{ try{ e.preventDefault(); e.stopPropagation(); }catch(_e){} }, {passive:false});
      clone.style.pointerEvents = "none";
      clone.classList.add("bubbleBtn--disabled");
      oppDeckBtn.parentNode.replaceChild(clone, oppDeckBtn);
    }
  }catch(_e){}
  }catch(_e){}
  // ===== PATCH UI MENUS (2026-01-28) =====
  // Ensure top bar buttons open the correct panel view and are visible.
  try{
    const logBtn = $("logBtn");
    const midBtn = $("midBtn");
    const setupBtn = $("setupBtn");
    if(logBtn){
      logBtn.style.display = "";
      logBtn.onclick = (e)=>{
        try{ e&&e.preventDefault&&e.preventDefault(); e&&e.stopImmediatePropagation&&e.stopImmediatePropagation(); e&&e.stopPropagation&&e.stopPropagation(); }catch(_e){}
        try{ armUiShield(450); }catch(_e){}
        openPanel({mode:"drawer", view:PANEL_VIEW.LOG, title:"Journal", context:""});
        return false;
      };
      logBtn.setAttribute("aria-label","Journal");
    }
    if(midBtn){
      midBtn.style.display = "";
      // The hand is always visible (hand dock). Use the middle button for game info.
      midBtn.onclick = (e)=>{
        try{ e&&e.preventDefault&&e.preventDefault(); e&&e.stopImmediatePropagation&&e.stopImmediatePropagation(); e&&e.stopPropagation&&e.stopPropagation(); }catch(_e){}
        try{ armUiShield(450); }catch(_e){}
        openPanel({mode:"drawer", view:PANEL_VIEW.GAME, title:"Partie"});
        return false;
      };
      midBtn.setAttribute("aria-label","Partie");
    }
    if(setupBtn){
      setupBtn.style.display = "";
      setupBtn.onclick = (e)=>{
        try{ e&&e.preventDefault&&e.preventDefault(); e&&e.stopImmediatePropagation&&e.stopImmediatePropagation(); e&&e.stopPropagation&&e.stopPropagation(); }catch(_e){}
        try{ armUiShield(450); }catch(_e){}
        openPanel({mode:"drawer", view:PANEL_VIEW.SETUP, title:"Setup / Connexion", context:""});
        return false;
      };
      setupBtn.setAttribute("aria-label","Setup");
    }
  }catch(_e){}

// Debug toggle désactivé en production — ne pas afficher le bouton
try{
  ensureDebugOverlay();
  // Auto-enable si URL ?debug=1 (reste disponible pour dev via URL)
  const params = new URLSearchParams(location.search || "");
  const want = (params.get("debug")==="1") || (()=>{
    try{ return localStorage.getItem(`bulle_debug_${GAME_MODE}`)==="1"; }catch(_e){ return false; }
  })();
  if(want){
    setDebugEnabled(true);
  }
}catch(_e){}
  // ===== END PATCH UI MENUS =====

  
  function showView(v){
    if(viewSetup) viewSetup.hidden = v !== PANEL_VIEW.SETUP;
    if(viewLog) viewLog.hidden = v !== PANEL_VIEW.LOG;
    if(viewGame) viewGame.hidden = v !== PANEL_VIEW.GAME;
    if(viewActions) viewActions.hidden = v !== PANEL_VIEW.ACTIONS;
    if(viewHand) viewHand.hidden = v !== PANEL_VIEW.HAND;
    if(viewDeck) viewDeck.hidden = v !== PANEL_VIEW.DECK;
    if(viewClaim) viewClaim.hidden = v !== PANEL_VIEW.CLAIM;
  }

  function openPanel({mode, view, title, context}){
    if(!panelOverlay || !panel) return;
    panel.classList.toggle("panel--drawer", mode === "drawer");
    // Mobile-first: on masque le titre du panneau (on garde uniquement la croix).
    safeText(panelTitle, "");
    // la ligne de contexte (ex: "X carte(s) en main") n'est pas utile ici
    const hideCtx = (view === PANEL_VIEW.HAND);
    if(panelContext){
      if(hideCtx){ panelContext.innerHTML = ""; panelContext.style.display = "none"; }
      else { panelContext.style.display = ""; panelContext.innerHTML = context || ""; }
    }
    showView(view);

    // Track current panel view so we can apply close behaviors (ex: auto-shuffle deck)
    try{ window.__panelCurrentView = view; }catch(_e){}

    panelOverlay.classList.add("open");
    // Drawer mode: remove overlay padding so the panel is not pushed out of view (desktop zoom bug)
    panelOverlay.classList.toggle("isDrawer", mode === "drawer");

    try{ document.body && document.body.classList.add('panelOpen'); }catch(_e){}
    panelOverlay.removeAttribute('inert');
        panelOverlay.setAttribute('aria-hidden','false');
    
    // FIX: Forcer le scroll en haut du panel et du panelOverlay pour corriger le problème de scroll initial
    requestAnimationFrame(() => {
      try {
        if (panelOverlay) panelOverlay.scrollTop = 0;
        const panelBody = document.querySelector('.panelBody');
        if (panelBody) panelBody.scrollTop = 0;
      } catch(_e) {}
    });
    
    // UX: refresh thumb buttons visibility when panels open
    try{ requestAnimationFrame(()=>{ try{ updateThumbPhase2Buttons&&updateThumbPhase2Buttons(); }catch(_e){} try{ updateThumbPhase3Buttons&&updateThumbPhase3Buttons(); }catch(_e){} }); }catch(_e){}
  }
  // Expose panel controls globally (other UI bindings rely on window.openPanel)
  try{ window.openPanel = openPanel; }catch(_e){}
  function closePanel(){
    if(!panelOverlay) return;

    // Auto-shuffle ONLY the deck when closing the Deck panel (vestiaire intact)
    try{
      if(window.__panelCurrentView === PANEL_VIEW.DECK){
        const st = roomState || initialRoomState();
        const slot = mySlotFromState(st);
        if(slot){
          updateRoomState((s)=>{
            s.deckPiles = s.deckPiles || {A:[],B:[]};
            const deck = Array.isArray(s.deckPiles[slot]) ? s.deckPiles[slot] : [];
            if(deck.length > 1){
              s.deckPiles[slot] = shuffleInPlace(deck.slice());
              if(s.players?.[slot]) s.players[slot].deckCount = (s.deckPiles[slot]||[]).length;
            }
            return s;
          }, 'auto-shuffle-deck-panel-close').catch(()=>{});
        }
      }
    }catch(_e){}
    panelOverlay.classList.remove("open");
    try{ document.body && document.body.classList.remove('panelOpen'); }catch(_e){}
    // A11Y: déplacer le focus hors du panneau AVANT de le masquer
        try{
          const ae = document.activeElement;
          if(ae && panelOverlay && panelOverlay.contains(ae)) ae.blur();
        }catch(_e){}
        try{
          const opener = document.querySelector('[data-panel-opener]') || document.getElementById('chatBtn') || document.getElementById('menuBtn');
          if(opener) opener.focus();
          else document.body && document.body.focus && document.body.focus();
        }catch(_e){}
        panelOverlay.setAttribute('inert','');
        panelOverlay.setAttribute('aria-hidden','true');
    // UX: refresh thumb buttons visibility when panels close
    try{ requestAnimationFrame(()=>{ try{ updateThumbPhase2Buttons&&updateThumbPhase2Buttons(); }catch(_e){} try{ updateThumbPhase3Buttons&&updateThumbPhase3Buttons(); }catch(_e){} }); }catch(_e){}
  }

  // Expose closePanel globally as well
  try{ window.closePanel = closePanel; }catch(_e){}

  // 🔧 CORRECTION: Utiliser plusieurs méthodes pour s'assurer que le bouton fonctionne sur tous les navigateurs
  if(panelClose) {
    panelClose.onclick = closePanel;
    panelClose.addEventListener('click', closePanel);
    panelClose.addEventListener('touchend', (e) => {
      e.preventDefault();
      e.stopPropagation();
      closePanel();
    }, {passive: false});
  }
  // IMPORTANT: no close on overlay click (croix only)
  if(panelOverlay) panelOverlay.addEventListener("click", (e) => { e.stopPropagation(); });

  // ===== Journal (local + remote + persistant DB) =====
  const logBox = $("logBox");
  const LOG_MAX = 200;

  // Local system lines (debug / UI events)
  const logLines = [];

  // Remote persistent lines from roomState.activityLog
  let lastRenderedActivityKey = "";
  function fmtTime(ts){
    try{
      const d = new Date(ts);
      return d.toLocaleTimeString();
    }catch(_e){ return ""; }
  }
  function getRemoteLines(st){
    const a = (st && st.activityLog) ? st.activityLog : [];
    // activityLog entries: {ts:number, line:string}
    return a
      .filter(e => e && e.line)
      .slice(-LOG_MAX)
      .map(e => `[${fmtTime(e.ts || Date.now())}] ${e.line}`);
  }
  function renderJournal(st){
    if(!logBox) return;
    const remote = getRemoteLines(st || roomState || {});
    const local = logLines.slice(-LOG_MAX);
    // Prefer remote (shared). Append local system lines (prefixed) at the end.
    const all = remote.concat(local.map(l => `[SYS] ${l}`)).slice(-LOG_MAX);
    logBox.textContent = all.join("\n");
  }

  function pushLog(line){
    const t = new Date().toLocaleTimeString();
    logLines.push(`[${t}] ${line}`);
    while(logLines.length > LOG_MAX) logLines.shift();
    renderJournal(roomState || {});
  }

  // Persistent activity queue (debounced DB append)
  const pendingActivity = [];
  let activityFlushTimer = null;
  function queueActivity(line){
    pendingActivity.push({ ts: Date.now(), line: String(line||"") });
    // debounce flush to DB
    clearTimeout(activityFlushTimer);
    activityFlushTimer = setTimeout(flushActivityToDB, 500);
  }
  async function flushActivityToDB(){
    if(pendingActivity.length === 0) return;
    const slot = mySlotFromState(roomState || initialRoomState());
    if(!slot) { pendingActivity.length = 0; return; }
    const batch = pendingActivity.splice(0, pendingActivity.length);
    try{
      await updateRoomStateAction((s)=>{
        s.activityLog = Array.isArray(s.activityLog) ? s.activityLog : [];
        for(const it of batch){
          if(!it || !it.line) continue;
          s.activityLog.push({ ts: it.ts || Date.now(), line: String(it.line) });
        }
        // cap
        if(s.activityLog.length > 80) s.activityLog = s.activityLog.slice(-80);
        return s;
      }, "activity-log");
    }catch(_e){
      // if DB write fails (offline), keep local only
    }
  }

  // 📢 Activity — flux chronologique partagé (persistant)
  function pushActivity(label) {
    const safe = String(label || "");
    pushLog(safe);       // local immediate
    queueActivity(safe); // shared persistent
  }
  window.pushActivity = pushActivity;
  // Claim win (opponent offline too long) — flow tournoi (popup + screenshot)
  if(claimWinBtn){
    claimWinBtn.onclick = async (e)=>{
      try{ e&&e.preventDefault&&e.preventDefault(); e&&e.stopPropagation&&e.stopPropagation(); }catch(_e){}
      const st0 = roomState || initialRoomState();
      const me = mySlotFromState(st0);
      if(!me){ showToast("⚠️ Spectateur"); return; }

      const opp = claimOppSlot || ((me === "A") ? "B" : "A");
      // Sécurité: si l'adversaire est revenu, on ne clôture pas.
      try{
        const info = computeOppPresence();
        if(info && !info.offline){
          showToast("✅ L'adversaire est reconnecté");
          try{ closePanel(); }catch(_e){}
          return;
        }
      }catch(_e){}

      try{
        await updateRoomStateAction((s)=>{
          // Si déjà terminé, ne rien faire
          const phase = String(s.phase || "lobby");
          if(phase === "ended" || phase === "finished") return s;

          // Clôturer comme une concession (déconnexion / abandon)
          const result = {
            A: (me === "A") ? "win" : "lose",
            B: (me === "B") ? "win" : "lose",
          };

          s.phase = "ended";
          s.endReason = "concede";
          s.endedAt = Date.now();
          s.concededBy = opp;
          s.winner = me;
          s.result = result;

          // Éjecter l'adversaire de la room (slot libéré)
          try{
            s.players = s.players || { A:{id:null,deckOk:false,ready:false}, B:{id:null,deckOk:false,ready:false} };
            if(s.players[opp]) s.players[opp] = { id:null, deckOk:false, ready:false };
          }catch(_e){ console.warn('[CLAIM] player reset failed:', _e); }

          return s;
        }, "claim-win");
        try{ pushActivity(`🏆 ${slotLabel(me)} gagne (abandon / déconnexion de ${opp})`); }catch(_e){}
        try{ closePanel(); }catch(_e){}
      }catch(_e){
        showToast("⚠️ Impossible de clore la partie");
      }
    };
  }

  // Refuser une première fois (on re-propose après 1 minute avec seulement OUI)
  if(claimNoBtn){
    claimNoBtn.onclick = (e)=>{
      try{ e&&e.preventDefault&&e.preventDefault(); e&&e.stopPropagation&&e.stopPropagation(); }catch(_e){}
      claimStage = 2;
      claimRefusedAt = getNowMs();
      try{ closePanel(); }catch(_e){}
      try{ showToast("⏳ D'accord, on réessaie dans 30 secondes"); }catch(_e){}
    };
  }

// 🏷️ Labels lisibles pour les zones dans le log
  function zoneLabel(z) {
    const map = {
      myTerrain:'Mon Terrain', oppTerrain:'Terrain adv.',
      myHand:'Main', myVestiaire:'Vestiaire', myDeck:'Deck',
      myBanch:'Banc', oppVestiaire:'Vestiaire adv.', oppBanch:'Banc adv.',
      oppHand:'Main adv.', oppDeck:'Deck adv.'
    };
    return map[z] || z;
  }
  // 🎭 Préfixe joueur pour le log
  function slotLabel(slot) { return slot === 'A' ? '🔵 A' : slot === 'B' ? '🟠 B' : ''; }

  function reportError(err, where){
    let msg;
    if (err && err.message) {
      msg = err.message;
    } else if (typeof err === 'string') {
      msg = err;
    } else if (err && typeof err === 'object') {
      // Essayer d'extraire des infos utiles de l'objet
      msg = JSON.stringify(err, null, 2);
    } else {
      msg = String(err);
    }
    
    const fullMsg = `ERR${where ? " "+where : ""} : ${msg}`;
    pushLog(fullMsg);
    console.error("❌", where || "Error", ":", err);
  }

  // ===== Setup inputs =====
  const roomInput = $("roomInput");
  const roleLabel = $("roleLabel");
const presenceLabel = $("presenceLabel");
  const connLabel = $("connLabel");
  // ===== Room + per-room persistence =====
  const ROOM_LAST_KEY = "bulle::room:last";
  function getRoom(){
    return ((roomInput && roomInput.value) ? roomInput.value : (storage.get(ROOM_LAST_KEY) || "TEST123")).trim() || "TEST123";
  }
  function setRoom(v){
    if(roomInput) roomInput.value = v;
    storage.set(ROOM_LAST_KEY, v);
  }
  // init room from storage
  setRoom(getRoom());

  function roomStorageKey(suffix){
    return `bulle::room::${getRoom()}::${suffix}`;
  }

  // Setup flow UI
  const readyBtn = $("readyBtn");
  const rolePill = $("rolePill");
  const presentPill = $("presentPill");
  const readyAEl = $("readyA");
  const readyBEl = $("readyB");
  const diceStatusEl = $("diceStatus");
  const rollBtn = $("rollBtn");
  const resyncBtn = $("resyncBtn");
  const recoverBtn = $("recoverBtn");
  
  // --- Deck ready sync (pour verrouiller Ready tant que les 2 decks ne sont pas prêts) ---
  let otherDeckReady = false;
  
  // --- Guard pour double appel initEnfantRoom ---
  let enfantInitInProgress = false;
  
  // --- Start de partie (v3) ---
  let gameStarted = false;
  let gameEnded = false; // 🏆 Partie terminée (bloque toutes les actions)
  let starter = null; // "A" ou "B"
  let startRollA = null;
  let startRollB = null;

  // Piles locales (privées)
  let validatedDeckIds = []; // ids decklist (42) validés localement
  let myLeaderId = null;
  let myDeckPile = [];  // 41 cartes (mélangées)
  let myHandPile = [];  // cartes en main (privé)
  let __handWriteAt = 0; // timestamp of last optimistic hand removal (guards against realtime overwrite)

  // Contexte du modal carte (zone source, id)
  let currentCardContext = null;

  // --- DB private piles commit (safe) ---
  // buildLocalPilesFromValidated() mélange le deck. On ne doit PAS le rappeler pour juste pousser l'état en DB.
  let _pilesCommitInFlight = false;
  // --- Deck idempotence (avoid double 'deck-import' collisions) ---
  // We compute a stable hash from the DECKLIST (validatedDeckIds), independent of shuffle/order.
  // This lets multiple clients converge without spamming version bumps.
  function _normDeckId(x){
    const v = String(x ?? '').trim();
    if(!v) return '';
    // Accept token form "A-000001::019" or plain "019"
    const cid = v.includes('::') ? (v.split('::')[1] || v) : v;
    const m = cid.match(/(\d+)/);
    return m ? m[1].padStart(3,'0') : cid.padStart(3,'0');
  }
  function stableHashDeck(ids){
    try{
      const arr = Array.isArray(ids) ? ids : [];
      const norm = arr.map(_normDeckId).filter(Boolean).sort();
      // FNV-1a 32-bit
      let h = 0x811c9dc5;
      const str = norm.join(',');
      for(let i=0;i<str.length;i++){
        h ^= str.charCodeAt(i);
        h = (h + ((h<<1) + (h<<4) + (h<<7) + (h<<8) + (h<<24))) >>> 0;
      }
      return ('00000000' + h.toString(16)).slice(-8);
    }catch(_e){
      return null;
    }
  }
  async function commitLocalPilesToDb(slot, reason){
    if(!slot) return;
    if(!connected || !sb || !roomCodeActive) return;
    if(!myLeaderId && !(typeof GAME_MODE !== "undefined" && GAME_MODE==="enfant")) return;
    const deckHash = stableHashDeck((Array.isArray(validatedDeckIds) && validatedDeckIds.length) ? validatedDeckIds : myDeckPile);

    // If we already have the same deck committed in our latest known roomState, don't write again.
    try{
      const st0 = roomState || initialRoomState();
      const already = !!(st0 && st0.players && st0.players[slot] && st0.players[slot].deckHash && st0.players[slot].deckHash === deckHash);
      const hasDeck = !!(st0 && st0.deckPiles && Array.isArray(st0.deckPiles[slot]) && st0.deckPiles[slot].length > 0);
      const alreadyChief = !!(st0 && st0.chiefs && st0.chiefs[slot] && (st0.chiefs[slot] === myLeaderId));
      const chiefOkForThisDeck = !!(st0 && st0.players && st0.players[slot] && st0.players[slot].chiefInitedHash && (st0.players[slot].chiefInitedHash === deckHash));
      // If deck is already committed AND chief init already done for this deck, nothing to do.
      if(already && hasDeck && alreadyChief && chiefOkForThisDeck) return;
    }catch(_e){}

    const chiefCard = cardsById.get(myLeaderId);
    const basePA = getChiefBasePA(chiefCard);

    await updateRoomState((s) => {
      // Idempotence: if this deck was already committed, do nothing.
      s.players = s.players || {A:{},B:{}};
      s.players[slot] = s.players[slot] || {};
      // Idempotence (per-slot): if this exact deck already initialized the chief, don't write again.
      if(deckHash && s.players[slot].chiefInitedHash && s.players[slot].chiefInitedHash === deckHash && s.chiefs && s.chiefs[slot]){
        return s;
      }
      if(deckHash && s.players[slot].deckHash === deckHash){
        return s;
      }
      if(!s.chiefs) s.chiefs = { A: null, B: null };
      s.chiefs[slot] = myLeaderId;

      if(!s.chiefBasePA) s.chiefBasePA = { A: null, B: null };
      if(basePA != null) s.chiefBasePA[slot] = basePA;

      // Init PA uniquement si pas encore defini (sinon on ne touche pas aux PA en cours)
      if(!s.actionDice) s.actionDice = { A: 0, B: 0 };
      if(s.actionDice[slot] == null || s.actionDice[slot] === 0){
        if(basePA != null) s.actionDice[slot] = basePA;
      }

      if(!s.deckPiles) s.deckPiles = { A: [], B: [] };
      if(!s.handPiles) s.handPiles = { A: [], B: [] };
      
      // Convert local piles (cid or token) -> tokens in DB (instance-safe)
      if(!s.nextInstanceNum) s.nextInstanceNum = { A: 1, B: 1 };
      const rawDeck = Array.isArray(myDeckPile) ? myDeckPile.slice() : [];
      const rawHand = Array.isArray(myHandPile) ? myHandPile.slice() : [];
      s.deckPiles[slot] = rawDeck.map(x => normalizeTokenInput(slot, x, s));
      s.handPiles[slot] = rawHand.map(x => normalizeTokenInput(slot, x, s));

      // Blueprint canonique du deck (liste de cid avec doublons), utilisé par "Nouvelle partie"
      if(!s.deckBlueprint) s.deckBlueprint = { A: [], B: [] };
      const cidFromInput = (x) => {
        if(isInstanceToken(x)) return getCid(x);
        const v = String(x || '');
        return v.padStart(3,'0');
      };
      s.deckBlueprint[slot] = rawDeck.map(cidFromInput);
      if(s.players && s.players[slot]){
        s.players[slot].deckCount = (s.deckPiles[slot] || []).length;
        s.players[slot].handCount = (s.handPiles[slot] || []).length;
        s.players[slot].deckOk = true;
        // Plus de bouton "Je suis prêt" : l'import decklist vaut validation.
        s.players[slot].ready = true;
      }
      // Mark deck hash to make 'deck-import' idempotent across clients
      if(deckHash) s.players[slot].deckHash = deckHash;
      if(deckHash) s.players[slot].chiefInitedHash = deckHash;

      // si on (re)commit un deck, on permet a la pioche de debut de se refaire proprement
      if(!s.startDrawn) s.startDrawn = { A: false, B: false };

      return s;
    }, reason || "commit-piles");
  }

  async function maybeCommitLocalPilesToDb(reason){
    if(_pilesCommitInFlight) return;
    if(!connected || !sb || !roomCodeActive) return;

    const st = roomState || initialRoomState();
    const slot = mySlotFromState(st);
    if(!slot) return;
    const deckHash = stableHashDeck((Array.isArray(validatedDeckIds) && validatedDeckIds.length) ? validatedDeckIds : myDeckPile);

    // If roomState already knows this deck, skip (idempotent).
    try{
      if(deckHash && st?.players?.[slot]?.deckHash === deckHash) return;
    }catch(_e){}

    // For 'deck-import', do a fresh read once to avoid acting on a stale roomState (reduces optimistic-lock collisions).
    if((reason || "") === "deck-import"){
      try{
        const { data: row, error } = await sb
          .from('rooms_kid')
          .select('state,version')
          .eq('room_code', roomCodeActive)
          .maybeSingle();
        if(!error && row && row.state){
          roomState = row.state;
          // --- Mode guard (évite d’écraser une room d’un autre format) ---
          {
            const mode = (roomState && roomState.gameMode) ? String(roomState.gameMode) : null;
            roomModeMismatch = !!(mode && mode !== GAME_MODE);
            if(roomModeMismatch){
              showToast(`⚠️ Room en mode "${mode}" (ce client = "${GAME_MODE}"). Utilise "Réinitialiser la room" pour convertir.`, "warn", 8000);
            } else if(roomState && !roomState.gameMode){
              // Room sans mode : on l’étiquette au premier chargement
              roomState.gameMode = GAME_MODE;
            }
          }

          if(typeof row.version !== 'undefined') roomVersion = Number(row.version || 0);
          const stFresh = roomState || initialRoomState();
          const slFresh = mySlotFromState(stFresh) || slot;
          if(deckHash && stFresh?.players?.[slFresh]?.deckHash === deckHash) return;
          const freshDeck = stFresh?.deckPiles?.[slFresh];
          const freshHand = stFresh?.handPiles?.[slFresh];
          const freshHas = !!((Array.isArray(freshDeck) && freshDeck.length) || (Array.isArray(freshHand) && freshHand.length));
          if(freshHas) return;
        }
      }catch(_e){}
    }

    const dbDeck = st.deckPiles && Array.isArray(st.deckPiles[slot]) ? st.deckPiles[slot] : null;
    const dbHand = st.handPiles && Array.isArray(st.handPiles[slot]) ? st.handPiles[slot] : null;
    const dbHas = (dbDeck && dbDeck.length) || (dbHand && dbHand.length);

    // On commit seulement si la DB n'a rien ET que le local est pret
    if(dbHas) return;
    if(!myLeaderId || !Array.isArray(myDeckPile) || myDeckPile.length === 0) return;

    _pilesCommitInFlight = true;
    try{
      await commitLocalPilesToDb(slot, reason || "autocommit-piles");
    }catch(e){
      reportError(e, "autocommit-piles");
    }finally{
      _pilesCommitInFlight = false;
    }
  }

  // Reset function for game variables
  function resetGameVariables() {
    gameStarted = false;
    starter = null;
    startRollA = null;
    startRollB = null;
    myLeaderId = null;
    myDeckPile = [];
    myHandPile = [];
    // Keep validatedDeckIds - it's the deck list
  }

  function shuffleInPlace(arr){
    for(let i=arr.length-1;i>0;i--){
      const j = Math.floor(Math.random()*(i+1));
      const t = arr[i]; arr[i]=arr[j]; arr[j]=t;
    }
    return arr;
  }

  function myRoleAB(){
    const txt = roleLabel ? String(roleLabel.textContent||"") : "";
    if(txt.includes("Joueur A")) return "A";
    if(txt.includes("Joueur B")) return "B";
    return null;
  }

  function resetStartStateLocal(){
    gameStarted = false;
    gameEnded = false; // 🔧 Reset pour nouvelle partie
    __endGameShown = false; // 🔧 Permettre de réafficher le popup
    starter = null;
    startRollA = null;
    startRollB = null;
    setDiceUI("—");
    myHandPile = []; // Vider la main
    updateHandUI(); // Cacher le bouton flottant

    // 🔧 Remove disconnect banner and end-game overlay if present
    try{ _hideDisconnectBanner(); }catch(_e){}
    try{ const ego = document.getElementById("endGameOverlay"); if(ego) ego.remove(); }catch(_e){}
    
    // 🔧 RESET DECK STATUS : remettre à "—" pour forcer revalidation
    localDeckReady = false;
    try{
      const deckStatus = document.getElementById('deckStatus');
      if(deckStatus) deckStatus.textContent = '—';
    }catch(_e){}
    
    // 🔧 RESET DES LED : retirer la classe 'red' et forcer updateTurnIndicators
    try{
      const dotA = document.getElementById('dotA');
      const dotB = document.getElementById('dotB');
      if(dotA){
        dotA.classList.remove('red');
        dotA.style.background = ''; // Reset inline style
      }
      if(dotB){
        dotB.classList.remove('red');
        dotB.style.background = ''; // Reset inline style
      }
      // Appeler updateTurnIndicators pour mettre à jour selon le tour actuel
      if(typeof updateTurnIndicators === 'function'){
        setTimeout(() => updateTurnIndicators(), 100);
      }
    }catch(_e){}
  }
  
  function resetAllLocalState(){
    // Clear all active timers
    clearAllTimers();
    
    // Reset game and phase variables
    resetGameVariables();
    resetPhaseVariables();
    
    // Reset flags de partie
    gameStarted = false;
    starter = null;
    startRollA = null;
    startRollB = null;
    myReady = false;
    localDeckReady = false;
    otherDeckReady = false;
    
    // Reset piles privées
    myDeckPile = [];
    myHandPile = [];
    myLeaderId = null;
    validatedDeckIds = [];

    // Reset gameState complet
    // NOTE: gameState est un const (objet). On le réinitialise par mutation (anti TypeError).
    for (const k of Object.keys(gameState)) { delete gameState[k]; }
    Object.assign(gameState, {
      myTerrain: [],
      oppTerrain: [],
      myVestiaire: [],
      oppVestiaireCount: 0,
      myBanch: [],
      oppBanchCount: 0,
      myRevealed: [],
      oppRevealedCount: 0,
      myChief: null,
      oppChief: null,
      myChiefNote: '',
      oppChiefNote: '',
      myActionDie: 0,
      oppActionDie: 0,
      myPassDie: 0,
      oppPassDie: 0,
      bulleStateLabel: '',
      occurrencesThisRound: 0,
      gamePhase: 'lobby',
      roundNumber: 1
    });
    
    // Reset UI
    setDiceUI("—");
    updateHandUI();
    updateAllZoneCounters();
    updateActionDieUI();
    updatePassDieUI();
    
    // Fermer les modals
    closeZoneModal();
    closeCardModal();
    
    pushLog("🔄 État local réinitialisé");
  }

  async function buildLocalPilesFromValidated(){
    // Construit piles locales à partir du deck validé.
    // - Mode complexe : extrait Chef + deck (41), mélange
    // - Mode enfant   : pas de Chef, deck = toutes les cartes validées (44), mélange
    const isEnfant = (typeof GAME_MODE !== "undefined" && GAME_MODE === "enfant");

    myLeaderId = null;

    if(isEnfant){
      const mainIds = [];
      for(const id of validatedDeckIds){
        const c = cardsById.get(id);
        if(!c) continue;
        // Enfant : interdiction des faces retournées dans le deck
        if(c.isBackFace) continue;
        // Enfant : pas de Chef
        if(String(c.type||"").toLowerCase() === "chef") continue;
        mainIds.push(id);
      }
      myDeckPile = shuffleInPlace(mainIds.slice());
      myHandPile = [];
      // Pas de chef en mode enfant
      gameState.myChief = null;
      return;
    }

    // ----- Mode complexe (comportement historique) -----
    // Toutes les cartes vont dans le deck (40 cartes)
    const mainIds = validatedDeckIds.slice();
    myDeckPile = shuffleInPlace(mainIds.slice());
    myHandPile = [];
  }

  /**
   * MODE ENFANT : Initialise les decks A et B en DB depuis validatedDeckIds
   * - Filtre les cartes isBackFace et type Chef
   * - Mélange les decks
   * - Pousse en DB (roomState.deckPiles)
   * - Appelé une seule fois par le joueur A quand les deux sont prêts
   */
  /**
   * 🎬 MODE ENFANT V5 : Initialisation complète de la room (UNE SEULE FOIS)
   * WRITER LEADER : Seul le joueur A exécute cette fonction
   * Appelée : Quand les 2 joueurs sont prêts avec decks validés
   */
  async function initEnfantRoom() {
    _log("🎮 [INIT] Tentative d'initialisation room enfant...");
    
    // Guard : Initialisation déjà en cours ?
    if(enfantInitInProgress) {
      console.log("⚠️ [INIT] Initialisation déjà en cours, skip");
      return;
    }
    
    // Guard : Peut écrire en mode enfant avec writer leader ?
    if(!canWriteEnfant(true)) return;
    
    const st = roomState || initialRoomState();
    
    // Guard : Déjà initialisé ?
    if(st.enfantInitialized) {
      console.log("✅ [INIT] Room déjà initialisée, skip");
      return;
    }
    
    // Marquer l'initialisation en cours
    enfantInitInProgress = true;
    
    try {
    
    // Guard : Les 2 joueurs ont un deck validé ?
    const playerAReady = !!st.players?.A?.deckOk;
    const playerBReady = !!st.players?.B?.deckOk;
    
    if(!playerAReady || !playerBReady) {
      console.log("⏳ [INIT] Attente des 2 joueurs...", {
        A: playerAReady ? "✅" : "❌",
        B: playerBReady ? "✅" : "❌"
      });
      enfantInitInProgress = false;
      return;
    }
    
    _log("🎮 [INIT] Conditions OK, initialisation de la room...");
    
    try {
      // Construire les 2 decks depuis la DB (validatedDeckIds stockés par chaque joueur).
      // IMPORTANT: ne pas utiliser validatedDeckIds local, sinon après refresh A peut rester bloqué en lobby.
      const rawA = Array.isArray(st.players?.A?.validatedDeckIds) ? st.players.A.validatedDeckIds : [];
      const rawB = Array.isArray(st.players?.B?.validatedDeckIds) ? st.players.B.validatedDeckIds : [];

      const filterIds = (ids)=>{
        const out = [];
        for(const id0 of (ids||[])){
          const id = String(id0).padStart(3,'0');
          const card = cardsById.get(id);
          if(!card) continue;
          if(card.isBackFace) continue;
          if(String(card.type || "").toLowerCase() === "chef") continue;
          out.push(id);
        }
        return out;
      };

      const validA = filterIds(rawA);
      const validB = filterIds(rawB);

      if(validA.length === 0 || validB.length === 0){
        console.error("❌ [INIT] Deck(s) manquant(s) dans la DB", {a: validA.length, b: validB.length});
        pushLog("❌ Impossible de démarrer : les 2 joueurs doivent importer leur deck.");
        return;
      }

      console.log(`📦 [INIT] Decks valides : A=${validA.length} • B=${validB.length}`);

      // Créer 2 decks indépendants mélangés
      const deckA = shuffleInPlace(validA.slice());
      const deckB = shuffleInPlace(validB.slice());
      
      // Déterminer premier joueur
      let diceA = Math.floor(Math.random()*6)+1;
      let diceB = Math.floor(Math.random()*6)+1;
      // évite les égalités pour être clair pour les enfants
      while (diceA === diceB) {
        diceA = Math.floor(Math.random()*6)+1;
        diceB = Math.floor(Math.random()*6)+1;
      }
      const starter = (diceA > diceB) ? "A" : "B";
      const startDice = { A: diceA, B: diceB, winner: starter };
      
      // Écrire ATOMIQUEMENT
      await updateRoomState((s) => {
        // Double guard
        if(s.enfantInitialized) {
          console.log("⚠️ [INIT] Double guard : déjà initialisé");
          return s;
        }
        
        // === MODE ===
        s.gameMode = "enfant";
        
        // === DECKS & HANDS ===
        s.deckPiles = { A: deckA.slice(), B: deckB.slice() };
        s.handPiles = { A: [], B: [] };
        
        // === FLOW ===
        s.phase = "started";
        s.roundNumber = 1;
        s.activePlayer = starter;
        s.starter = starter;

        // === TIMERS ===
        ensureTimersShape(s);
        const _now = (typeof Date !== "undefined") ? Date.now() : 0;
        // reset both timers
        s.timers.A.msLeft = TIMER_START_MS;
        s.timers.B.msLeft = TIMER_START_MS;
        s.timers.A.locked = false;
        s.timers.B.locked = false;
        s.timers.A.finalPassAvailable = true;
        s.timers.B.finalPassAvailable = true;
        s.timers.A.running = false;
        s.timers.B.running = false;
        s.timers.A.lastStartAt = null;
        s.timers.B.lastStartAt = null;
        if(starter === "A"){ startRunningTimer(s.timers.A, _now); }
        if(starter === "B"){ startRunningTimer(s.timers.B, _now); }
        s.startDice = startDice; // always overwrite (no ||, avoids stale dice from previous game)
        s.stopped = { A: false, B: false };
        
        // === TERRAINS & VESTIAIRES ===
        s.terrains = { A: [], B: [] };
        s.vestiaires = { A: [], B: [] };
        
        // === SCORES ===
        s.scores = { A: 0, B: 0 };
        
        // === FLAGS ===
        s.enfantInitialized = true;
        // timestamp used as a watchdog (if the auto draw is missed, writer leader can retry)
        s.enfantInitializedAt = (typeof Date !== 'undefined') ? Date.now() : s.enfantInitializedAt;
        s.startHandDrawn = { A: false, B: false };
        s.phase3Done = false;
        s.phase3Pending = false;
        
        // === PLAYERS COUNTS ===
        s.players = s.players || { A: {}, B: {} };
        s.players.A = s.players.A || {};
        s.players.B = s.players.B || {};
        s.players.A.deckCount = deckA.length;
        s.players.B.deckCount = deckB.length;
        s.players.A.handCount = 0;
        s.players.B.handCount = 0;
        
        return s;
      }, 'init-enfant-room');
      
      console.log("✅ [INIT] Room initialisée avec succès");
      _log(`📊 [INIT] Decks A=${deckA.length}, B=${deckB.length}`);
      console.log(`🎲 [INIT] Premier joueur : ${starter}`);
      pushLog(`✅ Partie initialisée ! ${starter} commence`);
      
      // Lancer pioche de départ
      setTimeout(() => {
        drawStartHands();
      }, 500);
      
    } catch(e) {
      console.error("❌ [INIT] Erreur:", e);
      reportError(e, "initEnfantRoom");
      pushLog("❌ Erreur d'initialisation");
    }
    
    } finally {
      // Toujours réinitialiser le flag, même en cas d'erreur
      enfantInitInProgress = false;
    }
  }

  /**
   * 🃏 MODE ENFANT V5 : Pioche de départ (5 cartes pour A et B)
   * WRITER LEADER : Seul le joueur A exécute cette fonction
   * Appelée : Après initEnfantRoom() OU après startNewRound()
   */
  async function drawStartHands() {
    _log("🃏 [DRAW] Tentative de pioche de départ...");
    
    // Guard : Peut écrire avec writer leader ?
    if(!canWriteEnfant(true)) return;
    
    const st = roomState || initialRoomState();
    
    // Guard : Room initialisée ?
    if(!st.enfantInitialized) {
      
    _log("⏭️ [DRAW] Room pas encore initialisée");
      return;
    }
    
    // Guard : Déjà pioché ?
    if(st.startHandDrawn?.A && st.startHandDrawn?.B) {
      console.log("✅ [DRAW] Pioche déjà faite cette manche");
      return;
    }

    // Compat : certains flux (bouton "Nouvelle partie" historique) utilisent startDrawn + handPiles
    // et effectuent déjà la pioche initiale. Dans ce cas, ne surtout pas repiocher 5 cartes.
    if(st.startDrawn?.A && st.startDrawn?.B) {
      console.log("✅ [DRAW] Pioche déjà faite (startDrawn legacy)");
      // Aligner le flag enfant pour éviter toute tentative future
      try{
        await updateRoomState((s)=>{
          s.startHandDrawn = { A: true, B: true };
          return s;
        }, 'sync-startHandDrawn');
      }catch(_e){ console.warn('[DRAW] sync-startHandDrawn failed:', _e); }
      return;
    }
    
    _log("🃏 [DRAW] Pioche de 5 cartes pour A et B...");
    
    try {
      const drawRunId = makeActionId('draw');
      await updateRoomStateAction((s) => {
        if(s.startHandDrawInProgress){ s.__skipWrite=true; return s; }
        s.startHandDrawInProgress = true;
        s.startHandDrawRunId = drawRunId;

        // Double guard
        if(s.startHandDrawn?.A && s.startHandDrawn?.B) {
          console.log("⚠️ [DRAW] Double guard : déjà pioché");
          return s;
        }
        
        // S'assurer structures existent
        s.deckPiles = s.deckPiles || { A: [], B: [] };
        s.handPiles = s.handPiles || { A: [], B: [] };
        s.vestiaires = s.vestiaires || { A: [], B: [] };
        
        // DEBUG: Vérifier état avant pioche
        console.log(`🔍 [DEBUG] Avant pioche - Deck A: ${s.deckPiles.A.length}, Vest A: ${s.vestiaires.A.length}`);
        console.log(`🔍 [DEBUG] Avant pioche - Deck B: ${s.deckPiles.B.length}, Vest B: ${s.vestiaires.B.length}`);
        
        // MODE ENFANT : manche 1 = 5 cartes, puis 2 cartes à chaque nouvelle manche
        const rnd = Number(s.roundNumber || 1);
        const drawN = (rnd === 1) ? 5 : 2;
        console.log(`🃏 [DRAW] Manche ${rnd} — pioche de ${drawN} cartes`);

        // Helper : Piocher avec recyclage auto
        const drawWithRecycle = (player) => {
          const deck = s.deckPiles[player];
          const hand = s.handPiles[player];
          const vest = s.vestiaires[player];
          
          for(let i = 0; i < drawN; i++) {
            // Deck vide ? Recycler vestiaire
            if(deck.length === 0 && vest.length > 0) {
              console.log(`♻️ [DRAW] Deck ${player} vide, recyclage Vestiaire (${vest.length} cartes)`);
              const mixed = shuffleInPlace(vest.slice());
              deck.push(...mixed);
              vest.length = 0;
            }
            
            // Piocher
            if(deck.length > 0) {
              hand.push(deck.shift());
            } else {
              console.warn(`⚠️ [DRAW] ${player} ne peut plus piocher`);
              break;
            }
          }
        };
        
        // Piocher pour les joueurs encore actifs (si un joueur est hors temps, il ne pioche plus)
        ensureTimersShape(s);
        const lockA = !!(s.timers?.A?.locked);
        const lockB = !!(s.timers?.B?.locked);
        if(!lockA) drawWithRecycle('A');
        if(!lockB) drawWithRecycle('B');
        // Si un joueur est verrouillé, on considère sa pioche comme "faite" pour éviter des retries
        s.startHandDrawn = { A: true, B: true };
        
        // Marquer comme fait + libérer le verrou
        s.startHandDrawInProgress = false; // ✅ FIX : verrou permanent supprimé
        
        // Update counts
        s.players = s.players || { A: {}, B: {} };
        s.players.A = s.players.A || {};
        s.players.B = s.players.B || {};
        s.players.A.deckCount = s.deckPiles.A.length;
        s.players.B.deckCount = s.deckPiles.B.length;
        s.players.A.handCount = s.handPiles.A.length;
        s.players.B.handCount = s.handPiles.B.length;
        
        return s;
      }, 'draw-start-hands');
      
      const stAfter = roomState || initialRoomState();
      const rndAfter = Number(stAfter.roundNumber || 1);
      console.log("✅ [DRAW] Pioche terminée");
      _log(`📊 [DRAW] Mains : A=${stAfter.handPiles?.A?.length || 0}, B=${stAfter.handPiles?.B?.length || 0}`);
      const drawAfter = (rndAfter === 1) ? 5 : 2;
      pushLog(`🃏 Pioche manche ${rndAfter} : ${drawAfter} carte${drawAfter>1?'s':''} chacun`);
      
      // 📸 Snapshot début de tour pour le joueur qui commence la manche
      try {
        await updateRoomState((s) => {
          const snap = structuredClone(s);
          delete snap.turnStartSnapshot;
          s.turnStartSnapshot = snap;
          return s;
        }, 'turn-start-snapshot-draw');
      } catch(_e) {}
      
    } catch(e) {
      console.error("❌ [DRAW] Erreur:", e);
      reportError(e, "drawStartHands");
      // ✅ FIX : libérer le verrou même en cas d'erreur (sinon la pioche est bloquée définitivement)
      try {
        await updateRoomState((s)=>{ s.startHandDrawInProgress = false; return s; }, 'draw-start-hands-release');
      } catch(_e) {}
    }
  }

  async function drawToHand(n){
    const st0 = roomState || initialRoomState();
    const slot = mySlotFromState(st0);
    if(!slot){
      pushLog('⚠️ Spectateur: pioche impossible');
      return;
    }

    try{
      // Utilise la version DB (gère le recyclage vestiaire → deck si deck vide)
      await drawToHandDb(slot, n);

      // Resync local piles depuis l'état DB (évite les désynchronisations)
      const st = roomState || initialRoomState();
      myDeckPile = (st.deckPiles && Array.isArray(st.deckPiles[slot])) ? st.deckPiles[slot].slice() : [];
      myHandPile = (st.handPiles && Array.isArray(st.handPiles[slot])) ? st.handPiles[slot].slice() : [];
      if(st.vestiaires && Array.isArray(st.vestiaires[slot])) gameState.myVestiaire = st.vestiaires[slot].slice();

      updateHandUI();
      updateAllZoneCounters();
      updateLocalUI();
    }catch(e){
      reportError(e,'drawToHand');
    }
  }

  function updateHandUI(){
    // Met à jour le bouton flottant avec le nombre de cartes
    if(handFloatingCount) safeText(handFloatingCount, myHandPile.length);
    
    // Affiche/cache le bouton flottant selon l'état de la partie
    if(handFloatingBtn){
      // UX: keep the Hand button available whenever the game is in a playable phase,
      // even if the hand is empty (effects can move cards to Vestiaire).
      const st = (typeof roomState !== 'undefined' && roomState) ? roomState : null;
      const playablePhase = !!(st && (st.phase === 'started' || st.phase === 'phase3_manual'));
      const shouldShow = !!(gameStarted && playablePhase);

      // Keep the existing class toggle (used by CSS), but also force display via inline style.
      // Some mobile landscape CSS rules may hide the button; inline !important ensures it stays accessible.
      if(shouldShow){
        handFloatingBtn.classList.add("visible");
        try{ handFloatingBtn.style.setProperty('display','flex','important'); }catch(_e){}
      } else {
        handFloatingBtn.classList.remove("visible");
        try{ handFloatingBtn.style.removeProperty('display'); }catch(_e){}
      }
    }

    // Met à jour le compteur de cartes dans le deck
    updateDeckUI();

    // Compteurs main/deck sont synchronisés via roomState (handPiles/deckPiles)
  }
  // === UX: ensure floating Hand button remains visible & on-screen on mobile rotation/resize ===
  function __forceHandFloatingVisible(){
    try{
      if(!handFloatingBtn) return;
      handFloatingBtn.classList.add('visible');
      handFloatingBtn.style.setProperty('display','flex','important');
      handFloatingBtn.style.setProperty('visibility','visible','important');
      handFloatingBtn.style.setProperty('opacity','1','important');
      handFloatingBtn.style.setProperty('pointer-events','auto','important');
    }catch(_e){}
  }

  function __ensureHandFloatingOnscreen(){
    try{
      if(!handFloatingBtn) return;
      // Make sure it's measurable (some landscape CSS may hide it)
      __forceHandFloatingVisible();
      const rect = handFloatingBtn.getBoundingClientRect();
      const vw = Math.max(1, window.innerWidth || document.documentElement.clientWidth || 1);
      const vh = Math.max(1, window.innerHeight || document.documentElement.clientHeight || 1);
      const margin = 8;

      const defaultX = vw - 80;
      const defaultY = (vh / 2) - (rect.height ? rect.height/2 : 35);

      // Current inline position (preferred)
      let x = parseFloat(handFloatingBtn.style.left);
      let y = parseFloat(handFloatingBtn.style.top);

      // If no inline position, use default
      if(!Number.isFinite(x)) x = defaultX;
      if(!Number.isFinite(y)) y = defaultY;

      // If clearly offscreen, reset to default
      const offscreen = (rect.width === 0 || rect.height === 0 ||
                         rect.right < margin || rect.left > (vw - margin) ||
                         rect.bottom < margin || rect.top > (vh - margin));

      if(offscreen){
        x = defaultX;
        y = defaultY;
      }

      // Clamp to viewport
      const w = rect.width || 70;
      const h = rect.height || 70;
      x = Math.min(Math.max(x, margin), vw - w - margin);
      y = Math.min(Math.max(y, margin), vh - h - margin);

      handFloatingBtn.style.left = x + 'px';
      handFloatingBtn.style.top = y + 'px';
      handFloatingBtn.style.right = 'auto';
      handFloatingBtn.style.bottom = 'auto';

      // Persist (so it doesn't vanish after refresh)
      try{ localStorage.setItem('handButtonPos', JSON.stringify({x, y})); }catch(_e){}
    }catch(_e){}
  }
  function updateDeckUI(){
    // Met à jour le compteur de cartes dans le deck du joueur
    const myDeckCount = $("myDeckCount");
    if(myDeckCount){
      safeText(myDeckCount, myDeckPile.length > 0 ? myDeckPile.length : "—");
    }
  }

  function renderHandCards(){
    // Affiche les cartes de la main
    if(!handCardsContainer) return;
    handCardsContainer.innerHTML = "";
    
    if(myHandPile.length === 0){
      const empty = document.createElement("div");
      empty.style.padding = "20px";
      empty.style.textAlign = "center";
      empty.style.opacity = "0.7";
      empty.textContent = "Aucune carte en main";
      handCardsContainer.appendChild(empty);
      return;
    }

    for(const cardTok of myHandPile){
      const card = cardByToken(cardTok);
      const cardId = getCid(cardTok);
      if(!card) continue;
      
      const div = document.createElement("div");
      div.className = "handCard";
      div.dataset.tok = cardTok; // allow hand reorder (long-press drag)
      div.style.cursor = "pointer";

	    // MODE ENFANT : "art only" (toutes les infos sont sur l'illustration)
	    const isEnfant = (typeof GAME_MODE !== "undefined" && GAME_MODE === "enfant") || (roomState && roomState.gameMode === "enfant");
	    if(isEnfant){
	      div.classList.add("enfantArtOnly");
	      const art = document.createElement('div');
	      art.className = 'cardArt';
	      const img = document.createElement('img');
	      img.alt = card.name || '';
	      img.loading = 'lazy';
	      img.decoding = 'async';
	      const s = safeImageSrc(card.image || '');
	      img.src = s || '/assets/cards/placeholder.jpg';
	      img.onerror = () => { img.onerror = null; img.src = '/assets/cards/placeholder.jpg'; };
	      
	      // 🔧 CORRECTION: Empêcher tout événement sur l'image elle-même
	      img.style.pointerEvents = 'none';
	      img.style.touchAction = 'none';
	      img.style.userSelect = 'none';
	      img.style.webkitUserSelect = 'none';
	      
	      art.appendChild(img);
	      div.appendChild(art);

	      // MODE ENFANT — Interactions main:
	      // - Tap/click: ouvre le menu carte
	      // - Long-press + drag: réordonne la main (géré par hand-reorder.js)
	      // IMPORTANT: on ne met PAS de long-press ici, sinon ça "mange" le drag.
	      div.addEventListener('click', (e) => {
	        // hand-reorder.js bloque le click après un drag (capture)
	        openCardModal(cardTok, 'myHand');
	      });
	      
	      // Preview hover (desktop seulement)
	      div.onmouseenter = (e) => {
	        if(!('ontouchstart' in window)){
	          if(typeof showCardPreview === 'function') showCardPreview(card, e);
	        }
	      };
	      div.onmouseleave = () => {
	        if(!('ontouchstart' in window)){
	          if(typeof hideCardPreview === 'function') hideCardPreview();
	        }
	      };
	      
	      handCardsContainer.appendChild(div);
	      continue;
	    }
      
      // Coût
      if(card.cost != null){
        const costDiv = document.createElement("div");
        costDiv.className = "card-cost";
        costDiv.textContent = card.cost;
        div.appendChild(costDiv);
      }
      

      // Illustration (si disponible)
      if(card.image){
        const s = safeImageSrc(card.image);
        if(s){
          const artDiv = document.createElement("div");
          artDiv.className = "cardArt";
          artDiv.style.backgroundImage = `url("${s.replace(/"/g,'\\\"')}")`;
          div.appendChild(artDiv);
        }
      }

      // Nom
      const nameLabel = document.createElement("div");
      nameLabel.className = "cardName";
      nameLabel.textContent = card.name || "???";
      div.appendChild(nameLabel);
      
      // Type
      if(card.type){
        const typeLabel = document.createElement("div");
        typeLabel.className = "cardType";
        typeLabel.textContent = card.type;
        div.appendChild(typeLabel);
      }
      
      // Sous-types
      if(card.subtypes && card.subtypes.length > 0){
        const subtypesLabel = document.createElement("div");
        subtypesLabel.className = "cardSubtypes";
        subtypesLabel.textContent = card.subtypes.join(' ');
        div.appendChild(subtypesLabel);
      }
      
      // Texte (raccourci)
      if(card.text){
        const textLabel = document.createElement("div");
        textLabel.className = "cardText";
        const shortText = card.text.length > 60 ? card.text.substring(0, 60) + '...' : card.text;
        textLabel.textContent = shortText;
        div.appendChild(textLabel);
      }
      
      // CLIC POUR OUVRIR LE MODAL DE CARTE (onclick au lieu de addEventListener)
      div.onclick = () => openCardModal(cardTok, 'myHand');
      
      handCardsContainer.appendChild(div);
    }
  }
  
  // Fonction pour jouer une créature depuis la main
  async function playCreatureFromHand(cardTok, card){
    // 🏆 GUARD : Partie terminée
    if(gameEnded){
      showToast("⏸️ La partie est terminée");
      return;
    }
    
    const cardId = getCid(cardTok);
    // Vérifier qu'on peut payer (UI peut être légèrement en retard, la DB reste autorité)
    if(card.cost != null && gameState.myActionDie < card.cost){
      pushLog(`❌ Pas assez de points d'action`);
      return;
    }

    const st0 = roomState || initialRoomState();
    const slot = mySlotFromState(st0);
    if(!slot) return;

    // 🎯 MODE ENFANT : si la carte a un effet, demander AVANT de la jouer.
    let enfantEffectChoice = "yes"; // yes = jouer + effet
    const isEnfant = (typeof GAME_MODE !== "undefined" && GAME_MODE === "enfant");
    const effectIdPre = (card && card.effectId) ? String(card.effectId) : "";
    if(isEnfant && effectIdPre && effectIdPre !== "E_NONE"){
      enfantEffectChoice = await showChoiceModal({
        title: "Activer cet effet ?",
        body: (card?.name ? (card.name + "\n\n") : "") + (card?.text || ""),
        buttons: [
          {key:"cancel", label:"Annuler"},
          {key:"no", label:"Non"},
          {key:"yes", label:"Oui"}
        ]
      });

      if(enfantEffectChoice === "cancel"){
        pushLog(`↩️ ${card?.name || "Carte"} : action annulée`);
        return;
      }
    }

    // 🔧 FIX carte infinie : retirer de myHandPile LOCAL *avant* updateRoomState (optimiste)
    // Sinon un realtime sync pendant le write peut réinjecter la carte
    const localHandIdx = myHandPile.indexOf(cardTok);
    if(localHandIdx >= 0) {
      myHandPile.splice(localHandIdx, 1);
      __handWriteAt = Date.now(); // guard against realtime overwrite during DB write
      // 🔧 Rafraîchir l'UI IMMÉDIATEMENT pour que la carte disparaisse visuellement
      renderHandCards();
    }
    
    try{
      await updateRoomState((s) => {
        // Piles
        s.handPiles = s.handPiles || { A: [], B: [] };
        s.deckPiles = s.deckPiles || { A: [], B: [] };
        const hand = Array.isArray(s.handPiles[slot]) ? s.handPiles[slot] : [];

        const idx = hand.indexOf(cardTok);
        if(idx === -1) { s.__skipWrite = true; return s; } // déjà joué/retiré (idempotent)
        hand.splice(idx, 1);
        s.handPiles[slot] = hand;

        // Terrains
        if(!s.terrains) s.terrains = { A: [], B: [] };
        if(!s.terrains[slot]) s.terrains[slot] = [];
        s.terrains[slot].push({ 
          inst: cardTok, 
          cardId: cardId,
          originalCardId: cardId, // CRITIQUE: stocker l'ID original pour transformations multiples
          tapped: false,
          counters: { pass: 0, charge: 0, time: 0 },
          note: ''
        });

        // Dé d'actions (DB autorité)
        if(card && card.cost != null){
          s.actionDice = s.actionDice || { A: 0, B: 0 };
          s.actionDice[slot] = Math.max(0, (s.actionDice[slot] || 0) - Number(card.cost));
        }

        // Counts
        if(s.players && s.players[slot]){
          s.players[slot].handCount = (s.handPiles[slot] || []).length;
          s.players[slot].deckCount = (s.deckPiles[slot] || []).length;
        }

        return s;
      }, "play-creature");

      // Logger
      pushLog(`✅ ${slotLabel(mySlotFromState(roomState))} ${card?.name || cardId} joué sur Terrain`);
      pushActivity(`${slotLabel(mySlotFromState(roomState))} a joué ${escapeHtml(card?.name || String(cardId))}`);

      // ✅ PATCH 1 : fermer le modal dès la carte écrite en DB, avant la chaîne d'effets
      try { closeCardModal(); } catch(_e) {}

      // 🎯 MODE ENFANT : après avoir joué une créature, le tour doit passer automatiquement.
      // - Si la carte a un effet : triggerCardEffect gère Oui/Non + la résolution + le passage de tour.
      // - Si la carte n'a PAS d'effet : on passe le tour ici.
      try{
        const isEnfant2 = (typeof GAME_MODE !== "undefined" && GAME_MODE === "enfant");
        if(isEnfant2){
          const effectId = (card && card.effectId) ? String(card.effectId) : "";
          if(effectId && effectId !== "E_NONE"){
            if(enfantEffectChoice === "yes"){
              const stNow = roomState || initialRoomState();
              const slotNow = mySlotFromState(stNow);
              // CRITIQUE: cardTok de la main n'est pas l'inst, chercher le vrai inst dans le terrain
              const terrain = stNow.terrains?.[slotNow] || [];
              const lastCreature = terrain[terrain.length - 1]; // La dernière créature ajoutée
              const actualToken = (lastCreature?.cardId === cardId && lastCreature?.inst) ? lastCreature.inst : cardTok;
              await triggerCardEffect(cardId, slotNow, actualToken); // résout + passe le tour
            } else {
              pushLog(`🚫 ${card?.name || cardId} : effet ignoré`);
              await autoPassTurn(slot);
            }
          } else {
            await autoPassTurn(slot);
          }
        }
      }catch(e){ /* silent */ }
      // 🔧 Double-check : si la carte est encore dans myHandPile, la retirer de force
      const stillInHand = myHandPile.indexOf(cardTok);
      if(stillInHand >= 0){
        console.warn('[PLAY] ⚠️ Carte encore en main après DB write, retrait forcé');
        myHandPile.splice(stillInHand, 1);
      }
      __handWriteAt = 0; // release guard — DB write is done
      
      // Rafraîchir UI (les piles seront resynchronisées depuis roomState)
      renderHandCards();
      updateHandUI();
      updateAllZoneCounters();
    }catch(e){
      __handWriteAt = 0; // release guard on error too
      reportError(e, "play-creature");
    }
  }

  async function syncHandCountToRoom(){
    // Protection : vérifier connexion
    if (!connected || !sb || !roomCodeActive) return;
    
    // Synchronise le nombre de cartes en main ET dans le deck (pas le contenu) via roomState
    try{
      const st = roomState || initialRoomState();
      const slot = mySlotFromState(st);
      if(!slot) return;
      
      await updateRoomState((s) => {
        if(!s.players?.[slot]) return s;
        s.players[slot].handCount = myHandPile.length;
        s.players[slot].deckCount = myDeckPile.length;
        return s;
      }, "sync-counts");
    }catch(e){
      // Silent fail - pas critique
    }
  }

  async function handleStartFromDb(){
    // Applique localement le démarrage lorsqu'on voit roomState.phase === "started".
    // La DB est la source de vérité pour starter + dés.
    try{
      const st = roomState || initialRoomState();
      if(st.phase !== "started") return;

      startRollA = st.startDice?.A ?? st.dice?.A ?? null;
      startRollB = st.startDice?.B ?? st.dice?.B ?? null;
      starter = st.starter || null;
      gameStarted = true;
      
      // Note: gamePhase, roundNumber, currentPlayer sont maintenant dans roomState
      // et synchronisés automatiquement via applyRoomStateToUI

      const aTxt = Number.isFinite(startRollA) ? startRollA : "—";
      const bTxt = Number.isFinite(startRollB) ? startRollB : "—";
      const sTxt = starter ? `${starter} commence` : "starter ?";
      setDiceUI(`A:${aTxt} B:${bTxt} — ${sTxt}`);

      // Initialiser piles privées en DB (deck/hand) si besoin, puis pioche de départ via DB
      const slot = mySlotFromState(roomState || initialRoomState());
      if(slot){
        // MODE ENFANT : la pioche de départ est gérée par initEnfantRoom() + drawStartHands()
        // (writer leader A pioche pour A et B). Il ne faut PAS repiocher ici via startDrawn.
        const isEnfant = (typeof GAME_MODE !== "undefined" && GAME_MODE === "enfant");
        if(isEnfant){
          pushLog('🎬 Début de partie: ' + (starter || '?') + ' commence.');
          return;
        }

        const stNow = roomState || initialRoomState();
        const hasPiles = !!(stNow.deckPiles && stNow.handPiles && Array.isArray(stNow.deckPiles[slot]) && Array.isArray(stNow.handPiles[slot]));
        if(!hasPiles && Array.isArray(validatedDeckIds) && validatedDeckIds.length){
          // Va écrire deck/hand + chef + basePA en DB
          await buildLocalPilesFromValidated().catch(e => reportError(e, "buildLocalPiles"));
        }

        // Pioche de départ : ATOMIQUE en DB (évite la double pioche si 2 clients croient être le même slot)
        // Note: on ne peut pas se baser uniquement sur le check local roomState.startDrawn[slot] car il peut être stale.
        try{
          let drew = 0;
          await updateRoomState((s)=>{
            const sl = slot;
            s.startDrawn = s.startDrawn || {A:false,B:false};
            s.deckPiles = s.deckPiles || {A:[],B:[]};
            s.handPiles = s.handPiles || {A:[],B:[]};
            s.players = s.players || {A:{},B:{}};

            // Normal: si déjà pioché, on ne repioche pas.
            // MAIS: après "Nouvelle partie" (restart) ou un désync rare, on peut se retrouver avec
            // startDrawn=true alors que la main est vide. Dans ce cas, on autorise une réparation:
            // piocher seulement si la main est vide (évite toute double-pioche).
            const existingHand = Array.isArray(s.handPiles?.[sl]) ? s.handPiles[sl] : [];
            if(s.startDrawn[sl] && existingHand.length > 0){
              drew = 0;
              return s;
            }

            // Marque AVANT de déplacer des cartes
            s.startDrawn[sl] = true;

            const deck = Array.isArray(s.deckPiles[sl]) ? s.deckPiles[sl] : [];
            const hand = Array.isArray(s.handPiles[sl]) ? s.handPiles[sl] : [];
            for(let i=0;i<5;i++){
              if(deck.length === 0) break;
              hand.push(deck.shift());
              drew++;
            }
            s.deckPiles[sl] = deck;
            s.handPiles[sl] = hand;
            if(s.players?.[sl]){
              s.players[sl].handCount = hand.length;
              s.players[sl].deckCount = deck.length;
            }
            return s;
          }, 'start-draw-atomic');

          if(drew > 0){
            addToHistory("Avant début de partie");
            updateHandUI();
            updateAllZoneCounters();
            pushLog(`📥 Pioché ${drew} carte(s)`);
          }
          pushLog('🎬 Début de partie: ' + (starter || '?') + ' commence.');
        } catch(e){
          reportError(e, 'start-draw');
        }
      } else {
        pushLog('🎬 Début de partie: ' + (starter || '?') + ' commence.');
      }
    }catch(e){
      reportError(e, "handleStartFromDb");
    }
  }

  function updateMidMenuControls(){
    // Source de vérité : roomState (DB). Pas de présence / maps pour l'état de partie.
    try{
      const st = roomState || initialRoomState();
      const mySlot = mySlotFromState(st); // "A" | "B" | null
      const canPlayLocal = !!mySlot;

      const aReady = !!st.players?.A?.ready;
      const bReady = !!st.players?.B?.ready;
      setReadyUI(aReady, bReady);

      const bothDeckOk = !!st.players?.A?.deckOk && !!st.players?.B?.deckOk;
      const myDeckOk = mySlot ? !!st.players?.[mySlot]?.deckOk : false;

      // Dice status (affichage simple)
      const da = st.startDice?.A ?? st.dice?.A ?? null;
      const db = st.startDice?.B ?? st.dice?.B ?? null;
      if(Number.isFinite(da) || Number.isFinite(db)){
        setDiceUI(`A:${Number.isFinite(da)?da:"—"}  B:${Number.isFinite(db)?db:"—"}`);
      }else{
        setDiceUI("—");
      }

      if(readyBtn){
        // Prêt autorisé si connecté + deck prêt (local OU remote)
        const isDeckReady = localDeckReady || myDeckOk;
        readyBtn.disabled = (!connected || !isDeckReady || (st.phase === "started"));
        readyBtn.title = readyBtn.disabled
          ? (connected ? "Importe ton deck pour être prêt." : "Connecte-toi d'abord.")
          : "";
      }

      if(rollBtn){
        // Dé autorisé si connecté + A/B (même en lobby)
        rollBtn.disabled = (!connected || !canPlayLocal);
      }
    }catch(e){
      reportError(e,"updateMidMenuControls");
    }
  }

  const setupFlowNote = $("setupFlowNote");
  const gameFlowNote = $("gameFlowNote");

  let myReady = false;

  function setReadyUI(aReady, bReady){
    safeText(readyAEl, aReady ? "Oui" : "—");
    safeText(readyBEl, bReady ? "Oui" : "—");
  }
  function setDiceUI(txt){
    safeText(diceStatusEl, txt || "—");
  }

  function lockSetup(isLocked){
    const lock = !!isLocked;
    const lockIds = ["roomInput","loadCardsBtn","cardsFile","decklistInput","importDeckBtn","sbUrlInput","sbKeyInput","saveConfigBtn","resetConfigBtn"];
    for(const id of lockIds){
      const el = $(id);
      if(!el) continue;
      // keep Supabase config editable even if locked? we'll lock for safety as requested
      el.disabled = lock;
    }
      }

  function updateFlowNote(txt){
    if(setupFlowNote) setupFlowNote.textContent = txt;
    if(gameFlowNote) gameFlowNote.textContent = txt;
  }
  // Ready button label sync (must be in global scope; used by applyRoomStateToUI)
  function syncBtnLabel(){
    try{
      if(!readyBtn) return;
      readyBtn.textContent = myReady ? "Je ne suis plus prêt" : "Je suis prêt";
    }catch(e){ /* noop */ }
  }

  if(readyBtn){
    syncBtnLabel();
    readyBtn.onclick = async () => {
      try{
        if(!connected) return;
        const st = roomState || initialRoomState();
        let slot = mySlotFromState(st);
        
        // Si pas de slot, essayer de claim un automatiquement
        if(!slot){
          try {
            await claimAutoSlot();
            // Recharger l'état après claim
            const freshSt = roomState || initialRoomState();
            slot = mySlotFromState(freshSt);
            if(!slot){
              alert("Room pleine : vous êtes spectateur.");
              return;
            }
          } catch(e) {
            pushLog("Erreur lors de l'assignation du slot");
            reportError(e, "claimSlot");
            return;
          }
        }
        
        // verrouillage: on ne peut être prêt que si MON deck est OK (local ou remote)
        const myDeckOk = !!st.players?.[slot]?.deckOk;
        const isDeckReady = localDeckReady || myDeckOk;
        if(!isDeckReady){
          pushLog("Impossible: ton deck doit être validé (vert) avant d'être prêt.");
          return;
        }
        
        // Mettre à jour le deckOk dans roomState si on l'a seulement localement
        if(localDeckReady && !myDeckOk){
          await updateRoomState((s) => {
            if(s.players?.[slot]){
              s.players[slot].deckOk = true;
            }
            return s;
          }, "deck-sync");
        }
        
        const next = !st.players?.[slot]?.ready;
        await updateRoomState((s) => {
          const p = s.players?.[slot];
          if(!p || p.id !== selfId) return s;
          p.ready = next;
          return s;
        }, "toggle-ready");
        pushLog(next ? "Je suis prêt" : "Je ne suis plus prêt");
      }catch(e){
        reportError(e,"ready");
      }
    };
  }

  // Bouton "À toi" (passer le tour)
  const endTurnBtn = $("endTurnBtn");
  if(endTurnBtn){
    endTurnBtn.onclick = async () => {
      if(!connected) {
        pushLog("⚠️ Pas connecté");
        return;
      }
      const st = roomState || initialRoomState();
      const slot = mySlotFromState(st);
      if(!slot) {
        pushLog("⚠️ Tu es spectateur");
        return;
      }
      if(getTurnPlayer(st) !== slot) {
        pushLog("⚠️ Ce n'est pas ton tour");
        return;
      }
      
const isEnfant = (typeof GAME_MODE !== "undefined" && GAME_MODE === "enfant");
if(isEnfant){
  pushLog("ℹ️ Enfant: le bouton 'À toi' n'est pas utilisé (automatique).");
  showToast("Enfant: le tour passe automatiquement", "info");
  return;
}

// Passer le tour à l'adversaire via roomState
const nextPlayer = slot === "A" ? "B" : "A";
await updateRoomState((s) => {
  s.currentPlayer = nextPlayer;
  return s;
}, "pass-turn");

pushLog(`✋ Tour passé à ${nextPlayer}`);
};
  }

  // Bouton "Annuler"
  const undoBtn = $("undoBtn");
  if(undoBtn){
    undoBtn.onclick = () => {
      undoPhaseStepDb();
    };
  }

  // Bouton "Je m'arrête" (Mode enfant: bouton unique dans la barre au-dessus de la main)
  async function handleStopAction(){
      _log("🛑 'Je m'arrête' cliqué");
      
      // 🏆 GUARD : Partie terminée
      if(gameEnded){
        showToast("⏸️ La partie est terminée");
        return;
      }
      
      if(!connected) {
        pushLog("⚠️ Pas connecté");
        return;
      }
      
      // ✅ MODE ENFANT V5 : Appel simple à playerStops()
      const isEnfant = (typeof GAME_MODE !== "undefined" && GAME_MODE === "enfant");
      if(isEnfant) {
        await playerStops();
        return;
      }
      
      // ===== MODE COMPLEXE (Code original conservé) =====
      const st = roomState || initialRoomState();
      const slot = mySlotFromState(st);
      
      if(!slot) {
        pushLog("⚠️ Tu es spectateur");
        return;
      }
      
      if(st.phase !== "started"){
        pushLog(`⚠️ Pas en phase de jeu (phase actuelle: ${st.phase})`);
        return;
      }
      
      if(st.passes && st.passes[slot]){
        pushLog("⚠️ Tu as déjà passé cette manche");
        return;
      }
      await pushPhaseHistory('Avant Fin Phase 2');
      
      
      await updateRoomState((s) => {
        if(!s.passes) s.passes = { A: false, B: false };
        s.passes[slot] = true;
        
        const otherSlot = slot === "A" ? "B" : "A";
        s.currentPlayer = otherSlot;
        
        // Si les 2 ont passé → Phase 3 AUTO
        if(s.passes.A && s.passes.B){
          const sumPoints = (arr) => {
            let total = 0;
            for(const tok of (Array.isArray(arr)?arr:[])){
              let cid = null;
              try{
                cid = (typeof getCid === 'function' && isInstanceToken(tok)) ? getCid(tok) : (tok.cardId || tok.cid || tok);
              }catch(_e){
                cid = tok.cardId || tok.cid || tok;
              }
              if(cid != null){
                const c = cardsById.get(String(cid).padStart(3,'0'));
                const pts = Number(c?.points ?? 0) || 0;
                const asleep = !!tok.tapped;
                if(!asleep) total += pts;
              }
            }
            return total;
          };

          const ptsA = sumPoints(s.terrains?.A);
          const ptsB = sumPoints(s.terrains?.B);

          if(!s.bubbles) s.bubbles = { A:{state:'',occurrences:0}, B:{state:'',occurrences:0} };
          s.bubbles.A.occurrences = Number(s.bubbles.A.occurrences||0) + ptsA;
          s.bubbles.B.occurrences = Number(s.bubbles.B.occurrences||0) + ptsB;

          // Nettoyage terrains -> vestiaires (RESET FLIP: utiliser originalCardId)
          if(!s.vestiaires) s.vestiaires = {A:[],B:[]};
          if(!s.terrains) s.terrains = {A:[],B:[]};
          // Pour chaque carte du terrain → vestiaire : conserver l'instance (iid) mais remettre en recto
          // (Les flips sont un état "terrain" uniquement.)
          const pushToVestiaire = (slotKey, entry) => {
            if(!entry) return;
            // entry may be an object ({inst, cardId, originalCardId}) or a token string
            const tok = (entry && typeof entry === 'object' && entry.inst) ? entry.inst : entry;
            if(!tok) return;
            const frontCid = (entry && typeof entry === 'object' && (entry.originalCardId || entry.cardId))
              ? (entry.originalCardId || entry.cardId)
              : null;
            s.vestiaires[slotKey].push(normalizeTokenToFront(tok, frontCid));
          };

          for (const c of (s.terrains.A || [])) pushToVestiaire('A', c);
          for (const c of (s.terrains.B || [])) pushToVestiaire('B', c);

          s.terrains.A = [];
          s.terrains.B = [];

          // Reset passes
          s.passes = {A:false,B:false};

          // Victoire ?
          const winA = (s.bubbles.A.occurrences||0) >= 12;
          const winB = (s.bubbles.B.occurrences||0) >= 12;
          if(winA || winB){
            s.phase = "ended";
            s.result = { A: winA ? "win" : "lose", B: winB ? "win" : "lose" };
            s.currentPlayer = null;
          } else {
            // Nouvelle manche
            s.roundNumber = Number(s.roundNumber||0) + 1;

            // Alterner le starter
            if(s.starter === "A") s.starter = "B";
            else if(s.starter === "B") s.starter = "A";
            else s.starter = (Math.random() < 0.5 ? "A" : "B");
            s.currentPlayer = s.starter;

            // Pioche 5 pour A et B (chaque manche)
            const drawN = 5;
            s.deckPiles = s.deckPiles || {A:[],B:[]};
            s.handPiles = s.handPiles || {A:[],B:[]};
            for(const sl of ["A","B"]){
              // Si deck vide, reformer automatiquement depuis vestiaire
              if((s.deckPiles[sl]||[]).length === 0 && (s.vestiaires[sl]||[]).length > 0){
                const v = s.vestiaires[sl].slice();
                const mixed = shuffleInPlace(v.slice());
                s.deckPiles[sl] = mixed;
                s.vestiaires[sl] = [];
              }
              const d = s.deckPiles[sl] || [];
              const h = s.handPiles[sl] || [];
              for(let i=0;i<drawN;i++){
                if(!d.length) break;
                h.push(d.shift());
              }
              s.deckPiles[sl] = d;
              s.handPiles[sl] = h;
            }

            // MAJ compteurs publics
            if(s.players){
              s.players.A.handCount = (s.handPiles.A||[]).length;
              s.players.B.handCount = (s.handPiles.B||[]).length;
              s.players.A.deckCount = (s.deckPiles.A||[]).length;
              s.players.B.deckCount = (s.deckPiles.B||[]).length;
            }

            s.phase = "started";
          }
        }
        return s;
      }, "end-phase2");
      
      // 🎯 Mettre à jour la piste de score visuelle
      if(typeof updateScoreTrack === 'function') updateScoreTrack();
      
      // Message de log adapté
      const updatedSt = roomState || initialRoomState();
      const otherSlot = slot === "A" ? "B" : "A";
      
      if(updatedSt.passes && updatedSt.passes.A && updatedSt.passes.B){
        pushLog(`🎯 Phase 3 : Les 2 joueurs ont fini la phase de jeu`);
      } else {
        pushLog(`⏭️ ${slot} a terminé la phase de jeu. En attente de l'adversaire...`);
      }
  }

  // Legacy button (si présent dans d'anciens index) + bouton principal dans la barre de main
  const endPhase2Btn = $("endPhase2Btn");
  if(endPhase2Btn) endPhase2Btn.onclick = handleStopAction;

  const handStopBtn = $("handStopBtn");
  if(handStopBtn) handStopBtn.onclick = (e)=>{
    try{ e&&e.preventDefault&&e.preventDefault(); e&&e.stopPropagation&&e.stopPropagation(); e&&e.stopImmediatePropagation&&e.stopImmediatePropagation(); }catch(_e){}
    try{ if(window.__armUiShield) window.__armUiShield(450); }catch(_e){}
    handleStopAction();
    return false;
  };
  
  // 🔧 CORRECTION: Ajouter l'événement pour myStopBtn (nouveau bouton bulle)
  const myStopBtn = $("myStopBtn");
  if(myStopBtn) {
    const handleStopClick = (e) => {
      try{ e&&e.preventDefault&&e.preventDefault(); e&&e.stopPropagation&&e.stopPropagation(); e&&e.stopImmediatePropagation&&e.stopImmediatePropagation(); }catch(_e){}
      try{ if(window.__armUiShield) window.__armUiShield(450); }catch(_e){}
      handleStopAction();
      return false;
    };
    
    // 🔧 Utiliser plusieurs méthodes pour s'assurer que ça fonctionne
    myStopBtn.onclick = handleStopClick;
    myStopBtn.addEventListener('click', handleStopClick);
    myStopBtn.addEventListener('touchend', (e) => {
      e.preventDefault();
      e.stopPropagation();
      handleStopClick(e);
    }, {passive: false});
  }

  // 🔄 Bouton "Annuler mes actions" — retour au début du tour
  const myUndoBtn = $("myUndoBtn");
  if(myUndoBtn) {
    let __undoLastFire = 0;
    const handleUndoClick = (e) => {
      console.log('[UNDO] ✅ handleUndoClick APPELÉ', e.type);
      try{ e&&e.preventDefault&&e.preventDefault(); e&&e.stopPropagation&&e.stopPropagation(); e&&e.stopImmediatePropagation&&e.stopImmediatePropagation(); }catch(_e){}
      // Debounce 400ms : touchend + click arrival pair → un seul fire
      const now = performance.now();
      if(now - __undoLastFire < 400) return;
      __undoLastFire = now;
      try{ if(window.__armUiShield) window.__armUiShield(450); }catch(_e){}
      undoToTurnStart();
      return false;
    };
    
    // 🔧 Utiliser plusieurs méthodes (même pattern que stop button)
    myUndoBtn.onclick = handleUndoClick;
    myUndoBtn.addEventListener('click', handleUndoClick);
    myUndoBtn.addEventListener('touchend', (e) => {
      e.preventDefault();
      e.stopPropagation();
      handleUndoClick(e);
    }, {passive: false});
  }

  /**
   * 📸 Annuler toutes les actions depuis le début du tour actuel.
   * Restaure le turnStartSnapshot sauvegardé quand le tour a passé.
   */
  async function undoToTurnStart() {
    console.log('[UNDO] Bouton undo cliqué');
    
    // Guard 1 : connecté ?
    if(!connected){ 
      console.log('[UNDO] ❌ Bloqué : pas connecté');
      showToast("⚠️ Pas connecté"); 
      return; 
    }
    console.log('[UNDO] ✅ Connecté');
    
    const st = roomState || initialRoomState();
    const mySlot = mySlotFromState(st);
    console.log('[UNDO] mySlot:', mySlot, 'activePlayer:', st.activePlayer);

    // Guard 2 : mon tour ?
    if(st.activePlayer !== mySlot){ 
      console.log('[UNDO] ❌ Bloqué : pas mon tour');
      showToast("⚠️ Ce n'est pas ton tour"); 
      return; 
    }
    console.log('[UNDO] ✅ Mon tour');
    
    // Guard 3 : snapshot existe ?
    if(!st.turnStartSnapshot){ 
      console.log('[UNDO] ❌ Bloqué : pas de snapshot');
      showToast("⚠️ Rien à annuler"); 
      return; 
    }
    console.log('[UNDO] ✅ Snapshot existe');
    
    // Guard 4 : effet en cours ?
    if(st.pendingEffect){ 
      console.log('[UNDO] ❌ Bloqué : effet en cours');
      showToast("Résous l'effet en cours d'abord 🙂"); 
      return; 
    }
    console.log('[UNDO] ✅ Pas d\'effet en cours');

    // Pas de confirm() : cassé dans async sur iOS Safari.
    // Le bouton ↩ est déjà petit et intentionnel — un toast post-undo suffit.

    console.log('[UNDO] 🔄 Tentative de restauration...');
    try {
      await updateRoomState((s) => {
        if(!s.turnStartSnapshot) return s;
        const restored = structuredClone(s.turnStartSnapshot);
        // Garder le même snapshot pour permettre un 2e undo si le joueur rejue puis se trompe
        restored.turnStartSnapshot = s.turnStartSnapshot;
        return restored;
      }, 'undo-to-turn-start');

      console.log('[UNDO] ✅ Restauration réussie');
      pushLog("↩️ Actions annulées — retour début de tour");
      showToast("↩️ Actions annulées");
      if(typeof applyRoomStateToUI === 'function') applyRoomStateToUI("undo");
    } catch(e) {
      console.error('[UNDO] ❌ Erreur:', e);
      reportError(e, "undoToTurnStart");
      showToast("❌ Erreur lors de l'annulation");
    }
  }
  window.undoToTurnStart = undoToTurnStart;
  async function declareWinGame(){
    if(!connected) {
      pushLog("⚠️ Pas connecté");
      return;
    }
    const st = roomState || initialRoomState();
    const slot = mySlotFromState(st);
    if(!slot){
      pushLog("⚠️ Tu es spectateur");
      return;
    }

    // Confirme léger (évite un misclick)
    if(!confirm("Déclarer que tu gagnes la partie ? (proto playtest)")) return;

    const other = slot === 'A' ? 'B' : 'A';
    await pushPhaseHistory('Déclaration victoire (proto)');
    await updateRoomState((s)=>{
      s.phase = 'ended';
      s.result = { A: null, B: null };
      s.result[slot] = 'win';
      s.result[other] = 'lose';
      // Optionnel: figer le tour
      s.currentPlayer = null;
      return s;
    }, 'declare-win');

    pushLog(`🏆 ${slot} déclare la victoire`);
    showToast('🏆 Victoire déclarée');
  }

  const winGameBtn = $("winGameBtn");
  if(winGameBtn){
    winGameBtn.onclick = () => declareWinGame();
  }

  // Fonction pour mettre à jour l'affichage du menu Partie (phases + Phase 3 sous-phases)

  // ===== Phase 3 (Résolution) en 4 sous-phases + embranchements =====
  const p3Step1LoseBtn = $("p3Step1LoseBtn");
  const p3Step1ContinueBtn = $("p3Step1ContinueBtn");
  const p3Step2DoneBtn = $("p3Step2DoneBtn");
  const p3Step3DoneBtn = $("p3Step3DoneBtn");
  const p3Step4WinBtn = $("p3Step4WinBtn");
  const p3Step4ContinueBtn = $("p3Step4ContinueBtn");

  function ensurePhase3State(s){
    s.phase3 = s.phase3 || {};
    s.phase3.step = Number(s.phase3.step || 1);
    s.phase3.step1 = s.phase3.step1 || { A: null, B: null }; // 'continue' | 'lose'
    s.phase3.step2 = s.phase3.step2 || { A: false, B: false };
    s.phase3.step3 = s.phase3.step3 || { A: false, B: false };
    s.phase3.step4 = s.phase3.step4 || { A: null, B: null }; // 'continue' | 'win'
    return s;
  }

  function computeStep1Outcome(step1){
    const a = step1?.A;
    const b = step1?.B;
    if(a == null || b == null) return null;
    if(a === 'lose' && b === 'lose') return { end:true, result:{A:'lose',B:'lose'}, label:'Égalité (les 2 perdent)'};
    if(a === 'lose' && b === 'continue') return { end:true, result:{A:'lose',B:'win'}, label:'B gagne'};
    if(a === 'continue' && b === 'lose') return { end:true, result:{A:'win',B:'lose'}, label:'A gagne'};
    return { end:false };
  }

  function computeStep4Outcome(step4){
    const a = step4?.A;
    const b = step4?.B;
    if(a == null || b == null) return null;
    if(a === 'win' && b === 'win') return { end:true, result:{A:'win',B:'win'}, label:'Égalité (les 2 gagnent)'};
    if(a === 'win' && b === 'continue') return { end:true, result:{A:'win',B:'lose'}, label:'A gagne'};
    if(a === 'continue' && b === 'win') return { end:true, result:{A:'lose',B:'win'}, label:'B gagne'};
    return { end:false }; // les 2 continuent
  }

  async function setPhase3Decision(step, value){
    if(!connected) return;
    const st = roomState || initialRoomState();
    const slot = mySlotFromState(st);
    if(!slot){ pushLog('⚠️ Spectateur'); return; }
    if(st.phase !== 'phase3_manual'){ pushLog(`⚠️ Pas en Phase 3 (${st.phase})`); return; }

    await pushPhaseHistory('Avant décision Phase 3');

    await updateRoomState((s)=>{
      ensurePhase3State(s);
      if(Number(s.phase3.step) !== step) return s;

      if(step === 1){
        s.phase3.step1[slot] = value; // 'continue' | 'lose'
        const out = computeStep1Outcome(s.phase3.step1);
        if(out && out.end){
          s.phase = 'ended';
          s.result = out.result;
        } else if(out && !out.end){
          // Les 2 continuent => étape 2
          s.phase3.step = 2;
        }
      }

      if(step === 2){
        s.phase3.step2[slot] = true;
        if(s.phase3.step2.A && s.phase3.step2.B){
          s.phase3.step = 3;
        }
      }

      if(step === 3){
        s.phase3.step3[slot] = true;
        if(s.phase3.step3.A && s.phase3.step3.B){
          s.phase3.step = 4;
        }
      }

      if(step === 4){
        s.phase3.step4[slot] = value; // 'continue' | 'win'
        const out = computeStep4Outcome(s.phase3.step4);
        if(out && out.end){
          s.phase = 'ended';
          s.result = out.result;
        } else if(out && !out.end){
          // Les 2 continuent => manche suivante AUTOMATIQUE : on passe en warmup_ready
          s.phase = 'warmup_ready';
          s.warmupDone = { A:false, B:false };

          // Manche suivante
          s.roundNumber = (Number.isFinite(s.roundNumber) ? s.roundNumber : 1) + 1;

          // Reset PA des chefs pour la prochaine manche (source: chiefBasePA en DB)
          s.actionDice = s.actionDice || {A:0,B:0};
          s.chiefBasePA = s.chiefBasePA || {A:null,B:null};
          if(s.chiefBasePA.A != null) s.actionDice.A = Number(s.chiefBasePA.A) || 0;
          if(s.chiefBasePA.B != null) s.actionDice.B = Number(s.chiefBasePA.B) || 0;

          // Reset passes pour la future phase2
          s.passes = { A:false, B:false };

          // Reset Phase 3
          s.phase3 = { step:1, step1:{A:null,B:null}, step2:{A:false,B:false}, step3:{A:false,B:false}, step4:{A:null,B:null} };

          // Nettoyer result éventuel
          s.result = { A:null, B:null };
        }
      }

      return s;
    }, `phase3-step${step}`);
  }

  if(p3Step1LoseBtn) p3Step1LoseBtn.onclick = () => setPhase3Decision(1,'lose');
  if(p3Step1ContinueBtn) p3Step1ContinueBtn.onclick = () => setPhase3Decision(1,'continue');
  if(p3Step2DoneBtn) p3Step2DoneBtn.onclick = () => setPhase3Decision(2,true);
  if(p3Step3DoneBtn) p3Step3DoneBtn.onclick = () => setPhase3Decision(3,true);
  if(p3Step4WinBtn) p3Step4WinBtn.onclick = () => setPhase3Decision(4,'win');
  if(p3Step4ContinueBtn) p3Step4ContinueBtn.onclick = () => setPhase3Decision(4,'continue');

  // ===== Phase 1 (Échauffement) automatique =====
  let warmupAutoRunning = false;
  let warmupAutoPromise = null;
  let warmupLocalDone = { A:false, B:false }; // ✅ FIX: Utiliser une Promise pour bloquer vraiment
  let lastWarmupKey = null; // Guard: reset local warmup only when entering a NEW warmup round

  // ===== UI polish helpers (toast / focus / help) =====
  const toastEl = $("toast");
  let toastTimer = null;
  function showToast(msg, _unused, duration){
    if(!toastEl) return;
    toastEl.textContent = String(msg || "");
    toastEl.classList.add('show');
    clearTimeout(toastTimer);
    // duration === 0 → persistent (ne disparaît qu'au prochain toast)
    if(duration === 0) return;
    toastTimer = setTimeout(()=> toastEl.classList.remove('show'), duration || 1600);
  }

  // ===== Presence / reconnexion (Supabase state.presence) =====
  let presencePingTimer = null;
  let presenceCheckTimer = null;
  let lastOppOffline = null;
  let oppOfflineSince = null;
  // Claim flow when opponent disconnected mid-game
  // stage: 0 none, 1 first prompt shown, 2 refused once (cooldown), 3 forced prompt shown
  let claimStage = 0;
  let claimRefusedAt = null;
  let claimOppSlot = null;

  function getNowMs(){ return Date.now(); }

  async function pingPresence(){
    const st0 = roomState || initialRoomState();
    const slot = mySlotFromState(st0);
    if(!slot) return;
    try{
      await updateRoomStateAction((s)=>{
        s.presence = s.presence || { A:{}, B:{} };
        s.presence[slot] = s.presence[slot] || {};
        s.presence[slot].lastSeenAt = getNowMs();
        s.presence[slot].online = true;
        return s;
      }, "presence-ping");
    }catch(_e){
      // offline: ignore
    }
  }

  function computeOppPresence(){
    const st = roomState || initialRoomState();
    const me = mySlotFromState(st);
    if(!me) return null;
    const opp = (me === "A") ? "B" : "A";
    const pres = (st.presence && st.presence[opp]) ? st.presence[opp] : {};
    const last = pres.lastSeenAt || 0;
    const offline = (getNowMs() - last) > 60000; // 60s — allows 2 missed 25s pings before "offline"
    return { me, opp, lastSeenAt:last, offline };
  }

  // ── Disconnect banner (visible on game board) ─────────────────────────────
  function _showDisconnectBanner(oppSlot){
    if(document.getElementById("disconnectBanner")) return; // already shown
    const banner = document.createElement("div");
    banner.id = "disconnectBanner";
    banner.style.cssText = `
      position:fixed; top:0; left:0; right:0; z-index:99998;
      background:linear-gradient(90deg,#b91c1c,#dc2626); color:#fff;
      text-align:center; padding:8px 16px; font-size:14px; font-weight:700;
      font-family:system-ui,-apple-system,sans-serif;
      box-shadow:0 2px 12px rgba(0,0,0,0.3);
      animation:slideDown .3s ease;
    `;
    banner.innerHTML = `🔌 Joueur ${oppSlot || "?"} déconnecté — en attente de reconnexion…`;
    // Add animation keyframes if not present
    if(!document.getElementById("disconnectBannerStyle")){
      const style = document.createElement("style");
      style.id = "disconnectBannerStyle";
      style.textContent = `@keyframes slideDown{from{transform:translateY(-100%)}to{transform:translateY(0)}}`;
      document.head.appendChild(style);
    }
    document.body.appendChild(banner);
  }
  function _hideDisconnectBanner(){
    const el = document.getElementById("disconnectBanner");
    if(el){ try{ el.remove(); }catch(_e){ el.style.display="none"; } }
  }

  function openClaimWinPopup(opp, stage){
    claimOppSlot = opp;
    try{
      if(claimWinText){
        if(stage === 1){
          claimWinText.textContent = `Il semblerait que le joueur ${opp} se soit déconnecté. Voulez-vous clore la partie sur l'abandon du joueur ${opp} ?`;
        }else{
          claimWinText.textContent = `Le joueur ${opp} est toujours absent. Cliquez sur OUI pour clore la partie (abandon).`;
        }
      }
    }catch(_e){}
    try{
      if(claimWinBtn){
        claimWinBtn.textContent = (stage === 1) ? "Oui" : "Oui, clore la partie";
      }
      if(claimNoBtn){
        claimNoBtn.style.display = (stage === 1) ? "" : "none";
      }
    }catch(_e){}
    try{
      openPanel({mode:"modal", view:PANEL_VIEW.CLAIM, title:"", context:""});
    }catch(_e){}
  }
  function checkPresenceLoop(){
    const info = computeOppPresence();
    if(!info) return;

    if(lastOppOffline === null){
      lastOppOffline = info.offline;
      if(info.offline) oppOfflineSince = getNowMs();
      return;
    }

    if(info.offline && !lastOppOffline){
      // just went offline
      oppOfflineSince = getNowMs();
      try{ pushActivity(`🔌 Joueur ${info.opp} : reconnexion…`); }catch(_e){}
      lastOppOffline = true;
      claimStage = 0; claimRefusedAt = null;
      // Show visible banner on game board
      try{ _showDisconnectBanner(info.opp); }catch(_e){}
    } else if(!info.offline && lastOppOffline){
      // back online
      try{ pushActivity(`✅ Joueur ${info.opp} reconnecté`); }catch(_e){}
      lastOppOffline = false;
      oppOfflineSince = null;
      claimStage = 0; claimRefusedAt = null;
      // Remove banner
      try{ _hideDisconnectBanner(); }catch(_e){}
    }

    // ⏱️ Prompt après 60s d'absence (seulement en partie), avec 2 étapes:
    //  - étape 1: Oui / Non (après 60s)
    //  - si Non: ré-afficher après 30s avec seulement Oui
    if(info.offline && oppOfflineSince){
      const st = roomState || initialRoomState();
      const phase = String(st.phase || "lobby");
      const inGame = (phase !== "lobby") && (phase !== "setup"); // setup = safe
      const dur = getNowMs() - oppOfflineSince;

      if(inGame){
        if(claimStage === 0 && dur >= (60 * 1000)){
          claimStage = 1;
          openClaimWinPopup(info.opp, 1);
        }else if(claimStage === 2 && claimRefusedAt && (getNowMs() - claimRefusedAt) >= (30 * 1000)){
          claimStage = 3;
          openClaimWinPopup(info.opp, 3);
        }
      }
    }
  }

  function stopPresenceSystem(){
    if(presencePingTimer){ clearInterval(presencePingTimer); presencePingTimer = null; }
    if(presenceCheckTimer){ clearInterval(presenceCheckTimer); presenceCheckTimer = null; }
  }

  function startPresenceSystem(){
    if(presencePingTimer || presenceCheckTimer) return;
    // immediate ping
    pingPresence();
    presencePingTimer = setInterval(pingPresence, 25000);
    presenceCheckTimer = setInterval(checkPresenceLoop, 3000);

    // best effort on unload
    window.addEventListener("beforeunload", ()=>{
      try{
        const st0 = roomState || initialRoomState();
        const slot = mySlotFromState(st0);
        if(!slot || !roomCodeActive) return;

        // Use fetch with keepalive for reliable delivery on page close.
        // Direct Supabase REST PATCH — bypasses optimistic lock (presence-only update).
        try{
          const url = CONFIG.supabaseUrl + "/rest/v1/rooms_kid?room_code=eq." + encodeURIComponent(roomCodeActive);
          const now = getNowMs();
          // Build patched state: only touch presence
          const pres = cloneState(st0.presence || {A:{},B:{}});
          pres[slot] = pres[slot] || {};
          pres[slot].online = false;
          pres[slot].lastSeenAt = now;
          const patched = cloneState(st0);
          patched.presence = pres;

          // Use fetch with keepalive for reliable delivery on page close (Supabase REST).
          // Best-effort: if a game action races, the heartbeat timeout (60s) handles it.
          fetch(url, {
            method: "PATCH",
            headers: {
              "Content-Type": "application/json",
              "apikey": CONFIG.supabaseAnonKey,
              "Authorization": "Bearer " + CONFIG.supabaseAnonKey,
              "Prefer": "return=minimal"
            },
            body: JSON.stringify({ state: patched }),
            keepalive: true
          }).catch(()=>{});
        }catch(_fe){}

        // Legacy fallback (fire-and-forget, may not complete)
        updateRoomStateAction((s)=>{
          s.presence = s.presence || {A:{},B:{}};
          s.presence[slot] = s.presence[slot] || {};
          s.presence[slot].online = false;
          s.presence[slot].lastSeenAt = getNowMs();
          return s;
        }, "presence-offline");
      }catch(_e){}
    });
  }
  // ───────────────────────────────────────────────────────────────────────────
  // ⏱️ AUTO-PASS après timeout (MODE ENFANT)
  // Règle: quand le timer d'un joueur atteint 0, on lui laisse 5s de grâce.
  // Si rien ne se passe, le tour est automatiquement passé.
  // ───────────────────────────────────────────────────────────────────────────
  let __timeoutAutoPassTimer = null;
  let __timeoutAutoPassArmedKey = ""; // avoid double triggers

  function startTimeoutAutoPassSystem(){
    if(__timeoutAutoPassTimer) return;
    __timeoutAutoPassTimer = setInterval(timeoutAutoPassLoop, 1000);
  }

  function stopTimeoutAutoPassSystem(){
    if(__timeoutAutoPassTimer){ clearInterval(__timeoutAutoPassTimer); __timeoutAutoPassTimer = null; }
    __timeoutAutoPassArmedKey = "";
  }

  async function timeoutAutoPassLoop(){
    try{
      const st = roomState || initialRoomState();
      const phase = String(st.phase || "lobby");
      if(phase !== "started") return;

      // Any writer client may advance the turn. We rely on optimistic concurrency (version)
      // Any connected client can trigger the timeout (not limited to writer leader).
      // The idempotent timedOutAt marker prevents double triggers.
      if(!connected || !sb || !roomCodeActive) return;

      const ap = st.activePlayer;
      if(ap !== "A" && ap !== "B") return;

      ensureTimersShape(st);
      const now = getNowMs();

      const t = st.timers?.[ap];
      if(!t) return;

      const msLeft = calcMsLeft(t, now);

      // If timer just reached 0: persist timedOutAt once
      if(msLeft <= 0){
        const already = Number(t.timedOutAt || 0);
        if(!already){
          // best-effort: mark timeout moment in DB (do not change turn yet)
          await updateRoomStateAction((s)=>{
            ensureTimersShape(s);
            const tt = s.timers?.[ap];
            if(!tt) return s;
            const curMs = calcMsLeft(tt, now);
            if(curMs > 0) return s; // got time back somehow
            tt.msLeft = 0;
            tt.running = false;
            tt.lastStartAt = null;
            if(!tt.timedOutAt) tt.timedOutAt = now;
            return s;
          }, "timer-timeout-mark");

          // Feedback: toast for both players
          try{
            const mySlot = mySlotFromState(roomState || initialRoomState());
            if(ap === mySlot){
              showToast("⏱️ Ton temps est écoulé ! Dernier tour…", "warn", 4000);
            } else {
              showToast(`⏱️ Temps écoulé pour ${slotLabel(ap)}`, "info", 3000);
            }
          }catch(_te){}

          return; // wait next loop to compute grace
        }

        // After 5s grace: auto-pass (advanceActivePlayer)
        if(now - already >= 5000){
          const key = `${st.roomCode || ""}|${st.version || ""}|${ap}|${already}`;
          if(__timeoutAutoPassArmedKey === key) return;
          __timeoutAutoPassArmedKey = key;

          // Still timed out? Re-check with latest snapshot before acting
          const st2 = roomState || initialRoomState();
          if(String(st2.phase||"") !== "started") return;
          if(st2.activePlayer !== ap) return;

          try{
            pushLog(`⏱️ Temps écoulé pour ${slotLabel(ap)} → passage automatique du tour`);
          }catch(_e){}
          await handleTimeoutOutOfTime(ap);
        }
      } else {
        // Has time again -> clear marker locally (keep DB marker if any, it's fine)
        __timeoutAutoPassArmedKey = "";
      }
    }catch(_e){
      // silence
    }
  }

  // ───────────────────────────────────────────────────────────────────────────
  // ⏱️ OUT-OF-TIME HANDLING (MODE ENFANT)
  // Quand un joueur dépasse le délai + grâce, il est considéré "hors temps":
  // - son timer est verrouillé (locked=true) et il est forcé à "stopped" pour toutes les manches suivantes
  // - l'autre joueur conserve la possibilité de terminer sa manche (stop) et, si l'adversaire est hors temps,
  //   de piocher/jouer seul sur les manches suivantes jusqu'à la victoire.
  // IMPORTANT: on ne fait PAS une victoire automatique ici (c'est le rôle du timer de déconnexion/abandon).
  // ───────────────────────────────────────────────────────────────────────────
  async function handleTimeoutOutOfTime(slotTimedOut){
    try{
      const st0 = roomState || initialRoomState();
      if(String(st0.phase||"") !== "started") return;
      const cur = st0.activePlayer;
      if(cur !== slotTimedOut) return;

      const opp = (slotTimedOut === "A") ? "B" : "A";

      await updateRoomStateAction((s)=>{
        if(String(s.phase||"") !== "started") return s;
        ensureTimersShape(s);
        s.stopped = s.stopped || {A:false,B:false};

        const now = getNowMs();
        // lock timed-out player
        if(s.timers?.[slotTimedOut]){
          flushRunningTimer(s.timers[slotTimedOut], now);
          s.timers[slotTimedOut].msLeft = 0;
          s.timers[slotTimedOut].running = false;
          s.timers[slotTimedOut].lastStartAt = null;
          s.timers[slotTimedOut].locked = true;
          // ensure we remember the moment
          if(!s.timers[slotTimedOut].timedOutAt) s.timers[slotTimedOut].timedOutAt = now;
        }
        // consider them stopped for future rounds
        s.stopped[slotTimedOut] = true;

        // If opponent is also locked, end by time DRAW (both out of time)
        if(!!(s.timers?.[opp]?.locked)){
          s.phase = "ended";
          s.endReason = "time_draw";
          s.endedBy = "timer";
          s.endedAt = Date.now ? Date.now() : now;
          s.winner = null;
          s.activePlayer = null;
          s.result = { A: "draw", B: "draw" };
          return s;
        }

        // Give the turn to opponent if possible
        s.activePlayer = opp;

        // Start opponent timer if playable (not stopped & not locked)
        if(s.timers?.[opp] && !(s.stopped?.[opp]) && !(s.timers[opp].locked)){
          startRunningTimer(s.timers[opp], now);
        }

        // If opponent had already stopped, request Phase 3 immediately (end of round)
        const effStoppedA = !!(s.stopped?.A || s.timers?.A?.locked);
        const effStoppedB = !!(s.stopped?.B || s.timers?.B?.locked);
        if(effStoppedA && effStoppedB && !s.phase3Done){
          s.phase3Pending = true;
        }
        return s;
      }, "timer-out-of-time-pass");

      // Feedback
      try{
        pushActivity(`⏱️ ${slotLabel(slotTimedOut)} n'a plus de temps — ${slotLabel((slotTimedOut==="A")?"B":"A")} continue`);
      }catch(_e){}
    }catch(_e){}
  }
  // 🎯 MODAL CHOIX (Annuler / Non / Oui) - remplace confirm() (pas de bandeau navigateur)
  function showChoiceModal({title="", body="", buttons=[]}){
    return new Promise((resolve) => {
      try{
        const existing = document.getElementById("choiceModalOverlay");
        if(existing) existing.remove();

        const ov = document.createElement("div");
        ov.id = "choiceModalOverlay";
        ov.className = "choiceModalOverlay";

        const card = document.createElement("div");
        card.className = "choiceModalCard";

        const h = document.createElement("div");
        h.className = "choiceModalTitle";
        h.textContent = title || "";
        card.appendChild(h);

        if(body){
          const p = document.createElement("div");
          p.className = "choiceModalBody";
          p.textContent = body;
          card.appendChild(p);
        }

        const row = document.createElement("div");
        row.className = "choiceModalBtns";

        const btnDefs = Array.isArray(buttons) && buttons.length ? buttons : [
          {key:"cancel", label:"Annuler"},
          {key:"no", label:"Non"},
          {key:"yes", label:"Oui"}
        ];

        btnDefs.forEach((b) => {
          const bt = document.createElement("button");
          bt.className = "choiceModalBtn";
          bt.setAttribute("data-key", b.key); // 🔧 Pour CSS spécifique
          bt.textContent = b.label || b.key;
          bt.onclick = (e) => {
            e.preventDefault();
            e.stopPropagation();
            ov.remove();
            resolve(b.key);
          };
          row.appendChild(bt);
        });

        card.appendChild(row);
        ov.appendChild(card);

        ov.addEventListener("click", (e) => {
          if(e.target === ov){
            ov.remove();
            resolve("cancel");
          }
        });

        document.body.appendChild(ov);
      }catch(e){
        resolve("yes");
      }
    });
  }

  function setFocusMode(isOn){
    document.body.classList.toggle('focusMode', !!isOn);
    try{ localStorage.setItem('bulle_focusMode', isOn ? '1':'0'); } catch(e) {}
    const focusLabel = $("focusLabel");
    if(focusLabel) safeText(focusLabel, isOn ? 'ON' : 'OFF');
  }

  // Restore focus mode
  try{ const v = localStorage.getItem('bulle_focusMode'); setFocusMode(v == null ? true : (v === '1')); } catch(e) { try{ setFocusMode(true); }catch(_e){} }

  const focusToggleBtn = $("focusToggleBtn");
  if(focusToggleBtn){
    focusToggleBtn.onclick = () => {
      const next = !document.body.classList.contains('focusMode');
      setFocusMode(next);
      showToast(next ? 'Mode Focus activé' : 'Mode Focus désactivé');
    };
  }

  const helpToggleBtn = $("helpToggleBtn");
  if(helpToggleBtn){
    helpToggleBtn.onclick = () => {
      const hb = $("helpBox");
      if(!hb) return;
      const willShow = hb.style.display === 'none' || hb.style.display === '';
      hb.style.display = willShow ? 'block' : 'none';
    };
  }

  let _lastPhase = null;
  let _lastRound = null;

  // Déterminer les PA de base d'un Chef (robuste : champs + fallback sur texte)
  function getChiefBasePA(chiefCard){
    if(!chiefCard) return null;

    // Champs possibles (selon cards.json)
    const direct = (
      chiefCard.actionDie ?? chiefCard.actiondie ?? chiefCard.action_die ??
      chiefCard.pa ?? chiefCard.PA ?? chiefCard.actionPoints ?? chiefCard.action_points ??
      chiefCard.pointsAction ?? chiefCard.points_action
    );
    if(direct != null && direct !== '' && !Number.isNaN(Number(direct))) return Number(direct);

    // Fallback : tenter de lire dans le texte (ex: "PA 3", "Points d'action: 3")
    const txt = String(chiefCard.text || chiefCard.rules || '').toLowerCase();
    const m = txt.match(/(?:\bpa\b|points?\s*d['’]?action)\s*[:=]?\s*(\d{1,2})/i);
    if(m) return Number(m[1]);

    return null;
  }

  
  async function maybeRunWarmupAuto(){
    // ✅ FIX: Si déjà en cours, attendre la fin
    if(warmupAutoPromise) {
      await warmupAutoPromise;
      return;
    }
    
    if(warmupAutoRunning) return;
    if(!connected) return;
    const st = roomState || initialRoomState();
    if(st.phase !== 'warmup_ready') return;
    const slot = mySlotFromState(st);
    if(!slot) return;

    // Déjà fait pour moi ?
    if(warmupLocalDone[slot]) return;
    if(st.warmupDone && st.warmupDone[slot]) return;

    // Anti-double pioche: ne pioche qu'une fois par manche et par joueur, même après Undo
    const rn = Number(st.roundNumber || 1);
    const alreadyDrewThisRound = !!(st.warmupDrawnRound && Number(st.warmupDrawnRound[slot]||0) === rn);

    warmupAutoRunning = true;
    warmupAutoPromise = (async () => {
    try{
      pushLog('🔥 Échauffement automatique...');

      // 1) Untap mes créatures (DB)
      await updateRoomState((s)=>{
        if(s.terrains && s.terrains[slot]){
          for(const c of s.terrains[slot]) c.tapped = false;
        }
        s.warmupDone = s.warmupDone || {A:false,B:false};
        return s;
      }, 'warmup-untap');

      // 2) Reset mes PA selon mon chef (DB + UI)
      // Priorite: chiefBasePA (persistant en DB) pour eviter calcul / soucis de carte non chargee
      const basePA = (st.chiefBasePA && st.chiefBasePA[slot] != null && !Number.isNaN(Number(st.chiefBasePA[slot])))
        ? Number(st.chiefBasePA[slot])
        : (()=>{
            const chiefId = (roomState && roomState.chiefs && roomState.chiefs[slot]) || (gameState && gameState.myChief) || null;
            const chiefCard = chiefId ? cardsById.get(chiefId) : null;
            return getChiefBasePA(chiefCard);
          })();

      if(basePA != null){
        await updateRoomState((s)=>{
          s.actionDice = s.actionDice || {A:0,B:0};
          s.actionDice[slot] = basePA;
          return s;
        }, 'warmup-pa');

        // MAJ locale DEPUIS roomState (qui contient les PA des deux joueurs)
        const freshState = roomState || initialRoomState();
        if(freshState.actionDice && freshState.actionDice[slot] != null){
          gameState.myActionDie = freshState.actionDice[slot];
          updateActionDieUI();
          updateAllZoneCounters();
        }
      }

      // 3) Sauvegarder l'historique AVANT la pioche (pour pouvoir annuler)
      addToHistory("Avant échauffement (Phase 1)");
      // 4) Pioche (DB) — IMPORTANT:
      //    - Anti double pioche par manche via warmupDrawnRound
      //    - On ne marque warmupDrawnRound qu'APRÈS une pioche effective
      //    - On ne marque warmupDone que si la pioche est validée (ou déjà faite)
      let warmupSuccess = false;
      const rnNow = Number((roomState && roomState.roundNumber) || st.roundNumber || 1);
      // MODE ENFANT: 5 cartes à chaque début de manche
      const drawN = 5;
      const alreadyDrewNow = !!((roomState && roomState.warmupDrawnRound) && Number((roomState.warmupDrawnRound[slot]||0)) === rnNow);

      if(alreadyDrewNow){
        warmupSuccess = true;
        pushLog('🔁 Échauffement: pioche déjà faite pour cette manche (anti double pioche)');
      } else {
        const stBeforeDraw = roomState || initialRoomState();
        const hand0 = (stBeforeDraw.handPiles && Array.isArray(stBeforeDraw.handPiles[slot])) ? stBeforeDraw.handPiles[slot].length : 0;

        // Marquer \"en cours\" pour éviter les doubles exécutions (ex: 2 onglets même joueur)
        await updateRoomState((s)=>{
          const rr = Number(s.roundNumber || 1);
          s.warmupDrawInProgress = s.warmupDrawInProgress || {A:0,B:0};
          if(Number(s.warmupDrawInProgress[slot]||0) !== rr){
            s.warmupDrawInProgress[slot] = rr;
          }
          return s;
        }, 'warmup-draw-inprogress');

        let drew = 0;
        try{
          await drawCards(drawN);
          const stAfterDraw = roomState || initialRoomState();
          const hand1 = (stAfterDraw.handPiles && Array.isArray(stAfterDraw.handPiles[slot])) ? stAfterDraw.handPiles[slot].length : 0;
          drew = Math.max(0, hand1 - hand0);
        } catch(e){
          drew = 0;
        }

        if(drew > 0){
          warmupSuccess = true;
          await updateRoomState((s)=>{
            const rr = Number(s.roundNumber || 1);
            s.warmupDrawnRound = s.warmupDrawnRound || {A:0,B:0};
            s.warmupDrawnRound[slot] = rr;
            s.warmupDrawInProgress = s.warmupDrawInProgress || {A:0,B:0};
            s.warmupDrawInProgress[slot] = 0;
            return s;
          }, 'warmup-drawn');
        } else {
          await updateRoomState((s)=>{
            s.warmupDrawInProgress = s.warmupDrawInProgress || {A:0,B:0};
            s.warmupDrawInProgress[slot] = 0;
            return s;
          }, 'warmup-draw-release');
          pushLog('⚠️ Échauffement: aucune carte piochée (deck vide / reform annulée / erreur).');
          warmupSuccess = false;
        }
      }

      // 5) Marquer warmupDone (LOCAL + DB) seulement si l'échauffement est validé pour ce joueur
      if(warmupSuccess){
        warmupLocalDone[slot] = true;
        await updateRoomState((s)=>{
          s.warmupDone = s.warmupDone || {A:false,B:false};
          s.warmupDone[slot] = true;
          return s;
        }, 'warmup-done');

        pushLog('🔥 Échauffement OK');
      } else {
        warmupLocalDone[slot] = false;
        // Ne marque pas done → l'auto pourra retenter (ou bouton d'urgence)
        pushLog('⏸️ Échauffement non validé: la pioche pourra être retentée.');
      }

      // 6) Si A et B ont fini : basculer en Phase 2 (started)
      const fresh = roomState || initialRoomState();
      if(fresh.warmupDone && fresh.warmupDone.A && fresh.warmupDone.B){
        await pushPhaseHistory('Avant Phase 2 (warmup→started)');
        await updateRoomState((s)=>{
          if(s.phase !== 'warmup_ready') return s;
          s.phase = 'started';
          // Début de manche : à toi si currentPlayer absent
          if(!s.currentPlayer) s.currentPlayer = s.starter || 'A';
          return s;
        }, 'warmup->started');
        pushLog('🎬 Phase 2 (Jeu) recommence !');
      }
    } catch(e){
      reportError(e,'warmup-auto');
    } finally {
      warmupAutoRunning = false;
      warmupAutoPromise = null; // ✅ FIX: Libérer la Promise
    }
    })(); // ✅ FIX: Fermer la Promise IIFE
    
    await warmupAutoPromise;
  }
  function updateGamePanelDisplay(){
    const st = roomState || initialRoomState();
    const mySlot = mySlotFromState(st);

    // ===== Phase banner (joli + fiable) =====
    const phaseBannerTitle = $("phaseBannerTitle");
    const phaseBannerSub = $("phaseBannerSub");
    const roundNumberEl = $("roundNumber");

    // ===== Game meta (starter + host) =====
    const starterLabelEl = $("starterLabel");
    const hostLabelEl = $("hostLabel");

    const prettySlot = (sl)=> sl === "A" ? "Joueur A" : (sl === "B" ? "Joueur B" : "—");

    // Starter (premier joueur de la manche) : st.starter si dispo, sinon activePlayer
    const starterSlot = (st.starter || st.activePlayer || null);
    if(starterLabelEl) safeText(starterLabelEl, starterSlot ? prettySlot(starterSlot) : "—");

    // Host : par convention = Joueur A (premier connecté). Si absent, fallback sur B.
    let hostSlot = null;
    try{
      if(st.players && st.players.A && st.players.A.id) hostSlot = "A";
      else if(st.players && st.players.B && st.players.B.id) hostSlot = "B";
    }catch(_e){}
    if(hostLabelEl) safeText(hostLabelEl, hostSlot ? prettySlot(hostSlot) : "—");

    // Noms simplifiés (sans icônes) comme demandé.
    const prettyPhase = (p)=>{
      if(p === 'started') return 'Jouer à tour de rôle';
      if(p === 'phase3_manual' || p === 'ended') return 'Fin de la manche';
      // Lobby / warmup
      return 'Début de la manche';
    };

    if(phaseBannerTitle) safeText(phaseBannerTitle, prettyPhase(st.phase));
    if(phaseBannerSub){
      let sub = '';
      if(st.phase === 'started'){
        sub = getTurnPlayer(st) ? (getTurnPlayer(st) === mySlot ? 'À toi de jouer' : 'Tour adverse') : '—';
        if(st.startDice && (st.startDice.A || st.startDice.B)){
          const a = st.startDice.A ?? '—';
          const b = st.startDice.B ?? '—';
          const first = st.starter ? prettySlot(st.starter) : '—';sub += ` • Dé: A ${a} — B ${b}`;
        }
      } else if(st.phase === 'phase3_manual' || st.phase === 'ended'){
        sub = 'Fin de manche';
      } else {
        // Lobby / warmup : on affiche le d12 auto si dispo
        if(st.startDice && (st.startDice.A || st.startDice.B)){
          const a = st.startDice.A ?? '—';
          const b = st.startDice.B ?? '—';
          const first = st.starter ? prettySlot(st.starter) : '—';
          sub = `Dé (auto) : A ${a} — B ${b} • Premier joueur : ${first}`;
        } else {
          sub = 'En attente des 2 decklists';
        }
      }
      safeText(phaseBannerSub, sub);
    }

    // Flash Manche + toast sur changement de phase
    if(_lastRound == null) _lastRound = st.roundNumber || 1;
    if(_lastPhase == null) _lastPhase = st.phase || 'lobby';
    const curRound = st.roundNumber || 1;
    if(roundNumberEl){
      safeText(roundNumberEl, curRound);
      if(curRound !== _lastRound){
        roundNumberEl.classList.remove('flash');
        // force reflow
        void roundNumberEl.offsetWidth;
        roundNumberEl.classList.add('flash');
        _lastRound = curRound;
      }
    }
    if(st.phase !== _lastPhase){
      // toast discret (utile en playtest)
      if(st.phase === 'started') showToast('Jouer à tour de rôle');
      else if(st.phase === 'phase3_manual' || st.phase === 'ended') showToast('Fin de la manche');
      _lastPhase = st.phase;
    }

    const gamePhaseEl = $("gamePhase");
    const currentTurnEl = $("currentTurn");
    // roundNumberEl handled by banner (above)
    const passStatusRow = $("passStatusRow");
    const passStatusText = $("passStatusText");

    // Phase 3 UI
    const phase3Box = $("phase3Box");
    const phase3StepLabel = $("phase3StepLabel");
    const phase3StepTitle = $("phase3StepTitle");
    const phase3StatusMini = $("phase3StatusMini");
    const phase3Hint = $("phase3Hint");
    const p3Step1Btns = $("p3Step1Btns");
    const p3Step2Btns = $("p3Step2Btns");
    const p3Step3Btns = $("p3Step3Btns");
    const p3Step4Btns = $("p3Step4Btns");

    if(gamePhaseEl){
      let phaseText = 'Lobby';
      if(st.phase === 'started') phaseText = '⚔️ Phase 2 (Jeu)';
      else if(st.phase === 'phase3_manual') phaseText = '🎯 Phase 3 (Résolution)';
      else if(st.phase === 'warmup_ready') phaseText = '🔥 Phase 1 (Échauffement)';
      else if(st.phase === 'ended') phaseText = 'Partie terminée';
      safeText(gamePhaseEl, phaseText);
    }

    // Tour
    if(currentTurnEl){
      const turnText = getTurnPlayer(st)
        ? (getTurnPlayer(st) === mySlot ? 'À toi' : 'Adversaire')
        : '—';
      safeText(currentTurnEl, turnText);
    }

    // Manche
    if(roundNumberEl){
      safeText(roundNumberEl, st.roundNumber || 1);
    }

    // Afficher état passes
    if(passStatusRow && passStatusText && st.passes){
      const passA = st.passes.A ? '✅' : '⏳';
      const passB = st.passes.B ? '✅' : '⏳';
      safeText(passStatusText, `A ${passA} • B ${passB}`);
      if(st.phase === 'started' && (st.passes.A || st.passes.B)) passStatusRow.style.display = 'block';
      else passStatusRow.style.display = 'none';
    } else if(passStatusRow){
      passStatusRow.style.display = 'none';
    }

    // Phase 3: affichage des sous-phases
    if(phase3Box){
      const isP3 = (st.phase === 'phase3_manual');
      phase3Box.style.display = isP3 ? 'block' : 'none';

      if(isP3){
        const p3 = st.phase3 || { step: 1, step1:{A:null,B:null}, step2:{A:false,B:false}, step3:{A:false,B:false}, step4:{A:null,B:null} };
        const step = Number(p3.step || 1);

        if(phase3StepLabel) safeText(phase3StepLabel, `${step}/4`);

        // Mini status A/B
        const ab = (obj, isDecision=false) => {
          const a = obj?.A;
          const b = obj?.B;
          const fmt = (v) => {
            if(isDecision){
              if(v === null) return '⏳';
              if(v === 'continue') return '✅';
              if(v === 'lose') return '💀';
              if(v === 'win') return '🏆';
              return String(v);
            }
            return v ? '✅' : '⏳';
          };
          return `A ${fmt(a)} • B ${fmt(b)}`;
        };

        // Show only relevant buttons
        if(p3Step1Btns) p3Step1Btns.style.display = (step === 1) ? 'flex' : 'none';
        if(p3Step2Btns) p3Step2Btns.style.display = (step === 2) ? 'flex' : 'none';
        if(p3Step3Btns) p3Step3Btns.style.display = (step === 3) ? 'flex' : 'none';
        if(p3Step4Btns) p3Step4Btns.style.display = (step === 4) ? 'flex' : 'none';

        // Titles + hints
        if(step === 1){
          if(phase3StepTitle) safeText(phase3StepTitle, 'Étape 1 — Passage de la Bulle (test)');
          if(phase3Hint) safeText(phase3Hint, "Choisis : tu continues (au moins 1 créature debout) OU tu perds (0 créature debout). Égalité si A et B perdent.");
          if(phase3StatusMini) safeText(phase3StatusMini, ab(p3.step1, true));
        } else if(step === 2){
          if(phase3StepTitle) safeText(phase3StepTitle, 'Étape 2 — Marquage des passes');
          if(phase3Hint) safeText(phase3Hint, 'Chaque joueur note ses passes, puis valide.');
          if(phase3StatusMini) safeText(phase3StatusMini, ab(p3.step2, false));
        } else if(step === 3){
          if(phase3StepTitle) safeText(phase3StepTitle, 'Étape 3 — Nettoyage');
          if(phase3Hint) safeText(phase3Hint, 'Nettoyage manuel du terrain, puis valide.');
          if(phase3StatusMini) safeText(phase3StatusMini, ab(p3.step3, false));
        } else {
          if(phase3StepTitle) safeText(phase3StepTitle, 'Étape 4 — Vérification victoire (test)');
          if(phase3Hint) safeText(phase3Hint, "Choisis : tu gagnes (>= 12 points) OU tu continues. Égalité si A et B gagnent. Si A et B continuent → manche suivante automatique.");
          if(phase3StatusMini) safeText(phase3StatusMini, ab(p3.step4, true));
        }
      }
    }

    // Warmup (phase 1) : bouton de secours uniquement

    // Afficher résultat si partie terminée
    if(st.phase === 'ended' && st.result && st.result.A && st.result.B){
      let resultText = '';
      if(st.result.A === 'win' && st.result.B === 'lose') resultText = 'A gagne !';
      else if(st.result.A === 'lose' && st.result.B === 'win') resultText = 'B gagne !';
      else if(st.result.A === 'win' && st.result.B === 'win') resultText = 'Égalité (les 2 gagnent)';
      else if(st.result.A === 'lose' && st.result.B === 'lose') resultText = 'Égalité (les 2 perdent)';
      if(resultText && gamePhaseEl) safeText(gamePhaseEl, resultText);
    }

    // ===== Aide contextuelle (simple) =====
    const helpBox = $("helpBox");
    const helpText = $("helpText");
    if(helpBox && helpText && helpBox.style.display === 'block'){
      let msg = '';
      if(st.phase === 'warmup_ready'){
        msg = 'Échauffement automatique : redressement + PA + pioche. Attends que les 2 joueurs aient fini.';
      } else if(st.phase === 'started'){
        msg = 'Phase 2 (Jeu) : joue normalement. Quand tu veux arrêter la manche, clique “⏭️ Fin Phase 2 (Jeu)”.';
      } else if(st.phase === 'phase3_manual'){
        const step = Number(st.phase3?.step || 1);
        if(step === 1) msg = 'Étape 1 : Passage de la Bulle. Si tu n\'as aucune créature debout → “Je perds”. Sinon → “Je continue”.';
        else if(step === 2) msg = 'Étape 2 : note tes passes (compte tes créatures debout), puis clique “Passes notées”.';
        else if(step === 3) msg = 'Étape 3 : nettoyage manuel du terrain, puis clique “Nettoyage terminé”.';
        else msg = 'Étape 4 : si tu as ≥ 9 passes → “Je gagne”. Sinon → “Je continue”. Si A et B continuent : manche suivante auto.';
      } else if(st.phase === 'ended'){
        msg = 'Manche terminée : regarde le résultat. Pour rejouer, réinitialise ou relance une nouvelle partie.';
      } else {
        msg = 'Lobby : connecte-toi, charge cards.json, importe ton deck, puis clique “Je suis prêt”.';
      }
      safeText(helpText, msg);
    }
  }

  // Exposer la fonction
  window.updateGamePanelDisplay = updateGamePanelDisplay;

  /**
   * 🎯 MODE ENFANT : Met à jour la piste de score visuelle (0-9)
   * Appelé automatiquement après chaque changement de score
   */

  // 🏆 POPUP FIN DE PARTIE
  let __endGameShown = false; // Guard pour ne montrer qu'une fois
  
  function showEndGamePopup(scoreA, scoreB) {
    if(__endGameShown) return; // Déjà montré
    __endGameShown = true;
    
    // 🔧 BLOQUER TOUTES LES ACTIONS
    gameEnded = true;
    
    // 🔧 PASSER LES 2 LED EN ROUGE
    const dotA = document.getElementById('dotA');
    const dotB = document.getElementById('dotB');
    if(dotA){
      dotA.classList.add('red');
      dotA.style.background = 'radial-gradient(circle at 35% 35%, rgba(255,255,255,0.5), transparent 65%), #ef4444';
    }
    if(dotB){
      dotB.classList.add('red');
      dotB.style.background = 'radial-gradient(circle at 35% 35%, rgba(255,255,255,0.5), transparent 65%), #ef4444';
    }
    
    let message = "";
    let winner = null;
    
    if(scoreA >= 12 && scoreB >= 12){
      // Égalité
      message = "Égalité !";
    } else if(scoreA >= 12){
      winner = "A";
      message = "Le Joueur A gagne la partie !";
    } else if(scoreB >= 12){
      winner = "B";
      message = "Le Joueur B gagne la partie !";
    }
    
    if(!message) return;
    
    // Créer le popup
    const overlay = document.createElement('div');
    overlay.id = 'endGameOverlay';
    overlay.style.cssText = `
      position: fixed;
      inset: 0;
      z-index: 999999;
      background: rgba(0,0,0,0.85);
      display: flex;
      align-items: center;
      justify-content: center;
      animation: fadeIn 0.3s ease;
    `;
    
    const card = document.createElement('div');
    card.style.cssText = `
      background: 
        radial-gradient(circle at 30% 30%, rgba(255,255,255,0.15), transparent 70%),
        linear-gradient(135deg, rgba(20,30,48,0.95) 0%, rgba(15,23,42,0.98) 100%);
      border: 2px solid ${winner === 'A' ? 'rgba(74, 158, 255, 0.5)' : winner === 'B' ? 'rgba(255, 107, 107, 0.5)' : 'rgba(255,255,255,0.3)'};
      border-radius: 24px;
      padding: 40px;
      max-width: 400px;
      text-align: center;
      box-shadow: 
        0 20px 60px rgba(0,0,0,0.5),
        ${winner === 'A' ? '0 0 40px rgba(74, 158, 255, 0.3)' : winner === 'B' ? '0 0 40px rgba(255, 107, 107, 0.3)' : '0 0 30px rgba(255,255,255,0.2)'};
      animation: scaleIn 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
    `;
    
    const icon = winner === 'A' ? '🏆' : winner === 'B' ? '🏆' : '🤝';
    
    card.innerHTML = `
      <div style="font-size: 64px; margin-bottom: 20px; animation: bounce 1s ease infinite;">${icon}</div>
      <div style="font-size: 28px; font-weight: 900; color: #fff; margin-bottom: 30px;">${message}</div>
      <div style="font-size: 16px; opacity: 0.8; margin-bottom: 30px;">
        Score final : <strong>A: ${scoreA}</strong> | <strong>B: ${scoreB}</strong>
      </div>
      <button id="endGameOk" style="
        background: radial-gradient(circle at 30% 30%, rgba(255,255,255,0.3), transparent 70%), linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
        border: 1px solid rgba(255,255,255,0.35);
        border-radius: 999px;
        padding: 14px 32px;
        font-size: 16px;
        font-weight: 800;
        color: rgba(0,0,0,0.95);
        cursor: pointer;
        box-shadow: 0 4px 12px rgba(34,197,94,.35);
        transition: all .2s ease;
      " onmouseover="this.style.transform='translateY(-2px)'; this.style.boxShadow='0 6px 18px rgba(34,197,94,.45)'" onmouseout="this.style.transform=''; this.style.boxShadow='0 4px 12px rgba(34,197,94,.35)'">
        OK
      </button>
    `;
    
    overlay.appendChild(card);
    document.body.appendChild(overlay);
    
    // Animation CSS
    const style = document.createElement('style');
    style.textContent = `
      @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
      @keyframes scaleIn { from { transform: scale(0.8); opacity: 0; } to { transform: scale(1); opacity: 1; } }
      @keyframes bounce { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-10px); } }
    `;
    document.head.appendChild(style);
    
    // Fermer sur click OK
    document.getElementById('endGameOk').onclick = () => {
      overlay.remove();
      style.remove();
      // 🔧 OUVRIR LE MENU SETUP AUTOMATIQUEMENT
      setTimeout(() => {
        if(typeof openPanel === 'function'){
          openPanel({mode:"drawer", view:"setup", title:"Setup / Connexion", context:""});
        }
      }, 200);
    };
    
    // Fermer sur click overlay (optional)
    overlay.onclick = (e) => {
      if(e.target === overlay){
        overlay.remove();
        style.remove();
        // 🔧 OUVRIR LE MENU SETUP AUTOMATIQUEMENT
        setTimeout(() => {
          if(typeof openPanel === 'function'){
            openPanel({mode:"drawer", view:"setup", title:"Setup / Connexion", context:""});
          }
        }, 200);
      }
    };
  }

  function showConcedePopup(winnerSlot, concededBy){
    if(__endGameShown) return;
    __endGameShown = true;
    gameEnded = true;

    const dotA = document.getElementById('dotA');
    const dotB = document.getElementById('dotB');
    if(dotA){
      dotA.classList.add('red');
      dotA.style.background = 'radial-gradient(circle at 35% 35%, rgba(255,255,255,0.5), transparent 65%), #ef4444';
    }
    if(dotB){
      dotB.classList.add('red');
      dotB.style.background = 'radial-gradient(circle at 35% 35%, rgba(255,255,255,0.5), transparent 65%), #ef4444';
    }

    const message = winnerSlot
      ? `Le Joueur ${winnerSlot} gagne la partie ! (adversaire a concédé)`
      : `Partie terminée (concession)`;

    const overlay = document.createElement('div');
    overlay.id = 'endGameOverlay';
    overlay.style.cssText = `
      position: fixed;
      inset: 0;
      z-index: 999999;
      background: rgba(0,0,0,0.85);
      display: flex;
      align-items: center;
      justify-content: center;
      animation: fadeIn 0.3s ease;
    `;

    const card = document.createElement('div');
    card.style.cssText = `
      background:
        radial-gradient(circle at 30% 30%, rgba(255,255,255,0.15), transparent 70%),
        linear-gradient(135deg, rgba(20,30,48,0.95) 0%, rgba(15,23,42,0.98) 100%);
      border: 1px solid rgba(255,255,255,0.15);
      border-radius: 24px;
      padding: 28px 24px;
      width: min(520px, 92vw);
      box-shadow: 0 25px 60px rgba(0,0,0,0.45);
      text-align: center;
      color: white;
    `;
    card.innerHTML = `
      <div style="font-size:42px; line-height:1; margin-bottom:12px;">🏆</div>
      <div style="font-size:22px; font-weight:800; margin-bottom:8px;">${message}</div>
      <div style="opacity:.85; font-size:14px; margin-bottom:18px;">La partie est terminée. Tu peux relancer une nouvelle partie.</div>
      <button id="endGameOkBtn" style="appearance:none;border:0;padding:12px 16px;border-radius:14px;font-weight:800;cursor:pointer;">OK</button>
    `;
    overlay.appendChild(card);
    document.body.appendChild(overlay);

    const okBtn = card.querySelector('#endGameOkBtn');
    if(okBtn){
      okBtn.addEventListener('click', ()=>{
        try{ overlay.remove(); }catch(_e){}
        // Comme une fin de partie normale : on coupe la room et on revient au Setup
        try{ (async()=>{ try{ await disconnect(); }catch(_e){} })(); }catch(_e){}
        try{ storage.del(ROOM_LAST_KEY); }catch(_e){}
        try{ setRoom(_randRoomCode ? _randRoomCode() : ""); }catch(_e){}
        try{ openPanel({mode:"drawer", view:"setup", title:"Setup / Connexion", context:""}); }catch(_e){}
      });
    }
  }

// POPUP: ÉGALITÉ (temps écoulé pour les deux joueurs)
function showTimeDrawPopup(){
    if(__endGameShown) return;
    __endGameShown = true;
    gameEnded = true;

    const dotA = document.getElementById('dotA');
    const dotB = document.getElementById('dotB');
    if(dotA){
      dotA.classList.add('red');
      dotA.style.background = 'radial-gradient(circle at 35% 35%, rgba(255,255,255,0.5), transparent 65%), #ef4444';
    }
    if(dotB){
      dotB.classList.add('red');
      dotB.style.background = 'radial-gradient(circle at 35% 35%, rgba(255,255,255,0.5), transparent 65%), #ef4444';
    }

    const message = "Égalité ! (Temps écoulé pour les deux joueurs)";

    const overlay = document.createElement('div');
    overlay.id = 'endGameOverlay';
    overlay.style.cssText = `
      position: fixed;
      inset: 0;
      z-index: 999999;
      background: rgba(0,0,0,0.85);
      display: flex;
      align-items: center;
      justify-content: center;
      animation: fadeIn 0.3s ease;
    `;

    const card = document.createElement('div');
    card.style.cssText = `
      background:
        radial-gradient(circle at 30% 30%, rgba(255,255,255,0.15), transparent 70%),
        linear-gradient(135deg, rgba(20,30,48,0.95) 0%, rgba(15,23,42,0.98) 100%);
      border: 1px solid rgba(255,255,255,0.15);
      border-radius: 24px;
      padding: 22px 22px 16px;
      width: min(92vw, 520px);
      box-shadow: 0 18px 60px rgba(0,0,0,0.55);
      color: #fff;
      text-align: center;
      font-family: system-ui, -apple-system, Segoe UI, Roboto, sans-serif;
    `;

    const h = document.createElement('div');
    h.style.cssText = 'font-size: 22px; font-weight: 800; margin-bottom: 10px;';
    h.textContent = "⏱️ Fin de partie";

    const p = document.createElement('div');
    p.style.cssText = 'font-size: 16px; opacity: .92; line-height: 1.35; margin-bottom: 14px;';
    p.textContent = message;

    const btn = document.createElement('button');
    btn.textContent = "OK";
    btn.style.cssText = `
      margin-top: 6px;
      border: 1px solid rgba(255,255,255,0.22);
      border-radius: 14px;
      padding: 10px 14px;
      background: rgba(255,255,255,0.10);
      color: #fff;
      font-weight: 800;
      cursor: pointer;
    `;
    btn.onclick = () => { try{ overlay.remove(); }catch(_e){} };

    card.appendChild(h);
    card.appendChild(p);
    card.appendChild(btn);
    overlay.appendChild(card);
    document.body.appendChild(overlay);
}

  

// =====================================================================
// POPUP: DEMANDE DE NOUVELLE PARTIE (2 confirmations)
// =====================================================================
let __restartReqOverlay = null;
function hideRestartRequestPopup(){
  try{
    if(__restartReqOverlay){
      __restartReqOverlay.remove();
      __restartReqOverlay = null;
    }
  }catch(_e){}
}

async function cancelRestartRequest(){
  try{
    await updateRoomState((st)=>{
      st.restartReq = {A:false, B:false};
      st.restartReqAt = Date.now();
      return st;
    }, "restart-cancel");
    try{ if(typeof showToast === 'function') showToast("❎ Demande de nouvelle partie refusée"); }catch(_e){}
  }catch(e){
    reportError(e, "restart-cancel");
  }
}

function showRestartRequestPopup(requestedBySlot){
  try{
    if(__restartReqOverlay) return;

    const overlay = document.createElement('div');
    overlay.id = 'restartReqOverlay';
    overlay.style.cssText = `
      position: fixed;
      inset: 0;
      z-index: 999998;
      background: rgba(0,0,0,0.78);
      display: flex;
      align-items: center;
      justify-content: center;
      animation: fadeIn 0.22s ease;
    `;

    const card = document.createElement('div');
    card.style.cssText = `
      width: min(520px, 92vw);
      background: rgba(18,18,18,0.92);
      border: 1px solid rgba(255,255,255,0.14);
      border-radius: 18px;
      padding: 16px 14px;
      color: #fff;
      box-shadow: 0 16px 55px rgba(0,0,0,0.55);
    `;

    const title = document.createElement('div');
    title.textContent = "Nouvelle partie ?";
    title.style.cssText = "font-size:18px;font-weight:900;margin-bottom:10px;";

    const msg = document.createElement('div');
    msg.textContent = `Le Joueur ${requestedBySlot} propose une nouvelle partie.`;
    msg.style.cssText = "font-size:14px;opacity:0.92;line-height:1.35;margin-bottom:14px;";

    const row = document.createElement('div');
    row.style.cssText = "display:flex;gap:10px;justify-content:flex-end;flex-wrap:wrap;";

    const btnNo = document.createElement('button');
    btnNo.textContent = "Refuser";
    btnNo.style.cssText = `
      padding: 10px 12px;
      border-radius: 12px;
      border: 1px solid rgba(255,255,255,0.18);
      background: rgba(255,255,255,0.06);
      color: rgba(255,255,255,0.92);
      font-weight: 800;
      cursor: pointer;
    `;
    btnNo.onclick = async ()=>{
      hideRestartRequestPopup();
      await cancelRestartRequest();
    };

    const btnYes = document.createElement('button');
    btnYes.textContent = "Accepter";
    btnYes.style.cssText = `
      padding: 10px 12px;
      border-radius: 12px;
      border: 1px solid rgba(255,255,255,0.18);
      background: rgba(255,255,255,0.14);
      color: rgba(255,255,255,0.98);
      font-weight: 900;
      cursor: pointer;
    `;
    btnYes.onclick = async ()=>{
      hideRestartRequestPopup();
      await requestRestartTwoConfirm();
    };

    row.append(btnNo, btnYes);
    card.append(title, msg, row);
    overlay.append(card);
    document.body.append(overlay);
    __restartReqOverlay = overlay;
  }catch(_e){}
}
  function updateScoreTrack(){
    const st = roomState || initialRoomState();

    // Scores (mode enfant: st.scores, sinon fallback legacy st.bubbles)
    const scoreA = Number(st.scores?.A ?? st.bubbles?.A?.occurrences ?? 0);
    const scoreB = Number(st.scores?.B ?? st.bubbles?.B?.occurrences ?? 0);

// Mise à jour des labels
    const scoreValueA = $("scoreValueA");
    const scoreValueB = $("scoreValueB");
    const WIN_POINTS = 12;
    if(scoreValueA) safeText(scoreValueA, `${scoreA}/${WIN_POINTS}`);
    if(scoreValueB) safeText(scoreValueB, `${scoreB}/${WIN_POINTS}`);

    // Mise à jour des barres (0-WIN_POINTS = 0%-100%)
    const scoreBarA = $("scoreBarA");
    const scoreBarB = $("scoreBarB");
    if(scoreBarA){
      const percentA = Math.min(100, (scoreA / WIN_POINTS) * 100);
      scoreBarA.style.width = `${percentA}%`;
      
      // Animation flash si victoire
      if(scoreA >= WIN_POINTS){
        scoreBarA.style.boxShadow = '0 0 20px rgba(74, 158, 255, 1)';
        scoreBarA.style.animation = 'pulse 1s ease-in-out infinite';
      }
    }
    if(scoreBarB){
      const percentB = Math.min(100, (scoreB / WIN_POINTS) * 100);
      scoreBarB.style.width = `${percentB}%`;
      
      // Animation flash si victoire
      if(scoreB >= WIN_POINTS){
        scoreBarB.style.boxShadow = '0 0 20px rgba(255, 107, 107, 1)';
        scoreBarB.style.animation = 'pulse 1s ease-in-out infinite';
      }
    }
    
    // 🏆 DÉTECTION FIN DE PARTIE
    if(scoreA >= WIN_POINTS || scoreB >= WIN_POINTS){
      // Petit délai pour laisser l'animation des barres se jouer
      setTimeout(() => {
        showEndGamePopup(scoreA, scoreB);
      }, 800);
    }
  }
  window.updateScoreTrack = updateScoreTrack;

  /**
   * ↪️ MODE ENFANT V5 : Avancer le tour (automatique)
   * N'importe quel joueur peut appeler
   * Logique : Si les 2 stopped → Phase 3, sinon passer au suivant
   */
  async function advanceActivePlayer() {
    
    _log("↪️ [TURN] Tentative d'avancer le tour...");
    
    // Guard
    if(!canWriteEnfant(false)) {
      if(typeof showToast === "function") showToast("⚠️ Impossible d\'écrire (mode enfant non initialisé)");
      pushLog("⚠️ Stop impossible : écriture non autorisée");
      return;
    }
    
    const st = roomState || initialRoomState();
    
    // Check Phase 3
    if(st.stopped?.A && st.stopped?.B) {
      
    _log("🎯 [TURN] Les 2 ont arrêté → Phase 3");
      // Seul A peut exécuter la résolution. Si ce client n'est pas leader, on demande à A via phase3Pending.
      if(canWriteEnfant(true)){
        await executePhase3();
      }else{
        try{
          await updateRoomState((s)=>{ if(!s.phase3Done) s.phase3Pending = true; return s; }, 'phase3-pending');
        }catch(_e){}
        pushLog("⏳ Résolution de manche en cours...");
      }
      return;
    }
    
    const current = st.activePlayer;
    const next = current === "A" ? "B" : "A";
    
    // Si suivant a arrêté, current garde la main
    if(st.stopped?.[next]) {
      _log(`⏭️ [TURN] ${next} a arrêté, ${current} garde la main`);
      pushLog(`↪️ ${next} a arrêté, ${current} peut continuer`);
      return;
    }
    
    // Changer joueur actif + sauvegarder l'état de début de tour pour undo
    await updateRoomState((s) => {
      // Timers: flush current, start next
      ensureTimersShape(s);
      const now = (typeof Date !== 'undefined') ? Date.now() : 0;
      const cur = s.activePlayer;
      const nxt = cur === 'A' ? 'B' : 'A';

      // If current timer is running, account elapsed
      if(cur && s.timers?.[cur]){
        flushRunningTimer(s.timers[cur], now);
        // if time reached 0, mark out-of-time (final pass consumes here)
        if(calcMsLeft(s.timers[cur], now) <= 0){
          s.timers[cur].msLeft = 0;
          // consume the final pass right now (this click is the pass)
          if(s.timers[cur].finalPassAvailable){
            s.timers[cur].finalPassAvailable = false;
            s.timers[cur].locked = true;
          } else {
            s.timers[cur].locked = true;
          }
        }
      }

      // Determine who can receive the turn
      let nextPlayer = nxt;
      const nextBlocked = !!(s.stopped?.[nextPlayer] || s.timers?.[nextPlayer]?.locked);
      if(nextBlocked){
        // if next can't play, current keeps turn ONLY if current is not blocked
        const curBlocked = !!(s.stopped?.[cur] || s.timers?.[cur]?.locked);
        if(!curBlocked){
          nextPlayer = cur;
        } else {
          // both cannot play -> end by time draw
          s.phase = 'ended';
          s.endReason = 'time_draw';
          s.endedBy = 'timer';
          s.endedAt = Date.now();
          s.winner = null;
          s.result = { A: 'draw', B: 'draw' };
          s.activePlayer = null;
          return s;
        }
      }

      // set active
      s.activePlayer = nextPlayer;

      // Snapshot début de tour: seulement si on a effectivement changé de joueur
      if(nextPlayer !== cur){
        const snap = structuredClone(s);
        delete snap.turnStartSnapshot;
        s.turnStartSnapshot = snap;
      }

      // Start timer for active player if playable
      if(s.activePlayer && s.timers?.[s.activePlayer] && !(s.stopped?.[s.activePlayer]) && !(s.timers[s.activePlayer].locked)){
        startRunningTimer(s.timers[s.activePlayer], now);
      }

      // If both timers are locked, end by time draw
      if(!!(s.timers?.A?.locked) && !!(s.timers?.B?.locked)){
        s.phase = 'ended';
        s.endReason = 'time_draw';
        s.endedBy = 'timer';
        s.endedAt = Date.now();
        s.winner = null;
        s.result = { A: 'draw', B: 'draw' };
        s.activePlayer = null;
      }

      return s;
    }, 'advance-player');
    
    _log(`✅ [TURN] Tour passé : ${current} → ${next}`);
    pushLog(`↪️ Tour de ${slotLabel(next)}`);
    pushActivity(`↪️ Tour de ${slotLabel(next)}`);
  }

  /**
   * 🛑 MODE ENFANT V5 : Le joueur clique "Je m'arrête"
   */
  async function playerStops() {
    _log("🛑 [STOP] Joueur tente de s'arrêter...");
    
    // Guard
    if(!canWriteEnfant(false)) return;
    
    const st = roomState || initialRoomState();
    const mySlot = mySlotFromState(st);
    
    if(!mySlot || mySlot === 'spectator') {
      showToast("⚠️ Tu es spectateur");
      return;
    }

    // 🎯 MODE ENFANT : si un effet attend une cible, on ne peut pas s'arrêter
    if(isMyPendingEffect(st)){
      showToast("Résous l'effet en cours d'abord 🙂");
      return;
    }
    
    // Guard : Mon tour ?
    if(st.activePlayer !== mySlot) {
      showToast("⚠️ Ce n'est pas ton tour");
      return;
    }
    
    // Guard : Déjà arrêté ?
    if(st.stopped?.[mySlot]) {
      showToast("⚠️ Tu as déjà arrêté");
      return;
    }
    
    // Marquer arrêté + arrêter le timer de ce joueur (pause)
    await updateRoomState((s) => {
      s.stopped = s.stopped || { A: false, B: false };
      s.stopped[mySlot] = true;
      ensureTimersShape(s);
      const now = (typeof Date !== 'undefined') ? Date.now() : 0;
      if(s.timers?.[mySlot]){
        flushRunningTimer(s.timers[mySlot], now);
      }
      return s;
    }, 'player-stop');

    // Si tout le monde est arrêté, déclencher la Phase 3.
    // IMPORTANT: seul le writer leader (Joueur A) peut exécuter executePhase3().
    // Si B est le dernier à cliquer, on pose un flag "phase3Pending".
    try{
      const stAfter = roomState || initialRoomState();
      if(((stAfter.stopped?.A) || (stAfter.timers?.A?.locked)) && ((stAfter.stopped?.B) || (stAfter.timers?.B?.locked)) && !stAfter.phase3Done){
        if(canWriteEnfant(true)){
          await executePhase3();
          return;
        } else {
          await updateRoomState((s)=>{
            if(!s.phase3Done) s.phase3Pending = true;
            return s;
          }, 'phase3-pending');
          pushLog("⏳ Résolution de manche en cours...");
          return;
        }
      }
    }catch(_e){}
    
    console.log(`✅ [STOP] ${mySlot} s'arrête`);
    pushLog(`🛑 ${mySlot} s'arrête pour cette manche`);
    pushActivity(`🛑 ${slotLabel(mySlot)} s'est arrêté`);
    
    // Passer tour
    await advanceActivePlayer();
  }

  /**
   * 🎯 MODE ENFANT V5 : Phase 3 automatique (résolution de manche)
   * WRITER LEADER : Seul le joueur A exécute
   */
  async function executePhase3() {
    
    _log("🎯 [PHASE3] Tentative d'exécution Phase 3...");
    
    // Guard : Writer leader
    if(!canWriteEnfant(true)) return;
    
    const st = roomState || initialRoomState();
    
    // Guard : Pas déjà fait / pas déjà en cours ?
    if(st.phase3InProgress){
      console.log("⏳ [PHASE3] Déjà en cours");
      return;
    }
    if(st.phase3Done) {
      console.log("✅ [PHASE3] Déjà exécutée");
      return;
    }
    
    
    _log("🎯 [PHASE3] Exécution résolution...");
    
    try {
      const runId = makeActionId('phase3');
      await updateRoomStateAction((s) => {
        if(s.phase3InProgress) { s.__skipWrite = true; return s; }
        s.phase3InProgress = true;
        s.phase3RunId = runId;
        // Double guard
        if(s.phase3Done) {
          console.log("⚠️ [PHASE3] Double guard");
          return s;
        }
        
        // 1. SCORING (créatures debout)
        const calculateScore = (terrain) => {
          let total = 0;
          for(const creature of (terrain || [])) {
            if(!creature.tapped) {
              const card = cardsById.get(String(creature.cardId).padStart(3, '0'));
              total += (card?.points ?? card?.score ?? 1);
            }
          }
          return total;
        };
        
        const scoreA = calculateScore(s.terrains?.A);
        const scoreB = calculateScore(s.terrains?.B);
        
        _log(`📊 [PHASE3] Points manche : A=${scoreA}, B=${scoreB}`);
        
        s.scores = s.scores || { A: 0, B: 0 };
        s.scores.A += scoreA;
        s.scores.B += scoreB;
        
        _log(`📊 [PHASE3] Scores totaux : A=${s.scores.A}/12, B=${s.scores.B}/12`);
        
        // 2. NETTOYAGE
        s.vestiaires = s.vestiaires || { A: [], B: [] };
        s.terrains = s.terrains || { A: [], B: [] };
        
        
        const pushToVest = (slotKey, entry) => {
          if(!entry) return;
          const tok = (entry && typeof entry === 'object' && entry.inst) ? entry.inst : entry;
          const frontCid = (entry && typeof entry === 'object') ? (entry.originalCardId || entry.cardId) : null;
          // If we don't have a token (legacy), mint one so we don't lose instance handling
          const tok2 = tok ? tok : normalizeTokenInput(slotKey, frontCid || entry, s);
          s.vestiaires[slotKey].push(normalizeTokenToFront(tok2, frontCid));
        };
        for(const creature of (s.terrains.A || [])) pushToVest('A', creature);
        for(const creature of (s.terrains.B || [])) pushToVest('B', creature);
        
        s.terrains.A = [];
        s.terrains.B = [];
        
        console.log(`♻️ [PHASE3] Nettoyage terrains → vestiaires`);
        
        // 3. VICTOIRE ?
        if(s.scores.A >= 12 || s.scores.B >= 12) {
          _log("🏆 [PHASE3] VICTOIRE !");
          s.phase = "ended";
          s.result = {
            A: s.scores.A >= 12 ? "win" : "lose",
            B: s.scores.B >= 12 ? "win" : "lose"
          };
          const winner = s.scores.A >= 12 ? 'A' : 'B';
          pushLog(`🏆 Victoire ! ${winner} remporte la partie`);
        } else {
          // 4. NOUVELLE MANCHE
          _log("🔄 [PHASE3] Nouvelle manche");
          s.roundNumber = (s.roundNumber || 1) + 1;
          s.stopped = { A: false, B: false };
          s.startHandDrawn = { A: false, B: false };
          s.startHandDrawInProgress = false; // ✅ FIX : libérer le verrou pour permettre la pioche de la manche suivante
          
          // Alterner premier joueur (à chaque manche)
          s.starter = (s.starter === "A") ? "B" : "A";
          s.activePlayer = s.starter;
          
          _log(`🔄 [PHASE3] Manche ${s.roundNumber}, ${s.activePlayer} commence`);
        }
        
        // Marquer fait
        s.phase3Done = true;
        s.phase3Pending = false;
        s.phase3LastRunId = runId;
        s.phase3InProgress = false;
        
        return s;
      }, { reason:'execute-phase3', type:'phase3', actionId: runId });
      
      console.log("✅ [PHASE3] Phase 3 terminée");
      
      // Si pas victoire, piocher
      const stAfter = roomState || initialRoomState();
      { const sc = stAfter.scores || {A:0,B:0}; if(stAfter.phase === "ended") pushActivity(`🏆 Victoire ! Scores: A ${sc.A} — B ${sc.B}`); else pushActivity(`📊 Fin manche — A: ${sc.A}/12 | B: ${sc.B}/12`); }
      if(stAfter.phase !== "ended") {
        // Reset flag
        await updateRoomStateAction((s) => {
          s.phase3Done = false;
          s.phase3Pending = false;
          s.phase3InProgress = false;
          return s;
        }, { reason:'reset-phase3-flag', type:'phase3-reset' });
        
        // Lancer pioche
        setTimeout(() => {
          drawStartHands();
        }, 1000);
      }
      
      // Mettre à jour piste score
      if(typeof updateScoreTrack === 'function') updateScoreTrack();
      
    } catch(e) {
      console.error("❌ [PHASE3] Erreur:", e);
      reportError(e, "executePhase3");
    }
  }

  // Exposer fonctions
  window.advanceActivePlayer = advanceActivePlayer;
  window.playerStops = playerStops;
  window.executePhase3 = executePhase3;

  /**
   * 🎯 MODE ENFANT : Système d'effets automatiques de cartes
   * Déclenché automatiquement quand une créature arrive sur le terrain
   */
  async function triggerCardEffect(cardId, slot, sourceTok){
    const isEnfant = (typeof GAME_MODE !== "undefined" && GAME_MODE === "enfant");
    if(!isEnfant) return;

    _log(`[triggerCardEffect] cardId: ${cardId}, slot: ${slot}, sourceTok: ${sourceTok}`);
    
    const card = cardsById.get(String(cardId).padStart(3,'0'));
    if(!card || !card.effectId || card.effectId === "E_NONE") return;

    _log(`✨ Déclenchement effet automatique: ${card.name} (${card.effectId})`);
    
    // 🎯 L\'activation de l\'effet est décidée AVANT (modal Annuler/Non/Oui)

    pushLog(`✨ ${card.name} : ${card.text || 'Effet activé'}`);
    pushActivity(`✨ ${slotLabel(slot)} ${escapeHtml(card.name)} : ${escapeHtml((card.text || 'Effet').substring(0,40))}`);

    try {
      const result = await resolveCardEffect(card.effectId, slot, cardId, sourceTok);

      // result: true (done), false (impossible), "PENDING" (waiting for user pick)
      if(result === false){
        pushLog(`⚠️ ${card.name} : Effet impossible à réaliser`);
        // Passer quand même le tour si l'effet échoue
        await autoPassTurn(slot);
        return;
      }

      if(result === "PENDING"){
        // Un choix est en cours : ne PAS passer le tour maintenant.
        // Le tour passera automatiquement à la fin de la résolution du pendingEffect.
        return;
      }

      // 🎯 MODE ENFANT : Passer automatiquement le tour après résolution
      await autoPassTurn(slot);
    } catch(e){
      console.error("Erreur effet carte:", e);
      pushLog(`⚠️ Erreur lors de l'effet de ${card.name}`);
      // Passer quand même le tour même en cas d'erreur
      await autoPassTurn(slot);
    }
  }

  /**
   * 🎯 MODE ENFANT : Résolution des effets de cartes
   * Retourne true si succès, false si impossible
   */
  async function resolveCardEffect(effectId, slot, cardId, sourceTok){
    const st = roomState || initialRoomState();
    
    switch(effectId){
      // ===== Effets simples (pas d'interaction) =====
      
      case "E_DRAW_1": {
        // Pioche 1 carte
        const deckSize = (st.deckPiles && st.deckPiles[slot]) ? st.deckPiles[slot].length : 0;
        const vestSize = (st.vestiaires && st.vestiaires[slot]) ? st.vestiaires[slot].length : 0;
        
        if(deckSize === 0 && vestSize === 0){
          pushLog("⚠️ Deck et vestiaire vides, impossible de piocher");
          return false;
        }
        
        await drawToHandDb(slot, 1);
        pushLog(`📥 ${slotLabel(slot)} Pioche 1 carte`);
        return true;

      }
      case "E_GAIN_1_POINT":
        // Gagne 1 point directement — écrit dans scores (victoire) ET bubbles (piste visuelle)
        await updateRoomState((s) => {
          // scores : utilisé par executePhase3 pour le check victoire (>= 12)
          if(!s.scores) s.scores = { A: 0, B: 0 };
          s.scores[slot] = Number(s.scores[slot] || 0) + 1;
          // bubbles : fallback piste visuelle (legacy end-phase2)
          if(!s.bubbles) s.bubbles = { A:{state:'',occurrences:0}, B:{state:'',occurrences:0} };
          s.bubbles[slot].occurrences = Number(s.bubbles[slot].occurrences || 0) + 1;
          return s;
        }, 'effect-gain-point');
        if(typeof updateScoreTrack === 'function') updateScoreTrack();
        pushLog(`⭐ ${slotLabel(slot)} +1 point`);
        return true;

      case "E_DRAW_1_THEN_DISCARD_1_TO_LOCKER": {
        // Pioche 1, puis choisis 1 carte de ta main à mettre au Vestiaire
        // ATOMIC: draw + set pending in ONE DB write (same race fix as farce)
        const deckSize = (st.deckPiles && st.deckPiles[slot]) ? st.deckPiles[slot].length : 0;
        const vestSize = (st.vestiaires && st.vestiaires[slot]) ? st.vestiaires[slot].length : 0;
        if(deckSize === 0 && vestSize === 0){
          pushLog("⚠️ Deck et vestiaire vides, impossible de piocher");
          return false;
        }
        await updateRoomState((s) => {
          s.deckPiles = s.deckPiles || {A:[], B:[]};
          s.handPiles = s.handPiles || {A:[], B:[]};
          s.vestiaires = s.vestiaires || {A:[], B:[]};
          const deck = s.deckPiles[slot] || [];
          const hand = s.handPiles[slot] || [];
          const vest = s.vestiaires[slot] || [];
          if(deck.length === 0 && vest.length > 0){
            const mixed = shuffleInPlace(vest.slice());
            s.deckPiles[slot] = mixed;
            s.vestiaires[slot] = [];
            deck.length = 0; deck.push(...mixed); vest.length = 0;
          }
          if(deck.length > 0) hand.push(deck.shift());
          s.deckPiles[slot] = deck;
          s.handPiles[slot] = hand;
          if(s.players?.[slot]){
            s.players[slot].deckCount = deck.length;
            s.players[slot].handCount = hand.length;
          }
          s.pendingEffect = {
            by: slot, effectId: effectId, step: 1, picks: [],
            allowedZones: ['myHand'],
            hint: "Choisis 1 carte de ta main à mettre au Vestiaire"
          };
          return s;
        }, 'effect-draw1-locker1-atomic');
        pushLog(`📥 ${slotLabel(slot)} Pioche 1 carte`);
        try{ closeCardModal(); }catch(_e){}
        try{ closeZoneModal && closeZoneModal(); }catch(_e){}
        try{ const ov = document.getElementById("choiceModalOverlay"); if(ov) ov.remove(); }catch(_e){}
        showToast("Choisis 1 carte de ta main à mettre au Vestiaire", null, 0);
        return "PENDING";
      }
      case "E_DRAW_2_THEN_PUT_1_FROM_HAND_ON_TOP": {
        // Pioche 2, puis choisis 1 carte de ta main à remettre au-dessus du deck
        // ATOMIC: draw + set pending in ONE DB write to prevent race condition
        // (fast clicks between draw and pending could skip the pick step)
        const deckSize = (st.deckPiles && st.deckPiles[slot]) ? st.deckPiles[slot].length : 0;
        const vestSize = (st.vestiaires && st.vestiaires[slot]) ? st.vestiaires[slot].length : 0;
        if(deckSize === 0 && vestSize === 0){
          pushLog("⚠️ Deck et vestiaire vides, impossible de piocher");
          return false;
        }
        await updateRoomState((s) => {
          // --- Draw 2 cards (same logic as drawToHandDb) ---
          s.deckPiles = s.deckPiles || {A:[], B:[]};
          s.handPiles = s.handPiles || {A:[], B:[]};
          s.vestiaires = s.vestiaires || {A:[], B:[]};
          const deck = s.deckPiles[slot] || [];
          const hand = s.handPiles[slot] || [];
          const vest = s.vestiaires[slot] || [];
          for(let i = 0; i < 2; i++){
            if(deck.length === 0 && vest.length > 0){
              const mixed = shuffleInPlace(vest.slice());
              s.deckPiles[slot] = mixed;
              s.vestiaires[slot] = [];
              deck.length = 0;
              deck.push(...mixed);
              vest.length = 0;
            }
            if(deck.length > 0) hand.push(deck.shift());
            else break;
          }
          s.deckPiles[slot] = deck;
          s.handPiles[slot] = hand;
          if(s.players?.[slot]){
            s.players[slot].deckCount = deck.length;
            s.players[slot].handCount = hand.length;
          }
          // --- Set pending effect in the SAME write ---
          s.pendingEffect = {
            by: slot,
            effectId: effectId,
            step: 1,
            picks: [],
            allowedZones: ['myHand'],
            hint: "Choisis 1 carte de ta main à remettre sur le deck (dessus)"
          };
          return s;
        }, 'effect-draw2-put1-atomic');
        pushLog(`📥 ${slotLabel(slot)} Pioche 2 cartes`);
        // Close any open modals that could block the pick
        try{ closeCardModal(); }catch(_e){}
        try{ closeZoneModal && closeZoneModal(); }catch(_e){}
        try{ const ov = document.getElementById("choiceModalOverlay"); if(ov) ov.remove(); }catch(_e){}
        showToast("Choisis 1 carte de ta main à remettre sur le deck", null, 0);
        return "PENDING";
      }
      case "E_SWAP_TOP_DECKS":
        // Échange les premières cartes des deux decks
        let swapped = false;
        await updateRoomState((s) => {
          if(!s.deckPiles) return s;
          if((s.deckPiles.A||[]).length === 0 || (s.deckPiles.B||[]).length === 0) return s;
          
          const tempTop = s.deckPiles.A[0];
          s.deckPiles.A[0] = s.deckPiles.B[0];
          s.deckPiles.B[0] = tempTop;
          swapped = true;
          return s;
        }, 'effect-swap-tops');
        
        if(swapped){
          pushLog(`🔄 ${slotLabel(slot)} Échange du dessus des decks`);
          return true;
        } else {
          pushLog("⚠️ Un deck est vide, échange impossible");
          return false;
        }

      // ===== Effets avec choix (nécessitent modal) =====

      case "E_SLEEP_ENEMY_1": {
        // Endormir 1 créature adverse (choix)
        const oppSlot = otherSlot(slot);
        const oppTer = (st.terrains && st.terrains[oppSlot]) ? st.terrains[oppSlot] : [];
        const candidates = oppTer.filter(c => c && !c.tapped);
        if(candidates.length === 0){
          pushLog("⚠️ Aucune créature adverse debout à endormir");
          return false;
        }
        await setPendingEffect({
          by: slot,
          effectId: effectId,
          step: 1,
          picks: [],
          allowedZones: ['oppTerrain'],
          hint: "Choisis 1 créature adverse à endormir 😴"
        });
        showToast("Choisis 1 créature adverse à endormir 😴", null, 0);
        return "PENDING";
      }
      case "E_WAKE_1": {
        // Réveiller 1 créature endormie (choix)
        const myTer = (st.terrains && st.terrains[slot]) ? st.terrains[slot] : [];
        const oppSlot = otherSlot(slot);
        const oppTer = (st.terrains && st.terrains[oppSlot]) ? st.terrains[oppSlot] : [];
        const anyTapped = [...myTer, ...oppTer].some(c => c && c.tapped);
        if(!anyTapped){
          pushLog("⚠️ Aucune créature endormie à réveiller");
          return false;
        }
        await setPendingEffect({
          by: slot,
          effectId: effectId,
          step: 1,
          picks: [],
          allowedZones: ['myTerrain','oppTerrain'],
          hint: "Choisis 1 créature à réveiller 🙂"
        });
        showToast("Choisis 1 créature à réveiller 🙂", null, 0);
        return "PENDING";
      }
      case "E_DRAW_1_THEN_GIVE_1_FROM_HAND_TO_OPPONENT": {
        // Ordre correct : PIOCHE d'abord, puis choisis une carte à donner
        // ATOMIC: draw + set pending in ONE DB write (same race fix)
        const deckSize = (st.deckPiles && st.deckPiles[slot]) ? st.deckPiles[slot].length : 0;
        const vestSize = (st.vestiaires && st.vestiaires[slot]) ? st.vestiaires[slot].length : 0;
        if(deckSize === 0 && vestSize === 0){
          pushLog("⚠️ Deck et vestiaire vides, impossible de piocher");
          return false;
        }
        await updateRoomState((s) => {
          s.deckPiles = s.deckPiles || {A:[], B:[]};
          s.handPiles = s.handPiles || {A:[], B:[]};
          s.vestiaires = s.vestiaires || {A:[], B:[]};
          const deck = s.deckPiles[slot] || [];
          const hand = s.handPiles[slot] || [];
          const vest = s.vestiaires[slot] || [];
          if(deck.length === 0 && vest.length > 0){
            const mixed = shuffleInPlace(vest.slice());
            s.deckPiles[slot] = mixed;
            s.vestiaires[slot] = [];
            deck.length = 0; deck.push(...mixed); vest.length = 0;
          }
          if(deck.length > 0) hand.push(deck.shift());
          s.deckPiles[slot] = deck;
          s.handPiles[slot] = hand;
          if(s.players?.[slot]){
            s.players[slot].deckCount = deck.length;
            s.players[slot].handCount = hand.length;
          }
          s.pendingEffect = {
            by: slot, effectId: effectId, step: 1, picks: [],
            allowedZones: ['myHand'],
            hint: "Choisis 1 carte de ta main à donner à l'adversaire 🎁"
          };
          return s;
        }, 'effect-draw1-give1-atomic');
        pushLog(`📥 ${slotLabel(slot)} pioche 1 carte`);
        try{ closeCardModal(); }catch(_e){}
        try{ closeZoneModal && closeZoneModal(); }catch(_e){}
        try{ const ov = document.getElementById("choiceModalOverlay"); if(ov) ov.remove(); }catch(_e){}
        showToast("Choisis 1 carte de ta main à donner 🎁", null, 0);
        return "PENDING";
      }
      case "E_SWAP_HAND_WITH_LOCKER_1":
        // Échange 1 carte de la main avec 1 carte du vestiaire (choix en 2 étapes)
        const hand = (st.handPiles && st.handPiles[slot]) ? st.handPiles[slot] : [];
        const vest = (st.vestiaires && st.vestiaires[slot]) ? st.vestiaires[slot] : [];
        if(hand.length === 0){
          pushLog("⚠️ Main vide, impossible d'échanger");
          return false;
        }
        if(vest.length === 0){
          pushLog("⚠️ Vestiaire vide, impossible d'échanger");
          return false;
        }
        await setPendingEffect({
          by: slot,
          effectId: effectId,
          step: 1,
          picks: [],
          allowedZones: ['myHand'],
          hint: "Choisis 1 carte de ta main"
        });
        showToast("Choisis 1 carte de ta main", null, 0);
        return "PENDING";
      case "E_SWAP_CREATURES_ACROSS_FIELDS_1": {
        // Échange 1 créature de ton terrain avec 1 créature adverse (2 étapes)
        const myTer = (st.terrains && st.terrains[slot]) ? st.terrains[slot] : [];
        const oppSlot = otherSlot(slot);
        const oppTer = (st.terrains && st.terrains[oppSlot]) ? st.terrains[oppSlot] : [];
        if(myTer.length === 0){
          pushLog("⚠️ Ton terrain est vide, impossible d'échanger");
          return false;
        }
        if(oppTer.length === 0){
          pushLog("⚠️ Terrain adverse vide, impossible d'échanger");
          return false;
        }
        await setPendingEffect({
          by: slot,
          effectId: effectId,
          step: 1,
          picks: [],
          allowedZones: ['myTerrain'],
          hint: "Choisis 1 de tes créatures"
        });
        showToast("Choisis 1 de tes créatures", null, 0);
        return "PENDING";
      }
      case "E_SEND_OWN_CREATURE_TO_LOCKER_THEN_FLIP": {
        // Sacrifice X créatures (selon flipCost), puis flip
        const myTer = (st.terrains && st.terrains[slot]) ? st.terrains[slot] : [];
        const srcCid = sourceTok ? String(getCid(sourceTok)).padStart(3,'0') : null;
        
        // Lire le flipCost de la carte source
        const sourceCard = srcCid ? cardsById.get(srcCid) : null;
        const flipCost = sourceCard?.flipCost || 1;
        
        const candidates = myTer.filter(c => {
          if(!c) return false;
          if(sourceTok && c.inst === sourceTok) return false;
          return true;
        });
        
        if(candidates.length < flipCost){
          pushLog(`⚠️ Pas assez de créatures à sacrifier (besoin: ${flipCost})`);
          return false;
        }
        
        await setPendingEffect({
          by: slot,
          effectId: effectId,
          step: 1,
          picks: [],
          maxPicks: flipCost,
          allowedZones: ['myTerrain'],
          hint: `Choisis ${flipCost} créature${flipCost>1?'s':''} à sacrifier 🧥`,
          sourceTok: sourceTok || null
        });
        showToast(`Choisis ${flipCost} créature${flipCost>1?'s':''} à sacrifier 🧥`, null, 0);
        return "PENDING";
      }

      default:
        console.warn(`Effet non implémenté: ${effectId}`);
        return false;
    }
  }

  /**
   * 🎯 MODE ENFANT : Flip une carte sur le terrain (1 → 12)
   * Utilisé par E_SEND_OWN_CREATURE_TO_LOCKER_THEN_FLIP
   */
  async function flipCardOnTerrain(oldCardId, slot, newCardId){
    await updateRoomState((s) => {
      if(!s.terrains || !s.terrains[slot]) return s;
      
      const terrain = s.terrains[slot];
      const cardIndex = terrain.findIndex(c => 
        String(c.cardId).padStart(3,'0') === String(oldCardId).padStart(3,'0')
      );
      
      if(cardIndex >= 0){
        // Garder les mêmes propriétés mais changer l'ID
        terrain[cardIndex].cardId = newCardId;
        _log(`🔄 Carte ${oldCardId} → ${newCardId}`);
      }
      
      return s;
    }, 'flip-card');
  }

  /**
   * 🎯 MODE ENFANT : Pioche X cartes pour un slot (via DB)
   */
  async function drawToHandDb(slot, count){
    await updateRoomState((s) => {
      s.deckPiles = s.deckPiles || {A:[], B:[]};
      s.handPiles = s.handPiles || {A:[], B:[]};
      s.vestiaires = s.vestiaires || {A:[], B:[]};

      const deck = s.deckPiles[slot] || [];
      const hand = s.handPiles[slot] || [];
      const vest = s.vestiaires[slot] || [];

      for(let i=0; i<count; i++){
        // Si deck vide, recycler vestiaire
        if(deck.length === 0 && vest.length > 0){
          console.log(`♻️ Deck vide, recyclage du Vestiaire pour ${slot}`);
          const mixed = shuffleInPlace(vest.slice());
          s.deckPiles[slot] = mixed;
          s.vestiaires[slot] = [];
          deck.length = 0;
          deck.push(...mixed);
          vest.length = 0;
        }

        // Piocher
        if(deck.length > 0){
          hand.push(deck.shift());
        } else {
          console.log(`⚠️ Impossible de piocher pour ${slot} (deck et vestiaire vides)`);
          break;
        }
      }

      s.deckPiles[slot] = deck;
      s.handPiles[slot] = hand;
      
      // Update counts
      if(s.players?.[slot]){
        s.players[slot].deckCount = deck.length;
        s.players[slot].handCount = hand.length;
      }

      return s;
    }, 'draw-cards');
  }

  /**
   * 🎯 MODE ENFANT : Passer automatiquement le tour après une action
   */
  /**
   * 🔄 Passer automatiquement le tour
   * MODE ENFANT V5 : Appelle advanceActivePlayer (nouvelle logique)
   * MODE COMPLEXE : Garde l'ancienne logique
   */
  async function autoPassTurn(slot){
    // MODE ENFANT V5 : Utiliser nouvelle logique
    const isEnfant = (typeof GAME_MODE !== "undefined" && GAME_MODE === "enfant");
    if(isEnfant) {
      await advanceActivePlayer();
      return;
    }
    
    // MODE COMPLEXE : Ancienne logique
    const st = roomState || initialRoomState();
    
    // Vérifier que le joueur n'a pas déjà passé
    if(st.passes && st.passes[slot]){
      _log(`⏭️ ${slot} a déjà passé, pas de changement de tour`);
      return;
    }

    const nextPlayer = slot === "A" ? "B" : "A";
    
    // Ne passer le tour que si l'adversaire n'a pas passé
    if(st.passes && st.passes[nextPlayer]){
      _log(`⏭️ ${nextPlayer} a déjà passé, ${slot} peut continuer`);
      return;
    }

    await updateRoomState((s) => {
      s.currentPlayer = nextPlayer;
      return s;
    }, "auto-pass-turn");
    
    pushLog(`↪️ Tour passé à ${slotLabel(nextPlayer)}`);
  }

  // Exposer les fonctions
  window.triggerCardEffect = triggerCardEffect;
  window.autoPassTurn = autoPassTurn;

  if(rollBtn){
    rollBtn.onclick = async () => {
      try{
        if(!connected) return;
        const st = roomState || initialRoomState();
        const slot = mySlotFromState(st);
        if(!slot){
          alert("Spectateur: impossible de lancer le dé.");
          return;
        }
        const v = 1 + Math.floor(Math.random() * 12);

        if(st.phase === "started"){
          // Dé en cours de partie: on stocke un "lastDice" sans toucher aux dés de départ
          await updateRoomState((s) => {
            s.misc = s.misc || {};
            s.misc.lastDice = { slot, value: v, at: Date.now() };
            return s;
          }, "dice");
          setDiceUI(`d12:${v}`);
          pushLog(`Dé d12: ${v}`);
          return;
        }

        // En lobby: on remplit dice A/B et si les deux sont là, on calcule starter (sans forcer started)
        await updateRoomState((s) => {
          s.dice = s.dice || { A:null, B:null };
          s.dice[slot] = v;
          const a = s.dice.A;
          const b = s.dice.B;
          if(Number.isFinite(a) && Number.isFinite(b) && a !== b){
            s.starter = a > b ? "A" : "B";
          }
          return s;
        }, "dice-lobby");
        pushLog(`Dé d12 (${slot}): ${v}`);
      }catch(e){
        reportError(e,"roll");
      }
    };
  }

  // Bouton "Resync" (lecture seule) : relit l'état DB et rerender.
  if(resyncBtn){
    resyncBtn.onclick = async () => {
      await forceResync();
    };
  }

  // Bouton "Recover UI" : referme les menus et force un rerender complet (sans reset, sans écriture DB).
  if(recoverBtn){
    recoverBtn.onclick = () => {
      try{ recoverUI("manual"); }catch(e){ console.warn(e); }
    };
  }
  if(roomInput){
    roomInput.onchange = async () => {
      setRoom(getRoom());
      // Changement de room = on repart en lobby côté UI et on invite à reconnecter
      myReady = false;
      syncBtnLabel();
      localDeckReady = false;
      otherDeckReady = false;
      resetStartStateLocal();

      if(decklistInput){
        decklistInput.value = storage.get(roomStorageKey("decklistText")) || "";
      }

      updateFlowNote("Room changée : reconnecte-toi pour charger l'état DB de la nouvelle room.");
      pushLog(`Room = ${getRoom()}`);

      // Si déjà connecté, on se déconnecte proprement pour éviter les mix d'abonnements DB
      try{ if(connected) await disconnect(); }catch(_e){ _sw("disconnect",_e); }
    };
  }

  const sbUrlInput = $("sbUrlInput");
  const sbKeyInput = $("sbKeyInput");
  const saveConfigBtn = $("saveConfigBtn");
  const resetConfigBtn = $("resetConfigBtn");

  function roomKey(){
    return getRoom();
  }

  function applyConfigToUI(){
    if(sbUrlInput) sbUrlInput.value = CONFIG.supabaseUrl;
    if(sbKeyInput) sbKeyInput.value = CONFIG.supabaseAnonKey;
  }
  applyConfigToUI();

  if(saveConfigBtn) saveConfigBtn.onclick = () => {
    CONFIG = {
      ...CONFIG,
      supabaseUrl: (sbUrlInput?.value || "").trim() || CONFIG_DEFAULT.supabaseUrl,
      supabaseAnonKey: (sbKeyInput?.value || "").trim() || CONFIG_DEFAULT.supabaseAnonKey
    };
    saveConfig(CONFIG);
    pushLog("Config Supabase sauvegardée");
  };
  if(resetConfigBtn) resetConfigBtn.onclick = () => {
    CONFIG = { ...CONFIG_DEFAULT };
    saveConfig(CONFIG);
    applyConfigToUI();
    pushLog("Config Supabase réinitialisée");
  };

  // ===== Menu buttons routing (Journal / Main / Setup) =====
  // NOTE: these buttons must stay enabled; hiding them makes the game impossible to start.
  const logBtn = $("logBtn");
  const setupBtn = $("setupBtn");
  const midBtn = $("midBtn");

  // Some mobile browsers (and/or PIXI pointer handling) can prevent the synthetic
  // 'click' event from firing. Bind pointer/touch handlers too so the top bar
  // remains usable everywhere.
  const bindFastTap = (el, fn) => {
    if (!el) return;
    const handler = (e) => {
      try { e?.preventDefault?.(); } catch(_) {}
      try { e?.stopPropagation?.(); } catch(_) {}
      try { fn(); } catch(err) { console.error('[TopBar] handler error', err); }
      return false;
    };
    // Make sure the browser does not add click delays / gestures.
    try { el.style.touchAction = 'manipulation'; } catch(_) {}
    el.onclick = handler;
    el.onpointerdown = handler;
    el.ontouchstart = handler;
  };

  if(logBtn) {
    logBtn.style.display = "";
    bindFastTap(logBtn, () => window.openPanel({ mode: "modal", view: PANEL_VIEW.LOG, title: "Journal", context: "" }));
  }

  // Middle button = Hand
  if(midBtn) {
    bindFastTap(midBtn, () => {
      // Fallback: open the hand panel/drawer if available
      if (typeof window.openHandPanel === "function") return window.openHandPanel();
      if (typeof window.openHand === "function") return window.openHand();
      // If neither exists, at least open the GAME panel (better than nothing)
      return window.openPanel({ mode: "modal", view: PANEL_VIEW.GAME, title: "Partie", context: "" });
    });
  }

  if(setupBtn) {
    setupBtn.style.display = "";
    bindFastTap(setupBtn, () => window.openPanel({ mode: "modal", view: PANEL_VIEW.SETUP, title: "Setup / Connexion", context: "" }));
  }

  // ===== Floating Hand Button =====
  if(handFloatingBtn){
    // Variables pour le drag
    let isDragging = false;
    let handOpenedFromTouch = false; // ✅ FIX: Flag pour éviter double ouverture mobile
    let dragStartX = 0;
    let dragStartY = 0;
    let buttonStartX = 0;
    let buttonStartY = 0;
    let dragThreshold = 10; // Seuil en pixels pour distinguer click vs drag
    let hasMoved = false;
    
    // Récupérer et appliquer la position sauvegardée IMMÉDIATEMENT pour éviter le sursaut
    const savedPos = localStorage.getItem('handButtonPos');
    if(savedPos){
      try{
        const pos = JSON.parse(savedPos);
        // Appliquer la position avant que le bouton ne soit visible
        handFloatingBtn.style.left = pos.x + 'px';
        handFloatingBtn.style.top = pos.y + 'px';
        handFloatingBtn.style.right = 'auto';
        handFloatingBtn.style.bottom = 'auto';
        handFloatingBtn.style.transition = 'box-shadow 200ms ease';
      }catch(e){
        // En cas d'erreur, position par défaut
        setDefaultPosition();
      }
    } else {
      // Pas de position sauvegardée, utiliser position par défaut
      setDefaultPosition();
    }
    
    function setDefaultPosition(){
      // Position par défaut: côté droit, mi-hauteur
      const defaultX = window.innerWidth - 80; // 80px du bord droit
      const defaultY = window.innerHeight / 2 - 35; // Centré verticalement (35 = moitié de la hauteur du bouton)
      
      handFloatingBtn.style.left = defaultX + 'px';
      handFloatingBtn.style.top = defaultY + 'px';
      handFloatingBtn.style.right = 'auto';
      handFloatingBtn.style.bottom = 'auto';
      handFloatingBtn.style.transition = 'box-shadow 200ms ease';
    }
    
    function doDrag(e){
      if(!isDragging) return;
      
      // Position actuelle du pointeur
      let currentX, currentY;
      if(e.type === 'mousemove'){
        currentX = e.clientX;
        currentY = e.clientY;
      } else {
        currentX = e.touches[0].clientX;
        currentY = e.touches[0].clientY;
      }
      
      // Calculer le déplacement
      const deltaX = currentX - dragStartX;
      const deltaY = currentY - dragStartY;
      
      // Si on a bougé plus que le seuil, c'est un drag
      if(Math.abs(deltaX) > dragThreshold || Math.abs(deltaY) > dragThreshold){
        if(!hasMoved){
          hasMoved = true;
          handFloatingBtn.classList.add('dragging');
        }
        
        // Nouvelle position
        let newX = buttonStartX + deltaX;
        let newY = buttonStartY + deltaY;
        
        // Contraintes pour garder le bouton dans la fenêtre
        const btnRect = handFloatingBtn.getBoundingClientRect();
        const maxX = window.innerWidth - btnRect.width;
        const maxY = window.innerHeight - btnRect.height;
        
        newX = Math.max(0, Math.min(newX, maxX));
        newY = Math.max(0, Math.min(newY, maxY));
        
        // Appliquer la position
        handFloatingBtn.style.left = newX + 'px';
        handFloatingBtn.style.top = newY + 'px';
        handFloatingBtn.style.right = 'auto';
        handFloatingBtn.style.bottom = 'auto';
        
        e.preventDefault();
        e.stopPropagation();
      }
    }
    
    function endDrag(e){
      if(!isDragging) return;
      
      // Détacher les event listeners
      document.removeEventListener('mousemove', doDrag);
      document.removeEventListener('mouseup', endDrag);
      document.removeEventListener('touchmove', doDrag);
      document.removeEventListener('touchend', endDrag);
      
      isDragging = false;
      handFloatingBtn.classList.remove('dragging');
      
      // Si on a bougé, sauvegarder la position
      if(hasMoved){
        const rect = handFloatingBtn.getBoundingClientRect();
        localStorage.setItem('handButtonPos', JSON.stringify({
          x: rect.left,
          y: rect.top
        }));
        e.preventDefault();
        e.stopPropagation();
      } else {
        // ✅ FIX: Ouvrir seulement si pas déjà ouvert par touchend
        if(!handOpenedFromTouch && e.type !== 'touchend'){
          renderHandCards();
          openPanel({mode:"modal", view:PANEL_VIEW.HAND, title:"Ma Main"});
        }
      }
      
      // ✅ FIX: Reset du flag après un court délai
      setTimeout(() => {
        handOpenedFromTouch = false;
      }, 100);
    }
    
    function startDrag(e){
      isDragging = true;
      hasMoved = false;
      
      // ✅ FIX: Marquer qu'on a commencé un drag
      e.target.dataset.dragStarted = 'true';
      
      // Position de départ du pointeur
      if(e.type === 'mousedown'){
        dragStartX = e.clientX;
        dragStartY = e.clientY;
      } else {
        dragStartX = e.touches[0].clientX;
        dragStartY = e.touches[0].clientY;
      }
      
      // Position actuelle du bouton
      const rect = handFloatingBtn.getBoundingClientRect();
      buttonStartX = rect.left;
      buttonStartY = rect.top;
      
      // Attacher les event listeners uniquement pendant le drag
      document.addEventListener('mousemove', doDrag);
      document.addEventListener('mouseup', endDrag);
      document.addEventListener('touchmove', doDrag, {passive: false});
      document.addEventListener('touchend', endDrag);
      
      // Ne pas faire preventDefault ici pour permettre le click
    }
    
    // Event listeners uniquement sur le bouton pour démarrer
    handFloatingBtn.addEventListener("mousedown", startDrag);
    handFloatingBtn.addEventListener("touchstart", startDrag, {passive: true});
    
    // ✅ FIX: Gestion touchend pour mobile (sans popup parasite)
    handFloatingBtn.addEventListener("touchend", (e) => {
      if(!isDragging) {
        // Simple tap sur mobile
        e.preventDefault();
        e.stopPropagation();
        handOpenedFromTouch = true; // ✅ Marquer qu'on a ouvert depuis ce listener
        renderHandCards();
        openPanel({mode:"modal", view:PANEL_VIEW.HAND, title:"Ma Main"});
      }
    }, {passive: false});
  }

  // ===== Deck Browser (comme la main, mais pour parcourir / chercher dans le deck) =====
  let deckBrowserFilter = null;
  // Anti double-clic / UI stale (deck browser): on marque les cartes en cours de déplacement
  const pendingDeckMoves = new Set();
 // { typeContains, subtypeContains, query }

  function normalizeStr(s){
    return (s ?? '').toString().toLowerCase();
  }

  function cardMatchesDeckSearch(card, query, filter){
    if(!card) return false;
    const q = normalizeStr(query).trim();

    // Filtre "type" / "subtype" (optionnel)
    if(filter && typeof filter === 'object'){
      if(filter.typeContains){
        const t = normalizeStr(card.type);
        if(!t.includes(normalizeStr(filter.typeContains))) return false;
      }
      if(filter.subtypeContains){
        const subs = (card.subtypes || []).map(normalizeStr).join(' ');
        if(!subs.includes(normalizeStr(filter.subtypeContains))) return false;
      }
    }

    if(!q) return true;

    const hay = [
      card.name,
      card.type,
      (card.subtypes || []).join(' '),
      card.text
    ].map(normalizeStr).join(' | ');

    return hay.includes(q);
  }

  function renderDeckCards(){
    if(!deckCardsContainer) return;

    const filter = (deckBrowserFilter && typeof deckBrowserFilter === 'object') ? deckBrowserFilter : null;
    const query = (deckSearchInput && deckSearchInput.value != null) ? deckSearchInput.value : (filter && filter.query ? String(filter.query) : '');
    // Hint + count (reprend le style de la main)
    const hintParts = [];
    if(filter && (filter.typeContains || filter.subtypeContains)) {
      const parts = [];
      if(filter.typeContains) parts.push(`type: ${filter.typeContains}`);
      if(filter.subtypeContains) parts.push(`sous-type: ${filter.subtypeContains}`);
      hintParts.push(`filtre (${parts.join(', ')})`);
    }
    if(query && query.trim()) hintParts.push(`recherche: "${query.trim()}"`);
    if(deckSearchHint) deckSearchHint.textContent = hintParts.length ? hintParts.join(' — ') : 'Deck (playtest)';

    deckCardsContainer.innerHTML = '';

    if(!Array.isArray(myDeckPile) || myDeckPile.length === 0){
      const empty = document.createElement('div');
      empty.style.padding = '20px';
      empty.style.textAlign = 'center';
      empty.style.opacity = '0.7';
      empty.textContent = 'Deck vide';
      deckCardsContainer.appendChild(empty);
      return;
    }

    // Top du deck = index 0 (comme drawCards: shift)
    let shown = 0;
    for(const cardTok of myDeckPile){
      const card = cardByToken(cardTok);
      const cardId = getCid(cardTok);
      if(!card) continue;
      if(!cardMatchesDeckSearch(card, query, filter)) continue;
      shown += 1;

      const div = document.createElement('div');
      div.className = 'handCard';
      div.style.cursor = 'pointer';

      // Anti double-clic: si cette carte est déjà en cours de déplacement, on la désactive visuellement
      if (pendingDeckMoves && pendingDeckMoves.has(cardTok)) {
        div.style.opacity = '0.45';
        div.style.pointerEvents = 'none';
      }

      // MODE ENFANT : "art only" (toutes les infos sont sur l'illustration)
      const isEnfant = (typeof GAME_MODE !== "undefined" && GAME_MODE === "enfant") || (roomState && roomState.gameMode === "enfant");
      if(isEnfant){
        div.classList.add("enfantArtOnly");
        const art = document.createElement('div');
        art.className = 'cardArt';
        const img = document.createElement('img');
        img.alt = card.name || '';
        img.loading = 'lazy';
        img.decoding = 'async';
        const s = safeImageSrc(card.image || '');
        img.src = s || '/assets/cards/placeholder.jpg';
        img.onerror = () => { img.onerror = null; img.src = '/assets/cards/placeholder.jpg'; };
        art.appendChild(img);
        div.appendChild(art);
        div.addEventListener('click', () => {
          openCardModal(cardTok, 'myDeck');
        });
        deckCardsContainer.appendChild(div);
        continue; // Passer à la carte suivante
      }

      if(card.cost != null){
        const costDiv = document.createElement('div');
        costDiv.className = 'card-cost';
        costDiv.textContent = card.cost;
        div.appendChild(costDiv);
      }

      const nameLabel = document.createElement('div');
      nameLabel.className = 'cardName';
      nameLabel.textContent = card.name || '???';
      div.appendChild(nameLabel);

      if(card.type){
        const typeLabel = document.createElement('div');
        typeLabel.className = 'cardType';
        typeLabel.textContent = card.type;
        div.appendChild(typeLabel);
      }

      if(card.subtypes && card.subtypes.length > 0){
        const subtypesLabel = document.createElement('div');
        subtypesLabel.className = 'cardSubtypes';
        subtypesLabel.textContent = card.subtypes.join(' ');
        div.appendChild(subtypesLabel);
      }

      if(card.text){
        const textLabel = document.createElement('div');
        textLabel.className = 'cardText';
        const shortText = card.text.length > 60 ? card.text.substring(0, 60) + '.' : card.text;
        textLabel.textContent = shortText;
        div.appendChild(textLabel);
      }

      // Clic = ouvrir le modal de carte (fromZone = myDeck)
      div.addEventListener('click', () => {
        openCardModal(cardTok, 'myDeck');
      });

      deckCardsContainer.appendChild(div);
    }

    // Count (affiché dans le pill)
    if(deckSearchCount){
      const hasFilter = !!(filter && (filter.typeContains || filter.subtypeContains));
      const hasQuery = !!(query && String(query).trim());
      deckSearchCount.textContent = (hasFilter || hasQuery) ? `${shown} / ${myDeckPile.length}` : `${myDeckPile.length}`;
    }

    
    if(shown === 0){
      const empty = document.createElement('div');
      empty.style.padding = '20px';
      empty.style.textAlign = 'center';
      empty.style.opacity = '0.7';
      empty.textContent = 'Aucune carte ne correspond';
      deckCardsContainer.appendChild(empty);
    }
  }

  function openDeckBrowser(filterObj = null){
    deckBrowserFilter = (filterObj && typeof filterObj === 'object') ? filterObj : null;

    // Message anti-triche visible par les deux joueurs
    pushLog('📖 Consultation du deck en cours...');

    // Pré-remplir la recherche si filtre.query existe
    if(deckSearchInput){
      deckSearchInput.value = (deckBrowserFilter && deckBrowserFilter.query) ? String(deckBrowserFilter.query) : '';
    }

    renderDeckCards();

    const count = Array.isArray(myDeckPile) ? myDeckPile.length : 0;
    const ctx = deckBrowserFilter ? 'Filtre actif (playtest)' : 'Deck (playtest)';
    openPanel({mode:'modal', view:PANEL_VIEW.DECK, title:'Mon Deck', context:``});
    // Focus recherche: desktop uniquement (sur mobile, ne pas ouvrir le clavier automatiquement)
    if(deckSearchInput){
      const isTouch = ("ontouchstart" in window) || (navigator.maxTouchPoints && navigator.maxTouchPoints > 0);
      const isFinePointer = !!(window.matchMedia && window.matchMedia("(pointer:fine)").matches);
      if(!isTouch && isFinePointer){
        setTimeout(()=>{ try{ deckSearchInput.focus(); }catch(e){} }, 50);
      }
    }
  }

  // Search listeners
  if(deckSearchInput){
    deckSearchInput.addEventListener('input', () => {
      try{ renderDeckCards(); }catch(e){ reportError(e,'deck-search'); }
    });
  }

  // Exposer pour les onclick / effets
  window.openDeckBrowser = openDeckBrowser;

  // ===== Game UI (pivot + long press actions) =====
  const actionsBox = $("actionsBox");
  function openActionsMenu(title, ctxHtml, items){
    if(actionsBox) actionsBox.innerHTML = "";
    if(Array.isArray(items) && actionsBox){
      for(const it of items){
        const b = document.createElement("button");
        b.className = "setupBtn secondary";
        b.style.width = "100%";
        b.style.marginBottom = "8px";
        b.textContent = it.label;
        b.addEventListener("click", () => {
          try{ it.onClick && it.onClick(); }catch(e){ reportError(e,"action"); }
        });
        actionsBox.appendChild(b);
      }
    }
    openPanel({mode:"modal", view:PANEL_VIEW.ACTIONS, title, context: ctxHtml || ""});
  }

  // Prevent selection/context menu on interactive elements
  document.addEventListener("contextmenu", (e) => {
    const t = e.target;
    if(t && ((t.closest(".btn") || t.closest(".square") || t.closest(".menuBtn")) || t.closest(".card"))) e.preventDefault();
  }, {capture:true});

  function isPivotable(el){
    return !!(el && el.classList && el.classList.contains("square"));
  }

  // Tap pivot
  function togglePivot(el){
    if(!el) return;
    el.classList.toggle("is-vertical");
  }

  // Long press handling
  const LP = { 
    timer:null, 
    fired:false, 
    target:null,
    startX: 0,
    startY: 0,
    moved: false
  };
  
  function clearLongPress(){
    if(LP.timer) clearTimeout(LP.timer);
    LP.timer=null; LP.fired=false; LP.target=null; LP.moved=false;
  }

  function handlePointerDown(e){
    const el = e.currentTarget;
    LP.fired=false;
    LP.target=el;
    LP.moved=false;
    
    // 🔧 CORRECTION: Enregistrer la position de départ
    LP.startX = e.clientX || (e.touches && e.touches[0] ? e.touches[0].clientX : 0);
    LP.startY = e.clientY || (e.touches && e.touches[0] ? e.touches[0].clientY : 0);
    
    clearTimeout(LP.timer);
    LP.timer = setTimeout(() => {
      // 🔧 CORRECTION: Ne déclencher le long press que si l'utilisateur n'a pas bougé
      if(!LP.moved){
        LP.fired=true;
        // Open actions menu for pivotables
        const label = (el && el.textContent) ? el.textContent.replace(/\s+/g," ").trim() : "Action";
        openActionsMenu("Actions", `<div style="opacity:.85;font-size:12px;">${escapeHtml(label)}</div>`, [
          { label:"(placeholder) Action 1", onClick: () => pushLog(`Action 1 sur ${label}`) },
          { label:"(placeholder) Action 2", onClick: () => pushLog(`Action 2 sur ${label}`) }
        ]);
      }
    }, CONFIG.longPressMs);
  }
  
  // 🔧 NOUVEAU: Gérer le mouvement pendant le long press
  function handlePointerMove(e){
    if(LP.target && LP.timer && !LP.fired){
      const currentX = e.clientX || (e.touches && e.touches[0] ? e.touches[0].clientX : 0);
      const currentY = e.clientY || (e.touches && e.touches[0] ? e.touches[0].clientY : 0);
      
      const deltaX = Math.abs(currentX - LP.startX);
      const deltaY = Math.abs(currentY - LP.startY);
      
      // 🔧 CORRECTION: Si l'utilisateur bouge de plus de 10px, annuler le long press
      if(deltaX > 10 || deltaY > 10){
        LP.moved = true;
        clearLongPress();
      }
    }
  }
  
  function handlePointerUp(e){
    const el = e.currentTarget;
    if(LP.timer) clearTimeout(LP.timer);
    if(!LP.fired && !LP.moved){
      // Short tap
      togglePivot(el);
      // TODO later: broadcast pivot here
    }
    clearLongPress();
  }
  function handlePointerCancel(){
    clearLongPress();
  }

  // Bind pivotable squares
  function bindPivotables(){
    const pivots = Array.from(document.querySelectorAll(".btn.square, .card"));
    for(const el of pivots){
      // IMPORTANT: ignore game-zone-btn qui ont déjà leurs propres onclick
      if(el.classList.contains("game-zone-btn")) continue;
      
      // make selection-proof
      el.style.userSelect = "none";
      el.style.webkitUserSelect = "none";
      el.style.touchAction = "none";
      el.addEventListener("pointerdown", handlePointerDown);
      el.addEventListener("pointermove", handlePointerMove); // 🔧 AJOUTÉ
      el.addEventListener("pointerup", handlePointerUp);
      el.addEventListener("pointercancel", handlePointerCancel);
      // 🔧 SUPPRIMÉ: pointerleave car il cause des problèmes sur mobile
    }
  }
  bindPivotables();

  // 🔧 CORRECTION: Exposer clearLongPress pour pouvoir l'appeler depuis d'autres fonctions
  window.clearLongPress = clearLongPress;

  // Non-pivot buttons open actions menu on tap
  function bindNonPivotButtons(){
    const btns = Array.from(document.querySelectorAll(".btn:not(.square)"));
    for(const el of btns){
      // ignore menu buttons
      if(el.closest(".menuBtn")) continue;
      // IMPORTANT: ignore game-zone-btn qui ont déjà leurs propres onclick
      if(el.classList.contains("game-zone-btn")) continue;
      
      el.style.userSelect = "none";
      el.addEventListener("click", () => {
        const label = (el.textContent||"").replace(/\s+/g," ").trim();
        openActionsMenu("Menu", `<div style="opacity:.85;font-size:12px;">${escapeHtml(label)}</div>`, [
          { label:"(placeholder) Voir", onClick: () => pushLog(`Voir ${label}`) }
        ]);
      });
    }
  }
  bindNonPivotButtons();

  // =====================================================================
  // SECTION:SUPABASE
  // =====================================================================

  // ===== Supabase (minimal connect + presence + remote log only) =====
  let sb = null;
  let connected = false;
  let mySlot = null; // "A" | "B" | "spectator" | null

  // Note: Si vous voyez des warnings "Multiple GoTrueClient instances" dans la console,
  // c'est normal en développement. Le code ci-dessous tente de les éviter en réutilisant
  // le client existant, mais Supabase peut quand même afficher ces warnings.
  // Ils ne causent aucun problème de fonctionnement.

  // =====================================================================
  // SECTION:STATE
  // =====================================================================

  // ===== RoomState DB (source de vérité unique) =====
  // Tout ce qui est "prêt / deck OK / dés / starter" vient de la table rooms.state (jsonb).
  // On garde presence/broadcast pour plus tard, mais on NE l'utilise pas pour l'état de partie.
  let roomCodeActive = null;
  let roomState = null;       // dernier state json
  let roomVersion = 0;        // version (optimistic lock)
  let roomRt = null;          // channel realtime (postgres_changes)

  // Helper: vérifier que Supabase est connecté
  function requireSupabase(fnName = "fonction inconnue") {
    if (!sb) {
      const msg = `❌ ${fnName} : Supabase non connecté`;
      console.error(msg);
      showToast("⚠️ Connexion requise");
      throw new Error(msg);
    }
    if (!roomCodeActive) {
      const msg = `❌ ${fnName} : Aucune room active`;
      console.error(msg);
      showToast("⚠️ Rejoignez une partie d'abord");
      throw new Error(msg);
    }
  }

  function initialRoomState(){
    return {
      phase: "lobby", // "lobby" | "started" | "phase3_manual" | "warmup_ready" | "ended"
      gameMode: null,
      starter: null,
      currentPlayer: null,
      // Mode enfant (Phase 2 simplifiée)
      activePlayer: null,
      stopped: { A: false, B: false },
      scores: { A: 0, B: 0 },
      timers: {
        A: { msLeft: TIMER_START_MS, running: false, lastStartAt: null, locked: false, finalPassAvailable: true },
        B: { msLeft: TIMER_START_MS, running: false, lastStartAt: null, locked: false, finalPassAvailable: true }
      },
      timerConfig: { startMs: TIMER_START_MS },
      startHandDrawn: { A: false, B: false },
      phase3Done: false,

      // Phase 3 (mode enfant) : le writer leader (Joueur A) est le seul à exécuter la résolution.
      // Quand B est le dernier à cliquer "Je m'arrête", on pose ce flag pour que A lance executePhase3().
      phase3Pending: false,

      roundNumber: 1,
      matchId: 0, // increments on Nouvelle partie (restart)
      nextInstanceNum: { A: 1, B: 1 },
      dice: { A: null, B: null },
      passes: { A: false, B: false },
      // Phase 1 (échauffement) : suivi pour éviter doubles exécutions
      warmupDone: { A: false, B: false },
      warmupDrawnRound: { A: 0, B: 0 },
      result: { A: null, B: null },
      enfantInitialized: false, // ✅ MODE ENFANT : flag pour éviter double init
      players: {
        A: { id: null, deckOk: false, ready: false, handCount: 0, deckCount: 0 },
        B: { id: null, deckOk: false, ready: false, handCount: 0, deckCount: 0 }
      },
      // Zones synchronisées
      terrains: { A: [], B: [] },
      vestiaires: { A: [], B: [] },
      banchs: { A: [], B: [] },
      revealed: { A: [], B: [] },
      chiefs: { A: null, B: null }, // cardId du chef
      chiefNotes: { A: '', B: '' }, // Notes des chefs (persistantes)
      chiefBasePA: { A: null, B: null }, // PA de base du chef (persistant)
      deckPiles: { A: [], B: [] }, // ordre complet du deck (persistant)
      handPiles: { A: [], B: [] }, // contenu complet de la main (persistant)
      startDrawn: { A: false, B: false }, // anti double-pioche de départ
      // Dés de jeu
      actionDice: { A: 0, B: 0 },
      passDice: { A: 0, B: 0 },
      // Bulle
      bubbles: { 
        A: { state: '', occurrences: 0 }, 
        B: { state: '', occurrences: 0 } 
      }
    };
  }
  function mySlotFromState(st){
    if(!st || !st.players) {
      mySlot = null;
      return null;
    }
    if(st.players.A?.id === selfId) {
      mySlot = "A";
      return "A";
    }
    if(st.players.B?.id === selfId) {
      mySlot = "B";
      return "B";
    }
    // Si connecté mais pas de slot, on est spectateur.
    // IMPORTANT: ne renvoie PAS une string "spectator" ici.
    // Beaucoup de logique (sync deck/hand, accès aux piles) considère qu'un slot
    // truthy est forcément "A" ou "B". Retourner "spectator" provoque un
    // écrasement des piles (deck/hand vides) et rend le jeu injouable.
    mySlot = null;
    return null;
  }

// ===== Turn helper (mode enfant vs complexe) =====
function getTurnPlayer(st){
  const isEnfant = (typeof GAME_MODE !== "undefined" && GAME_MODE === "enfant");
  if(isEnfant) return st?.activePlayer ?? null;
  return st?.currentPlayer ?? null;
}

// ===== Timer (horloge d'échecs) =====
const TIMER_START_MS = 15 * 60 * 1000;

function formatMMSS(ms){
  ms = Math.max(0, Math.floor(Number(ms)||0));
  const total = Math.floor(ms/1000);
  const m = String(Math.floor(total/60)).padStart(2,'0');
  const s = String(total%60).padStart(2,'0');
  return `${m}:${s}`;
}

function ensureTimersShape(s){
  if(!s.timers){
    s.timers = {
      A: { msLeft: TIMER_START_MS, running: false, lastStartAt: null, locked: false, finalPassAvailable: true },
      B: { msLeft: TIMER_START_MS, running: false, lastStartAt: null, locked: false, finalPassAvailable: true }
    };
  }
  for(const k of ["A","B"]){
    s.timers[k] = s.timers[k] || {};
    if(typeof s.timers[k].msLeft !== "number") s.timers[k].msLeft = TIMER_START_MS;
    if(typeof s.timers[k].running !== "boolean") s.timers[k].running = false;
    if(typeof s.timers[k].lastStartAt !== "number") s.timers[k].lastStartAt = null;
    if(typeof s.timers[k].locked !== "boolean") s.timers[k].locked = false;
    if(typeof s.timers[k].finalPassAvailable !== "boolean") s.timers[k].finalPassAvailable = true;
  }
  if(!s.timerConfig) s.timerConfig = { startMs: TIMER_START_MS };
  return s;
}

function calcMsLeft(timer, now){
  let ms = typeof timer.msLeft === "number" ? timer.msLeft : TIMER_START_MS;
  if(timer.running && typeof timer.lastStartAt === "number" && timer.lastStartAt != null){
    ms -= (now - timer.lastStartAt);
  }
  return Math.max(0, Math.floor(ms));
}

function flushRunningTimer(timer, now){
  if(timer.running && typeof timer.lastStartAt === "number" && timer.lastStartAt != null){
    timer.msLeft = calcMsLeft(timer, now);
  }
  timer.running = false;
  timer.lastStartAt = null;
}

function startRunningTimer(timer, now){
  if(timer.locked) { timer.running = false; timer.lastStartAt = null; return; }
  if(typeof timer.msLeft !== "number") timer.msLeft = TIMER_START_MS;
  timer.running = true;
  timer.lastStartAt = now;
}

function timerBlockMessage(st, slot){
  try{
    const t = st?.timers?.[slot];
    if(!t) return null;
    const now = (typeof Date !== 'undefined') ? Date.now() : 0;
    const ms = calcMsLeft(t, now);
    if(t.locked) return "Temps ecoule : tu ne peux plus jouer.";
    if(ms <= 0) return "Temps ecoule : passe une derniere fois.";
    return null;
  }catch(_e){ return null; }
}

  function presentCount(st){
    if(!st || !st.players) return 0;
    return (st.players.A?.id ? 1 : 0) + (st.players.B?.id ? 1 : 0);
  }

  /**
   * 🔒 MODE ENFANT V5 : Guard principal avant toute écriture
   * @param {boolean} requiresWriterLeader - Si true, seul A peut écrire
   * @returns {boolean} - true si écriture autorisée
   */
  function canWriteEnfant(requiresWriterLeader = false) {
    // Guard 1 : Mode enfant actif ?
    // NOTE: en production, GAME_MODE peut ne pas être défini (cache/variantes d'index).
    // On autorise si la room est marquée enfant OU si l'URL/host indique enfant.
    const st0 = roomState || initialRoomState();
    const urlLooksEnfant = (()=>{
      try{
        const host = (location && location.hostname) ? location.hostname : "";
        const path = (location && location.pathname) ? location.pathname : "";
        return host.includes("enfant") || path.includes("enfant");
      }catch(_e){ return false; }
    })();
    if(typeof GAME_MODE === "undefined"){
      if(!(st0.gameMode === "enfant" || urlLooksEnfant)){
        console.warn("⚠️ [GUARD] GAME_MODE indéfini et room non-enfant, blocage écriture");
        return false;
      }
    } else if(GAME_MODE !== "enfant"){
      console.warn("⚠️ [GUARD] GAME_MODE n'est pas 'enfant', blocage écriture");
      return false;
    }

    
    const st = roomState || initialRoomState();
    
    // Guard 2 : Room compatible ?
    if(st.gameMode && st.gameMode !== "enfant") {
      console.warn("⚠️ [GUARD] Room non-enfant (gameMode=" + st.gameMode + "), blocage écriture");
      if(typeof showToast === 'function'){
        showToast("⚠️ Cette room n'est pas en mode enfant");
      }
      return false;
    }
    
    // Guard 3 : Writer leader requis ?
    if(requiresWriterLeader) {
      const mySlot = mySlotFromState(st);
      if(mySlot !== 'A') {
        if(!window.__guardLastLog || (Date.now()-window.__guardLastLog)>3000){ window.__guardLastLog=Date.now(); 
    _log("⏭️ [GUARD] Seul le joueur A peut exécuter cette automatisation"); }
        return false;
      }
    }
    
    return true;
  }
  // ===== Libre total (playtest) helpers =====
  function otherSlotFromSlot(slot){
    if(slot === 'A') return 'B';
    if(slot === 'B') return 'A';
    return null;
  }
  function slotForZone(zoneId){
    const st = roomState || initialRoomState();
    const mySlot = mySlotFromState(st);

    // Playtest: même un spectateur peut manipuler (utile pour arbitre / debug).
    // Convention: my* => A, opp* => B si on ne connait pas le slot joueur.
    const zid = String(zoneId || '');
    if(mySlot === 'spectator' || !mySlot){
      if(zid.startsWith('my')) return 'A';
      if(zid.startsWith('opp')) return 'B';
      return 'A';
    }

    if(zid.startsWith('my')) return mySlot;
    if(zid.startsWith('opp')) return otherSlotFromSlot(mySlot);
    return mySlot;
  }
  function zoneIsOpp(zoneId){
    return String(zoneId||'').startsWith('opp');
  }

  async function ensureRoomRow(code){
    if (!sb) {
      console.error("❌ ensureRoomRow : Supabase non connecté");
      throw new Error("Supabase non connecté");
    }
    
    // crée la ligne si absente
    const { data: existing, error: selErr } = await sb
      .from("rooms_kid")
      .select("room_code,state,version")
      .eq("room_code", code)
      .maybeSingle();
    if(selErr) throw selErr;
    if(existing){
      roomState = existing.state || initialRoomState();
      roomVersion = Number(existing.version || 0);

      // Cleanup stale state: if phase is "lobby" but enfantInitialized is still true
      // from a previous game, reset it so auto-start can trigger again.
      try{
        const _rs = roomState;
        if(_rs && _rs.phase === "lobby" && _rs.enfantInitialized){
          console.warn("[ensureRoomRow] Cleaning stale enfantInitialized in lobby room");
          _rs.enfantInitialized = false;
          _rs.startDice = null;
          _rs.starter = null;
          _rs.startDrawn = { A: false, B: false };
          // Write cleanup to DB
          await sb
            .from("rooms_kid")
            .update({ state: _rs, updated_at: new Date().toISOString() })
            .eq("room_code", code)
            .eq("version", roomVersion);
        }
      }catch(_e){ /* best-effort cleanup */ }

      return;
    }
    const init = initialRoomState();
    const { error: insErr } = await sb
      .from("rooms_kid")
      .insert({ room_code: code, state: init, version: 0 });
    if(insErr) throw insErr;
    roomState = init;
    roomVersion = 0;
  }

  

// ===== Serialized room writes (prevents optimistic-lock conflicts on burst updates) =====
// Many game actions (warmup, draw, autostart, effects) can trigger multiple updateRoomState calls
// in quick succession. Supabase optimistic locking will conflict if writes are concurrent.
// We serialize updates through a promise queue to guarantee order and reduce conflicts.
let __roomWriteQueue = Promise.resolve();
async function updateRoomState(patchFn, reason){
  // Track pending writes for debug
  try{
    __debug.pendingWrites++;
    __debug.lastWriteReason = reason || "";
    __debug.lastWriteAt = Date.now();
    updateDebugOverlay();
  }catch(_e){}
  __roomWriteQueue = __roomWriteQueue.then(() => __updateRoomStateCore(patchFn, reason))
    .catch((e)=>{ throw e; })
    .finally(()=>{ 
      try{ __debug.pendingWrites = Math.max(0, (__debug.pendingWrites||0)-1); updateDebugOverlay(); }catch(_e){} 
    });
  try { return await __roomWriteQueue; } catch (e) { throw e; }
}

// Idempotent wrapper: stores actionId in roomState.meta.recentActionIds
async function updateRoomStateAction(patchFn, opts){
  const reason = (opts && opts.reason) ? opts.reason : (opts || "");
  const type = (opts && opts.type) ? opts.type : reason;
  const actionId = (opts && opts.actionId) ? opts.actionId : makeActionId(String(type||"act"));
  __debug.lastAction = { id: actionId, type: type, reason: reason, at: Date.now() };
  updateDebugOverlay();
  return updateRoomState((s)=>{
    s.meta = s.meta || {};
    const maxKeep = 60;
    const arr = Array.isArray(s.meta.recentActionIds) ? s.meta.recentActionIds : [];
    if(arr.includes(actionId)){
      // Special marker: __updateRoomStateCore will skip write
      s.__skipWrite = true;
      return s;
    }
    arr.push(actionId);
    while(arr.length > maxKeep) arr.shift();
    s.meta.recentActionIds = arr;
    s.meta.lastAction = { id: actionId, type: type, by: CLIENT_ID, at: Date.now() };
    return patchFn(s) || s;
  }, reason);
}

// 🔧 NOUVEAU : Persist hand order after drag & drop reorder
// Called by hand-reorder.js to ensure the new order is saved to Supabase
window.persistHandOrder = async function(newOrder) {
  _log("🔄 persistHandOrder called with:", newOrder?.slice(0, 3));
  
  if(!newOrder || !Array.isArray(newOrder)) {
    console.warn("⚠️ persistHandOrder: invalid newOrder", newOrder);
    return;
  }
  
  try {
    await updateRoomState((s) => {
      const slot = mySlotFromState(s);
      if(!slot) {
        console.warn("⚠️ persistHandOrder: no slot found");
        return s;
      }
      
      console.log("📝 persistHandOrder: updating slot", slot, "with", newOrder.length, "cards");
      
      if(!s.handPiles) s.handPiles = { A: [], B: [] };
      
      // Store the new order
      s.handPiles[slot] = newOrder.slice();
      
      // Update hand count for consistency
      if(s.players && s.players[slot]) {
        s.players[slot].handCount = newOrder.length;
      }
      
      console.log("✅ persistHandOrder: state updated, handPiles[" + slot + "]:", s.handPiles[slot].slice(0, 3));
      
      return s;
    }, "hand-reorder");
    
    console.log("✅ persistHandOrder: Supabase write complete");
  } catch(e) {
    console.error("❌ Erreur persistHandOrder:", e);
    reportError(e, "persistHandOrder");
    throw e; // Re-throw so caller knows it failed
  }
};

// 🔧 Expose myHandPile via getter/setter for hand-reorder.js
Object.defineProperty(window, 'myHandPile', {
  get() { return myHandPile; },
  set(v) { myHandPile = v; },
  configurable: true
});

// 🔧 Expose renderHandCards for hand-reorder.js
window.renderHandCards = function() { renderHandCards(); };

async function __updateRoomStateCore(patchFn, reason){
  // --- Mode guard : ne pas écrire dans une room d’un autre format ---
  if(roomModeMismatch && reason !== "reset-room" && reason !== "new-game" && reason !== "reset-hard"){
    console.warn("[mode-guard] write blocked:", {reason, roomModeMismatch});
    showToast("⚠️ Écriture bloquée : room d’un autre mode. Clique 'Réinitialiser la room'.", "warn", 6000);
    return { ok:false, blocked:true, reason:"mode-mismatch" };
  }

    // Protection anti-crash : vérifier connexion Supabase
    if (!sb || !roomCodeActive) {
      console.warn("❌ updateRoomState impossible : Supabase non connecté");
      return;
    }

    // --- Presence ping: ne doit PAS bump la version (évite les conflits avec les actions de jeu) ---
    // ⚠️ IMPORTANT: on ne doit pas écraser l'état de jeu en cours.
    // Donc on lit la DERNIÈRE version serveur, on patch UNIQUEMENT presence,
    // puis on tente une update avec verrou optimiste sur la version lue.
    // En cas de conflit (0 row), on retente une fois.
    if(reason === "presence-ping"){
      try{
        for(let attempt = 0; attempt < 2; attempt++){
          const { data: rowSel, error: errSel } = await sb
            .from("rooms_kid")
            .select("state,version")
            .eq("room_code", roomCodeActive)
            .maybeSingle();

          if(errSel){
            return { ok:false, presence:true, error:true };
          }

          const currentP = (rowSel && rowSel.state) ? rowSel.state : (roomState || initialRoomState());
          const verP = (rowSel && typeof rowSel.version !== "undefined") ? Number(rowSel.version || 0) : Number(roomVersion || 0);

          const nextP = patchFn(cloneState(currentP));
          // Ne jamais persister les champs helpers
          try{ if(nextP){ delete nextP.__skipWrite; } }catch(_e){}

          const { data: rowsP, error: errP } = await sb
            .from("rooms_kid")
            .update({ state: nextP, updated_at: new Date().toISOString() })
            .eq("room_code", roomCodeActive)
            .eq("version", verP)
            .select("state,version");

          if(errP){
            return { ok:false, presence:true, error:true };
          }

          const rowP = Array.isArray(rowsP) ? rowsP[0] : rowsP;
          if(rowP){
            roomState = rowP.state || initialRoomState();
            roomVersion = Number(rowP.version || verP || 0);
            return { ok:true, presence:true };
          }
          // Conflit (0 row) → retenter (au prochain attempt)
        }
        return { ok:false, presence:true, conflict:true };
      }catch(_e){
        return { ok:false, presence:true, error:true };
      }
    }

    // Sauvegarder l'état AVANT la modification pour l'historique
    // SAUF pour "autostart" et "warmup-*" car on le fait manuellement après les pioches
    const skipHistory = !reason || reason === "update" || reason === "realtime" 
                     || reason === "autostart" || reason.startsWith("warmup-");
    
    if (!skipHistory) {
      addToHistory(reason);
    }
    
    // optimistic lock: update only if version matches
    const current = roomState || initialRoomState();
    const next = patchFn(cloneState(current));

// Skip write if patchFn requested it (idempotence / duplicates)
if(next && next.__skipWrite){
  try{ delete next.__skipWrite; }catch(_e){}
  return { ok:true, skipped:true, reason: reason || "update" };
}
// Never persist helper fields
try{ if(next){ delete next.__skipWrite; } }catch(_e){}
    const nextVersion = (roomVersion || 0) + 1;

    const { data: rows, error } = await sb
      .from("rooms_kid")
      .update({ state: next, version: nextVersion, updated_at: new Date().toISOString() })
      .eq("room_code", roomCodeActive)
      .eq("version", roomVersion)
      .select("state,version");

    if(error){ try{ __debug.lastError = (error && (error.message||error.toString())) || String(error); updateDebugOverlay(); }catch(_e){} throw error; }

    const row = Array.isArray(rows) ? rows[0] : rows;

    // Si 0 rows (conflit version), on resync et on réessaye une fois.
    if(!row){
      const { data: fresh, error: err2 } = await sb
        .from("rooms_kid")
        .select("state,version")
        .eq("room_code", roomCodeActive)
        .maybeSingle();
      if(err2){ try{ __debug.lastError = (err2 && (err2.message||err2.toString())) || String(err2); updateDebugOverlay(); }catch(_e){} throw err2; }
      if(fresh){
        roomState = fresh.state || initialRoomState();
        roomVersion = Number(fresh.version || 0);
      }
      // retry once
      const current2 = roomState || initialRoomState();
      const next2 = patchFn(cloneState(current2));

if(next2 && next2.__skipWrite){
  try{ delete next2.__skipWrite; }catch(_e){}
  return { ok:true, skipped:true, reason: reason || "update" };
}
try{ if(next2){ delete next2.__skipWrite; } }catch(_e){}
      const nextVersion2 = (roomVersion || 0) + 1;
      const { data: rows2, error: err3 } = await sb
        .from("rooms_kid")
        .update({ state: next2, version: nextVersion2, updated_at: new Date().toISOString() })
        .eq("room_code", roomCodeActive)
        .eq("version", roomVersion)
        .select("state,version");
      if(err3){ try{ __debug.lastError = (err3 && (err3.message||err3.toString())) || String(err3); updateDebugOverlay(); }catch(_e){} throw err3; }
      const row2 = Array.isArray(rows2) ? rows2[0] : rows2;
      if(row2){
        roomState = row2.state;
        roomVersion = Number(row2.version || nextVersion2);
      }else{
        // Reconcile common optimistic-lock conflicts for idempotent ops (ex: two clients importing the same deck).
        if((reason||"")==="deck-import"){
          try{
            const desiredSlot = mySlotFromState(roomState || initialRoomState());
            const desiredHash = stableHashDeck((Array.isArray(validatedDeckIds) && validatedDeckIds.length) ? validatedDeckIds : myDeckPile);
            const { data: freshRow, error: freshErr } = await sb
              .from("rooms_kid")
              .select("state,version")
              .eq("room_code", roomCodeActive)
              .maybeSingle();
            if(!freshErr && freshRow && freshRow.state){
              const fs = freshRow.state;
              const fslot = desiredSlot || mySlotFromState(fs);
              if(fslot && desiredHash && fs?.players?.[fslot]?.deckHash === desiredHash){
                // Another client already committed the same deck; treat as success and stay silent.
                roomState = fs;
                roomVersion = Number(freshRow.version || roomVersion || 0);
                applyRoomStateToUI("deck-import");
                return;
              }
            }
          }catch(_e){}
        }
        console.warn("⚠️ updateRoomState: conflit version persistant (retry a échoué)", {reason, roomCodeActive});
        try{ showToast("⚠️ Désynchronisation, resync..."); }catch(_){ }
        try{ forceResync(); }catch(_){ }
      }
    }else{
      roomState = row.state;
      roomVersion = Number(row.version || nextVersion);
    }

    applyRoomStateToUI(reason || "update");
  }

  // ===== Manual Resync (read-only) =====
  // Relit l'état courant en base et force un rerender complet.
  // IMPORTANT: ne modifie PAS la room (pas de reset, pas d'écriture).

  // UI recovery (front-only): force un rerender complet depuis roomState/gameState + resync Pixi overlay.
  function syncPixiOverlays(){
    try{
      if(window.__pixiRenderTerrain){
        // gameState est la source locale courante pour les terrains, mais il ne contient pas toujours l'illustration.
        // On enrichit ici avec les infos de cardsById (name/image) pour que Pixi puisse afficher la miniature full-art.
        const enrich = (arr)=>{
          return (Array.isArray(arr) ? arr : []).map((c)=>{
            const id = c?.cardId || c?.id || c?.cid;
            const def = id ? cardsById.get(id) : null;
            return {
              ...c,
              id: id || c?.id,
              name: c?.name || def?.name || c?.label || 'Carte',
              image: c?.image || def?.image || c?.img
            };
          });
        };
        window.__pixiRenderTerrain('myTerrain', enrich(gameState && gameState.myTerrain));
        window.__pixiRenderTerrain('oppTerrain', enrich(gameState && gameState.oppTerrain));
      }
    }catch(e){ /* no-op */ }
  }

  function recoverUI(reason){
    try{
      // Fermer menus/modales susceptibles de bloquer la main/deck (best-effort)
      try{
        if(typeof closeCardModal === 'function') closeCardModal();
        if(typeof closeZoneModal === 'function') closeZoneModal();
        if(typeof closeDeckBrowser === 'function') closeDeckBrowser();
        if(typeof closeImportModal === 'function') closeImportModal();
      }catch(_e){}
      // Rerender global depuis l'état courant
      try{ applyRoomStateToUI(reason || "recover"); }catch(_e){ _sw("recover-applyUI",_e); }
      // Forcer mises à jour clés (au cas où une étape UI serait restée bloquée)
      try{ if(typeof updateHandUI === 'function') updateHandUI(); }catch(_e){}
        try{ if(typeof __ensureHandFloatingOnscreen === 'function') __ensureHandFloatingOnscreen(); }catch(_e){}
      try{ if(typeof updateThumbPhase2Buttons === 'function') updateThumbPhase2Buttons(); }catch(_e){}
      try{ if(typeof updateThumbPhase3Buttons === 'function') updateThumbPhase3Buttons(); }catch(_e){}
      try{ if(typeof renderDeckCards === 'function') renderDeckCards(); }catch(_e){}
      try{ if(typeof updateAllZoneCounters === 'function') updateAllZoneCounters(); }catch(_e){}
      // Resync Pixi overlay immédiatement
      syncPixiOverlays();
      try{ showToast && showToast("🧯 UI récupérée"); }catch(_e){}
      try{ pushLog && pushLog(`🧯 Recover UI (${reason||'recover'})`); }catch(_e){}
    }catch(e){
      console.warn(e);
    }
  }

  async function forceResync(){
    try{
      if(!sb || !roomCodeActive){
        pushLog("⚠️ Resync impossible : pas connecté");
        showToast("⚠️ Pas connecté");
        return;
      }

      const { data: fresh, error } = await sb
        .from("rooms_kid")
        .select("state,version")
        .eq("room_code", roomCodeActive)
        .maybeSingle();
      if(error){ try{ __debug.lastError = (error && (error.message||error.toString())) || String(error); updateDebugOverlay(); }catch(_e){} throw error; }

      if(!fresh || !fresh.state){
        pushLog("⚠️ Resync : état introuvable");
        showToast("⚠️ État introuvable");
        return;
      }

      roomState = fresh.state || initialRoomState();
      roomVersion = Number(fresh.version || 0);
      recoverUI("resync");
      showToast("🔄 Partie resynchronisée");
      pushLog("🔄 Resync effectué");
    }catch(e){
      reportError(e, "resync");
      showToast("❌ Resync échoué");
    }
  }
  window.forceResync = forceResync;

  // ===== Phase Rescue (anti-blocage) =====
  async function forceNextPhase(){
    try{
      if(!connected || !roomCodeActive){
        pushLog("⚠️ Secours: pas connecté");
        return;
      }
      const slot = mySlotFromState(roomState);
      await updateRoomState((s)=>{
        const p = s.phase;
        s.phase3 = s.phase3 || {};

        if(p === 'lobby'){
          s.phase = 'warmup_ready';
          s.roundNumber = Number(s.roundNumber||1);
          s.warmupDone = s.warmupDone || {A:false,B:false};
          s.warmupDrawnRound = s.warmupDrawnRound || {A:0,B:0};
        } else if(p === 'warmup_ready'){
          s.phase = 'started';
          s.warmupDone = s.warmupDone || {A:false,B:false};
          if(slot && slot !== 'spectator') s.warmupDone[slot] = true;
        } else if(p === 'started'){
          s.phase = 'phase3_manual';
          s.phase3.step = Number(s.phase3.step||1);
          s.phase3.step1 = s.phase3.step1 || { A: null, B: null };
          s.phase3.step2 = s.phase3.step2 || { A: false, B: false };
          s.phase3.step3 = s.phase3.step3 || { A: false, B: false };
          s.phase3.step4 = s.phase3.step4 || { A: null, B: null };
        } else if(p === 'phase3_manual'){
          s.phase = 'warmup_ready';
          s.roundNumber = Number(s.roundNumber||1) + 1;
          s.warmupDone = {A:false,B:false};
          s.warmupDrawnRound = s.warmupDrawnRound || {A:0,B:0};
        } else if(p === 'ended'){
          s.phase = 'lobby';
        }
        return s;
      }, 'rescue-next-phase');

      pushLog("🧯 Secours: phase +1 forcée");
      showToast("⏩ Phase forcée");
      await forceResync();
    }catch(e){
      reportError(e,'forceNextPhase');
      showToast("❌ Secours phase échoué");
    }
  }

  async function forceNextStep(){
    try{
      if(!connected || !roomCodeActive){
        pushLog("⚠️ Secours: pas connecté");
        return;
      }
      await updateRoomState((s)=>{
        if(s.phase !== 'phase3_manual') return s;
        s.phase3 = s.phase3 || {};
        let step = Number(s.phase3.step||1);
        step = Math.min(4, step + 1);
        s.phase3.step = step;
        return s;
      }, 'rescue-next-step');

      pushLog("🧯 Secours: étape +1 forcée");
      showToast("⏭ Étape forcée");
      await forceResync();
    }catch(e){
      reportError(e,'forceNextStep');
      showToast("❌ Secours étape échoué");
    }
  }

  async function rearmAuto(){
    try{
      if(!connected || !roomCodeActive){
        pushLog("⚠️ Secours: pas connecté");
        return;
      }
      const slot = mySlotFromState(roomState);

      // Reset local locks
      warmupAutoRunning = false;
      warmupAutoPromise = null;
      if(slot && slot !== 'spectator') warmupLocalDone[slot] = false;

      await updateRoomState((s)=>{
        s.phase = 'warmup_ready';
        s.warmupDone = s.warmupDone || {A:false,B:false};
        if(slot && slot !== 'spectator') s.warmupDone[slot] = false;
        s.warmupDrawnRound = s.warmupDrawnRound || {A:0,B:0};
        if(slot && slot !== 'spectator') s.warmupDrawnRound[slot] = 0;
        return s;
      }, 'rescue-rearm-auto');

      pushLog("🧯 Secours: auto réarmé (Phase 1)");
      showToast("🧯 Auto réarmé");
      await forceResync();

      try{ await warmupAuto(); } catch(_){ }
    }catch(e){
      reportError(e,'rearmAuto');
      showToast("❌ Réarm auto échoué");
    }
  }

  window.forceNextPhase = forceNextPhase;
  window.forceNextStep = forceNextStep;
  window.rearmAuto = rearmAuto;

  // Wire UI buttons
  (function(){
    const a = document.getElementById('forceNextStepBtn');
    const b = document.getElementById('forceNextPhaseBtn');
    const c = document.getElementById('rearmAutoBtn');
    if(a) a.addEventListener('click', ()=>{ forceNextStep(); });
    if(b) b.addEventListener('click', ()=>{ forceNextPhase(); });
    if(c) c.addEventListener('click', ()=>{ rearmAuto(); });
  })();
  async function claimAutoSlot(){
    // auto: premier = A, second = B. Si déjà assigné, ne touche pas.
    await updateRoomState((st) => {
      st.players = st.players || { A:{}, B:{} };
      if(st.players.A?.id === selfId || st.players.B?.id === selfId) return st;

      if(!st.players.A) st.players.A = { id:null, deckOk:false, ready:false };
      if(!st.players.B) st.players.B = { id:null, deckOk:false, ready:false };

      // Evict stale players (presence heartbeat > 90s)
      const now = Date.now();
      const STALE_MS = 90_000;
      for(const slot of ["A","B"]){
        const p = st.players[slot];
        if(p && p.id && p.id !== selfId){
          const pres = (st.presence && st.presence[slot]) ? st.presence[slot] : null;
          if(pres && pres.lastSeenAt && (now - pres.lastSeenAt) > STALE_MS){
            console.warn(`[CLAIM] Evicting stale player from slot ${slot} (last seen ${Math.round((now - pres.lastSeenAt)/1000)}s ago)`);
            st.players[slot] = { id:null, deckOk:false, ready:false };
          }
        }
      }

      if(!st.players.A.id){
        st.players.A.id = selfId;
        st.players.A.deckOk = false;
        st.players.A.ready = false;
      } else if(!st.players.B.id){
        st.players.B.id = selfId;
        st.players.B.deckOk = false;
        st.players.B.ready = false;
      } else {
        // room pleine (spectateur)
      }
      return st;
    }, "claim");
    // Après reprise/claim, relire l’état et rerender immédiatement (sans reset)
    try{ await forceResync(); }catch(e){}
    try{ recoverUI("role-recovered"); }catch(e){}
  }

  async function leaveSlotIfOwned(){
    const slot = mySlotFromState(roomState);
    if(!slot) return;
    await updateRoomState((st) => {
      const p = st.players?.[slot];
      if(p && p.id === selfId){

        // ✅ Si on quitte pendant une partie (ou une phase non-lobby), on considère ça comme une concession
        // pour que l'autre joueur voie un popup "victoire (abandon)" et puisse faire un screenshot (tournoi).
        try{
          const phase = String(st.phase || "lobby");
          const opp = (slot === "A") ? "B" : "A";
          const oppPresent = !!(st.players && st.players[opp] && st.players[opp].id);
          const alreadyEnded = (phase === "ended") || (phase === "finished");
          const inGame = (phase !== "lobby");

          if(inGame && oppPresent && !alreadyEnded){
            const result = {
              A: (opp === "A") ? "win" : "lose",
              B: (opp === "B") ? "win" : "lose",
            };
            st.phase = "ended";
            st.endReason = "concede";
            st.endedAt = Date.now();
            st.concededBy = slot;
            st.winner = opp;
            st.result = result;
          }
        }catch(_e){}

        // Libérer mon slot (mais ne PAS forcer phase=lobby si un adversaire reste — sinon on casse le screenshot)
        st.players[slot] = { id: null, deckOk:false, ready:false };

        // Si plus personne n'est dans la room, on peut repasser proprement en lobby
        const hasA = !!(st.players && st.players.A && st.players.A.id);
        const hasB = !!(st.players && st.players.B && st.players.B.id);
        if(!hasA && !hasB){
          st.phase = "lobby";
          st.starter = null;
          st.dice = { A:null, B:null };
        }
      }
      return st;
    }, "leave");
  }

  async function resetRoomHard(){
    // Effacer TOUT dans roomState (reset complet)
    await updateRoomState((st) => {
      // Reset COMPLET - retour à l'état initial
      const s = initialRoomState(); s.gameMode = GAME_MODE; roomModeMismatch = false; return s;
    }, "reset-hard");
    
    // Reset local pour moi
    resetAllLocalState();
    
    pushLog("🔄 Room complètement réinitialisée");
  }

  // Nouvelle partie (RESTART): relance une partie complète SANS changer de JSON/decklist.
  // Objectif:
  // - garder A/B (ids)
  // - garder le blueprint de deck validé (deckBlueprint)
  // - remettre PA/états/zone à zéro
  // - reconstruire les decks depuis le blueprint (anti chiffres bizarres)
  // - piocher 5 pour A et B, et démarrer directement (sans repasser par le lobby)

  async function newGameSoft(){
    // Restart robuste: on lit d'abord l'etat le plus recent depuis la DB pour eviter
    // d'ecraser les IDs joueurs / blueprints avec un roomState local stale.
    requireSupabase('newGameSoft');

    // 1) Reset local visuel minimum (evite d'afficher l'ancienne partie 1 frame)
    try{
      resetStartStateLocal();
      gameState.myTerrain = [];
      gameState.oppTerrain = [];
      gameState.myVestiaire = [];
      gameState.oppVestiaire = [];
      gameState.oppVestiaireCount = 0;
      gameState.myBanch = [];
      gameState.oppBanch = [];
      gameState.oppBanchCount = 0;
      gameState.myRevealed = [];
      gameState.oppRevealedCount = 0;
      gameState.myChief = null;
      gameState.oppChief = null;
      gameState.myChiefNote = '';
      gameState.oppChiefNote = '';
      gameState.myActionDie = 0;
      gameState.oppActionDie = 0;
      gameState.myPassDie = 0;
      gameState.oppPassDie = 0;
      updateAllZoneCounters();
      updateHandUI();
    }catch(_e){}

    // 2) Snapshot DB (source de verite)
    let snapshot = null;
    try{
      const { data: row, error } = await sb
        .from('rooms_kid')
        .select('state,version')
        .eq('room_code', roomCodeActive)
        .maybeSingle();
      if(error){ try{ __debug.lastError = (error && (error.message||error.toString())) || String(error); updateDebugOverlay(); }catch(_e){} throw error; }
      snapshot = row && row.state ? row.state : null;
      // Mettre a jour nos caches locaux pour l'optimistic lock
      if(row && typeof row.version !== 'undefined') roomVersion = Number(row.version || 0);
      if(snapshot) roomState = snapshot;
    }catch(e){
      console.warn('⚠️ Snapshot DB impossible, fallback sur roomState local', e);
      snapshot = roomState || initialRoomState();
    }

    const snapPlayers = snapshot.players || {A:{},B:{}};
    const snapBlueprint = snapshot.deckBlueprint || {A:[],B:[]};
    const snapChiefBasePA = snapshot.chiefBasePA || {A:null,B:null};

    // 3) Update DB via optimistic lock
    await updateRoomState((st)=>{
      // NB: on utilise le snapshot pour les elements critiques (IDs, blueprints, PA de base)
      st.gameMode = GAME_MODE;
      roomModeMismatch = false;
      const base = initialRoomState();

      // Incremente matchId (force reset local chez tous)
      base.matchId = Number((snapshot && snapshot.matchId) || st.matchId || 0) + 1;

      // Conserver blueprint (deck valide)
      base.deckBlueprint = {
        A: Array.isArray(snapBlueprint.A) ? snapBlueprint.A.slice() : [],
        B: Array.isArray(snapBlueprint.B) ? snapBlueprint.B.slice() : []
      };

      // Conserver PA de base
      base.chiefBasePA = {
        A: (snapChiefBasePA.A != null ? Number(snapChiefBasePA.A) : null),
        B: (snapChiefBasePA.B != null ? Number(snapChiefBasePA.B) : null)
      };

      // Reappliquer PA courants = base PA (debut de partie)
      base.actionDice = {
        A: (base.chiefBasePA.A != null ? Number(base.chiefBasePA.A) || 0 : 0),
        B: (base.chiefBasePA.B != null ? Number(base.chiefBasePA.B) || 0 : 0)
      };
      base.passDice = { A: 0, B: 0 };

      // 🔧 DÉVALIDER LES DECKS : forcer les joueurs à recliquer "Importer Decklist"
      const bpAOk = false; // Force revalidation
      const bpBOk = false; // Force revalidation

      base.players = {
        A: {
          id: snapPlayers?.A?.id || null,
          deckOk: false, // 🔧 Dévalidé pour nouvelle partie
          ready: true,
          handCount: 0,
          deckCount: 0
        },
        B: {
          id: snapPlayers?.B?.id || null,
          deckOk: false, // 🔧 Dévalidé pour nouvelle partie
          ready: true,
          handCount: 0,
          deckCount: 0
        }
      };

      // Rebuild piles depuis blueprint (tokens propres)
      base.deckPiles = {A:[],B:[]};
      base.handPiles = {A:[],B:[]};
      base.vestiaires = {A:[],B:[]};
      base.banchs = {A:[],B:[]};
      base.revealed = {A:[],B:[]};
      base.terrains = {A:[],B:[]};
      base.nextInstanceNum = {A:1,B:1};

      for(const sl of ['A','B']){
        // IMPORTANT: pour la stabilité et la compatibilité (filtrage/lookup),
        // on stocke dans deck/hand uniquement des IDs de cartes (ex: '001').
        // Les doublons sont autorisés, donc pas besoin de tokens uniques.
        const bp = base.deckBlueprint[sl] || [];
        const ids = bp.map(cid0 => String(cid0 || '').padStart(3,'0'));
        base.deckPiles[sl] = shuffleInPlace(ids);
        base.nextInstanceNum[sl] = 1;
      }

// Démarrage direct uniquement si 2 joueurs + 2 decks valides
      const canStart = !!(base.players?.A?.id && base.players?.B?.id && bpAOk && bpBOk);
      if(canStart){
        // Pioche initiale 5 (source de verite DB)
        base.startDrawn = {A:true, B:true};
        for(const sl of ['A','B']){
          const take = base.deckPiles[sl].splice(0, 5);
          base.handPiles[sl].push(...take);
        }

        // Dés + starter
        let a=0,b=0;
        for(let i=0;i<20;i++){
          a = 1 + Math.floor(Math.random()*12);
          b = 1 + Math.floor(Math.random()*12);
          if(a !== b) break;
        }
        const starterSlot = (a > b) ? 'A' : 'B';
        base.dice = {A:a, B:b};
        base.starter = starterSlot;
        base.currentPlayer = starterSlot;
        base.roundNumber = 1;
        base.phase = 'started';
      } else {
        // Sinon lobby
        base.phase = 'lobby';
        base.dice = {A:null, B:null};
        base.starter = null;
        base.currentPlayer = null;
        base.roundNumber = 0;
        base.startDrawn = {A:false, B:false};
        base.players.A.ready = false;
        base.players.B.ready = false;
      }

      // Compteurs publics
      base.players.A.handCount = (base.handPiles.A||[]).length;
      base.players.B.handCount = (base.handPiles.B||[]).length;
      base.players.A.deckCount = (base.deckPiles.A||[]).length;
      base.players.B.deckCount = (base.deckPiles.B||[]).length;

      // 🔁 Clear restart confirmations after restart
      base.restartReq = {A:false, B:false};
      base.restartReqAt = null;

      return base;
    }, 'new-game');

    pushLog('🆕 Nouvelle partie : restart (snapshot DB, PA reset, pioche 5)');
    updateHandUI();
    updateAllZoneCounters();
    applyRoomStateToUI('new-game');
  }
  function subscribeRoom(code){
    if (!sb) {
      console.error("❌ subscribeRoom : Supabase non connecté");
      return;
    }
    
    if(roomRt){
      try{ sb.removeChannel(roomRt); }catch(_e){ _sw("removeChannel",_e); }
      roomRt = null;
    }
    // Enfant version: use a dedicated table to avoid mixing with the main game
    roomRt = sb.channel(`db:rooms_kid:${code}`);
    // Debounce realtime UI renders: state is applied immediately, but UI re-render
    // is batched (avoids 3-4 full renders during a card-play→effect→autoPass chain).
    // CRITICAL: auto-start check runs IMMEDIATELY (not debounced) to avoid delaying game start.
    let __rtRenderTimer = null;
    function _debouncedRealtimeRender(){
      if(__rtRenderTimer) clearTimeout(__rtRenderTimer);
      __rtRenderTimer = setTimeout(()=>{ __rtRenderTimer = null; applyRoomStateToUI("realtime"); }, 80);
    }

    roomRt.on("postgres_changes", { event:"*", schema:"public", table:"rooms_kid", filter:`room_code=eq.${code}` }, (payload) => {
      try{
        const row = payload?.new;
        if(row && row.state){
          roomState = row.state;
          roomVersion = Number(row.version || roomVersion || 0);

          // Immediate auto-start check (not debounced!) — game must start ASAP
          try{
            const _st = roomState;
            if(_st && _st.phase === "lobby" && !_st.enfantInitialized){
              const _bothDeckOk = !!_st.players?.A?.deckOk && !!_st.players?.B?.deckOk;
              const _bothIds = !!_st.players?.A?.id && !!_st.players?.B?.id;
              if(_bothDeckOk && _bothIds){
                const _isE = (typeof GAME_MODE !== "undefined" && GAME_MODE === "enfant");
                if(_isE){
                  initEnfantRoom().catch((e)=>reportError(e,"init-enfant-room-rt"));
                }
              }
            }
          }catch(_ae){}

          _debouncedRealtimeRender();
        }
      }catch(e){
        reportError(e, "realtime");
      }
    });
    roomRt.subscribe((status) => {
      // status: SUBSCRIBED etc.
      if(status === "SUBSCRIBED"){
        pushLog("Realtime DB: abonné");
      }
    });
  }

  // =====================================================================
  // SECTION:UI_RENDER
  // =====================================================================

  function applyRoomStateToUI(from){
    setConnectedUI(connected);
    // met à jour UI "setup"
    try{
      const st = roomState || initialRoomState();

      // ✅ Fin de partie par concession (visible pour les 2 joueurs, sans dépendre du debug overlay)
      // Supporte aussi l'ancien format "phase: finished" pour compat.
      try{
        const isConcede = (st.phase === 'ended' && st.endReason === 'concede') || (st.phase === 'finished' && (st.finishedBy || st.winner));
        if(isConcede){
          let winnerSlot = st.winner || st.winnerSlot || null;
          // Si result est présent, il prime
          if(st.result && typeof st.result === 'object'){
            if(st.result.A === 'win' && st.result.B === 'lose') winnerSlot = 'A';
            else if(st.result.B === 'win' && st.result.A === 'lose') winnerSlot = 'B';
          }
          showConcedePopup(winnerSlot, st.concededBy || st.finishedBy || null);
        }
      }catch(_e){}

      // ✅ Fin de partie par temps (égalité si les 2 joueurs sont lock)
      try{
        const isTimeDraw = (st.phase === 'ended' && st.endReason === 'time_draw');
        if(isTimeDraw){
          showTimeDrawPopup();
        }
      }catch(_e){}

      // ✅ Catch-all: victoire/défaite normale (scores ≥ 12, declare-win, phase3) sans popup spécifique
      try{
        if(st.phase === 'ended' && !__endGameShown){
          const hasResult = st.result && (st.result.A || st.result.B);
          const isConcede2 = (st.endReason === 'concede');
          const isTimeDraw2 = (st.endReason === 'time_draw');
          if(hasResult && !isConcede2 && !isTimeDraw2){
            const sA = Number(st.scores?.A || 0);
            const sB = Number(st.scores?.B || 0);
            showEndGamePopup(sA, sB);
          }
        }
      }catch(_e){}
      // 🔁 Restart à 2 confirmations (A + B)
      // - Chaque joueur clique "Nouvelle partie" -> marque sa confirmation dans st.restartReq
      // - Quand les 2 sont OK, le leader writer (A) déclenche newGameSoft()
      try{
        const rr = st.restartReq || null;
        const both = !!(rr && rr.A && rr.B);

// 🔔 Si l'adversaire demande une nouvelle partie, afficher un popup pour accepter/refuser
const mySlot2 = (typeof mySlotFromState === 'function') ? (mySlotFromState(st) || null) : null;
if(mySlot2 && rr){
  const opp2 = (mySlot2 === 'A') ? 'B' : 'A';
  if(!both && !!rr[opp2] && !rr[mySlot2]){
    showRestartRequestPopup(opp2);
  }else{
    hideRestartRequestPopup();
  }
}else{
  hideRestartRequestPopup();
}

        if(both){
          if(!window.__restartSoftInProgress){
            if(canWriteEnfant(true)){
              window.__restartSoftInProgress = true;
              setTimeout(async ()=>{
                try{ await newGameSoft(); }catch(_e){}
                // clear guard after a short delay (avoid spam)
                setTimeout(()=>{ try{ window.__restartSoftInProgress = false; }catch(_e){} }, 1200);
              }, 0);
            }else{
              // Non-leader : petit feedback
              try{ if(typeof showToast === 'function') showToast("⏳ Nouvelle partie demandée — en attente de A"); }catch(_e){}
            }
          }
        }
      }catch(_e){}
      // MODE ENFANT : si la Phase 3 est demandée (B a été le dernier à s'arrêter),
      // le writer leader (A) doit l'exécuter dès qu'il voit l'état.
      try{
        if(st.phase3Pending && !st.phase3Done){
          if(canWriteEnfant(true)){
            setTimeout(()=>{ try{ executePhase3(); }catch(_e){} }, 0);
          }
        }
      }catch(_e){}
      // Enfant repair (flags): if validatedDeckIds exist but deckOk/ready were reset (refresh/reconnect),
      // re-assert them from the writer leader so init can proceed.
      try{
        const isEnfant2 = (typeof GAME_MODE !== "undefined" && GAME_MODE === "enfant") || st.gameMode === "enfant" || (location && String(location.hostname||"").includes("enfant"));
        if(isEnfant2 && canWriteEnfant(true)){
          const hasValA2 = Array.isArray(st.players?.A?.validatedDeckIds) && st.players.A.validatedDeckIds.length > 0;
          const hasValB2 = Array.isArray(st.players?.B?.validatedDeckIds) && st.players.B.validatedDeckIds.length > 0;
          const needFix = (hasValA2 && (!st.players?.A?.deckOk || !st.players?.A?.ready)) || (hasValB2 && (!st.players?.B?.deckOk || !st.players?.B?.ready));
          if(needFix){
            if(!window.__enfantFlagRepair){ window.__enfantFlagRepair = 0; }
            const now2 = Date.now();
            if(now2 - window.__enfantFlagRepair > 800){
              window.__enfantFlagRepair = now2;
              setTimeout(()=>{ 
                try{
                  updateRoomState((s)=>{
                    s.players = s.players || {A:{},B:{}};
                    s.players.A = s.players.A || {};
                    s.players.B = s.players.B || {};
                    if(Array.isArray(s.players.A.validatedDeckIds) && s.players.A.validatedDeckIds.length>0){
                      s.players.A.deckOk = true; s.players.A.ready = true;
                    }
                    if(Array.isArray(s.players.B.validatedDeckIds) && s.players.B.validatedDeckIds.length>0){
                      s.players.B.deckOk = true; s.players.B.ready = true;
                    }
                    return s;
                  }, "enfant-flag-repair");
                }catch(_e){}
              }, 20);
            }
          }
        }
      }catch(_e){}
      // Enfant watchdog: if the init happened but the delayed start-hand draw was missed,
      // retry from the writer leader (A) once the room is visible.
      try{
        const isEnfant = (typeof GAME_MODE !== "undefined" && GAME_MODE === "enfant") || st.gameMode === "enfant";
        if(isEnfant && st.enfantInitialized){
          const decksOk = (st.deckPiles?.A?.length || 0) > 0 && (st.deckPiles?.B?.length || 0) > 0;
          const handsEmpty = (st.handPiles?.A?.length || 0) === 0 && (st.handPiles?.B?.length || 0) === 0;
          const notDrawn = !(st.startHandDrawn?.A && st.startHandDrawn?.B) && !(st.startDrawn?.A && st.startDrawn?.B);
          if(decksOk && handsEmpty && notDrawn && canWriteEnfant(true)){
            if(!window.__enfantStartHandWatchdog){ window.__enfantStartHandWatchdog = 0; }
            const now = Date.now();
            if(now - window.__enfantStartHandWatchdog > 1500){
              window.__enfantStartHandWatchdog = now;
              setTimeout(()=>{ try{ drawStartHands(); }catch(_e){} }, 50);
            }
          }
        }
      
      // Enfant repair: if players have validatedDeckIds but deckPiles/handPiles are missing (stuck lobby / empty deck),
      // rebuild deckPiles from validatedDeckIds and (re)draw start hands from the writer leader.
      try{
        const isEnfant = (typeof GAME_MODE !== "undefined" && GAME_MODE === "enfant") || st.gameMode === "enfant" || (location && String(location.hostname||"").includes("enfant"));
        if(isEnfant && canWriteEnfant(true)){
          const hasValA = Array.isArray(st.players?.A?.validatedDeckIds) && st.players.A.validatedDeckIds.length > 0;
          const hasValB = Array.isArray(st.players?.B?.validatedDeckIds) && st.players.B.validatedDeckIds.length > 0;
          const decksMissing = !((st.deckPiles?.A?.length||0) > 0 && (st.deckPiles?.B?.length||0) > 0);

          // If not initialized yet but both are ready/ok, attempt init again (idempotent)
          if(!st.enfantInitialized && hasValA && hasValB && st.players?.A?.ready && st.players?.B?.ready && st.players?.A?.deckOk && st.players?.B?.deckOk){
            if(!window.__enfantInitRetry){ window.__enfantInitRetry = 0; }
            const now = Date.now();
            if(now - window.__enfantInitRetry > 1200){
              window.__enfantInitRetry = now;
              setTimeout(()=>{ try{ initEnfantRoom(); }catch(_e){} }, 30);
            }
          }

          // If initialized but deck piles are empty, repair them once.
          // IMPORTANT: Ne réparer QUE si la partie n'a pas encore commencé
          // (avant première pioche - mains vides, pas de pioche faite)
          const handsEmpty = (st.handPiles?.A?.length || 0) === 0 && (st.handPiles?.B?.length || 0) === 0;
          const notStarted = !st.startHandDrawn?.A && !st.startHandDrawn?.B;
          const roundOne = (st.roundNumber || 1) === 1;
          
          // Ne réparer QUE si toutes ces conditions sont vraies:
          // - Partie initialisée
          // - Les deux decks manquent
          // - Les deux mains sont vides (pas encore joué)
          // - Pioche de départ pas encore faite
          // - Manche 1 (pas en cours de partie)
          if(st.enfantInitialized && decksMissing && hasValA && hasValB && handsEmpty && notStarted && roundOne){
            if(!window.__enfantRepairDecks){ window.__enfantRepairDecks = 0; }
            const now = Date.now();
            if(now - window.__enfantRepairDecks > 1500){
              window.__enfantRepairDecks = now;
              const build = (ids)=>{
                const out=[];
                for(const id0 of (ids||[])){
                  const id = String(id0).padStart(3,'0');
                  const card = cardsById.get(id);
                  if(!card) continue;
                  if(card.isBackFace) continue;
                  if(String(card.type||'').toLowerCase()==='chef') continue;
                  out.push(id);
                }
                return shuffleInPlace(out.slice());
              };
              const deckA = build(st.players.A.validatedDeckIds);
              const deckB = build(st.players.B.validatedDeckIds);
              if(deckA.length && deckB.length){
                updateRoomState((s)=>{
                  s.gameMode = 'enfant';
                  s.deckPiles = {A: deckA.slice(), B: deckB.slice()};
                  s.handPiles = s.handPiles || {A:[],B:[]};
                  s.players = s.players || {A:{},B:{}};
                  s.players.A = s.players.A || {};
                  s.players.B = s.players.B || {};
                  s.players.A.deckCount = deckA.length;
                  s.players.B.deckCount = deckB.length;
                  s.players.A.handCount = (s.handPiles.A||[]).length;
                  s.players.B.handCount = (s.handPiles.B||[]).length;
                  // allow start draw again if hands are empty
                  if((s.handPiles.A||[]).length===0 && (s.handPiles.B||[]).length===0){
                    s.startHandDrawn = {A:false,B:false};
                    s.startDrawn = {A:false,B:false};
                  }
                  return s;
                }, 'enfant-repair-decks').then(()=>{
                  setTimeout(()=>{ try{ drawStartHands(); }catch(_e){} }, 120);
                }).catch(()=>{});
              }
            }
          }
        }
      }catch(_e){}
}catch(_e){}

// Enfant: masquer le bouton "À toi" (le tour passe automatiquement)
try{
  const isEnfant = (typeof GAME_MODE !== "undefined" && GAME_MODE === "enfant");
  const endTurnBtn = $("endTurnBtn");
  if(endTurnBtn) endTurnBtn.style.display = isEnfant ? "none" : "";
}catch(_e){}
      // FORCE RESET LOCAL when matchId changes (Nouvelle partie), even if we stay in phase 'started'
      // This prevents the other client from keeping old hand and adding 5 (9 cards bug).
      if(typeof window.__localMatchId === 'undefined') window.__localMatchId = null;
      const incomingMatchId = (st && typeof st.matchId !== 'undefined') ? st.matchId : null;
      if(incomingMatchId !== null && incomingMatchId !== window.__localMatchId){
        window.__localMatchId = incomingMatchId;
        resetStartStateLocal();
        gameStarted = false;
        // Clear local piles so SYNC PRIVATE PILES will refill from DB on this same pass
        myDeckPile = [];
        myHandPile = [];
        updateHandUI();
      }

      const slot = mySlotFromState(st);
      // Reset warmupLocalDone ONLY when entering a NEW warmup round (prevents double auto-run)
      const warmupKey = `${(st.matchId ?? '')}|${st.phase}|${Number(st.roundNumber||1)}`;
      if(st.phase === 'warmup_ready'){
        if(warmupKey !== lastWarmupKey){
          lastWarmupKey = warmupKey;
          warmupLocalDone.A = false;
          warmupLocalDone.B = false;
        }
      }

      setRoleUI(slot ? `Joueur ${slot}` : "Spectateur", presentCount(st));
      // Sync setup pills too (screens Setup / Connexion)
      safeText(roleLabel, slot ? `Joueur ${slot}` : "Spectateur");
      safeText(presenceLabel, String(presentCount(st)));

      const aReady = !!st.players?.A?.ready;
      const bReady = !!st.players?.B?.ready;
      setReadyUI(aReady, bReady);

      // dice display
      const da = st.startDice?.A ?? st.dice?.A ?? null;
      const db = st.startDice?.B ?? st.dice?.B ?? null;
      if(Number.isFinite(da) || Number.isFinite(db)){
        setDiceUI(`A:${Number.isFinite(da)?da:"—"}  B:${Number.isFinite(db)?db:"—"}`);
      } else {
        setDiceUI("—");
      }

      // Update opponent deck count display
      const mySlot = slot;
      const otherSlot = mySlot === "A" ? "B" : (mySlot === "B" ? "A" : null);
      if(otherSlot){
        const oppDeckCount = st.players?.[otherSlot]?.deckCount ?? 0;
        const oppDeckCountEl = $("oppDeckCount");
        if(oppDeckCountEl){
          safeText(oppDeckCountEl, oppDeckCount > 0 ? oppDeckCount : "—");
        }
      }

      // Update opponent hand count display
      if(otherSlot){
        const oppHandCount = st.players?.[otherSlot]?.handCount ?? 0;
        const oppHandEl = $("oppHandCount");
        if(oppHandEl){ safeText(oppHandEl, String(oppHandCount)); }
      }
      
      // Update opponent vestiaire count display
      if(otherSlot){
        const oppVestCount = (st.vestiaires?.[otherSlot] || []).length;
        const oppVestEl = $("oppVestiaireCount");
        if(oppVestEl){ safeText(oppVestEl, String(oppVestCount)); }
      }
      
      // Update opponent banch count display
      if(otherSlot){
        const oppBanchCnt = (st.banchs?.[otherSlot] || []).length;
        const oppBanchEl = $("oppBanchCount");
        if(oppBanchEl){ safeText(oppBanchEl, String(oppBanchCnt)); }
      }
      // ==== SYNC PRIVATE PILES FROM DB (deck/hand) ====
      // IMPORTANT: ne pas ecraser des piles locales non-vides avec une DB vide (cas: deck importe avant que la room/slot soit resolu).
      if(mySlot === 'A' || mySlot === 'B'){
        try{
          let dbDeck = (st.deckPiles && Array.isArray(st.deckPiles[mySlot])) ? st.deckPiles[mySlot] : null;
          let dbHand = (st.handPiles && Array.isArray(st.handPiles[mySlot])) ? st.handPiles[mySlot] : null;

          // Repair path (stability): in some edge cases the roomState can carry
          // up-to-date counters but missing/empty private piles (deckPiles/handPiles).
          // When that happens the UI shows "deck vide" and the hand never renders.
          const p = st.players && st.players[mySlot] ? st.players[mySlot] : null;
          const validated = (p && Array.isArray(p.validatedDeckIds)) ? p.validatedDeckIds : [];
          // IMPORTANT: ne jamais reconstruire un deck plein quand le deck DB est *réellement vide*.
          // Un deck à 0 carte est un état valide (on doit alors recycler le vestiaire au moment d'une pioche).
          // On ne fait ce fallback que si deckPiles est absent/inexistant (null), pas si c'est un tableau vide.
          if(dbDeck === null && validated.length>0){
            dbDeck = validated.slice();
          }
          // If the hand pile is missing but we know how many cards should be in hand,
          // reconstruct deterministically using the same draw logic (pop from end).
          const hc = p && typeof p.handCount==='number' ? p.handCount : 0;
          if((!dbHand || dbHand.length===0) && hc>0 && dbDeck && dbDeck.length>=hc){
            const tmp = dbDeck.slice();
            const rebuiltHand=[];
            for(let i=0;i<hc;i++) rebuiltHand.unshift(tmp.pop());
            dbHand = rebuiltHand;
            dbDeck = tmp;

            // Persist the repaired piles so all clients converge (only if we can write).
            try{
              if(canWriteEnfant(st)){
                updateRoomState(s=>{
                  s.deckPiles = s.deckPiles || {A:[],B:[]};
                  s.handPiles = s.handPiles || {A:[],B:[]};
                  s.deckPiles[mySlot] = (dbDeck||[]).slice();
                  s.handPiles[mySlot] = (dbHand||[]).slice();
                  return s;
                });
              }
            }catch(_e){}
          }
          const dbHasData = !!((dbDeck && dbDeck.length) || (dbHand && dbHand.length));
          const localHasData = !!((myDeckPile && myDeckPile.length) || (myHandPile && myHandPile.length));

          if(dbHasData || !localHasData){
            // DB fait foi si elle contient quelque chose, ou si le local est vide
            myDeckPile = (dbDeck ? dbDeck.slice() : []);
            // 🔧 Guard: don't overwrite hand if an optimistic removal is in flight (< 3s)
            const handWriteRecent = (__handWriteAt && (Date.now() - __handWriteAt) < 3000);
            if(!handWriteRecent){
              myHandPile = (dbHand ? dbHand.slice() : []);
            }
          } else {
            // Sinon on garde le local, et on tentera de le commit en DB
          }

          // Opponent deck count: prefer DB piles length if present
          if(otherSlot && st.deckPiles){
            const oppDeck = Array.isArray(st.deckPiles[otherSlot]) ? st.deckPiles[otherSlot] : null;
            if(oppDeck){
              const oppDeckCountEl2 = $("oppDeckCount");
              if(oppDeckCountEl2) safeText(oppDeckCountEl2, oppDeck.length > 0 ? oppDeck.length : "—");
            }
          }

          updateHandUI();
          
          // 🔧 CORRECTION CRITIQUE: Afficher les cartes après synchronisation
          if(typeof renderHandCards === 'function') {
            renderHandCards();
          }
          
          // 🔧 CORRECTION: Afficher le deck après synchronisation
          if(typeof renderDeckCards === 'function') {
            renderDeckCards();
          }

          // Si DB n'a pas encore les piles mais le local oui, pousser en DB maintenant.
          if(localHasData && !dbHasData){
            maybeCommitLocalPilesToDb("autocommit-after-sync");
          }
        }catch(e){
          reportError(e,'syncPrivatePiles');
        }
      }

      // --- Thumb-first (mobile) : clone Phase 3 step buttons near the bottom (no ugly bar) ---
      // This does NOT change the rules; it just mirrors existing buttons for easier access.
      try{ requestAnimationFrame(()=>{ try{ updateThumbPhase3Buttons(); }catch(_e){} }); }catch(_e){}
      // Same idea for Phase 2 (gameplay): keep the two main action buttons reachable by thumb.
      try{ requestAnimationFrame(()=>{ try{ updateThumbPhase2Buttons(); }catch(_e){} }); }catch(_e){}

      // SYNC_ZONES_ANY_PHASE: garder les zones publiques (terrain/vestiaire/banc/revealed/chefs) synchronisées
      // même en Phase 3 (résolution manuelle) ou warmup_ready, sinon le nettoyage ne se voit pas avant la phase suivante.
      if(gameStarted && mySlot && otherSlot){
        try{
          // CRITIQUE: Assurer que TOUTES les créatures ont un inst AVANT de synchroniser
          if(st.terrains){
            ensureTerrainInstances(st, mySlot);
            ensureTerrainInstances(st, otherSlot);
            gameState.myTerrain = st.terrains[mySlot] || [];
            gameState.oppTerrain = st.terrains[otherSlot] || [];
          }
          if(st.vestiaires){
            gameState.myVestiaire = st.vestiaires[mySlot] || [];
            gameState.oppVestiaire = st.vestiaires[otherSlot] || [];
            gameState.oppVestiaireCount = (st.vestiaires[otherSlot] || []).length;
          }
          if(st.banchs){
            gameState.myBanch = st.banchs[mySlot] || [];
            gameState.oppBanch = st.banchs[otherSlot] || [];
            gameState.oppBanchCount = (st.banchs[otherSlot] || []).length;
          }
          if(st.revealed){
            gameState.myRevealed = st.revealed[mySlot] || [];
            gameState.oppRevealedCount = (st.revealed[otherSlot] || []).length;
          }
          if(st.chiefs){
            gameState.myChief = st.chiefs[mySlot];
            gameState.oppChief = st.chiefs[otherSlot];
          }
          if(st.chiefNotes){
            gameState.myChiefNote = st.chiefNotes[mySlot] || '';
            gameState.oppChiefNote = st.chiefNotes[otherSlot] || '';
          }
        }catch(e){
          reportError(e,'syncZonesAnyPhase');
        }
      }
      // deck ready lock
      const myDeckOk = mySlot ? !!st.players?.[mySlot]?.deckOk : false;
      otherDeckReady = otherSlot ? !!st.players?.[otherSlot]?.deckOk : false;
      // IMPORTANT: Ne pas écraser localDeckReady s'il est déjà true (deck importé localement)
      localDeckReady = localDeckReady || !!myDeckOk;

      // sync local myReady with DB (source de vérité)
      if(mySlot === 'A' || mySlot === 'B'){
        myReady = !!st.players?.[mySlot]?.ready;
        syncBtnLabel();
      }

      // auto-start trigger: seulement A déclenche, une fois, quand tout est ok.
      // IMPORTANT: on ne doit JAMAIS relancer une "nouvelle partie" depuis une phase autre que le lobby
      // (ex: phase3_manual) sinon on réinitialise tout et les boutons de résolution disparaissent.
      const bothDeckOk = !!st.players?.A?.deckOk && !!st.players?.B?.deckOk;
      const bothReady = !!st.players?.A?.ready && !!st.players?.B?.ready;
      // Dès que les 2 joueurs ont importé leur deck (et sont connectés), on lance.
      // (Le flag ready est gardé pour compat/reprise, mais n'est plus un "clic".)
      if(st.phase === "lobby" && bothDeckOk && st.players?.A?.id && st.players?.B?.id){
        // ✅ MODE ENFANT V5 : Initialiser la room (par A uniquement)
        const isEnfant = (typeof GAME_MODE !== "undefined" && GAME_MODE === "enfant");
        if(isEnfant && !st.enfantInitialized){
          // Player A initialise la room (decks + phase + tout)
          // initEnfantRoom gère TOUT : init + pioche + start
          initEnfantRoom().catch((e)=>reportError(e,"init-enfant-room"));
        } else if(!isEnfant) {
          // Mode complexe classique
          if(st.players.A.id === selfId){
            triggerAutoStartDb().catch((e)=>reportError(e,"autostart"));
          }
        }
      } else if(st.phase === "started" && !st.enfantInitialized && isEnfant){
        // Cas de reprise : phase started mais pas initialisé (ne devrait pas arriver)
        if(st.players?.A?.id === selfId){
          initEnfantRoom().catch((e)=>reportError(e,"init-enfant-room-recovery"));
        }
      }

      // Si retour en lobby (déco/reset), on réinitialise l'état local de partie
      // IMPORTANT: ne pas reset pendant phase3_manual (résolution) sinon on perd l'UI de victoire/défaite.
      if(st.phase === "lobby" && gameStarted){
        resetStartStateLocal();
      }

      // si démarré: on applique localement (distribution main, etc.) une seule fois
      if(st.phase === "started"){
        if(!gameStarted){
          gameStarted = true;
          starter = st.starter || null;
          startRollA = st.startDice?.A ?? st.dice?.A ?? null;
          startRollB = st.startDice?.B ?? st.dice?.B ?? null;
          handleStartFromDb(); // construit piles, main initiale, etc.
        }
        
        // Synchroniser TOUT depuis roomState
        if(mySlot && otherSlot){
          // Terrains - CRITIQUE: Assurer que TOUTES les créatures ont un inst
          if(st.terrains){
            ensureTerrainInstances(st, mySlot);
            ensureTerrainInstances(st, otherSlot);
            gameState.myTerrain = st.terrains[mySlot] || [];
            gameState.oppTerrain = st.terrains[otherSlot] || [];
          }
          
          // Vestiaires
          if(st.vestiaires){
            gameState.myVestiaire = st.vestiaires[mySlot] || [];
            gameState.oppVestiaire = st.vestiaires[otherSlot] || [];
            gameState.oppVestiaireCount = (st.vestiaires[otherSlot] || []).length;
          }
          
          // Banchs
          if(st.banchs){
            gameState.myBanch = st.banchs[mySlot] || [];
            gameState.oppBanch = st.banchs[otherSlot] || [];
            gameState.oppBanchCount = (st.banchs[otherSlot] || []).length;
          }
          
          // Révélée
          if(st.revealed){
            gameState.myRevealed = st.revealed[mySlot] || [];
            gameState.oppRevealedCount = (st.revealed[otherSlot] || []).length;
          }
          
          // Chefs
          if(st.chiefs){
            gameState.myChief = st.chiefs[mySlot];
            gameState.oppChief = st.chiefs[otherSlot];
          }

          // Notes Chef
          if(st.chiefNotes){
            gameState.myChiefNote = st.chiefNotes[mySlot] || '';
            gameState.oppChiefNote = st.chiefNotes[otherSlot] || '';
          }
          
          // Dés
          if(st.actionDice){
            gameState.myActionDie = st.actionDice[mySlot] || 0;
            gameState.oppActionDie = st.actionDice[otherSlot] || 0;
            updateActionDieUI();
          }
          
          if(st.passDice){
            gameState.myPassDie = st.passDice[mySlot] || 0;
            gameState.oppPassDie = st.passDice[otherSlot] || 0;
            updatePassDieUI();
          }
          
          // Bulle
          if(st.bubbles){
            const myBubble = st.bubbles[mySlot];
            if(myBubble){
              gameState.bulleStateLabel = myBubble.state || '';
              gameState.occurrencesThisRound = myBubble.occurrences || 0;
            }
          }
        }
      }

      // SYNC_DICE_ANY_PHASE: garder les compteurs de dés à jour même hors phase 'started' (ex: warmup_ready)
      if(mySlot && otherSlot){
        if(st.actionDice){
          gameState.myActionDie = st.actionDice[mySlot] || 0;
          gameState.oppActionDie = st.actionDice[otherSlot] || 0;
          updateActionDieUI();
        }
        if(st.passDice){
          gameState.myPassDie = st.passDice[mySlot] || 0;
          gameState.oppPassDie = st.passDice[otherSlot] || 0;
          updatePassDieUI();
        }
      }
      // --- Thumb-first buttons must follow REAL game state (not local clicks).
      // We re-run the thumb mirroring AFTER all phase/step UI has been updated in this pass.
      try{
        requestAnimationFrame(()=>{ try{ updateThumbPhase3Buttons(); }catch(_e){} });
        requestAnimationFrame(()=>{ try{ updateThumbPhase2Buttons(); }catch(_e){} });
      }catch(_e){}
      updateMidMenuControls();
      updateTurnIndicators();
      updateAllZoneCounters();
      if(typeof updateGamePanelDisplay === "function") updateGamePanelDisplay();
      if(typeof updateScoreTrack === "function") updateScoreTrack();
      if(typeof maybeRunWarmupAuto === "function") maybeRunWarmupAuto();
    }catch(e){
      reportError(e, "applyRoomStateToUI");
    }
  }

  async function triggerAutoStartDb(){
    // Relit l'état (sécurité), puis écrit phase started + dés + starter
    // + distribue la main initiale dans la DB (évite les désync / un joueur sans main)
    const st = roomState || initialRoomState();
    if(st.phase === "started") return;
    if(!(st.players?.A?.deckOk && st.players?.B?.deckOk)) return;
    if(!(st.players?.A?.ready && st.players?.B?.ready)) return;

    // roll d12 until no tie
    let a=0,b=0;
    for(let i=0;i<20;i++){
      a = 1 + Math.floor(Math.random()*12);
      b = 1 + Math.floor(Math.random()*12);
      if(a !== b) break;
    }
    const starterSlot = (a > b) ? "A" : "B";

    await updateRoomState((s) => {
      if(s.phase === "started") return s;
      if(!(s.players?.A?.deckOk && s.players?.B?.deckOk)) return s;
      if(!(s.players?.A?.ready && s.players?.B?.ready)) return s;

      s.deckPiles = s.deckPiles || {A:[],B:[]};
      s.handPiles = s.handPiles || {A:[],B:[]};
      s.startDrawn = s.startDrawn || {A:false,B:false};

      const drawN = (slot, n) => {
        if(s.startDrawn?.[slot]) return;
        const deck = Array.isArray(s.deckPiles[slot]) ? s.deckPiles[slot] : (s.deckPiles[slot]=[]);
        const hand = Array.isArray(s.handPiles[slot]) ? s.handPiles[slot] : (s.handPiles[slot]=[]);
        const take = deck.splice(0, n);
        hand.push(...take);
        s.startDrawn[slot] = true;
      };

      // Pioche initiale (DB source de vérité)
      drawN('A', 5);
      drawN('B', 5);

      // Dice + starter
      s.dice = {A:a, B:b};
      s.starter = starterSlot;
      s.currentPlayer = starterSlot; // Initialiser le tour au starter
      s.roundNumber = 1;
      s.phase = "started";

      // Public counts
      s.players = s.players || {A:{},B:{}};
      s.players.A = s.players.A || {};
      s.players.B = s.players.B || {};
      s.players.A.handCount = (s.handPiles.A||[]).length;
      s.players.B.handCount = (s.handPiles.B||[]).length;
      s.players.A.deckCount = (s.deckPiles.A||[]).length;
      s.players.B.deckCount = (s.deckPiles.B||[]).length;

      return s;
    }, "autostart");
  }

  // ===== Identity (persisted across refresh AND browser restarts) =====
  const ID_KEY = "bulle::identity::persistent";
  function loadIdentity(){
    try{
      const raw = storage.get(ID_KEY); // Utilise localStorage via notre wrapper safe
      if(raw){
        const j = JSON.parse(raw);
        if(j && typeof j.id === "string" && Number.isFinite(j.joinedAt)){
          // Identité valide trouvée - on la réutilise
          return { id: j.id, joinedAt: j.joinedAt };
        }
      }
    }catch(_e){}
    // Aucune identité trouvée ou invalide - on en crée une nouvelle
    const fresh = { id: `${Math.random().toString(16).slice(2)}-${now()}`, joinedAt: now() };
    storage.set(ID_KEY, JSON.stringify(fresh));
    return fresh;
  }
  const IDENTITY = loadIdentity();
  const selfId = IDENTITY.id;
  const selfJoinedAt = IDENTITY.joinedAt;

  function setConnectedUI(ok){
    connected = !!ok;
    safeText(connLabel, ok ? "Connecté" : "Déconnecté");
  }

  function setRoleUI(role, count){
    safeText(roleLabel, role || "—");
    safeText(presenceLabel, String(count ?? 0));
    safeText(rolePill, role || "—");
    safeText(presentPill, String(count ?? 0));
  }

  try{ updateMidMenuControls(); }catch(_){ }

  
// Protection against double init
let connectingInProgress = false;
let connectPromise = null;

async function connect(){
  if(connected) return;
  if(connectPromise) {
    // Important: wait for the ongoing connect rather than returning early.
    await connectPromise;
    return;
  }

  connectingInProgress = true;

  connectPromise = (async () => {
    try{
      if(!window.supabase) throw new Error("supabase-js introuvable");

      // Réutiliser le client existant ou en créer un nouveau
      // Cela évite le warning "Multiple GoTrueClient instances"
      if(!sb || !sb.auth) {
      // Prefer the singleton client from services.js (clean architecture)
      try{
        const s = window.BulleServices;
        if(s && s.supabase && typeof s.supabase.getClient === "function"){
          const c = s.supabase.getClient();
          if(c && c.auth) sb = c;
        }
      }catch(_e){}

      // Fallback (should not happen): create client from current CONFIG
      if(!sb || !sb.auth){
        sb = window.supabase.createClient(CONFIG.supabaseUrl, CONFIG.supabaseAnonKey, {
          auth: {
            persistSession: true,
            autoRefreshToken: true,
            detectSessionInUrl: true
          }
        });
        // Expose a shared client for modules like cloudDeckImport (avoid multiple GoTrueClient instances)
        try{ window.__bulleSupabaseClient = sb; window.__bulleSupabaseSig = `${CONFIG.supabaseUrl}::${(CONFIG.supabaseAnonKey||"").slice(0,16)}`; }catch(_e){}
      }
    }

      // Vérifier que le client est bien créé
      if (!sb) {
        throw new Error("Impossible de créer le client Supabase");
      }

      const code = roomKey();
      roomCodeActive = code;

      await ensureRoomRow(code);
      subscribeRoom(code);
      connected = true;
      setConnectedUI(true);

      try{ startPresenceSystem(); }catch(_e){}
      try{ startTimeoutAutoPassSystem(); }catch(_e){}

      // Auto-assign slot A/B via DB
      await claimAutoSlot();

      pushLog(`Connecté à room:${code}`);
      applyRoomStateToUI("connect");
      updateSpectatorMode();

      // sécurité : si on ferme l'onglet, on essaie de libérer le slot + cleanup
      window.addEventListener("beforeunload", () => {
        try{
          clearAllTimers();
          // ✅ PATCH 3 : leaveSlotIfOwned() SUPPRIMÉ ici.
          // Elle se déclenche aussi sur F5 (refresh), ce qui réinitialise phase → "lobby"
          // et détruit les terrains pour tous les joueurs.
          // → Le slot reste réclamé au refresh ; un heartbeat / timeout serverless
          //   doit être utilisé à la place pour libérer les slots abandonnés.
        }catch(_e){}
      });
    }catch(e){
      reportError(e,"connect");
    } finally {
      connectingInProgress = false;
      connectPromise = null;
    }
  })();

  await connectPromise;
  // --- live refresh des panels ouverts (main / vestiaire / deck) ---
  // Quand un effet déplace une carte (ex: main -> vestiaire), on veut voir l'action immédiatement,
  // sans devoir fermer/ré-ouvrir le panel.
  try {
    const overlay = document.getElementById("panelOverlay");
    const isOpen = overlay && overlay.classList.contains("open");
    if (isOpen) {
      const viewHand = document.getElementById("viewHand");
      const viewVest = document.getElementById("viewVestiaire");
      const viewDeck = document.getElementById("viewDeckBrowse");
      if (viewHand && viewHand.classList.contains("active")) renderHandCards();
      if (viewVest && viewVest.classList.contains("active")) renderVestiaireCards();
      if (viewDeck && viewDeck.classList.contains("active")) renderDeckBrowse();
    }
  } catch (e) {}

}
  async function disconnect(){
    if(!connected) return;
    try{
      // libère le slot si possible (évite les "3 présents")
      await leaveSlotIfOwned();
    }catch(e){
      // non bloquant
      reportError(e,"leaveSlot");
    }
    try{
      if(roomRt && sb){
        try{ sb.removeChannel(roomRt); }catch(_e){ _sw("removeChannel",_e); }
      }
      roomRt = null;
      connected = false;
      stopPresenceSystem();
      stopTimeoutAutoPassSystem();
    setConnectedUI(false);
      // status pill removed
pushLog("Déconnecté");
    }catch(e){
      reportError(e,"disconnect");
    }
  }
  // =====================================================================
  

// =====================================================================
// CONCÉDER (quitter + empêcher la reconnexion sur la même room)
// =====================================================================
async function concedeGame(){
  try{
    if(!connected || !sb || !roomCodeActive) {
      // même si pas connecté, on reset la room code pour éviter un "retour" involontaire
      try{ setRoom(_randRoomCode ? _randRoomCode() : ""); }catch(_e){}
      try{ if(typeof openPanel === 'function'){ openPanel({mode:"drawer", view:"setup", title:"Setup / Connexion", context:""}); } }catch(_e){}
      return;
    }

    // 1) Marquer la partie comme terminée côté DB (source de vérité)
    try{
      const st = roomState || {};

      // Déterminer mon slot et donc le gagnant
      const mySlot = (typeof mySlotFromState === 'function') ? (mySlotFromState(st) || null) : null;
      const winnerSlot = mySlot === 'A' ? 'B' : mySlot === 'B' ? 'A' : null;
      const result = {
        A: (winnerSlot === 'A') ? 'win' : (winnerSlot === 'B') ? 'lose' : undefined,
        B: (winnerSlot === 'B') ? 'win' : (winnerSlot === 'A') ? 'lose' : undefined,
      };

      const next = {
        ...st,
        phase: "ended",
        endReason: "concede",
        endedAt: Date.now(),
        concededBy: mySlot || (selfId || "unknown"),
        winner: winnerSlot || st.winner || null,
        result: (winnerSlot ? result : (st.result || null))
      };
      const { error } = await sb
        .from("rooms_kid")
        .update({ state: next })
        .eq("room_code", roomCodeActive);
      if(error) _sw("concede-update", error);
    }catch(e){
      _sw("concede-update-try", e);
    }

    // 2) L'UI affichera le pop-up de victoire automatiquement via applyRoomStateToUI().
    //    On ne déconnecte pas tout de suite pour que le joueur qui concède le voie aussi.
    try{ pushLog("🏳️ Partie concédée"); }catch(_e){}
  }catch(e){
    reportError(e, "concede");
  }
}
// MATCHMAKING (auto room) — UX "Jouer" sans code room
  // =====================================================================

  let matchmakingInProgress = false;

  function _randRoomCode(){
    // Fallback: truly random code (rarely used now)
    const alphabet = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
    let s = "M";
    for(let i=0;i<6;i++) s += alphabet[Math.floor(Math.random()*alphabet.length)];
    return s;
  }

  function _mmRoomCode(){
    // Deterministic matchmaking code (15s bucket).
    // Goal: if 2 joueurs cliquent "Jouer" en même temps, ils ont de fortes chances
    // de tomber sur le même code => même room (au lieu de 2 rooms séparées).
    const alphabet = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
    let n = Math.floor(Date.now() / 15000); // bucket de 15 secondes
    let s = "M";
    for(let i=0;i<6;i++){
      s += alphabet[n % alphabet.length];
      n = Math.floor(n / alphabet.length);
    }
    return s;
  }

  function _isRoomSuitableForMatchmaking(st){
    try{
      if(!st) return false;
      const mode = st.gameMode ? String(st.gameMode) : null;
      if(mode && mode !== GAME_MODE) return false;

      const phase = String(st.phase || "lobby");
      // Accept lobby rooms directly; accept ended/finished rooms (will be auto-reset on connect)
      const acceptablePhase = (phase === "lobby" || phase === "ended" || phase === "finished");
      if(!acceptablePhase) return false;

      const now = Date.now();
      const STALE_MS = 90_000;

      function isSlotActive(slot){
        const p = st.players?.[slot];
        if(!p || !p.id) return false;
        // In ended rooms, all players are considered stale (room is recyclable)
        if(phase !== "lobby") return false;
        const pres = st.presence?.[slot];
        if(pres && pres.lastSeenAt && (now - pres.lastSeenAt) > STALE_MS) return false;
        return true;
      }
      const count = (isSlotActive("A") ? 1 : 0) + (isSlotActive("B") ? 1 : 0);
      return count < 2;
    }catch(_e){ return false; }
  }

  async function ensureSupabaseClientOnly(){
    if(sb && sb.auth) return sb;
    if(!window.supabase) throw new Error("supabase-js introuvable");
    // Prefer singleton services
    try{
      const s = window.BulleServices;
      if(s && s.supabase && typeof s.supabase.getClient === "function"){
        const c = s.supabase.getClient();
        if(c && c.auth){ sb = c; return sb; }
      }
    }catch(_e){}
    // Fallback: create client from CONFIG
    sb = window.supabase.createClient(CONFIG.supabaseUrl, CONFIG.supabaseAnonKey, {
      auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true }
    });
    try{ window.__bulleSupabaseClient = sb; window.__bulleSupabaseSig = `${CONFIG.supabaseUrl}::${(CONFIG.supabaseAnonKey||"").slice(0,16)}`; }catch(_e){}
    return sb;
  }

  function isJoinableRoomRow(row){
    try{
      if(!row || !row.state) return false;
      const st = row.state;
      const mode = st.gameMode ? String(st.gameMode) : null;
      if(mode && mode !== GAME_MODE) return false;
      if(st.phase && String(st.phase) !== "lobby") return false;

      const now = Date.now();
      const STALE_MS = 90_000; // 90s — si pas vu depuis 90s, considéré absent

      // Count actually-active players (not just id present)
      function isPlayerActive(slot){
        const p = st.players?.[slot];
        if(!p || !p.id) return false;
        // Don't match with myself
        if(p.id === selfId) return false;
        // Check presence heartbeat
        const pres = st.presence?.[slot];
        if(pres && pres.lastSeenAt){
          if((now - pres.lastSeenAt) > STALE_MS) return false; // stale
        } else {
          // No presence data — check row updated_at as fallback
          const updAt = row.updated_at ? Date.parse(row.updated_at) : 0;
          if(updAt && (now - updAt) > STALE_MS) return false; // stale
        }
        return true;
      }

      const activeA = isPlayerActive("A");
      const activeB = isPlayerActive("B");
      const activeCount = (activeA ? 1 : 0) + (activeB ? 1 : 0);

      // Joinable: exactly one ACTIVE player (not me)
      return activeCount === 1;
    }catch(_e){
      return false;
    }
  }

  async function startMatchmaking(){
    if(matchmakingInProgress) return;
    matchmakingInProgress = true;

    try{
      if(connected){
        // Leave current room cleanly (avoid staying counted as present)
        try{ await disconnect(); }catch(_e){}
      }

      await ensureSupabaseClientOnly();

      setConnectedUI(false);
      try{ pushLog("🔎 Recherche d'un adversaire…"); }catch(_e){}

      // Look for a waiting room (recent first)
      let candidate = null;
      try{
        const { data: rows, error } = await sb
          .from("rooms_kid")
          .select("room_code,state,updated_at")
          .order("updated_at", { ascending: false })
          .limit(50);

        if(error) throw error;

        const now = Date.now();
        const fresh = (rows || []).filter(r=>{
          const t = r.updated_at ? Date.parse(r.updated_at) : 0;
          // ignore stale lobbies (10 min — presence heartbeat is the real check)
          return !t || (now - t) < (10 * 60 * 1000);
        });

        candidate = fresh.find(isJoinableRoomRow) || null;
      }catch(e){
        _sw("matchmaking-search", e);
      }

      if(candidate && candidate.room_code){
        try{ pushLog(`✅ Adversaire trouvé : ${candidate.room_code}`); }catch(_e){}
        const inp = $("roomInput");
        if(inp) inp.value = String(candidate.room_code || "").toUpperCase();
      }else{
        // Use deterministic bucket code first (so two players starting at the same moment converge)
        let code = _mmRoomCode();

        // If this bucket room is already "busy" (started / full / wrong mode), fallback to random unique codes.
        for(let attempt=0; attempt<4; attempt++){
          try{
            roomCodeActive = code;
            await ensureRoomRow(code);
            const st = roomState || initialRoomState();
            if(_isRoomSuitableForMatchmaking(st)){
              break;
            }
          }catch(_e){}
          code = _randRoomCode(); // fallback
        }

        try{ pushLog(`⏳ Aucun adversaire. Création / reprise d'une attente : ${code}`); }catch(_e){}
        const inp = $("roomInput");
        if(inp) inp.value = code;

        // Ensure row exists now (so others can join immediately)
        roomCodeActive = code;
        await ensureRoomRow(code);
      }

      // Connect to selected / created room
      await connect();

      // Auto-reset if we joined an old finished game (avoids stale victory popup)
      try{
        const stMM = roomState || initialRoomState();
        const phaseMM = String(stMM.phase || "lobby");
        if(phaseMM === "ended" || phaseMM === "finished" || phaseMM === "phase3_manual"){
          console.warn("[matchmaking] Room in stale phase:", phaseMM, "→ resetting to lobby");
          await updateRoomState((s)=>{
            const base = initialRoomState();
            base.gameMode = GAME_MODE;
            // Keep player IDs (they just connected)
            base.players = s.players || {A:{},B:{}};
            // But reset their ready/deckOk flags
            for(const sl of ["A","B"]){
              if(base.players[sl]){
                base.players[sl].deckOk = false;
                base.players[sl].ready = false;
              }
            }
            return base;
          }, "matchmaking-reset");
          // Reset local state too
          try{ resetStartStateLocal(); }catch(_e){}
          try{ applyRoomStateToUI("matchmaking-reset"); }catch(_e){}
        }
      }catch(_e){}

      // If we are alone, show "waiting" banner
      try{
        const st = roomState || initialRoomState();
        const a = st.players?.A?.id || null;
        const b = st.players?.B?.id || null;
        const count = (a?1:0) + (b?1:0);
        if(count === 1){
          try{ pushLog("⏳ En attente d'un adversaire…"); }catch(_e){}
        }
      }catch(_e){}
    }catch(e){
      reportError(e, "matchmaking");
      try{ pushLog("❌ Matchmaking impossible. Vérifie la connexion."); }catch(_e){}
    } finally {
      matchmakingInProgress = false;
    }
  }

  
  // =====================================================================
  // RESTART À 2 CONFIRMATIONS (A + B)
  // =====================================================================
  async function requestRestartTwoConfirm(){
    try{
      if(!connected){ alert("Vous devez être connecté."); return; }
      const st0 = roomState || initialRoomState();
      const mySlot = (typeof mySlotFromState === 'function') ? (mySlotFromState(st0) || null) : null;
      if(!mySlot){
        try{ if(typeof showToast === 'function') showToast("👀 Mode spectateur : impossible de demander une nouvelle partie"); }catch(_e){}
        return;
      }

      await updateRoomState((st)=>{
        if(!st.restartReq || typeof st.restartReq !== 'object'){
          st.restartReq = {A:false, B:false};
        }
        // Toggle pour permettre d'annuler
        st.restartReq[mySlot] = !st.restartReq[mySlot];
        st.restartReqAt = Date.now();
        return st;
      }, "restart-req");

      // Feedback
      try{
        const st = roomState || {};
        const rr = st.restartReq || {};
        const me = !!rr[mySlot];
        const opp = (mySlot === 'A') ? 'B' : 'A';
        const oppOk = !!rr[opp];
        if(!me){
          if(typeof showToast === 'function') showToast("↩️ Demande de nouvelle partie annulée");
        }else if(oppOk){
          if(typeof showToast === 'function') showToast("✅ Les 2 joueurs ont confirmé — relance en cours…");
        }else{
          if(typeof showToast === 'function') showToast("✅ Demande envoyée — en attente de l'adversaire");
        }
      }catch(_e){}
    }catch(e){
      reportError(e, "restart-req");
    }
  }

const connectBtn = $("connectBtn");
  const disconnectBtn = $("disconnectBtn");
  if(connectBtn) connectBtn.addEventListener("click", connect);
  if(disconnectBtn) disconnectBtn.addEventListener("click", disconnect);

  const matchBtn = $("matchBtn");
  if(matchBtn) matchBtn.addEventListener("click", startMatchmaking);

  const concedeBtnSetup = $("concedeBtnSetup");
  if(concedeBtnSetup){
    concedeBtnSetup.onclick = () => concedeGame();
  }

  const newGameBtn = $("newGameBtn");
  if(newGameBtn){
    newGameBtn.addEventListener("click", async ()=>{
      // ✅ Restart à 2 confirmations (A + B)
      // - 1er clic: j'accepte / j'annule
      // - quand les 2 ont accepté, le leader (A) relance automatiquement (voir applyRoomStateToUI)
      await requestRestartTwoConfirm();
    });
  }

  const resetRoomBtn = $("resetRoomBtn");
  if(resetRoomBtn){
    resetRoomBtn.addEventListener("click", async () => {
      try{
        if(!connected){
          alert("Vous devez être connecté.");
          return;
        }
        if(!confirm("Réinitialiser la room (HARD) ?\n- libère Joueur A/B\n- remet prêt/dés/starter\n- repart en lobby")) return;

        myReady = false;
        localDeckReady = false;
        otherDeckReady = false;
        resetStartStateLocal();

        await resetRoomHard();
        pushLog("Room réinitialisée (hard).");
      }catch(e){
        reportError(e,"reset-room");
      }
    });
  }

  const reloadBtn = $("reloadBtn");
  if(reloadBtn){
    reloadBtn.addEventListener("click", () => {
      try{
        // Rafraîchissement "hard" (comme F5). Utile en PWA (pas de barre navigateur).
        window.location.reload();
      }catch(e){
        // fallback
        window.location.href = window.location.href;
      }
    });
  }
  // ===== cards.json + decklist (proto hooks + logs) =====
  let cardsById = new Map();
  // ===== Instance tokens (V10) =====
  // We store copies as unique tokens: "A-000001::019" (iid::cid)
  function isInstanceToken(x){
    return (typeof x === 'string') && x.includes('::') && /^[AB]-\d{6}::/.test(x);
  }
  function getCid(tok){
    if(typeof tok === 'string'){
      const parts = tok.split('::');
      return parts.length === 2 ? parts[1] : tok;
    }
    if(tok && typeof tok === 'object'){
      // tokens may be stored as objects depending on the zone
      const v = tok.cid ?? tok.cardId ?? tok.card_id ?? tok.id ?? tok.number;
      if(v != null) return String(v).match(/(\d{1,3})/) ? String(String(v).match(/(\d{1,3})/)[1]).padStart(3,'0') : String(v);
    }
    return String(tok||'');
  }
  function getIid(tok){
    if(typeof tok === 'string'){
      const parts = tok.split('::');
      return parts.length === 2 ? parts[0] : null;
    }
    if(tok && typeof tok === 'object'){
      const v = tok.iid ?? tok.instanceId ?? tok.inst ?? tok.instance;
      return v != null ? String(v) : null;
    }
    return null;
  }

  function makeToken(slot, n, cid){
    const iid = `${slot}-${String(n).padStart(6,'0')}`;
    return `${iid}::${String(cid).padStart(3,'0')}`;
  }
  function cardByToken(tok){
    return cardsById.get(getCid(tok));
  }

  // ===== Token helpers (front/flip normalization) =====
  function padCid(x){
    return String(x ?? '').match(/\d{1,3}/) ? String(String(x).match(/(\d{1,3})/)[1]).padStart(3,'0') : String(x ?? '').padStart(3,'0');
  }
  function replaceCidInToken(tok, newCid){
    const cid3 = padCid(newCid);
    // V10 format: iid::cid
    const iid = getIid(tok);
    if(iid) return `${iid}::${cid3}`;
    // legacy format: cid_timestamp
    if(typeof tok === 'string' && tok.includes('_')){
      const parts = String(tok).split('_');
      const ts = parts[parts.length-1];
      return `${cid3}_${ts}`;
    }
    return cid3;
  }
  function frontCidFromCid(cid){
    const c = cardsById.get(padCid(cid));
    // If this cid is a "back face", cards.json should contain transformFrom
    if(c && c.transformFrom) return padCid(c.transformFrom);
    return padCid(cid);
  }
  function normalizeTokenToFront(tok, explicitFrontCid){
    // If explicitFrontCid is provided, use it; otherwise infer from tok/cid (transformFrom).
    const frontCid = explicitFrontCid ? padCid(explicitFrontCid) : frontCidFromCid(getCid(tok));
    return replaceCidInToken(tok, frontCid);
  }
  function normalizeTokenInput(slot, raw, st){
    // raw may be a cid ("019") or already token.
    if(isInstanceToken(raw)) return raw;
    if(!st.nextInstanceNum) st.nextInstanceNum = {A:1,B:1};
    let n = st.nextInstanceNum[slot] || 1;
    const tok = makeToken(slot, n, raw);
    st.nextInstanceNum[slot] = n + 1;
    return tok;
  }
  // Ensure every terrain creature has an instance token (inst).
  // This prevents ambiguity when multiple copies share the same cardId.
  function ensureTerrainInstances(st, slot){
    if(!st) return;
    if(!st.nextInstanceNum) st.nextInstanceNum = {A:1,B:1};
    if(!st.terrains) st.terrains = {A:[],B:[]};
    if(!Array.isArray(st.terrains[slot])) st.terrains[slot] = [];

    let n = st.nextInstanceNum[slot] || 1;
    for(const c of st.terrains[slot]){
      if(!c || typeof c !== 'object') continue;
      if(c.inst && isInstanceToken(c.inst)) continue;
      const cid = String(c.cardId||'').padStart(3,'0');
      c.inst = makeToken(slot, n, cid);
      n += 1;
    }
    st.nextInstanceNum[slot] = n;
  }
  // otherSlot — single definition at line ~8373 (handles null)
  let cardsLoaded = false;
  let cardModalShowAltFace = false; // FIX #4: État flip menu carte
  function updateImportDeckBtn(){
    const btn = $("importDeckBtn");
    if(!btn) return;
    btn.disabled = !cardsLoaded;
  }
  // disable import until cards.json is loaded
  updateImportDeckBtn();

  const loadCardsBtn = $("loadCardsBtn");
  const cardsFile = $("cardsFile");
  const cardsStatus = $("cardsStatus");
  

  // ===== Auto-load cards.json from repo (public/data/cards.json) =====
  // Robust against cache and early clicks on mobile.
  let __cardsLoadPromise = null;
  async function loadCardsFromServer(force = false){
    try{
      if(force) __cardsLoadPromise = null;
      if(__cardsLoadPromise) return __cardsLoadPromise;
      __cardsLoadPromise = (async ()=>{
        try{
          if(cardsStatus) safeText(cardsStatus, "Chargement…");
          const url = `/data/cards.json?v=${Date.now()}`;
          const res = await fetch(url, { cache: "no-store" });
          if(!res.ok) throw new Error(`HTTP ${res.status} sur ${url}`);
          const j = await res.json();
          const cardsArr = Array.isArray(j) ? j : (j && Array.isArray(j.cards) ? j.cards : null);
          if(!cardsArr) throw new Error("Format attendu: { cards:[...] }");

          cardsById = new Map();
          for(const c of cardsArr){
            const raw = String(c.number ?? c.id ?? c.collectorNumber ?? "").trim();
            const m = raw.match(/(\d+)/);
            const id = m ? String(m[1]).padStart(3,'0') : raw;
            if(!id) continue;
            cardsById.set(id, c);
          }
          cardsLoaded = true;

          // Expose a read-only view for other modules (e.g. Pixi board).
          // This helps render full-art miniatures for cards stored as ids/tokens.
          try {
            window.CARDS_BY_ID = cardsById;
            window.getCardById = (id) => {
              const s = String(id ?? "");
              const m = s.match(/(\d+)/);
              const key = (m ? String(m[1]).padStart(3, "0") : s);
              return (window.CARDS_BY_ID && window.CARDS_BY_ID.get) ? window.CARDS_BY_ID.get(key) : null;
            };
          } catch (e) {}

          updateImportDeckBtn();
          if(cardsStatus) safeText(cardsStatus, `OK (${cardsById.size})`);
          pushLog(`cards.json chargé (${cardsById.size})`);
          return true;
        }catch(e){
          cardsLoaded = false;
          updateImportDeckBtn();
          if(cardsStatus) safeText(cardsStatus, "Erreur");
          reportError(e,"cards");
          return false;
        }
      })();
      return __cardsLoadPromise;
    }catch(_e){
      cardsLoaded = false;
      updateImportDeckBtn();
      return false;
    }
  }

  async function ensureCardsLoaded(){
    if(cardsLoaded && cardsById && typeof cardsById.get === "function" && cardsById.size > 0) return true;
    // try twice (mobile + cache)
    if(await loadCardsFromServer(false)) return true;
    return await loadCardsFromServer(true);
  }

  // Kick off cards load early (non-blocking)
  ensureCardsLoaded();

if(loadCardsBtn && cardsFile){
    loadCardsBtn.addEventListener("click", () => cardsFile.click());
    cardsFile.addEventListener("change", async () => {
      const f = cardsFile.files && cardsFile.files[0];
      if(!f) return;
      try{
        const txt = await f.text();
        const j = JSON.parse(txt);
        if(!j.cards || !Array.isArray(j.cards)) throw new Error("Format attendu: { cards: [...] }");
        cardsById = new Map();
        for(const c of j.cards){
          const raw = String(c.number ?? c.id ?? c.collectorNumber ?? "").trim();
          const m = raw.match(/(\d+)/);
          if(!m) continue;
          const id = m[1].padStart(3,"0");
          cardsById.set(id, c);
        }
        cardsLoaded = true;
        updateImportDeckBtn();
        safeText(cardsStatus, `OK (${cardsById.size})`);
        pushLog(`cards.json chargé (${cardsById.size})`);
      }catch(e){
        cardsLoaded = false;
        safeText(cardsStatus, "Erreur");
        reportError(e,"cards");
      }finally{
        cardsFile.value = "";
      }
    });
  }

  const decklistInput = $("decklistInput");
  if(decklistInput){
    decklistInput.value = storage.get(roomStorageKey("decklistText")) || decklistInput.value || "";
    decklistInput.addEventListener("input", () => {
      storage.set(roomStorageKey("decklistText"), decklistInput.value);
    });
  }
  const importDeckBtn = $("importDeckBtn");
  const deckStatus = $("deckStatus");

  function parseDecklist(text){
    const ids = [];
    const lines = (text||"").split(/\r?\n/).map(l=>l.trim()).filter(Boolean);
    for(const line of lines){
      if(line.startsWith("#")) continue;
      const m = line.match(/^(\d+)\s*x\s*\[(.+?)\]/i);
      if(!m) continue;
      const qty = parseInt(m[1],10);
      const id = String(m[2]).trim().padStart(3,"0");
      for(let i=0;i<qty;i++) ids.push(id);
    }
    return ids;
  }
// ===== Deck validation (copié du deckbuilder, adapté au playtest) =====
function isTokenCard(c){
  if(!c) return false;
  if(c.isToken === true) return true;
  const t = String(c.type || "").toLowerCase();
  return t.includes("token") || t.includes("jeton");
}

function isLeaderCard(c){
  // Système de chef supprimé
  return false;
}

function rarityOf(c){
  return String(c?.rarity || "").toUpperCase().trim();
}

function maxCopiesForCard(c){
  if(!c) return 4;
  if(isTokenCard(c)) return 0;     // tokens interdits
  const r = rarityOf(c);
  if(r === "R") return 1;          // rare: 1 exemplaire
  if(r === "C") return 4;          // commune: 4 exemplaires
  return 4;                        // fallback
}

function countsFromIds(ids){
  const m = new Map();
  for(const id of ids){
    m.set(id, (m.get(id) || 0) + 1);
  }
  return m;
}

  var localDeckReady = false;
function validateDeckFromIds(ids){
  const errors = [];
  const counts = countsFromIds(ids);

  let mainCount   = 0; // 
  let tokenCount  = 0;
  let rareTotal   = 0;

  // IDs manquants
  const missing = [];
  for(const [id] of counts){
    if(!cardsById.has(id)) missing.push(id);
  }
  if(missing.length){
    errors.push(`IDs introuvables dans cards.json: ${missing.slice(0,10).join(", ")}${missing.length>10?"…":""}`);
    return {
      isLegal:false,
      errors,
      stats:{ mainCount, totalCount: ids.length, tokenCount, rareTotal },
      missing
    };
  }

  // Règles
  for(const [id, qty] of counts){
    const c = cardsById.get(id);

    if(isTokenCard(c)) tokenCount += qty;

    //     if(isLeaderCard(c)){
    //       leaderCount += qty;
    //       if(qty > 1) errors.push(`Chef d’équipe: "${c.name || id}" est en ${qty} exemplaires (max 1).`);
    //       continue;
    //     }

    mainCount += qty;

    const r = rarityOf(c);
    if(r === "R"){
      rareTotal += qty;
      if(qty > 1) errors.push(`Rare: "${c.name || id}" est en ${qty} exemplaires (max 1).`);
    } else if(r === "C"){
      if(qty > 4) errors.push(`Commune: "${c.name || id}" est en ${qty} exemplaires (max 4).`);
    } else {
      const max = maxCopiesForCard(c);
      if(qty > max) errors.push(`"${c.name || id}" est en ${qty} exemplaires (max ${max} par défaut).`);
    }
  }

  if(tokenCount > 0) errors.push(`Tokens interdits: ${tokenCount} token(s) présent(s) dans le deck.`);
  // Validation chef supprimée
  // if(leaderCount !== 1) errors.push(`Chef d’équipe obligatoire: tu en as ${leaderCount} (il en faut exactement 1).`);
  if(mainCount !== 40) errors.push(`Cartes principales: tu en as ${mainCount} (il en faut exactement 40).`);
  if(rareTotal > 9) errors.push(`Rares: ${rareTotal} au total (maximum 9).`);

  const totalCount = mainCount;

  return {
    isLegal: errors.length === 0,
    errors,
    stats: { mainCount, totalCount, tokenCount, rareTotal },
    missing:[]
  };
}
  
if(importDeckBtn){
  importDeckBtn.addEventListener("click", async () => {
    try{
      clearDeckValidationUI();
        const ids = parseDecklist(decklistInput?.value || "");
      if(!ids.length){
        safeText(deckStatus, "Vide");
        localDeckReady = false;
        if(connected){ const st=roomState||initialRoomState(); const slot=mySlotFromState(st); if(slot){ updateRoomState((s)=>{ s.players[slot].deckOk=false; s.players[slot].ready=false; return s; }, "deck-empty").catch(()=>{}); } }
        pushLog("Decklist vide / format non reconnu");
        showDeckValidationInfo("Decklist vide / format non reconnu.");
        return;
      }

      if(!cardsLoaded){
        const okCards = await ensureCardsLoaded();
        if(!okCards){
          safeText(deckStatus, `cards.json indisponible (deck: ${ids.length})`);
          localDeckReady = false;
          if(connected){ 
            const st=roomState||initialRoomState(); 
            const slot=mySlotFromState(st); 
            if(slot){ 
              updateRoomState((s)=>{ 
                s.players = s.players || {A:{},B:{}}; 
                s.players[slot] = s.players[slot] || {}; 
                s.players[slot].deckOk=false; 
                s.players[slot].ready=false; 
                return s; 
              }, "deck-empty").catch(()=>{}); 
            } 
          }
          pushLog("Decklist importée mais impossible de valider: cards.json indisponible");
          showDeckValidationInfo("Impossible de valider : cards.json indisponible (refresh / cache).");
          return;
        }
      }

      const v = validateDeckFromIds(ids);

      // --- Format ENFANT : override légalité deck (règles d'équilibrage) ---
      try{
        const EXPECTED_SIZE = 40;
        const MAX_COPIES_COMMON = 4;
        const MAX_COPIES_RARE = 2;
        const MAX_TOTAL_RARES = 12;
        
        let ok = Array.isArray(ids) && ids.length === EXPECTED_SIZE;
        let reason = ok ? `Deck OK (${EXPECTED_SIZE})` : `Deck NON légal (${ids?.length||0}/${EXPECTED_SIZE} cartes)`;
        let totalRares = 0;
        
        if(ok){
          const counts = new Map();
          for(const id of ids){
            const c = cardsById.get(id);
            if(!c){ ok=false; reason="Deck NON légal (carte inconnue)"; break; }
            if(c.isBackFace){ ok=false; reason="Deck NON légal (face retournée interdite)"; break; }
            if(String(c.type||"").toLowerCase()==="chef"){ ok=false; reason="Deck NON légal (Chef interdit)"; break; }
            
            counts.set(id, (counts.get(id)||0)+1);
            const copies = counts.get(id);
            const rarity = (c.rarity || "C").toUpperCase();
            
            if(rarity === "R"){
              totalRares++;
              if(copies > MAX_COPIES_RARE){ 
                ok=false; 
                reason=`Deck NON légal (carte ${c.name||id}: max ${MAX_COPIES_RARE} rares identiques)`; 
                break; 
              }
            } else {
              if(copies > MAX_COPIES_COMMON){ 
                ok=false; 
                reason=`Deck NON légal (carte ${c.name||id}: max ${MAX_COPIES_COMMON} communes identiques)`; 
                break; 
              }
            }
          }
          
          if(ok && totalRares > MAX_TOTAL_RARES){
            ok=false;
            reason=`Deck NON légal (${totalRares} rares / max ${MAX_TOTAL_RARES})`;
          }
        }
        
        v.isLegal = !!ok;
        v.errors = ok ? [] : [reason];
        v.stats.totalRares = totalRares;
      }catch(e){ console.warn("validateDeckEnfant override failed", e); }

      
      localDeckReady = !!v.isLegal;
      updateMidMenuControls();
      if(!v.isLegal){
        safeText(deckStatus, `NON légal (${v.stats.totalCount})`);
        if(connected){
          const st = roomState || initialRoomState();
          const slot = mySlotFromState(st);
          if(slot){ updateRoomState((s)=>{ s.players[slot].deckOk=false; s.players[slot].ready=false; return s; }, "deck-not-ok").catch(()=>{}); }
        }
pushLog(`Deck NON légal: ${v.errors.join(" | ")}`);
        showDeckValidationErrors(v.errors);
        return;
      }

      // Statut affiché pour le deck légal (40 cartes)
      safeText(deckStatus, `OK (40)`);
      localDeckReady = true; // Marquer le deck comme prêt localement
      
      if(connected){
        const st = roomState || initialRoomState();
        const slot = mySlotFromState(st);
        if(slot){ 
          updateRoomState((s)=>{ 
            s.players[slot].deckOk=true; 
            // ENFANT: l'import decklist remplace le bouton "Je suis prêt".
            s.players[slot].ready=true;
            s.players[slot].validatedDeckIds = ids.slice();
            return s; 
          }, "deck-ok").catch((e)=>{
            console.warn("⚠️ deck-ok write failed, will retry via commitDeckToDb:", e);
          });
        }
      }
      pushLog(`Deck légal ✅ (40 cartes, Rares ${v.stats.totalRares||0}/12)`);
      showDeckValidationInfo(`Deck légal ✅ (40 cartes, ${v.stats.totalRares||0} rares / max 12)`);
      validatedDeckIds = ids.slice();
      buildLocalPilesFromValidated();
      // si on a deja un slot/connexion, on pousse aussi en DB (sinon autocommit le fera plus tard)
      maybeCommitLocalPilesToDb("deck-import");
      pushLog(`Deck prêt (Chef: ${myLeaderId||"—"}, Deck: ${myDeckPile.length})`);
      
      // Forcer la mise à jour du bouton "Je suis prêt"
      updateMidMenuControls();
      
      // 🔧 FERMER LE PANEL SETUP AUTOMATIQUEMENT après validation
      setTimeout(() => {
        if(typeof closePanel === 'function'){
          closePanel();
        }
      }, 500);

    }catch(e){
      reportError(e,"decklist");
    }
  });
}
  
  // --- UI: validation deck (messages + liste, mobile-friendly) ---
  const deckValidationErrors = document.getElementById("deckValidationErrors");
  const deckValidationErrorsList = document.getElementById("deckValidationErrorsList");
  const deckValidationSummary = document.getElementById("deckValidationSummary");

  function clearDeckValidationUI(){
    if(!deckValidationErrors) return;
    if(deckValidationErrorsList) deckValidationErrorsList.innerHTML = "";
    if(deckValidationSummary) deckValidationSummary.textContent = "";
    deckValidationErrors.style.display = "none";
  }

  function showDeckValidationInfo(message){
    if(!deckValidationErrors) return;
    if(deckValidationErrorsList) deckValidationErrorsList.innerHTML = "";
    if(deckValidationSummary) deckValidationSummary.textContent = message || "";
    deckValidationErrors.style.display = "block";
    try{ deckValidationErrors.scrollIntoView({ behavior: "smooth", block: "nearest" }); }catch(_){}
  }

  function showDeckValidationErrors(errors){
    if(!deckValidationErrors) return;
    if(deckValidationErrorsList) deckValidationErrorsList.innerHTML = "";
    if(deckValidationSummary) deckValidationSummary.textContent = "Deck NON légal :";
    if(!errors || !errors.length){
      deckValidationErrors.style.display = "none";
      return;
    }
    if(deckValidationErrorsList){
      for(const msg of errors){
        const li = document.createElement("li");
        li.textContent = msg;
        deckValidationErrorsList.appendChild(li);
      }
    }
    deckValidationErrors.style.display = "block";
    try{ deckValidationErrors.scrollIntoView({ behavior: "smooth", block: "nearest" }); }catch(_){}
  }
// ===== Nouvelles fonctionnalités (Enhanced) =====

// Historique des actions pour Undo
const actionHistory = [];
const MAX_HISTORY = 3; // reduced from 5 — each entry is a full state clone

function addToHistory(action) {
  // structuredClone is faster than JSON roundtrip (~2-3× on large objects)
  actionHistory.push({
    action,
    timestamp: Date.now(),
    state: cloneState(gameState),
    roomState: cloneState(roomState || {}),
    myHandPile: [...myHandPile],
    myDeckPile: [...myDeckPile]
  });
  
  if (actionHistory.length > MAX_HISTORY) {
    actionHistory.shift();
  }
  
  updateHistoryPanel();
}
// ===== Phase/Étape Undo (DB) — "propre" (limite, anti-boucle, log) =====
const PHASE_HISTORY_LIMIT = 20;
let phaseUndoInProgress = false;

// Reset phase-related variables
function resetPhaseVariables() {
  phaseUndoInProgress = false;
  lastMyPA = null;
  lastOppPA = null;
  lastPasses = null;
}

/** Deep clone small objects safely (phase3) */
/** Snapshot minimal de phase/étape (stocké en DB) */
function _phaseSnapshot(s, label){
  // Snapshot complet (sauf historique) pour que l'undo remette un état cohérent
  const full = structuredClone(s || initialRoomState());
  // On ne veut pas imbriquer l'historique dans l'historique
  if(full && full.phaseHistory) delete full.phaseHistory;
  return {
    label: String(label || ""),
    at: Date.now(),
    state: full
  };
}

/** Empile un snapshot AVANT un changement de phase/étape */
async function pushPhaseHistory(label){
  if(phaseUndoInProgress) return;
  if(!connected) return;
  try{
    await updateRoomState((s)=>{
      s.phaseHistory = Array.isArray(s.phaseHistory) ? s.phaseHistory : [];
      s.phaseHistory.push(_phaseSnapshot(s, label));
      if(s.phaseHistory.length > PHASE_HISTORY_LIMIT){
        s.phaseHistory = s.phaseHistory.slice(-PHASE_HISTORY_LIMIT);
      }
      return s;
    }, "phasehist-push");
    if(label) pushLog(`🧭 Sauvegarde phase: ${label}`);
  } catch(e){
    reportError(e, "pushPhaseHistory");
  }
}

/** Undo DB: restaure la dernière phase/étape sauvegardée */
async function undoPhaseStepDb(){
  if(!connected){
    showToast("⚠️ Pas connecté");
    return;
  }
  if(phaseUndoInProgress) return;
  phaseUndoInProgress = true;
  try{
    const st = roomState || initialRoomState();
    const hist = Array.isArray(st.phaseHistory) ? st.phaseHistory : [];
    if(hist.length === 0){
      showToast("❌ Rien à annuler (phase)");
      pushLog("❌ Undo phase: historique vide");
      return;
    }

    const last = hist[hist.length - 1];

    await updateRoomState((s)=>{
      s.phaseHistory = Array.isArray(s.phaseHistory) ? s.phaseHistory : [];
      if(s.phaseHistory.length === 0) return s;
      const entry = s.phaseHistory.pop();
      // Restaure un état complet et cohérent
      const restored = structuredClone(entry.state || {});
      // Conserve l'historique restant
      restored.phaseHistory = s.phaseHistory;
      return restored;
    }, "phasehist-undo");

    const ph = last?.state?.phase ?? last?.phase ?? "?";
    const step = last?.state?.phase3?.step != null ? ` (étape ${last.state.phase3.step})` : (last?.phase3?.step != null ? ` (étape ${last.phase3.step})` : "");
    pushLog(`↩️ Undo phase → ${ph}${step}`);
    showToast("↩️ Phase/étape annulée");

    // Après un undo vers une phase antérieure, on resynchronise l'UI locale (évite les verrous)
    applyRoomStateToUI("undo");
  }catch(e){
    reportError(e, "undoPhaseStepDb");
  }finally{
    phaseUndoInProgress = false;
  }
}
// ===== Fin Phase/Étape Undo (DB) =====
async function undoLastAction() {
  if (actionHistory.length === 0) {
    showToast("❌ Aucune action à annuler");
    return;
  }
  
  const lastEntry = actionHistory.pop();
  Object.assign(gameState, lastEntry.state);
  
  // Restaurer la main et le deck
  if (lastEntry.myHandPile) {
    myHandPile = [...lastEntry.myHandPile];
    renderHandCards(); // Rafraîchir l'affichage de la main
    updateHandUI();
  }
  if (lastEntry.myDeckPile) {
    myDeckPile = [...lastEntry.myDeckPile];
  }
  
  // Restaurer roomState aussi (phases, tours, etc.)
  if (lastEntry.roomState) {
    roomState = cloneState(lastEntry.roomState);
    // Forcer la mise à jour DB
    if (roomCodeActive && sb) {      updateRoomState(() => structuredClone(roomState), "update");
    }
  }
  
  // Update all UI elements
  updateAllZoneCounters();
  updateActionDieUI();
  updatePassDieUI();
  updatePABar();
  updateSpectatorMode();
  
  showToast("↩️ Action annulée");
  updateHistoryPanel();
}

function updateHistoryPanel() {
  const entriesEl = $("historyEntries");
  if (!entriesEl) return;
  
  entriesEl.innerHTML = "";
  
  // Afficher les 10 dernières actions
  const recentActions = actionHistory.slice(-10).reverse();
  recentActions.forEach((entry, index) => {
    const div = document.createElement("div");
    div.className = "history-entry undoable";
    
    const time = new Date(entry.timestamp).toLocaleTimeString();
    div.innerHTML = `
      <div style="opacity: 0.7; font-size: 10px; margin-bottom: 4px;">${time}</div>
      <div>${escapeHtml(entry.action)}</div>
    `;
    
    if (index === 0) {
      div.onclick = () => undoPhaseStepDb();
      div.title = "Cliquer pour annuler";
    }
    
    entriesEl.appendChild(div);
  });
}

function toggleHistoryPanel() {
  const panel = $("historyPanel");
  if (!panel) return;
  panel.classList.toggle("open");
}

// ============================================================================
// Thumb-first Phase 2 buttons (mobile portrait)
// - No rule change: mirrors existing Phase 2 main action buttons
// - Appears only when Phase 3 box is NOT visible (i.e., during gameplay)
// - On click: triggers the original button click (single source of truth)
// ============================================================================
let __thumbP2Wrap = null;
let __thumbP2Buttons = [];
let __thumbP2Shown = false;
let __thumbP2DragBound = false;

// When Phase 2 actions are mirrored into the thumb bar on mobile, we must avoid
// showing the same action twice (e.g. two "Je m'arrête"). We hide the source
// buttons while the thumb bar is shown on mobile, and restore them otherwise.
let __thumbP2HidSources = false;
function __thumbP2SetSourceVisibility(visible){
  const ids = ['endPhase2Btn','endTurnBtn'];
  ids.forEach((id)=>{
    const el = document.getElementById(id);
    if (!el) return;
    // Use a data flag to restore safely.
    if (visible){
      if (el.dataset && el.dataset.__thumbHidden === '1'){
        el.style.display = '';
        el.dataset.__thumbHidden = '0';
      }
    } else {
      if (el.dataset && el.dataset.__thumbHidden !== '1'){
        el.dataset.__thumbHidden = '1';
        el.style.display = 'none';
      }
    }
  });
}

function __thumbIsDesktopLayout(){
  try{
    const w = window.innerWidth || 0;
    if (w >= 900) return true;
    const mq = window.matchMedia ? window.matchMedia('(pointer:fine)') : null;
    return !!(mq && mq.matches);
  }catch(_e){
    return false;
  }
}

function __thumbAnyOverlayOpen(){
  try{
    const overlay = document.getElementById('panelOverlay');
    if (!overlay) return false;
    return overlay.classList.contains('open');
  }catch(_e){
    return false;
  }
}

function __thumbSetShown(wrap, shown){
  if (!wrap) return;
  // Smooth appear/disappear: no layout shift
  if (shown){
    if (!wrap.style.display || wrap.style.display === 'none') wrap.style.display = 'block';
    requestAnimationFrame(()=>{
      wrap.classList.add('shown');
    });
  } else {
    wrap.classList.remove('shown');
    // Wait for transition end, then fully hide
    try{
      const t = setTimeout(()=>{ try{ if(!wrap.classList.contains('shown')) wrap.style.display = 'none'; }catch(_e){} }, 180);
      // keep reference to avoid GC warnings (no-op)
      void t;
    }catch(_e){
      wrap.style.display = 'none';
    }
  }
}

function __thumbDefaultDesktopPos(){
  // Default: under Chef + Vestiaire buttons (my side)
  const a = document.getElementById('myChiefBtn');
  const b = document.getElementById('myVestiaireBtn');
  const r1 = a?.getBoundingClientRect?.();
  const r2 = b?.getBoundingClientRect?.();
  if (r1 && r2){
    const left = Math.min(r1.left, r2.left);
    const top = Math.max(r1.bottom, r2.bottom) + 10;
    return { left, top };
  }
  // Fallback: near bottom-right
  return { left: (window.innerWidth||0) - 210, top: (window.innerHeight||0) - 180 };
}

function __thumbApplyDesktopPos(wrap, key){
  if (!wrap) return;
  wrap.dataset.thumbMode = 'desktop';
  wrap.style.right = 'auto';
  wrap.style.bottom = 'auto';
  wrap.style.left = '0px';
  wrap.style.top = '0px';

  let pos = null;
  try{
    const raw = localStorage.getItem(key);
    if (raw) pos = JSON.parse(raw);
  }catch(_e){}
  if (!pos || typeof pos.left !== 'number' || typeof pos.top !== 'number'){
    pos = __thumbDefaultDesktopPos();
  }

  // Clamp to viewport
  const w = window.innerWidth || 0;
  const h = window.innerHeight || 0;
  const left = Math.max(6, Math.min(pos.left, w - 60));
  const top = Math.max(6, Math.min(pos.top, h - 60));
  wrap.style.left = `${left}px`;
  wrap.style.top = `${top}px`;
}

function __thumbApplyMobilePos(wrap){
  if (!wrap) return;
  wrap.dataset.thumbMode = 'mobile';
  wrap.style.left = '0';
  wrap.style.right = '0';
  wrap.style.top = 'auto';
  wrap.style.bottom = `calc(10px + env(safe-area-inset-bottom))`;
}

function __thumbBindDesktopDragOnce(wrap, storageKey){
  if (!wrap) return;
  if (wrap.__thumbDragBound) return;
  wrap.__thumbDragBound = true;

  let dragging = false;
  let startX = 0, startY = 0, baseL = 0, baseT = 0;

  const onDown = (ev) => {
    if (!__thumbIsDesktopLayout()) return;
    if (wrap.dataset.thumbMode !== 'desktop') return;
    // Don't start drag if user clicked a button
    const t = ev.target;
    if (t && (t.tagName === 'BUTTON' || t.closest?.('button'))) return;
    dragging = true;
    startX = ev.clientX;
    startY = ev.clientY;
    const r = wrap.getBoundingClientRect();
    baseL = r.left;
    baseT = r.top;
    wrap.classList.add('dragging');
    ev.preventDefault();
  };
  const onMove = (ev) => {
    if (!dragging) return;
    const dx = ev.clientX - startX;
    const dy = ev.clientY - startY;
    const w = window.innerWidth || 0;
    const h = window.innerHeight || 0;
    const left = Math.max(6, Math.min(baseL + dx, w - 60));
    const top = Math.max(6, Math.min(baseT + dy, h - 60));
    wrap.style.left = `${left}px`;
    wrap.style.top = `${top}px`;
  };
  const onUp = () => {
    if (!dragging) return;
    dragging = false;
    wrap.classList.remove('dragging');
    try{
      const r = wrap.getBoundingClientRect();
      localStorage.setItem(storageKey, JSON.stringify({ left: r.left, top: r.top }));
    }catch(_e){}
  };

  wrap.addEventListener('pointerdown', onDown, { passive:false });
  window.addEventListener('pointermove', onMove, { passive:true });
  window.addEventListener('pointerup', onUp, { passive:true });
}

function ensureThumbPhase2UI(){
  if (__thumbP2Wrap) return __thumbP2Wrap;
  try{
    const style = document.createElement('style');
    style.textContent = `
      #thumbP2Wrap{position:fixed;z-index:100;display:none;pointer-events:auto;
        width:max-content;max-width:92vw;}
      #thumbP2Wrap .inner{display:flex;gap:10px;justify-content:center;align-items:center;pointer-events:auto;
        padding:6px;border-radius:999px;}
      #thumbP2Wrap .tbtn{appearance:none;border:1px solid rgba(255,255,255,0.16);background:rgba(11,34,56,0.75);color:#fff;
        border-radius:999px;padding:10px 14px;font-weight:800;font-family:inherit;letter-spacing:0.2px;
        box-shadow:0 10px 24px rgba(0,0,0,0.28);backdrop-filter:blur(10px);-webkit-backdrop-filter:blur(10px);
        max-width:46vw;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
      #thumbP2Wrap .tbtn.secondary{opacity:0.92;background:rgba(11,34,56,0.58);}
      #thumbP2Wrap{opacity:0;transform:translateY(8px) scale(0.98);transition:opacity .16s ease, transform .16s ease;}
      #thumbP2Wrap.shown{opacity:1;transform:translateY(0) scale(1);}
      #thumbP2Wrap.dragging{cursor:grabbing;}
    `;
    document.head.appendChild(style);

    const wrap = document.createElement('div');
    wrap.id = 'thumbP2Wrap';
    wrap.innerHTML = `<div class="inner"></div>`;
    document.body.appendChild(wrap);
    __thumbP2Wrap = wrap;
    return wrap;
  }catch(e){
    return null;
  }
}

function updateThumbPhase2Buttons(){
  const wrap = ensureThumbPhase2UI();
  if (!wrap) return;

  // Desktop: do NOT use the thumb bar. Keep the original button only.
  // On desktop we already have enough space; the thumb bar creates duplicates.
  if (__thumbIsDesktopLayout()){
    __thumbSetShown(wrap, false);
    __thumbP2Shown = false;
    __thumbP2SetSourceVisibility(true);
    return;
  }

  // Never cover active panels/menus.
  if (__thumbAnyOverlayOpen()){
    __thumbSetShown(wrap, false);
    __thumbP2Shown = false;
    __thumbP2SetSourceVisibility(true);
    return;
  }

  // Show only in Phase 2 ("started"), never during Phase 3.
  try{
    const st = (typeof roomState !== 'undefined' && roomState) ? roomState : null;
    if (st){
      if (st.phase === 'phase3_manual'){
        __thumbSetShown(wrap, false);
        __thumbP2Shown = false;
        __thumbP2SetSourceVisibility(true);
        return;
      }
      if (st.phase !== 'started'){
        __thumbSetShown(wrap, false);
        __thumbP2Shown = false;
        __thumbP2SetSourceVisibility(true);
        return;
      }
    }
  }catch(_e){}
  // Source buttons: the main Phase 2 manual actions row
  // We now have the single canonical stop button inside the hand dock (handStopBtn).
  // Do not mirror/duplicate it in the thumb bar.
  const hasHandStop = !!document.getElementById('handStopBtn');
  if(hasHandStop){
    __thumbSetShown(wrap, false);
    __thumbP2Shown = false;
    __thumbP2SetSourceVisibility(true);
    return;
  }
  const srcIds = ['endPhase2Btn'];
  // IMPORTANT: do not depend on visibility; middle menu can be collapsed.
  const srcBtns = srcIds
    .map(id => document.getElementById(id))
    .filter(Boolean);

  if (!srcBtns.length){
    __thumbSetShown(wrap, false);
    __thumbP2Shown = false;
    __thumbP2SetSourceVisibility(true);
    return;
  }

  const max = Math.min(2, srcBtns.length);
  const inner = wrap.querySelector('.inner');
  if (!inner){ __thumbSetShown(wrap, false); __thumbP2Shown = false; __thumbP2SetSourceVisibility(true); return; }

  while(__thumbP2Buttons.length < max){
    const b = document.createElement('button');
    b.className = 'tbtn';
    b.type = 'button';
    b.addEventListener('click', (ev)=>{
      ev.preventDefault();
      ev.stopPropagation();
      const srcId = b.getAttribute('data-src');
      const src = srcId ? document.getElementById(srcId) : null;
      try{ src?.click?.(); }catch(_e){}
    }, { passive:false });
    __thumbP2Buttons.push(b);
    inner.appendChild(b);
  }
  while(__thumbP2Buttons.length > max){
    const b = __thumbP2Buttons.pop();
    try{ b.remove(); }catch(_e){}
  }

  for (let i=0; i<max; i++){
    const src = srcBtns[i];
    const dst = __thumbP2Buttons[i];
    const label = (src.textContent || '').trim();
    dst.textContent = label;
    dst.setAttribute('data-src', src.id || '');
    dst.disabled = !!src.disabled;
    const isSecondary = src.classList.contains('secondary');
    dst.classList.toggle('secondary', !!isSecondary);
  }

  // Positioning + show: mobile = bottom centered, desktop = floating draggable
  if (__thumbIsDesktopLayout()){
    __thumbApplyDesktopPos(wrap, 'thumbP2Pos');
    __thumbBindDesktopDragOnce(wrap, 'thumbP2Pos');
    // Desktop: keep the source buttons visible.
    __thumbP2SetSourceVisibility(true);
  } else {
    __thumbApplyMobilePos(wrap);
    // Mobile: hide the source buttons to avoid duplicates.
    __thumbP2SetSourceVisibility(false);
  }

  __thumbSetShown(wrap, true);
  __thumbP2Shown = true;
}

// ============================================================================
// Thumb-first Phase 3 buttons (mobile portrait)
// - No rule change: this only mirrors the existing Phase 3 step buttons
// - Appears only when Phase 3 box is visible and at least one step-button row is visible
// - On click: triggers the original button click (single source of truth)
// ============================================================================
let __thumbP3Wrap = null;
let __thumbP3Buttons = [];
let __thumbP3Shown = false;
function ensureThumbPhase3UI(){
  if (__thumbP3Wrap) return __thumbP3Wrap;
  try{
    const style = document.createElement('style');
    style.textContent = `
      /*
        Thumb buttons must remain clickable on mobile.
        IMPORTANT: pointer-events:none on the wrapper would ALSO disable events for children.
      */
      #thumbP3Wrap{position:fixed;z-index:100;display:none;pointer-events:auto;
        width:max-content;max-width:92vw;}
      #thumbP3Wrap .inner{display:flex;gap:10px;justify-content:center;align-items:center;pointer-events:auto;
        padding:6px;border-radius:999px;}
      #thumbP3Wrap .tbtn{appearance:none;border:1px solid rgba(255,255,255,0.16);background:rgba(11,34,56,0.75);color:#fff;
        border-radius:999px;padding:10px 14px;font-weight:800;font-family:inherit;letter-spacing:0.2px;
        box-shadow:0 10px 24px rgba(0,0,0,0.28);backdrop-filter:blur(10px);-webkit-backdrop-filter:blur(10px);
        max-width:46vw;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
      #thumbP3Wrap .tbtn.secondary{opacity:0.92;background:rgba(11,34,56,0.58);}
      #thumbP3Wrap{opacity:0;transform:translateY(8px) scale(0.98);transition:opacity .16s ease, transform .16s ease;}
      #thumbP3Wrap.shown{opacity:1;transform:translateY(0) scale(1);} 
      #thumbP3Wrap.dragging{cursor:grabbing;}
    `;
    document.head.appendChild(style);

    const wrap = document.createElement('div');
    wrap.id = 'thumbP3Wrap';
    wrap.innerHTML = `<div class="inner"></div>`;
    document.body.appendChild(wrap);
    __thumbP3Wrap = wrap;
    return wrap;
  }catch(e){
    return null;
  }
}

function updateThumbPhase3Buttons(){
  const wrap = ensureThumbPhase3UI();
  if (!wrap) return;

  // Never cover active panels/menus.
  if (__thumbAnyOverlayOpen()){
    __thumbSetShown(wrap, false);
    __thumbP3Shown = false;
    return;
  }

  // Phase 3 must be driven by GAME STATE, not by UI visibility (middle menu can be collapsed)
  let step = 1;
  try{
    const st = (typeof roomState !== 'undefined' && roomState) ? roomState : null;
    const isP3 = !!(st && st.phase === 'phase3_manual');
    if (!isP3){
      __thumbSetShown(wrap, false);
      __thumbP3Shown = false;
      return;
    }
    const p3 = st.phase3 || {};
    step = Number(p3.step || 1) || 1;
  }catch(_e){
    // If state is unknown, keep it hidden to avoid wrong actions
    wrap.style.display = 'none';
    return;
  }

  const rowId = `p3Step${step}Btns`;
  const activeRow = document.getElementById(rowId);
  if (!activeRow){
    __thumbSetShown(wrap, false);
    __thumbP3Shown = false;
    return;
  }

  // Take buttons from the current step row, regardless of its visibility
  const btns = Array.from(activeRow.querySelectorAll('button'))
    .filter(Boolean);

  if (!btns.length){
    __thumbSetShown(wrap, false);
    __thumbP3Shown = false;
    return;
  }

  // Mirror up to 2 buttons (keeps it clean)
  const max = Math.min(2, btns.length);
  const inner = wrap.querySelector('.inner');
  if (!inner){ __thumbSetShown(wrap, false); __thumbP3Shown = false; return; }

  while(__thumbP3Buttons.length < max){
    const b = document.createElement('button');
    b.className = 'tbtn';
    b.type = 'button';
    b.addEventListener('click', (ev)=>{
      ev.preventDefault();
      ev.stopPropagation();
      const srcId = b.getAttribute('data-src');
      const src = srcId ? document.getElementById(srcId) : null;
      try{ src?.click?.(); }catch(_e){}
    }, { passive:false });
    __thumbP3Buttons.push(b);
    inner.appendChild(b);
  }
  while(__thumbP3Buttons.length > max){
    const b = __thumbP3Buttons.pop();
    try{ b.remove(); }catch(_e){}
  }

  for (let i=0; i<max; i++){
    const src = btns[i];
    const dst = __thumbP3Buttons[i];
    const label = (src.textContent || '').trim();
    dst.textContent = label;
    dst.setAttribute('data-src', src.id || '');
    dst.disabled = !!src.disabled;
    const isSecondary = src.classList.contains('secondary');
    dst.classList.toggle('secondary', !!isSecondary);
  }

  // Positioning + show: mobile = bottom centered, desktop = floating draggable
  if (__thumbIsDesktopLayout()){
    __thumbApplyDesktopPos(wrap, 'thumbP3Pos');
    __thumbBindDesktopDragOnce(wrap, 'thumbP3Pos');
  } else {
    __thumbApplyMobilePos(wrap);
  }

  __thumbSetShown(wrap, true);
  __thumbP3Shown = true;
}

// Keep thumb buttons responsive to orientation/resize even when state doesn't change.
// (i.e., user rotates phone without any DB update)
(function bindThumbButtonsListenersOnce(){
  try{
    if (window.__thumbButtonsListenersBound) return;
    window.__thumbButtonsListenersBound = true;
    
    // --- UX: mobile landscape helpers (hand button + optional fullscreen) ---
    let __fsTapArmed = false;
    function __isCoarsePointer(){
      try{ return !!(window.matchMedia && window.matchMedia('(pointer:coarse)').matches); }catch(_e){ return false; }
    }
    function __isLandscape(){
      try{ return (window.innerWidth || 0) > (window.innerHeight || 0); }catch(_e){ return false; }
    }
    function __tryRequestFullscreen(){
      try{
        if(document.fullscreenElement) return;
        const el = document.documentElement || document.body;
        const req = (el && (el.requestFullscreen || el.webkitRequestFullscreen || el.mozRequestFullScreen || el.msRequestFullscreen)) || null;
        if(req){
          try{ req.call(el); }catch(_e){}
        }
      }catch(_e){}
    }

function __armFullscreenNextTap(){
      try{
        if(__fsTapArmed) return;
        __fsTapArmed = true;
        const handler = () => {
          try{
            window.removeEventListener('pointerdown', handler, true);
            window.removeEventListener('touchstart', handler, true);
          }catch(_e){}
          __fsTapArmed = false;
          __tryRequestFullscreen();
        };
        window.addEventListener('pointerdown', handler, true);
        window.addEventListener('touchstart', handler, true);
        // Auto-disarm after a short window (avoid surprising later taps)
        setTimeout(()=>{
          if(!__fsTapArmed) return;
          __fsTapArmed = false;
          try{
            window.removeEventListener('pointerdown', handler, true);
            window.removeEventListener('touchstart', handler, true);
          }catch(_e){}
        }, 3000);
      }catch(_e){}
    }

    function __ensureFullscreenButton(){
      try{
        const id = 'fsFloatingBtn';
        let btn = document.getElementById(id);
        const shouldShow = __isCoarsePointer() && __isLandscape() && !document.fullscreenElement;
        if(!btn){
          btn = document.createElement('button');
          btn.id = id;
          btn.type = 'button';
          btn.textContent = '⛶';
          btn.setAttribute('aria-label', 'Plein écran');
          btn.style.position = 'fixed';
          btn.style.right = '14px';
          btn.style.top = '72px';
          btn.style.width = '44px';
          btn.style.height = '44px';
          btn.style.borderRadius = '14px';
          btn.style.border = '1px solid rgba(255,255,255,0.12)';
          btn.style.background = 'rgba(18,22,40,0.55)';
          btn.style.backdropFilter = 'blur(10px)';
          btn.style.webkitBackdropFilter = 'blur(10px)';
          btn.style.color = '#fff';
          btn.style.fontSize = '22px';
          btn.style.fontWeight = '800';
          btn.style.display = 'none';
          btn.style.alignItems = 'center';
          btn.style.justifyContent = 'center';
          btn.style.zIndex = '140';
          btn.style.boxShadow = '0 10px 30px rgba(0,0,0,0.25)';
          btn.addEventListener('click', (ev)=>{
            try{ ev.preventDefault(); ev.stopPropagation(); }catch(_e){}
            __tryRequestFullscreen();
          }, {passive:false});
          document.body.appendChild(btn);
        }
        btn.style.display = shouldShow ? 'flex' : 'none';
      }catch(_e){}
    }

const onUpdate = () => {
      // Mobile browsers (especially iOS) can apply the new viewport size in multiple ticks.
      // We refresh immediately, then once again shortly after.
      const refresh = () => {
        // Also refresh the Hand button layout/visibility (mobile rotation can hide it).
        try{ if(typeof __ensureHandFloatingOnscreen === 'function') __ensureHandFloatingOnscreen(); }catch(_e){}
        try{ if(typeof updateHandUI === 'function') updateHandUI(); }catch(_e){}
        try{ requestAnimationFrame(()=>{ try{ updateThumbPhase2Buttons(); }catch(_e){} }); }catch(_e){}
        try{ requestAnimationFrame(()=>{ try{ updateThumbPhase3Buttons(); }catch(_e){} }); }catch(_e){}
      };

      refresh();

      // Optional: on mobile landscape, arm a one-tap fullscreen request (browser requires user gesture)
      try{ if(__isCoarsePointer() && __isLandscape()) __armFullscreenNextTap(); }catch(_e){}
      try{ __ensureFullscreenButton(); }catch(_e){}
      // Second pass (helps when the button is hidden by a late-applied landscape media query)
      try{
        const isCoarse = !!(window.matchMedia && window.matchMedia('(pointer:coarse)').matches);
        if(isCoarse){
          setTimeout(refresh, 250);
        }
      }catch(_e){}
    };
    window.addEventListener('resize', onUpdate, { passive:true });
    window.addEventListener('orientationchange', onUpdate, { passive:true });
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) onUpdate();
    }, { passive:true });
  }catch(_e){}
})();

// Ctrl+Z pour annuler
document.addEventListener("keydown", (e) => {
  if ((e.ctrlKey || e.metaKey) && e.key === "z") {
    e.preventDefault();
    undoPhaseStepDb();
  }
  
  // Ctrl+H pour ouvrir l'historique
  if ((e.ctrlKey || e.metaKey) && e.key === "h") {
    e.preventDefault();
    toggleHistoryPanel();
  }
});

// Mise à jour de la barre PA
function updatePABar() {
  const myPAValue = $("myPAValue");
  const oppPAValue = $("oppPAValue");
  const passValue = $("passValue");
  const myPAIndicator = $("myPAIndicator");
  const oppPAIndicator = $("oppPAIndicator");
  
  if (!myPAValue || !oppPAValue || !passValue) return;
  
  const myPA = gameState.myActionDie ?? 0;
  const oppPA = gameState.oppActionDie ?? 0;
  const passes = gameState.myPassDie ?? 0;
  
  safeText(myPAValue, myPA);
  safeText(oppPAValue, oppPA);
  safeText(passValue, passes);
  
  // Couleurs selon les valeurs
  myPAValue.className = "pa-value";
  if (myPA <= 1) myPAValue.classList.add("low");
  else if (myPA <= 3) myPAValue.classList.add("medium");
  else myPAValue.classList.add("high");
  
  oppPAValue.className = "pa-value";
  if (oppPA <= 1) oppPAValue.classList.add("low");
  else if (oppPA <= 3) oppPAValue.classList.add("medium");
  else oppPAValue.classList.add("high");
  
  passValue.className = "pa-value";
  if (passes <= 2) passValue.classList.add("low");
  else if (passes <= 5) passValue.classList.add("medium");
  else passValue.classList.add("high");
}

// Flash PA quand il change
let lastMyPA = null;
let lastOppPA = null;
let lastPasses = null;

function flashPAIfChanged() {
  const myPA = gameState.myActionDie;
  const oppPA = gameState.oppActionDie;
  const passes = gameState.myPassDie;
  
  const myIndicator = $("myPAIndicator");
  const oppIndicator = $("oppPAIndicator");
  const passIndicator = $("passIndicator");
  
  if (lastMyPA !== null && lastMyPA !== myPA && myIndicator) {
    myIndicator.classList.add("flash");
    safeSetTimeout(() => {
      if (myIndicator && myIndicator.isConnected) {
        myIndicator.classList.remove("flash");
      }
    }, 500);
  }
  
  if (lastOppPA !== null && lastOppPA !== oppPA && oppIndicator) {
    oppIndicator.classList.add("flash");
    safeSetTimeout(() => {
      if (oppIndicator && oppIndicator.isConnected) {
        oppIndicator.classList.remove("flash");
      }
    }, 500);
  }
  
  if (lastPasses !== null && lastPasses !== passes && passIndicator) {
    passIndicator.classList.add("flash");
    safeSetTimeout(() => {
      if (passIndicator && passIndicator.isConnected) {
        passIndicator.classList.remove("flash");
      }
    }, 500);
  }
  
  lastMyPA = myPA;
  lastOppPA = oppPA;
  lastPasses = passes;
}

// ===== TIMER MANAGEMENT SYSTEM =====
// Store active timers for cleanup
const activeTimers = new Set();

function safeSetTimeout(fn, delay) {
  const timer = setTimeout(() => {
    activeTimers.delete(timer);
    fn();
  }, delay);
  activeTimers.add(timer);
  return timer;
}

function clearAllTimers() {
  activeTimers.forEach(timer => clearTimeout(timer));
  activeTimers.clear();
}

function safeClearTimeout(timer){
  if(!timer) return;
  try { clearTimeout(timer); } catch(_) {}
  try { activeTimers.delete(timer); } catch(_) {}
}

// ===== DEBOUNCE UTILITY =====
function debounce(fn, delay) {
  let timer = null;
  return function(...args) {
    if(timer) clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, args), delay);
  };
}

// Preview cartes (hover + double-clic)
let cardPreviewTimeout = null;

function showCardPreview(cardData, event) {
  // 🚫 Touch : iOS Safari fire mouseenter sur tap → preview se colle. Bloquer ici.
  if("ontouchstart" in window) return;
  const preview = $("cardPreview");
  const img = $("cardPreviewImg");
  
  if (!preview || !img || !cardData || !cardData.image) return;
  
  safeClearTimeout(cardPreviewTimeout);
  
  const imgSrc = safeImageSrc(cardData.image);
  if(!imgSrc) return;
  img.src = imgSrc;
  
  const x = event.clientX;
  const y = event.clientY;
  
  // Position du preview (à droite ou à gauche selon la position)
  if (x > window.innerWidth / 2) {
    preview.style.right = (window.innerWidth - x + 20) + "px";
    preview.style.left = "auto";
  } else {
    preview.style.left = (x + 20) + "px";
    preview.style.right = "auto";
  }
  
  // 🔧 CORRECTION: Positionner le popup plus haut pour voir la carte entière
  // Calculer la position en fonction de la hauteur disponible
  const previewHeight = 400; // Hauteur approximative du preview (280px * 1.4)
  const topPos = y - previewHeight + 50; // Mettre le popup au-dessus du curseur
  preview.style.top = Math.max(20, topPos) + "px";
  preview.classList.add("visible");
}

function hideCardPreview() {
  const preview = $("cardPreview");
  if (!preview) return;
  
  cardPreviewTimeout = safeSetTimeout(() => {
    if (preview && preview.isConnected) {
      preview.classList.remove("visible");
    }
  }, 200);
}

// Modal détails carte (double-clic)
// Mode Spectateur
function updateSpectatorMode() {
  const badge = $("spectatorBadge");
  const hands = $("spectatorHands");
  
  if (!badge) return;
  
  if (mySlot === "spectator") {
    badge.style.display = "block";
    // Note: hands display disabled as hand data is not synced in current architecture
    // To enable, gameState would need to include myHand and oppHand arrays
    if (hands) hands.style.display = "none";
  } else {
    badge.style.display = "none";
    if (hands) hands.style.display = "none";
  }
}

// Reconnexion automatique
let reconnectAttempts = 0;
const MAX_RECONNECT_ATTEMPTS = 5;
let reconnectTimeout = null;

function attemptReconnect() {
  if (reconnectAttempts >= MAX_RECONNECT_ATTEMPTS) {
    hideReconnectingBanner();
    showToast("❌ Impossible de reconnecter. Veuillez actualiser la page.");
    return;
  }
  
  reconnectAttempts++;
  showReconnectingBanner();
  
  reconnectTimeout = setTimeout(() => {
    if (!connected) {
      // Try to reconnect using the connect button's function
      const connectBtn = $("connectBtn");
      if (connectBtn) connectBtn.click();
    }
    
    if (connected) {
      hideReconnectingBanner();
      reconnectAttempts = 0;
      showToast("✅ Reconnecté avec succès");
    } else {
      attemptReconnect();
    }
  }, Math.min(2000 * reconnectAttempts, 10000)); // Backoff exponentiel
}

function showReconnectingBanner() {
  const banner = $("reconnectingBanner");
  if (banner) {
    banner.textContent = `🔄 Reconnexion en cours (tentative ${reconnectAttempts}/${MAX_RECONNECT_ATTEMPTS})...`;
    banner.classList.add("visible");
  }
}

function hideReconnectingBanner() {
  const banner = $("reconnectingBanner");
  if (banner) {
    banner.classList.remove("visible");
  }
}

// Détection de déconnexion
function monitorConnection() {
  if (!connected && !reconnectTimeout) {
    attemptReconnect();
  }
}

// Vérifier la connexion toutes les 5 secondes
let __monitorConnectionTimer = null;
if(!__monitorConnectionTimer){
  __monitorConnectionTimer = setInterval(monitorConnection, 5000);
}

// Détection de retour online
window.addEventListener("online", () => {
  showToast("🌐 Connexion rétablie");
  if (!connected) {
    attemptReconnect();
  }
});

window.addEventListener("offline", () => {
  showToast("⚠️ Connexion perdue");
});
// ===== Game State (v5) =====
const gameState = {
  // Mon côté
  myChief: null,
  myActionDie: 4,
  myPassDie: 0,
  myTerrain: [],        // [{cardId, tapped, counters:{pass,charge,time}, note}]
  myVestiaire: [],      // [cardId]
  myBanch: [],          // [cardId]
  myRevealed: [],       // [cardId]
  
  // Adversaire
  oppChief: null,
  oppActionDie: 4,
  oppPassDie: 0,
  oppTerrain: [],
  oppVestiaire: [],
  oppVestiaireCount: 0,
  oppBanch: [],
  oppBanchCount: 0,
  oppRevealedCount: 0,
  
  // État partie
  gamePhase: 'lobby',   // lobby | warmup | game | endOfRound
  currentPlayer: null,
  roundNumber: 1,
  playerAPassed: false,
  playerBPassed: false,
  bulleStateLabel: '',  // État de la bulle (texte libre)
  occurrencesThisRound: 0  // Compteur manuel
};

// ===== FONCTIONS UTILITAIRES SANDBOX =====

// Helper: get opposite slot
function otherSlot(slot){
  return slot === "A" ? "B" : (slot === "B" ? "A" : null);
}
// Shuffle array in place
function shuffle(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}

// Détecter si une carte est un token
function isToken(card) {
  if (!card) return false;
  const type = String(card.type || '').toLowerCase();
  return type.includes('token');
}

// Déplacer une carte d'une zone à une autre
async function moveCard(cardTok, fromZone, toZone, options = {}) {
  const cardId = getCid(cardTok);
  const isOpp = String(fromZone||'').startsWith('opp') || String(toZone||'').startsWith('opp');

  // Déplacements côté "moi" : DB autoritaire si disponible
  if (!isOpp) {
    const actor = mySlotFromState(roomState || initialRoomState());
    const hasDbPiles = !!(roomState && roomState.deckPiles && roomState.handPiles);

    // Si pas de piles DB (mode fallback), conserver l'ancien comportement local
    if(!hasDbPiles){
      const { toTop = true, toBottom = false } = options;

      switch(fromZone) {
        case 'myDeck': {
          const deckIndex = myDeckPile.indexOf(cardId);
          if (deckIndex >= 0) myDeckPile.splice(deckIndex, 1);
          break;
        }
        case 'myHand': {
          const handIndex = myHandPile.indexOf(cardTok);
          if (handIndex >= 0) myHandPile.splice(handIndex, 1);
          break;
        }
        case 'myTerrain': {
          const terrainIndex = gameState.myTerrain.findIndex(c => (c.inst ? c.inst === cardTok : c.cardId === cardId));
          if (terrainIndex >= 0) gameState.myTerrain.splice(terrainIndex, 1);
          break;
        }
        case 'myVestiaire': {
          const vestIndex = gameState.myVestiaire.indexOf(cardId);
          if (vestIndex >= 0) gameState.myVestiaire.splice(vestIndex, 1);
          break;
        }
        case 'myBanch': {
          const banchIndex = gameState.myBanch.indexOf(cardId);
          if (banchIndex >= 0) gameState.myBanch.splice(banchIndex, 1);
          break;
        }
        case 'myRevealed': {
          const revIndex = gameState.myRevealed.indexOf(cardId);
          if (revIndex >= 0) gameState.myRevealed.splice(revIndex, 1);
          break;
        }
      }

      switch(toZone) {
        case 'myDeck':
          if (toBottom) myDeckPile.push(cardTok);
          else myDeckPile.unshift(cardTok);
          break;
        case 'myHand':
          myHandPile.push(cardTok);
          break;
        case 'myTerrain':
          gameState.myTerrain.push({
            inst: cardTok,
            cardId,
            tapped: false,
            counters: { pass: 0, charge: 0, time: 0 },
            note: ''
          });
          
          // 🎯 MODE ENFANT : Déclencher l'effet automatiquement
          if(typeof triggerCardEffect === 'function'){
            const st = roomState || initialRoomState();
            const slot = mySlotFromState(st);
            if(slot){
              setTimeout(() => {
                // CRITIQUE: Chercher l'inst réel dans le terrain
                const stNow = roomState || initialRoomState();
                const terrain = stNow.terrains?.[slot] || [];
                const creature = terrain.find(c => c && c.cardId === cardId && c.inst);
                const actualToken = creature?.inst || cardTok;
                triggerCardEffect(cardId, slot, actualToken).catch(e => console.error("Erreur effet:", e));
              }, 300);
            }
          }
          break;
        case 'myVestiaire':
          gameState.myVestiaire.push(cardTok);
          break;
        case 'myBanch':
          gameState.myBanch.push(cardTok);
          break;
        case 'myRevealed':
          gameState.myRevealed.push(cardTok);
          break;
      }

      await syncPublicZones();
      updateHandUI();
      updateAllZoneCounters();

      const cardData = cardsById.get(cardId);
      pushLog(`📦 ${slotLabel(mySlotFromState(roomState))} ${cardData?.name || cardId} : ${zoneLabel(fromZone)} → ${zoneLabel(toZone)}`);
      return;
    }

    if(!actor || actor === 'spectator') return;
    const slot = 'A'===actor||'B'===actor ? actor : null;
    if(!slot) return;

    const { toTop = true, toBottom = false } = options;

    await updateRoomState((st)=>{
      st.deckPiles = st.deckPiles || {A:[],B:[]};
      st.handPiles = st.handPiles || {A:[],B:[]};
      st.terrains  = st.terrains  || {A:[],B:[]};
      st.vestiaires= st.vestiaires|| {A:[],B:[]};
      st.banchs    = st.banchs    || {A:[],B:[]};
      st.revealed  = st.revealed  || {A:[],B:[]};

      const removeFromArr = (arr, id) => {
        const i = Array.isArray(arr) ? arr.indexOf(id) : -1;
        if(i >= 0) {
          arr.splice(i, 1);
          return true;
        }
        return false;
      };

      let removed = false;

      // remove from source
      if(fromZone === 'myDeck') removed = removeFromArr(st.deckPiles[slot], cardTok);
      else if(fromZone === 'myHand') removed = removeFromArr(st.handPiles[slot], cardTok);
      else if(fromZone === 'myVestiaire') removed = removeFromArr(st.vestiaires[slot], cardTok);
      else if(fromZone === 'myBanch') removed = removeFromArr(st.banchs[slot], cardTok);
      else if(fromZone === 'myRevealed') removed = removeFromArr(st.revealed[slot], cardTok);
      else if(fromZone === 'myTerrain') {
        const idx = (st.terrains[slot]||[]).findIndex(c => (c.inst ? c.inst === cardTok : c.cardId === cardId));
        if(idx>=0){ 
          // CORRECTION FLIP: Récupérer originalCardId avant suppression
          const terrainCard = st.terrains[slot][idx];
          const originalId = terrainCard.originalCardId || terrainCard.cardId;
          
          // Si la carte va au vestiaire ou au deck, utiliser l'ID original (recto)
          if (toZone === 'myVestiaire' || toZone === 'myDeck' || toZone === 'myHand') {
            cardId = originalId;
            // ✅ V10 token: conserver l'instance (iid) et remettre la face recto
            cardTok = normalizeTokenToFront(cardTok, originalId);
          }
          
          st.terrains[slot].splice(idx,1); 
          removed = true; 
        }
      }

      // Guard: prevent duplication if the card was not found in source pile (stale UI click)
      if(!removed) {
        st._lastMoveNoop = { cardId, fromZone, toZone, slot };
        return st;
      }

      // add to dest
      if(toZone === 'myDeck') {
        if(toBottom) st.deckPiles[slot].push(cardTok);
        else st.deckPiles[slot].unshift(cardTok);
      } else if(toZone === 'myHand') {
        st.handPiles[slot].push(cardTok);
      } else if(toZone === 'myVestiaire') {
        st.vestiaires[slot].push(cardTok);
      } else if(toZone === 'myBanch') {
        st.banchs[slot].push(cardTok);
      } else if(toZone === 'myRevealed') {
        st.revealed[slot].push(cardTok);
      } else if(toZone === 'myTerrain') {
        st.terrains[slot].push({
          inst: cardTok,
          cardId,
          originalCardId: cardId, // CRITIQUE: pour transformations
          tapped: false,
          counters: { pass: 0, charge: 0, time: 0 },
          note: '',
          lastBy: actor
        });
        
        // 🎯 MODE ENFANT : Déclencher l'effet automatiquement après l'ajout
        st._lastCardPlayed = { cardId, slot, timestamp: Date.now() };
      }

      // counts
      st.players = st.players || {A:{},B:{}};
      st.players.A = st.players.A || {};
      st.players.B = st.players.B || {};
      st.players.A.deckCount = (st.deckPiles.A||[]).length;
      st.players.B.deckCount = (st.deckPiles.B||[]).length;
      st.players.A.handCount = (st.handPiles.A||[]).length;
      st.players.B.handCount = (st.handPiles.B||[]).length;

      return st;
    }, 'move-card-db');

    // 🎯 MODE ENFANT : Déclencher l'effet de la carte si elle va sur le terrain
    if(toZone === 'myTerrain' && typeof triggerCardEffect === 'function'){
      const st = roomState || initialRoomState();
      if(st._lastCardPlayed && st._lastCardPlayed.cardId === cardId && !st.pendingEffect){
        // Déclencher l'effet après un petit délai pour que l'UI se mette à jour
        setTimeout(() => {
          // CRITIQUE: Chercher l'inst réel dans le terrain après l'ajout
          const stNow = roomState || initialRoomState();
          const terrain = stNow.terrains?.[slot] || [];
          const creature = terrain.find(c => c && c.cardId === cardId && c.inst);
          const actualToken = creature?.inst || cardTok;
          triggerCardEffect(cardId, slot, actualToken).catch(e => {
            console.error("Erreur déclenchement effet:", e);
          });
        }, 300);
      }
    }

    // Immediate UI sync (avoid feeling of "nothing happened" before realtime refresh)
    try{
      const stNow = roomState || initialRoomState();
      const slotNow = mySlotFromState(stNow);
      if(slotNow && stNow.deckPiles && stNow.handPiles){
        myDeckPile = Array.isArray(stNow.deckPiles[slotNow]) ? stNow.deckPiles[slotNow].slice() : [];
        myHandPile = Array.isArray(stNow.handPiles[slotNow]) ? stNow.handPiles[slotNow].slice() : [];
      }
      if(slotNow && stNow.vestiaires){ gameState.myVestiaire = stNow.vestiaires[slotNow] || []; }
      if(slotNow && stNow.banchs){ gameState.myBanch = stNow.banchs[slotNow] || []; }
      if(slotNow && stNow.revealed){ gameState.myRevealed = stNow.revealed[slotNow] || []; }
      if(slotNow && stNow.terrains){
        ensureTerrainInstances(stNow, slotNow);
        gameState.myTerrain = stNow.terrains[slotNow] || [];
      }
      updateHandUI();
      updateAllZoneCounters();
    }catch(e){}

    const cardData = cardsById.get(cardId);
    pushLog(`📦 ${cardData?.name || cardId} : ${fromZone} → ${toZone}`);
    return;
  }

  // Déplacements impliquant zones publiques / adversaire : on manipule directement le roomState
  const actor = mySlotFromState(roomState || initialRoomState());
  if(actor === 'spectator') {
    pushLog('👀 Spectateur : action ignorée');
    return;
  }

  // Sécurité : pas de deck adverse dans ce proto
  if (toZone === 'oppDeck' || fromZone === 'oppDeck') {
    pushLog('⚠️ Deck adverse non géré dans ce proto (déplacement ignoré)');
    return;
  }

  // Slots source/destination (important pour "Terrain adverse")
  const sourceSlot = slotForZone(fromZone);
  const destSlot = slotForZone(toZone);
  if(!sourceSlot || !destSlot) return;

  await updateRoomState((st) => {
    if(!st.terrains) st.terrains = { A: [], B: [] };
    if(!st.vestiaires) st.vestiaires = { A: [], B: [] };
    if(!st.banchs) st.banchs = { A: [], B: [] };
    if(!st.revealed) st.revealed = { A: [], B: [] };

    // helpers list ops
    const removeFromList = (arr, id) => {
      const idx = Array.isArray(arr) ? arr.indexOf(id) : -1;
      if(idx >= 0) { arr.splice(idx, 1); return true; }
      return false;
    };

    let removedPublic = false;

    // Remove (depuis la zone source)
    if(fromZone === 'myTerrain' || fromZone === 'oppTerrain') {
      const idx = (st.terrains[sourceSlot] || []).findIndex(c => (c.inst ? c.inst === cardTok : c.cardId === cardId));
      if(idx >= 0) st.terrains[sourceSlot].splice(idx, 1);
    } else if(fromZone === 'myVestiaire' || fromZone === 'oppVestiaire') {
      removeFromList(st.vestiaires[sourceSlot], cardTok);
    } else if(fromZone === 'myBanch' || fromZone === 'oppBanch') {
      removeFromList(st.banchs[sourceSlot], cardTok);
    } else if(fromZone === 'myRevealed' || fromZone === 'oppRevealed') {
      removeFromList(st.revealed[sourceSlot], cardTok);
    }

    // Add (dans la zone destination)
    if(toZone === 'myTerrain' || toZone === 'oppTerrain') {
      st.terrains[destSlot].push({
        inst: cardTok,
        cardId,
        originalCardId: cardId, // CRITIQUE: pour transformations
        tapped: false,
        counters: { pass: 0, charge: 0, time: 0 },
        note: '',
        lastBy: actor
      });
    } else if(toZone === 'myVestiaire' || toZone === 'oppVestiaire') {
      st.vestiaires[destSlot].push(cardTok);
    } else if(toZone === 'myBanch' || toZone === 'oppBanch') {
      st.banchs[destSlot].push(cardTok);
    } else if(toZone === 'myRevealed' || toZone === 'oppRevealed') {
      st.revealed[destSlot].push(cardTok);
    }

    return st;
  }, 'move-card-public');

  const cardData = cardsById.get(cardId);
  pushLog(`📦 ${cardData?.name || cardId} : ${fromZone} → ${toZone}`);
  addToHistory(`Déplacement: ${cardData?.name || cardId} (${fromZone} → ${toZone})`);
}

// Synchroniser zones publiques vers roomState (mon slot uniquement)
async function syncPublicZones() {
  const slot = mySlotFromState(roomState);
  if(!slot || slot === 'spectator') return;

  await updateRoomState((s) => {
    // Zones publiques
    if(!s.terrains) s.terrains = { A: [], B: [] };
    s.terrains[slot] = gameState.myTerrain || [];

    if(!s.vestiaires) s.vestiaires = { A: [], B: [] };
    s.vestiaires[slot] = gameState.myVestiaire || [];

    if(!s.banchs) s.banchs = { A: [], B: [] };
    s.banchs[slot] = gameState.myBanch || [];

    if(!s.revealed) s.revealed = { A: [], B: [] };
    s.revealed[slot] = gameState.myRevealed || [];

    // 🔧 SYNC: Synchroniser aussi deck et main
    if(!s.deckPiles) s.deckPiles = { A: [], B: [] };
    if(!s.handPiles) s.handPiles = { A: [], B: [] };
    s.deckPiles[slot] = myDeckPile.slice();
    s.handPiles[slot] = myHandPile.slice();
    
    if(s.players?.[slot]){
      s.players[slot].deckCount = myDeckPile.length;
      s.players[slot].handCount = myHandPile.length;
    }

    return s;
  }, "sync-zones");
}

// Ajouter/retirer un marqueur sur une carte du terrain
async function modifyCounter(cardTok, counterType, delta, fromZone = 'myTerrain') {
  const slot = slotForZone(fromZone);
  if(!slot) return;

  try {
    const tok = String(cardTok);
    const cid = getCid(tok);

    await updateRoomState((s) => {
      const arr = (s.terrains && s.terrains[slot]) ? s.terrains[slot] : [];
      const creature = arr.find(c => c && typeof c === 'object' && ((c.inst && c.inst === tok) || (!c.inst && String(c.cardId) === String(cid))));
      if(creature){
        if(!creature.counters) creature.counters = { pass: 0, charge: 0, time: 0 };
        creature.counters[counterType] = Math.max(0, (creature.counters[counterType] || 0) + delta);
      } else {
        // Token/meta fallback (permet marqueurs sur tokens hors-terrain)
        s.tokenMeta = s.tokenMeta || {A:{}, B:{}};
        const metaSlot = s.tokenMeta[slot] || {};
        const entry = metaSlot[tok] || { counters: { pass:0, charge:0, time:0 }, note: '' };
        entry.counters = entry.counters || { pass:0, charge:0, time:0 };
        entry.counters[counterType] = Math.max(0, (entry.counters[counterType] || 0) + delta);
        metaSlot[tok] = entry;
        s.tokenMeta[slot] = metaSlot;
      }

      const actor = mySlotFromState(roomState || s);
      if(actor && actor !== 'spectator' && creature) creature.lastBy = actor;
      return s;
    }, 'modify-counter');

    const cardData = cardsById.get(cid);
    pushLog(`${delta > 0 ? '+' : ''}${delta} ${counterType} sur ${cardData?.name || cid}`);

    // refresh zone modal if open
    if (currentOpenZone === fromZone) {
      const cfg = getZoneConfig(fromZone);
      if(cfg) renderZoneContent(fromZone, cfg);
    }
  } catch(e) {
    reportError(e, 'modifyCounter');
  }
}

// Modifier la note d'une carte du terrain
async function setCardNote(cardTok, note, fromZone = 'myTerrain') {
  const slot = slotForZone(fromZone);
  if(!slot) return;

  try {
    const tok = String(cardTok);
    const cid = getCid(tok);

    await updateRoomState((s) => {
      const arr = (s.terrains && s.terrains[slot]) ? s.terrains[slot] : [];
      const creature = arr.find(c => c && typeof c === 'object' && ((c.inst && c.inst === tok) || (!c.inst && String(c.cardId) === String(cid))));
      if(creature){
        creature.note = note || '';
      } else {
        // Token/meta fallback (permet note sur tokens hors-terrain)
        s.tokenMeta = s.tokenMeta || {A:{}, B:{}};
        const metaSlot = s.tokenMeta[slot] || {};
        const entry = metaSlot[tok] || { counters: { pass:0, charge:0, time:0 }, note: '' };
        entry.note = note || '';
        metaSlot[tok] = entry;
        s.tokenMeta[slot] = metaSlot;
      }
      const actor = mySlotFromState(roomState || s);
      if(actor && actor !== 'spectator' && creature) creature.lastBy = actor;
      return s;
    }, 'set-note');

    pushLog('📝 Note mise à jour');
    if (currentOpenZone === fromZone) {
      const cfg = getZoneConfig(fromZone);
      if(cfg) renderZoneContent(fromZone, cfg);
    }
  } catch(e) {
    reportError(e, 'setCardNote');
  }
}
// Modifier la note du Chef (A/B)
async function setChiefNote(note, zoneId = 'myChief') {
  const slot = slotForZone(zoneId);
  if(!slot) return;

  try {
    await updateRoomState((s) => {
      s.chiefNotes = s.chiefNotes || {A:'', B:''};
      s.chiefNotes[slot] = note || '';
      return s;
    }, 'set-chief-note');

    // Sync local immédiat : mettre à jour gameState selon mon slot
    const mySlot = mySlotFromState(roomState);
    if(slot === mySlot) {
      gameState.myChiefNote = note || '';
    } else {
      gameState.oppChiefNote = note || '';
    }

    pushLog('📝 Note Chef mise à jour');

    if (currentOpenZone === zoneId) {
      const cfg = getZoneConfig(zoneId);
      if(cfg) renderZoneContent(zoneId, cfg);
    }
  } catch(e) {
    reportError(e, 'setChiefNote');
  }
}

async function handleSetChiefNote(zoneId, note){
  await setChiefNote(note, zoneId);
}

// Sauvegarde "live" (debounce) : sur mobile, le blur/change peut ne pas partir
// si on ferme la modale trop vite. On persiste en arrière-plan.
let __chiefNoteTimer = null;
let __chiefNoteInFlight = false;
let __chiefNotePending = null;
function handleChiefNoteInput(zoneId, note){
  try{
    // Debounce longer to avoid flooding updateRoomState -> version conflicts -> resync -> modal closes.
    if(__chiefNoteTimer) clearTimeout(__chiefNoteTimer);
    __chiefNotePending = { zoneId, note };
    __chiefNoteTimer = setTimeout(async ()=>{
      if(__chiefNoteInFlight) return; // will be retried when in-flight finishes
      const pending = __chiefNotePending;
      __chiefNotePending = null;
      if(!pending) return;
      __chiefNoteInFlight = true;
      try{ await setChiefNote(pending.note, pending.zoneId); }catch(_e){}
      __chiefNoteInFlight = false;
      // If user kept typing while we were saving, flush the latest value once.
      if(__chiefNotePending){
        try{ handleChiefNoteInput(__chiefNotePending.zoneId, __chiefNotePending.note); }catch(_e){}
      }
    }, 900);
  }catch(e){ /* noop */ }
}
// Marquer une créature : "a perdu tous ses effets" (badge)
async function setCardNullified(cardTok, isOn, fromZone = 'myTerrain'){
  const slot = slotForZone(fromZone);
  if(!slot) return;

  try{
    const tok = String(cardTok);
    const cid = getCid(tok);

    await updateRoomState((s)=>{
      const arr = (s.terrains && s.terrains[slot]) ? s.terrains[slot] : [];
      const creature = arr.find(c => c && typeof c === 'object' && ((c.inst && c.inst === tok) || (!c.inst && String(c.cardId) === String(cid))));
      if(!creature) return s;

      creature.nullified = !!isOn;
      const actor = mySlotFromState(roomState || s);
      if(actor && actor !== 'spectator' && creature) creature.lastBy = actor;
      return s;
    }, 'set-nullified');

    pushLog(`🚫 Effets ${isOn ? 'annulés' : 'rétablis'}`);

    if (currentOpenZone === fromZone) {
      const cfg = getZoneConfig(fromZone);
      if(cfg) renderZoneContent(fromZone, cfg);
    }
  }catch(e){
    reportError(e, 'setCardNullified');
  }
}
// Créer un token sur le terrain (zone cible: myTerrain / oppTerrain)
async function createToken(tokenCardId, zoneId = 'myTerrain') {
  const tokenCard = cardsById.get(tokenCardId);
  if (!tokenCard || !isToken(tokenCard)) {
    pushLog(`❌ Carte ${tokenCardId} n'est pas un token`);
    return;
  }

  const slot = slotForZone(zoneId);
  if(!slot) return;

  // Interdit aux spectateurs
  const actor = mySlotFromState(roomState || initialRoomState());
  if(actor === 'spectator') {
    pushLog('👀 Spectateur : action ignorée');
    return;
  }

  try {
    await updateRoomState((s) => {
      if(!s.terrains) s.terrains = { A: [], B: [] };
      if(!s.terrains[slot]) s.terrains[slot] = [];
      s.terrains[slot].push({
        cardId: tokenCardId,
        originalCardId: tokenCardId, // CRITIQUE: pour transformations
        inst: normalizeTokenInput(slot, String(tokenCardId).padStart(3,'0'), s),
        tapped: false,
        counters: { pass: 0, charge: 0, time: 0 },
        note: '',
        lastBy: actor
      });
      return s;
    }, zoneIsOpp(zoneId) ? 'create-token-opp' : 'create-token');

    pushLog(`✨ Token créé${zoneIsOpp(zoneId) ? ' (adverse)' : ''} : ${tokenCard.name}`);

    // Rafraîchir le modal si ouvert
    if (currentOpenZone === zoneId) {
      const cfg = getZoneConfig(zoneId);
      if(cfg) renderZoneContent(zoneId, cfg);
    }
  } catch(e) {
    reportError(e, 'createToken');
  }
}

// Piocher X cartes
// =====================================================================
// SECTION:ACTIONS
// =====================================================================

async function drawCards(count) {
  const st0 = roomState || initialRoomState();
  const slot = mySlotFromState(st0);
  if(!slot){ pushLog('⚠️ Spectateur: pioche impossible'); return; }

  await updateRoomState((s) => {
    s.deckPiles = s.deckPiles || { A: [], B: [] };
    s.handPiles = s.handPiles || { A: [], B: [] };
    s.vestiaires = s.vestiaires || { A: [], B: [] };
    s.players = s.players || { A:{}, B:{} };

    const deck = s.deckPiles[slot] || [];
    const hand = s.handPiles[slot] || [];
    const vest = s.vestiaires[slot] || [];

    // Piocher avec recyclage automatique vestiaire (comme drawStartHands)
    for(let i=0; i<count; i++){
      // Deck vide ? Recycler vestiaire automatiquement
      if(deck.length === 0 && vest.length > 0){
        console.log(`♻️ [DRAW] Deck ${slot} vide, recyclage Vestiaire (${vest.length} cartes)`);
        const mixed = shuffleInPlace(vest.slice());
        deck.push(...mixed);
        vest.length = 0;
        showToast("♻️ Deck vide → Vestiaire mélangé en nouveau deck");
        try{ pushActivity(`♻️ Deck ${slotLabel(slot)} recyclé (vestiaire → deck)`); }catch(_e){}
      }
      
      // Piocher
      if(deck.length > 0){
        hand.push(deck.shift());
      } else {
        console.warn(`⚠️ [DRAW] ${slot} ne peut plus piocher (deck et vestiaire vides)`);
        break;
      }
    }

    s.deckPiles[slot] = deck;
    s.handPiles[slot] = hand;
    s.vestiaires[slot] = vest;
    if(s.players?.[slot]){
      s.players[slot].handCount = hand.length;
      s.players[slot].deckCount = deck.length;
    }
    return s;
  }, 'draw');

  updateHandUI();
  updateAllZoneCounters();
  pushLog(`📥 Pioché ${count} carte(s)`);
  try{ pushActivity(`📥 ${slotLabel(mySlotFromState(roomState||{}))} pioche ${count}`); }catch(_e){}
}

// Wrapper pour pioches manuelles avec historique
async function drawCardsManual(count) {
  addToHistory(`Avant pioche de ${count} carte(s)`);
  await drawCards(count);
}

// Révéler la carte du dessus du deck
async function revealTopDeck() {
  const st0 = roomState || initialRoomState();
  const slot = mySlotFromState(st0);
  if(!slot){ pushLog(`⚠️ Spectateur`); return; }

  await updateRoomState((s)=>{
    s.deckPiles = s.deckPiles || {A:[],B:[]};
    s.handPiles = s.handPiles || {A:[],B:[]};
    s.revealed = s.revealed || {A:[],B:[]};
    const deck = Array.isArray(s.deckPiles[slot]) ? s.deckPiles[slot] : [];
    if(deck.length === 0) return s;
    const cardTok = deck.shift();
    s.deckPiles[slot] = deck;
    if(!Array.isArray(s.revealed[slot])) s.revealed[slot] = [];
    s.revealed[slot].push(cardTok);
    if(s.players && s.players[slot]){
      s.players[slot].deckCount = (s.deckPiles[slot]||[]).length;
      s.players[slot].handCount = (s.handPiles[slot]||[]).length;
    }
    return s;
  }, 'reveal-top-deck');

  const st = roomState || initialRoomState();
  const deckNow = (st.deckPiles && st.deckPiles[slot]) ? st.deckPiles[slot] : [];
  if(!deckNow || deckNow.length < 0){ }

  updateHandUI();
  updateAllZoneCounters();
  updateLocalUI();
  pushLog(`🎴 Révélé depuis deck`);
}

// Mélanger le deck
async function shuffleDeck() {
  const st0 = roomState || initialRoomState();
  const slot = mySlotFromState(st0);
  if(!slot){ pushLog(`⚠️ Spectateur`); return; }
  await updateRoomState((s)=>{
    s.deckPiles = s.deckPiles || {A:[],B:[]};
    const deck = Array.isArray(s.deckPiles[slot]) ? s.deckPiles[slot].slice() : [];
    s.deckPiles[slot] = shuffleInPlace(deck);
    if(s.players && s.players[slot]) s.players[slot].deckCount = (s.deckPiles[slot]||[]).length;
    return s;
  }, 'shuffle-deck');
  pushLog(`🔀 Deck mélangé`);
  updateHandUI();
}

// Couper le deck
async function cutDeck() {
  const st0 = roomState || initialRoomState();
  const slot = mySlotFromState(st0);
  if(!slot){ pushLog(`⚠️ Spectateur`); return; }

  const deckLen = (st0.deckPiles && Array.isArray(st0.deckPiles[slot])) ? st0.deckPiles[slot].length : myDeckPile.length;
  if(deckLen < 2){ pushLog(`⚠️ Deck trop petit pour couper`); return; }

  const cutPoint = Math.floor(Math.random() * (deckLen - 1)) + 1;
  try{
    await updateRoomState((s)=>{
      s.deckPiles = s.deckPiles || {A:[],B:[]};
      const deck = Array.isArray(s.deckPiles[slot]) ? s.deckPiles[slot].slice() : [];
      if(deck.length < 2) return s;
      const top = deck.slice(0, cutPoint);
      const bottom = deck.slice(cutPoint);
      s.deckPiles[slot] = bottom.concat(top);
      if(s.players && s.players[slot]){
        s.players[slot].deckCount = s.deckPiles[slot].length;
      }
      return s;
    }, 'cut-deck');
    pushLog(`✂️ Deck coupé`);
    updateHandUI();
  }catch(e){
    reportError(e,'cut-deck');
  }
}

// Reformer le deck (Deck + Vestiaire) (DB)
async function reformDeckFromVestiaire(){
  const st0 = roomState || initialRoomState();
  const slot = mySlotFromState(st0);
  if(!slot){ pushLog('⚠️ Spectateur : action impossible'); return; }

  const v0 = (st0.vestiaires && Array.isArray(st0.vestiaires[slot])) ? st0.vestiaires[slot] : [];
  const d0 = (st0.deckPiles && Array.isArray(st0.deckPiles[slot])) ? st0.deckPiles[slot] : [];
  const total0 = (d0 ? d0.length : 0) + (v0 ? v0.length : 0);
  if(!total0){ pushLog('♻️ Deck et vestiaire vides'); return; }

  const _isEnf2 = (typeof GAME_MODE !== "undefined" && GAME_MODE === "enfant");
  const ok = _isEnf2 ? true : confirm('Reformer le deck (deck + vestiaire) : ' + total0 + ' cartes ?');
  if(!ok) return;

  try{
    await updateRoomState((s)=>{
      s.deckPiles = s.deckPiles || {A:[],B:[]};
      s.handPiles = s.handPiles || {A:[],B:[]};
      if(!s.vestiaires) s.vestiaires = {A:[],B:[]};
      const v = Array.isArray(s.vestiaires[slot]) ? s.vestiaires[slot].slice() : [];
      const d = Array.isArray(s.deckPiles[slot]) ? s.deckPiles[slot].slice() : [];
      const combined = d.concat(v);
      if(combined.length){
        s.deckPiles[slot] = shuffleInPlace(combined.slice());
      }else{
        s.deckPiles[slot] = [];
      }
      // Le vestiaire est vidé après reforme
      s.vestiaires[slot] = [];
      if(s.players && s.players[slot]){
        s.players[slot].deckCount = (s.deckPiles[slot]||[]).length;
        s.players[slot].handCount = (s.handPiles[slot]||[]).length;
      }
      return s;
    }, 'reform-deck-from-vestiaire');

    pushLog('♻️ Deck reformé (deck + vestiaire)');
    updateHandUI();
    updateAllZoneCounters();
    updateLocalUI();

    // Si le navigateur de deck est ouvert, rafraîchir
    try{ if(typeof openDeckBrowser === 'function'){ /* no-op */ } }catch(e){}
  }catch(e){
    reportError(e,'reformDeckFromVestiaire');
  }
}
// Ouvrir le modal de carte (détails + actions)
// Utilisé par la main, le deck (browse) et les zones publiques.

/* =========================
   🎯 MODE ENFANT : Pending effects (choix/cibles)
   - Bloque les actions tant que l'effet n'est pas résolu
   - Le tour ne passe qu'une fois l'effet finalisé
========================= */

function getPendingEffect(st){
  return st && st.pendingEffect ? st.pendingEffect : null;
}
function isMyPendingEffect(st){
  const pe = getPendingEffect(st);
  if(!pe) return false;
  const me = mySlotFromState(st);
  return !!(me && pe.by === me);
}
function pendingBlocksActions(){
  const isEnfant = (typeof GAME_MODE !== "undefined" && GAME_MODE === "enfant");
  if(!isEnfant) return false;
  const st = roomState || initialRoomState();
  return isMyPendingEffect(st);
}

async function setPendingEffect(effect){
  await updateRoomState((s) => {
    s.pendingEffect = effect || null;
    return s;
  }, 'effect-pending-set');

  // ✅ SAFETY: if an effect enters "pending", we must not leave any modal overlay blocking taps.
  // This prevents the "card freezes + X doesn't work" situation on mobile.
  try{ closeCardModal(); }catch(_e){}
  try{ closeZoneModal && closeZoneModal(); }catch(_e){}
  try{
    const ov = document.getElementById("choiceModalOverlay");
    if(ov) ov.remove();
  }catch(_e){}
}

function zoneMatches(pe, fromZone){
  if(!pe) return false;
  const z = String(fromZone||'');
  const allowed = pe.allowedZones || [];
  return allowed.includes(z);
}

function getCreatureFromZone(st, zoneId, instOrCid){
  const slot = slotForZone(zoneId); // A/B
  if(!slot) return null;
  const arr = (st.terrains && st.terrains[slot]) ? st.terrains[slot] : [];
  if(isInstanceToken(instOrCid)){
    return arr.find(c => c && c.inst === instOrCid) || null;
  }
  const cid = String(instOrCid||'').padStart(3,'0');
  return arr.find(c => c && String(c.cardId||'').padStart(3,'0') === cid) || null;
}

async function tryResolvePendingEffectPick(cardTok, fromZone){
  const isEnfant = (typeof GAME_MODE !== "undefined" && GAME_MODE === "enfant");
  if(!isEnfant) return false;

  const st0 = roomState || initialRoomState();
  const pe = getPendingEffect(st0);
  if(!pe) return false;

  const me = mySlotFromState(st0);
  if(!me || pe.by !== me){
    // pas à moi de résoudre
    return false;
  }

  if(!zoneMatches(pe, fromZone)){
    showToast("⚠️ " + (pe.hint || "Mauvaise zone"), null, 0);
    return true; // on intercepte quand même (UX enfant)
  }

  // Résolution selon l'effet
  const opp = otherSlot(me);

  const selected = String(cardTok||'');
  const cid = getCid(selected);

  const finish = async (logMsg) => {
    await setPendingEffect(null);
    if(logMsg) { pushLog(logMsg); showToast(logMsg); }
    // Passer le tour à la fin d'un pending
    await autoPassTurn(me);
  };

  // Helper: update + keep single write
  const applyUpdate = async (fn, reason) => {
    await updateRoomState((s) => {
      // defensive init
      if(!s.handPiles) s.handPiles = {A:[],B:[]};
      if(!s.deckPiles) s.deckPiles = {A:[],B:[]};
      if(!s.vestiaires) s.vestiaires = {A:[],B:[]};
      if(!s.terrains) s.terrains = {A:[],B:[]};
      return fn(s) || s;
    }, reason || 'effect-pending-apply');
  };

  switch(pe.effectId){

    case "E_SLEEP_ENEMY_1": {
      const creature = getCreatureFromZone(st0, 'oppTerrain', selected);
      if(!creature){ showToast("Aucune cible"); await finish("⚠️ Effet échoué (pas de cible)"); return true; }
      if(creature.tapped){ showToast("Elle dort déjà 😴"); return true; }
      await applyUpdate((s) => {
        const c = getCreatureFromZone(s, 'oppTerrain', selected);
        if(c) c.tapped = true;
        return s;
      }, 'effect-sleep-1');
      await finish(`😴 ${slotLabel(me)} Une créature adverse s'endort`);
      return true;
    }

    case "E_WAKE_1": {
      // autorise réveiller sur mon terrain ou adverse (si UX le veut). Ici: zones autorisées dans pe.allowedZones.
      const zone = fromZone;
      const creature = getCreatureFromZone(st0, zone, selected);
      if(!creature){ showToast("Aucune cible"); await finish("⚠️ Effet échoué (pas de cible)"); return true; }
      if(!creature.tapped){ showToast("Elle est déjà réveillée 🙂"); return true; }
      await applyUpdate((s) => {
        const c = getCreatureFromZone(s, zone, selected);
        if(c) c.tapped = false;
        return s;
      }, 'effect-wake-1');
      await finish(`🙂 ${slotLabel(me)} Une créature se réveille`);
      return true;
    }

    case "E_DRAW_1_THEN_DISCARD_1_TO_LOCKER": {
      // pick: une carte de ma main -> vestiaire
      await applyUpdate((s) => {
        const hi = (s.handPiles[me]||[]).indexOf(selected);
        if(hi < 0) return s;
        const tok = (s.handPiles[me]||[]).splice(hi,1)[0];
        (s.vestiaires[me]||[]).push(tok);
        return s;
      }, 'effect-draw1-discard1');
      await finish("🗑️ 1 carte va au Vestiaire");
      return true;
    }

    case "E_DRAW_1_THEN_GIVE_1_FROM_HAND_TO_OPPONENT": {
      // La pioche a déjà été faite dans le trigger, maintenant juste donner
      await applyUpdate((s) => {
        const hi = (s.handPiles[me]||[]).indexOf(selected);
        if(hi < 0) return s;
        const tok = (s.handPiles[me]||[]).splice(hi,1)[0];
        (s.handPiles[opp]||[]).push(tok);
        return s;
      }, 'effect-draw1-give1');
      await finish(`🎁 ${slotLabel(me)} donne 1 carte à l'adversaire`);
      return true;
    }

    case "E_DRAW_2_THEN_PUT_1_FROM_HAND_ON_TOP": {
      // put selected back on top of my deck
      await applyUpdate((s) => {
        const hi = (s.handPiles[me]||[]).indexOf(selected);
        if(hi < 0) return s;
        const tok = (s.handPiles[me]||[]).splice(hi,1)[0];
        // top of deck = unshift
        (s.deckPiles[me]||[]).unshift(tok);
        return s;
      }, 'effect-draw2-put1top');
      await finish("🔝 1 carte est remise au-dessus du deck");
      return true;
    }

    case "E_SWAP_HAND_WITH_LOCKER_1": {
      if(pe.step === 1){
        // first pick from hand
        await setPendingEffect({ ...pe, step: 2, picks: [selected], hint: "Choisis 1 carte du Vestiaire" , allowedZones: ['myVestiaire'] });
        showToast("✅ Choisis 1 carte du Vestiaire", null, 0);
        return true;
      }
      // step 2: pick from vestiaire
      const tokHand = (pe.picks && pe.picks[0]) ? pe.picks[0] : null;
      const tokLocker = selected;
      if(!tokHand){ await finish("⚠️ Effet échoué"); return true; }

      await applyUpdate((s) => {
        const hi = (s.handPiles[me]||[]).indexOf(tokHand);
        const vi = (s.vestiaires[me]||[]).indexOf(tokLocker);
        if(hi < 0 || vi < 0) return s;
        (s.handPiles[me]||[]).splice(hi,1);
        (s.vestiaires[me]||[]).splice(vi,1);
        (s.handPiles[me]||[]).push(tokLocker);
        (s.vestiaires[me]||[]).push(tokHand);
        return s;
      }, 'effect-swap-hand-locker-1');
      await finish("🔁 1 carte est échangée Main ↔ Vestiaire");
      return true;
    }

    case "E_SWAP_CREATURES_ACROSS_FIELDS_1": {
      if(pe.step === 1){
        // pick my creature from myTerrain
        await setPendingEffect({ ...pe, step: 2, picks: [selected], hint: "Choisis 1 créature adverse" , allowedZones: ['oppTerrain'] });
        showToast("✅ Choisis 1 créature adverse", null, 0);
        return true;
      }

      const myPick = (pe.picks && pe.picks[0]) ? pe.picks[0] : null;
      const oppPick = selected;
      if(!myPick){ await finish("⚠️ Effet échoué"); return true; }

      await applyUpdate((s) => {
        const myArr = s.terrains[me] || [];
        const oppArr = s.terrains[opp] || [];
        const mi = isInstanceToken(myPick) ? myArr.findIndex(c => c && c.inst === myPick) : myArr.findIndex(c => c && String(c.cardId||'').padStart(3,'0') === String(getCid(myPick)).padStart(3,'0'));
        const oi = isInstanceToken(oppPick) ? oppArr.findIndex(c => c && c.inst === oppPick) : oppArr.findIndex(c => c && String(c.cardId||'').padStart(3,'0') === String(getCid(oppPick)).padStart(3,'0'));
        if(mi < 0 || oi < 0) return s;
        const a = myArr[mi];
        const b = oppArr[oi];
        // swap owners: move objects across arrays
        myArr.splice(mi,1,b);
        oppArr.splice(oi,1,a);

        // preserve inst tokens but need to ensure they remain unique / belong to owner; simplest: keep inst as-is.
        // (Optionnel) marquer lastBy
        if(myArr[mi]) myArr[mi].lastBy = me;
        if(oppArr[oi]) oppArr[oi].lastBy = me;
        return s;
      }, 'effect-swap-creatures-1');
      await finish("🔁 Deux créatures échangent de place");
      return true;
    }

    case "E_SEND_OWN_CREATURE_TO_LOCKER_THEN_FLIP": {
      console.log('[FLIP EFFECT] selected:', selected);
      console.log('[FLIP EFFECT] sourceTok:', pe.sourceTok);
      
      if(pe.sourceTok){
        const isSrc = (selected === pe.sourceTok);
        if(isSrc){ showToast("Cette créature va être flippée — choisis une autre 🧥"); return true; }
      }

      const creature = getCreatureFromZone(st0, 'myTerrain', selected);
      console.log('[FLIP EFFECT] Found creature:', creature);
      
      if(!creature){ showToast("Pas de créature à sacrifier"); await finish("⚠️ Effet échoué (pas de cible)"); return true; }

      // Ajouter à la liste des picks
      const picks = pe.picks || [];
      console.log('[FLIP EFFECT] Current picks:', picks);
      
      const alreadyPicked = picks.includes(selected);
      if(alreadyPicked){ showToast("Déjà sélectionnée"); return true; }
      
      picks.push(selected);
      console.log('[FLIP EFFECT] After push, picks:', picks);
      
      const maxPicks = pe.maxPicks || 1;
      
      // Si pas encore assez de picks, continuer
      if(picks.length < maxPicks){
        await setPendingEffect({
          ...pe,
          picks: picks,
          hint: `Choisis ${maxPicks - picks.length} créature${maxPicks - picks.length > 1 ? 's' : ''} de plus 🧥`
        });
        showToast(`${picks.length}/${maxPicks} sélectionnée${picks.length > 1 ? 's' : ''}`, null, 0);
        return true;
      }

      // Toutes les picks faites, sacrifier et transformer
      console.log('[FLIP EFFECT] All picks done. Picks:', picks);
      
      await applyUpdate((s) => {
        const arr = s.terrains[me] || [];
        console.log('[FLIP EFFECT] Terrain before filter:', arr.map(c => ({inst: c?.inst, cardId: c?.cardId})));
        
        // Sacrifier toutes les créatures sélectionnées
        const removed = [];
        const sourceTok = pe.sourceTok;
        
        s.terrains[me] = arr.filter(c => {
          if(!c) return true;
          
          // CRITIQUE: Ne JAMAIS retirer la carte source
          if(sourceTok && c.inst === sourceTok) {
            console.log('[FLIP EFFECT] Keeping source creature:', c.inst);
            return true;
          }
          
          // CRITIQUE: Comparer UNIQUEMENT par instance token (inst)
          // Ne JAMAIS comparer par cardId car plusieurs créatures peuvent avoir le même cardId
          const isPicked = picks.some(pick => {
            const match = (c.inst === pick);
            console.log(`[FLIP EFFECT] Comparing c.inst=${c.inst} with pick=${pick}: ${match}`);
            return match;
          });
          
          if(isPicked){
            console.log('[FLIP EFFECT] Removing creature:', c.inst, c.cardId);
            removed.push(c);
            return false;
          }
          return true;
        });
        
        console.log('[FLIP EFFECT] Terrain after filter:', s.terrains[me].map(c => ({inst: c?.inst, cardId: c?.cardId})));
        console.log('[FLIP EFFECT] Removed:', removed.map(c => ({inst: c?.inst, cardId: c?.cardId})));
        
        // Envoyer au vestiaire
        for(const r of removed){
          const tok = (r && r.inst && isInstanceToken(r.inst)) ? r.inst : normalizeTokenInput(me, r.cardId, s);
          (s.vestiaires[me]||[]).push(tok);
        }
        
        // Transformer la carte source
        if(sourceTok){
          const src = s.terrains[me].find(c => c && c.inst === sourceTok);
          if(src){
            // CRITIQUE: Utiliser originalCardId pour lookup transformTo
            // Car cardId actuel peut déjà être transformé (011->012)
            const lookupId = src.originalCardId || src.cardId;
            const sourceCard = cardsById.get(String(lookupId).padStart(3,'0'));
            const newCardId = sourceCard?.transformTo ? String(sourceCard.transformTo).padStart(3,'0') : "012";
            src.cardId = newCardId;
          }
        }
        return s;
      }, 'effect-sacrifice-flip');
      await finish(`🧥 ${slotLabel(me)} Sacrifice ${picks.length} créature${picks.length > 1 ? 's' : ''} + transformation`);
      return true;
    }

    default:
      // unknown pending, clear to avoid lock
      await finish(null);
      return true;
  }
}

function openCardModal(cardTok, fromZone) {
  // 🔧 CORRECTION: Annuler tout long press en cours pour éviter les bugs visuels
  if(typeof clearLongPress === 'function') {
    clearLongPress();
  }
  
  // 🎯 MODE ENFANT : si un effet attend une cible, on intercepte le clic/tap ici.
  try{
    const isEnfant = (typeof GAME_MODE !== "undefined" && GAME_MODE === "enfant");
    const st = roomState || initialRoomState();
    if(isEnfant && st && st.pendingEffect && isMyPendingEffect(st) && typeof tryResolvePendingEffectPick === 'function'){
      // async resolve; si ça gère le clic, on stop ici
      tryResolvePendingEffectPick(cardTok, fromZone).catch(()=>{});
      return;
    }
  }catch(_e){}

  const modal = $("cardModal");
  const body = $("cardModalBody");
  const title = $("cardModalTitle");
  if(!modal || !body || !title){
    console.warn('[openCardModal] éléments du modal introuvables');
    return;
  }
  // IMPORTANT: for terrain creatures, the instance token keeps the ORIGINAL cid,
  // but the creature may have been flipped and thus has a different current cardId.
  // So when opening from a Terrain zone, resolve the live creature first.
  let cardId = getCid(cardTok);
  try{
    if(isInstanceToken(cardTok) && (fromZone === 'myTerrain' || fromZone === 'oppTerrain')){
      const st = roomState || initialRoomState();
      const zoneSlot = slotForZone(fromZone);
      const arr = (zoneSlot && st.terrains && st.terrains[zoneSlot]) ? st.terrains[zoneSlot] : [];
      const live = Array.isArray(arr) ? arr.find(c => c && c.inst === cardTok) : null;
      if(live && live.cardId) cardId = String(live.cardId).padStart(3,'0');
    }
  }catch(_e){}
  const card = cardsById.get(cardId);
  if(!card){
    console.warn('[openCardModal] carte introuvable:', cardId);
    return;
  }
  
  // FIX #4: Calculer face alternative (ne reset que si c'est une nouvelle carte)
  const isNewCard = !currentCardContext || currentCardContext.cardId !== cardId;
  if (isNewCard) cardModalShowAltFace = false;
  
  const hasAltFace = !!(card.transformTo || card.transformFrom);
  const altFaceId = card.transformTo || card.transformFrom;
  const altCard = (hasAltFace && altFaceId) ? cardsById.get(String(altFaceId).padStart(3,'0')) : null;
  const displayCard = (cardModalShowAltFace && altCard) ? altCard : card;

  // Contexte utilisé pour re-render après update DB (PA, etc.)
  currentCardContext = { cardTok, cardId, fromZone };

  safeText(title, displayCard.name || 'Carte');
  renderCardModalContent(displayCard, fromZone);
  
  // FIX #4: Ajouter bouton flip si transformTo/transformFrom existe
  if (hasAltFace && altCard) {
    const existingBtn = body.querySelector('.card-modal-flip-btn-container');
    if (existingBtn) existingBtn.remove();
    
    const btnContainer = document.createElement('div');
    btnContainer.className = 'card-modal-flip-btn-container';
    btnContainer.style.cssText = 'margin-top: 12px; text-align: center;';
    
    const flipBtn = document.createElement('button');
    flipBtn.className = 'card-modal-flip-btn';
    flipBtn.textContent = cardModalShowAltFace ? '← Voir recto' : 'Voir verso →';
    flipBtn.onclick = () => {
      cardModalShowAltFace = !cardModalShowAltFace;
      openCardModal(cardTok, fromZone);
    };
    
    btnContainer.appendChild(flipBtn);
    body.appendChild(btnContainer);
  }
  
  modal.classList.add('open');
  
  // 🔧 CORRECTION: Centrer le modal après ouverture, surtout sur mobile
  if(typeof centerCardModal === 'function') {
    // Appel immédiat
    centerCardModal();
    // Et après un court délai pour être sûr que le DOM est à jour
    setTimeout(() => {
      centerCardModal();
    }, 50);
  }
}
function closeCardModal() {
  const el = document.getElementById('cardModal');
  if (!el) return;
  el.classList.remove('open');
  // extra hard-close (some mobile browsers keep capturing taps briefly)
  try{ el.style.display = 'none'; }catch(_e){}
  // restore default (next open uses CSS .open to set display:flex)
  setTimeout(()=>{ try{ if(!el.classList.contains('open')) el.style.display = ''; }catch(_e){} }, 0);
  currentCardContext = null;
}

function renderCardModalContent(card, fromZone) {
  if (!cardModalBody) return;

  const tok = String((currentCardContext && currentCardContext.cardTok) || '');
  const cid = tok ? getCid(tok) : (card && card.number != null ? String(card.number).padStart(3,'0') : '');

  let html = '';

	const isEnfant = (typeof GAME_MODE !== "undefined" && GAME_MODE === "enfant") || (roomState && roomState.gameMode === "enfant");

	// 1. FICHE CARTE
	if(isEnfant){
	  const s = safeImageSrc(card.image || '');
	  const src = s || '/assets/cards/placeholder.jpg';
	  html += `<div class="card-sheet enfantArtOnly">`;
	  html += `<div class="cardArt cardArtModal"><img src="${escapeHtml(src)}" alt="${escapeHtml(card.name || '')}" loading="lazy" decoding="async" onerror="this.onerror=null;this.src='/assets/cards/placeholder.jpg';"></div>`;
	  if(card.text){ html += `<div class="card-sheet-text enfantCardText">${escapeHtml(card.text)}</div>`; }
	  html += `</div>`;
	} else {
	  html += `<div class="card-sheet">`;
	  html += `<div class="card-sheet-name">${escapeHtml(card.name)}</div>`;

	  if (card.cost != null) {
	    html += `<div class="card-sheet-cost">${card.cost}</div>`;
	  }

	  html += `<div class="card-sheet-type">${escapeHtml(card.type || '')}</div>`;

	  if (card.subtypes && card.subtypes.length > 0) {
	    html += `<div class="card-sheet-subtypes">${card.subtypes.map(escapeHtml).join(' • ')}</div>`;
	  }

	  if (card.text) {
	    html += `<div class="card-sheet-text">${escapeHtml(card.text)}</div>`;
	  }
	  html += `</div>`;
	}

  // 1.5 ACTIONS RAPIDES SI EN MAIN
  if (fromZone === 'myHand') {
    html += `<div class="card-actions-section">`;
    // (enfant UX) title removed to keep actions visible without scroll
    html += ``;
    html += `<div class="card-action-list">`;

    const isCreature = card.type && card.type.toLowerCase().includes('créature');
    const isFarce = card.type && card.type.toLowerCase().includes('farce');

    if (isCreature) {
      const canAfford = isEnfant ? true : (card.cost == null || gameState.myActionDie >= card.cost);
      const playLabel = isEnfant ? `Jouer sur Terrain` : (canAfford ? `Jouer sur Terrain (Coût: ${card.cost || 0})` : `Jouer (⚠️ Insuffisant: ${card.cost}, Dispo: ${gameState.myActionDie})`);

      html += `<div class="card-action-item ${canAfford ? '' : 'disabled-action'}" onclick="if(${canAfford}) handlePlayFromHand('${tok}')">${playLabel}</div>`;
    }

    if (isFarce) {
      html += `<div class="card-action-item" onclick="handlePlayFarce('${tok}')">✨ Jouer Farce → Vestiaire</div>`;
    }

    html += `</div></div>`;
  }

  // 2. ACTIONS "DÉPLACER VERS..." — 🔧 CACHÉ EN MODE ENFANT (tout est automatique)
  const isEnfantMode = (typeof GAME_MODE !== "undefined" && GAME_MODE === "enfant") || (roomState && roomState.gameMode === "enfant");
  const isTokenCard = isToken(card);
  const destinations = getAvailableDestinations(fromZone, isTokenCard);

  if (destinations.length > 0 && !isEnfantMode) {
    html += `<div class="card-actions-section">`;
    html += `<div class="card-actions-title">📦 Déplacer vers...</div>`;
    html += `<div class="card-action-list">`;

    for (const dest of destinations) {
      html += `<div class="card-action-item move-card-btn" data-card-id="${escapeHtml(tok)}" data-from-zone="${fromZone}" data-to-zone="${dest.zone}" data-options='${JSON.stringify(dest.options || {})}'>${dest.label}</div>`;
    }

    html += `</div></div>`;
  }

  // 2.5 TOKENS : MARQUEURS + NOTE (toutes zones)
  if (isTokenCard) {
    const slot = slotForZone(fromZone);
    if (slot) {
      // Pour les tokens sur le terrain: les marqueurs/notes vivent sur l'objet "creature" (terrain),
      // pas dans tokenMeta. tokenMeta reste un fallback (tokens hors-terrain / ancien format).
      let counters = { pass:0, charge:0, time:0 };
      let noteVal = '';
      let foundOnTerrain = false;

      if (fromZone === 'myTerrain' || fromZone === 'oppTerrain') {
        const arr = (fromZone === 'myTerrain') ? gameState.myTerrain : gameState.oppTerrain;
        const cid = getCid(tok);
        const creature = Array.isArray(arr)
          ? arr.find(c => c && typeof c === 'object' && ((c.inst && c.inst === tok) || (!c.inst && String(c.cardId) === String(cid))))
          : null;

        if (creature) {
          foundOnTerrain = true;
          counters = creature.counters || counters;
          noteVal = (creature.note != null) ? String(creature.note) : '';
        }
      }

      if (!foundOnTerrain) {
        const metaSlot = (gameState.tokenMeta && gameState.tokenMeta[slot]) ? gameState.tokenMeta[slot] : {};
        const entry = metaSlot[tok] || { counters: { pass:0, charge:0, time:0 }, note: '' };
        counters = entry.counters || counters;
        noteVal = (entry.note != null) ? String(entry.note) : '';
      }

      // 🔧 MODE ENFANT : cacher les marqueurs (tout est automatique)
      const isEnfantMode = (typeof GAME_MODE !== "undefined" && GAME_MODE === "enfant") || (roomState && roomState.gameMode === "enfant");
      
      if(!isEnfantMode){
        html += `<div class="counters-section">`;
        html += `<div class="card-actions-title">🧮 Marqueurs</div>`;
      }

      const mkRow = (label, key, emoji) => {
        const v = (counters && Number.isFinite(counters[key])) ? counters[key]
          : (counters && counters[key] != null ? Number(counters[key]) : 0);
        return `
          <div class="counter-row">
            <div class="counter-label">${emoji} ${label}</div>
            <div class="counter-controls">
              <button class="counter-btn" onclick="handleModifyCounter('${tok}', '${key}', -1, '${fromZone}')">−</button>
              <div class="counter-value">${Number.isFinite(v) ? v : 0}</div>
              <button class="counter-btn" onclick="handleModifyCounter('${tok}', '${key}', 1, '${fromZone}')">+</button>
            </div>
          </div>`;
      };
      if(!isEnfantMode){
        html += mkRow('Pass', 'pass', '⚡');
        html += mkRow('Charge', 'charge', '🔋');
        html += mkRow('Time', 'time', '⏱️');
        html += `</div>`;

        html += `<div class="note-section">`;
        html += `<div class="card-actions-title">📝 Note</div>`;
        html += `<textarea class="note-input" placeholder="Note token" oninput="handleSetNote('${tok}', this.value, '${fromZone}')">${escapeHtml(noteVal)}</textarea>`;
        html += `</div>`;
      }
    }
  }
  if (!isTokenCard && (fromZone === 'myTerrain' || fromZone === 'oppTerrain')) {
    const terrainArr = (fromZone === 'myTerrain') ? gameState.myTerrain : gameState.oppTerrain;
    const terrainCard = terrainArr.find(c => (c.inst && c.inst === tok) || (!c.inst && String(c.cardId) === String(cid)));

    if (terrainCard) {
      // 🔧 MODE ENFANT : cacher les marqueurs (tout est automatique)
      const isEnfantMode = (typeof GAME_MODE !== "undefined" && GAME_MODE === "enfant") || (roomState && roomState.gameMode === "enfant");
      
      if(!isEnfantMode){
        html += `<div class="counters-section">`;
        html += `<div class="card-actions-title">🎯 Marqueurs</div>`;
      }

      const counters = terrainCard.counters || { pass: 0, charge: 0, time: 0 };

      const mkRow = (label, key, icon) => {
        return `
          <div class="counter-row">
            <span class="counter-label">${icon} ${label}</span>
            <div class="counter-controls">
              <button class="counter-btn" onclick="handleModifyCounter('${tok}', '${key}', -1, '${fromZone}')">−</button>
              <span class="counter-value">${counters[key] || 0}</span>
              <button class="counter-btn" onclick="handleModifyCounter('${tok}', '${key}', 1, '${fromZone}')">+</button>
            </div>
          </div>`;
      };

      if(!isEnfantMode){
        html += mkRow('Pass', 'pass', '⚡');
        html += mkRow('Charge', 'charge', '🔋');
        html += mkRow('Time', 'time', '⏱️');

        html += `</div>`;

        html += `<div class="note-section">`;
        html += `<div class="card-actions-title">📝 Note</div>`;
        html += `<textarea class="note-input" placeholder="Note libre (ex: protège, silence, 1 fois/tour...)" onchange="handleSetNote('${tok}', this.value, '${fromZone}')">${escapeHtml(terrainCard.note || '')}</textarea>`;
        html += `</div>`;
      }
    }
  }

  cardModalBody.innerHTML = html;

  // listeners move
  const moveCardBtns = cardModalBody.querySelectorAll('.move-card-btn');
  for(const btn of moveCardBtns) {
    btn.addEventListener('click', async () => {
      const cardTok = btn.dataset.cardId;
      const fz = btn.dataset.fromZone;
      const tz = btn.dataset.toZone;
      let options = {};
      try { options = JSON.parse(btn.dataset.options || '{}'); } catch(_e) { console.warn('[MoveCard] Invalid options JSON:', btn.dataset.options); }
      await handleMoveCard(cardTok, fz, tz, options);
    });
  }
}

function getAvailableDestinations(fromZone, isTokenCard) {
  const destinations = [];
  const z = String(fromZone || '');
  const isOppZone = z.startsWith('opp');
  const isEnfant = (typeof GAME_MODE !== "undefined" && GAME_MODE === "enfant");

  if (isTokenCard) {
    if (!isOppZone) {
      if (z !== 'myTerrain') destinations.push({ zone: 'myTerrain', label: '⚔️ Terrain', options: {} });
      if (!isEnfant && z !== 'myBanch') destinations.push({ zone: 'myBanch', label: '🗑️ Banc', options: {} });
    } else {
      if (z !== 'oppTerrain') destinations.push({ zone: 'oppTerrain', label: '⚔️ Terrain (adv.)', options: {} });
      if (!isEnfant && z !== 'oppBanch') destinations.push({ zone: 'oppBanch', label: '🗑️ Banc (adv.)', options: {} });
    }
    return destinations;
  }

  if (!isOppZone) {
    if (z !== 'myTerrain') destinations.push({ zone: 'myTerrain', label: '⚔️ Terrain', options: {} });
    if (z === 'myTerrain') destinations.push({ zone: 'oppTerrain', label: '🏴 Terrain adverse', options: {} });
    if (z !== 'myHand') destinations.push({ zone: 'myHand', label: '✋ Main', options: {} });
    if (z !== 'myVestiaire') destinations.push({ zone: 'myVestiaire', label: '🗂️ Vestiaire', options: {} });
    if (z !== 'myDeck') {
      destinations.push({ zone: 'myDeck', label: '📚 Deck (dessus)', options: { toTop: true } });
      destinations.push({ zone: 'myDeck', label: '📚 Deck (dessous)', options: { toBottom: true } });
    }
    if (!isEnfant && z !== 'myBanch') destinations.push({ zone: 'myBanch', label: '🗑️ Banc', options: {} });
  } else {
    if (z !== 'oppTerrain') destinations.push({ zone: 'oppTerrain', label: '⚔️ Terrain (adv.)', options: {} });
    if (z === 'oppTerrain') destinations.push({ zone: 'myTerrain', label: '🏴 Terrain (chez toi)', options: {} });
    if (z !== 'oppVestiaire') destinations.push({ zone: 'oppVestiaire', label: '🗂️ Vestiaire (adv.)', options: {} });
    if (!isEnfant && z !== 'oppBanch') destinations.push({ zone: 'oppBanch', label: '🗑️ Banc (adv.)', options: {} });
  }

  return destinations;
}

async function handleMoveCard(cardTok, fromZone, toZone, options) {
  // Anti double-clic depuis le deck: retirer visuellement tout de suite et bloquer le spam
  const tok = String(cardTok);
  const from = String(fromZone || '');

  // Optimistic UI pour le deck browser
  if (from === 'myDeck') {
    if (pendingDeckMoves.has(tok)) return;
    pendingDeckMoves.add(tok);

    // Fermer le modal immédiatement (UX plus rapide)
    try { closeCardModal(); } catch(e) {}

    // Retirer du deck localement pour éviter de pouvoir re-cliquer dessus avant refresh DB
    try {
      if (Array.isArray(myDeckPile)) {
        const i = myDeckPile.indexOf(tok);
        if (i >= 0) myDeckPile.splice(i, 1);
      }
      // Rafraîchir l'affichage du deck si le navigateur est ouvert
      try { renderDeckCards(); } catch(e) {}
    } catch(e) {}
  }

  try {
    await moveCard(tok, fromZone, toZone, options);
    // Fermer le modal si on ne vient pas du deck (le deck se ferme deja plus haut)
    if (from !== 'myDeck') { try { closeCardModal(); } catch(e) {} }
  } catch (e) {
    reportError(e, 'handleMoveCard');
    // En cas d'échec: resync pour rétablir un état propre
    try { await resyncFromDb(); } catch(_) {}
  } finally {
    if (from === 'myDeck') {
      pendingDeckMoves.delete(tok);
      // Un dernier refresh (au cas où)
      try { renderDeckCards(); } catch(e) {}
    }
  }

  // Rafraîchir le modal de zone si ouvert (vestiaire, révélée, banc, etc.)
  if (currentOpenZone) {
    const config = getZoneConfig(currentOpenZone);
    if (config) {
      renderZoneContent(currentOpenZone, config);
    }
  }
}

async function handleModifyCounter(cardId, counterType, delta, fromZone = 'myTerrain') {
  await modifyCounter(cardId, counterType, delta, fromZone);
  
  // Rafraîchir le modal de carte
  if (currentCardContext) {
    const card = cardsById.get(currentCardContext.cardId);
    if (card) {
      renderCardModalContent(card, currentCardContext.fromZone);
    }
  }
}

async function handleToggleNullified(cardTok, fromZone = 'myTerrain'){
  const tok = String(cardTok);
  const cid = getCid(tok);

  const arr = (fromZone === 'myTerrain') ? gameState.myTerrain : (fromZone === 'oppTerrain' ? gameState.oppTerrain : null);
  if(!arr) return;

  const creature = arr.find(c => (c.inst && c.inst === tok) || (!c.inst && String(c.cardId) === String(cid)));
  if(!creature) return;

  const next = !creature.nullified;
  await setCardNullified(tok, next, fromZone);

  if (currentCardContext) {
    const card = cardsById.get(currentCardContext.cardId);
    if (card) renderCardModalContent(card, currentCardContext.fromZone);
  }
}
async function handleSetNote(cardId, note, fromZone = 'myTerrain') {
  // Debounce pour éviter d'écrire en DB à chaque frappe
  if(!window.__noteDebounceTimers) window.__noteDebounceTimers = {};
  const k = `${fromZone}::${cardId}`;
  try { clearTimeout(window.__noteDebounceTimers[k]); } catch(e) {}
  window.__noteDebounceTimers[k] = setTimeout(async () => {
    try { await setCardNote(cardId, note, fromZone); } catch(e) { reportError(e, 'handleSetNote'); }
  }, 250);
}

async function handlePlayFromHand(cardTok) {
  // 🏆 GUARD : Partie terminée
  if(gameEnded){
    showToast("⏸️ La partie est terminée");
    return;
  }
  
  const cardId = getCid(cardTok);
    const card = cardsById.get(cardId);
  if (!card) return;

  // 🎯 MODE ENFANT : si un effet attend une cible, on bloque les actions
  if(pendingBlocksActions()){
    showToast("Résous l'effet en cours d'abord 🙂");
    pushLog("⏳ Effet en cours : choisis une cible");
    return;
  }
  
  // Vérifier que c'est mon tour
  const st = roomState || initialRoomState();
  const mySlot = mySlotFromState(st);
  if (getTurnPlayer(st) && getTurnPlayer(st) !== mySlot) {
    pushLog(`⏸️ Ce n'est pas ton tour (c'est à ${getTurnPlayer(st)})`);
    return;
  }

  // Timer: si ton temps est ecoule, tu ne peux plus jouer
  {
    const m = timerBlockMessage(st, mySlot);
    if(m){
      showToast(m);
      pushLog('⏱️ ' + m);
      return;
    }
  }
  
  // Vérifier le coût
  if (card.cost != null && gameState.myActionDie < card.cost) {
    pushLog(`❌ Pas assez de points d'action (${gameState.myActionDie}/${card.cost})`);
    return;
  }
  
  // Jouer la créature
  await playCreatureFromHand(cardTok, card);

  // Fermer le modal de carte
  closeCardModal();

  // Rafraîchir la main
  renderHandCards();

  // Auto-close the hand panel on successful play (thumb-friendly).
  try{
    if (panelOverlay && panelOverlay.classList.contains('open') && viewHand && !viewHand.hidden){
      closePanel();
    }
  }catch(_e){}
}

async function handlePlayFarce(cardTok) {
  const cardId = getCid(cardTok);
    const card = cardsById.get(cardId);
  if (!card) return;

  // 🎯 MODE ENFANT : si un effet attend une cible, on bloque les actions
  if(pendingBlocksActions()){
    showToast("Résous l'effet en cours d'abord 🙂");
    pushLog("⏳ Effet en cours : choisis une cible");
    return;
  }
  
  // Vérifier que c'est mon tour
  const st = roomState || initialRoomState();
  const mySlot = mySlotFromState(st);
  if (getTurnPlayer(st) && getTurnPlayer(st) !== mySlot) {
    pushLog(`⏸️ Ce n'est pas ton tour (c'est à ${getTurnPlayer(st)})`);
    return;
  }

  // Timer: si ton temps est ecoule, tu ne peux plus jouer
  {
    const m = timerBlockMessage(st, mySlot);
    if(m){
      showToast(m);
      pushLog('⏱️ ' + m);
      return;
    }
  }

  // Vérifier le coût
  if (card.cost != null && gameState.myActionDie < card.cost) {
    pushLog(`❌ Pas assez de points d'action (${gameState.myActionDie}/${card.cost})`);
    return;
  }

  // 🎯 MODE ENFANT : si la carte a un effet, demander AVANT de la jouer.
  let enfantEffectChoice = "yes"; // yes = jouer + effet
  const isEnfant = (typeof GAME_MODE !== "undefined" && GAME_MODE === "enfant");
  const effectIdPre = (card && card.effectId) ? String(card.effectId) : "";
  if (isEnfant && effectIdPre && effectIdPre !== "E_NONE") {
    enfantEffectChoice = await showChoiceModal({
      title: "Activer cet effet ?",
      body: (card?.name ? (card.name + "\n\n") : "") + (card?.text || ""),
      buttons: [
        { key: "cancel", label: "Annuler" },
        { key: "no", label: "Non" },
        { key: "yes", label: "Oui" }
      ]
    });

    if (enfantEffectChoice === "cancel") {
      pushLog(`↩️ ${card?.name || "Carte"} : action annulée`);
      return;
    }
  }

// ✅ PATCH 4 : mutations locales APRÈS la confirmation DB (pas avant)
  // Retirer de la main + payer le coût uniquement si l'écriture a réussi
  const slot = mySlotFromState(roomState);
  if(slot) {
    try {
      await updateRoomState((s) => {
        // Retirer de la main (DB autoritaire)
        s.handPiles = s.handPiles || { A: [], B: [] };
        const hi = (s.handPiles[slot] || []).indexOf(cardTok);
        if(hi >= 0) s.handPiles[slot].splice(hi, 1);
        else { s.__skipWrite = true; return s; } // idempotent : déjà retiré

        // Ajouter au vestiaire
        if(!s.vestiaires) s.vestiaires = { A: [], B: [] };
        s.vestiaires[slot].push(cardTok);
        
        // Payer le coût
        if(card.cost != null && card.cost > 0){
          if(!s.actionDice) s.actionDice = { A: 0, B: 0 };
          s.actionDice[slot] = Math.max(0, (s.actionDice[slot] || 0) - card.cost);
        }
        
        return s;
      }, "play-farce");

      // ✅ Mutations locales uniquement après succès DB
      const hi2 = myHandPile.indexOf(cardTok);
      if (hi2 >= 0) myHandPile.splice(hi2, 1);

      if (card.cost != null && card.cost > 0) {
        gameState.myActionDie = Math.max(0, gameState.myActionDie - card.cost);
        updateActionDieUI();
      }
    } catch(e) {
      reportError(e, "handlePlayFarce");
      // pas de mutation locale → l'UI reste cohérente avec le DB
    }
  }
  
  pushLog(`✨ ${slotLabel(mySlotFromState(roomState))} ${card.name} joué (Farce → Vestiaire)`);
  // 🎯 MODE ENFANT : déclencher l'effet (Farce) puis passer le tour automatiquement
  try{
    const isEnfant2 = (typeof GAME_MODE !== "undefined" && GAME_MODE === "enfant");
    if(isEnfant2){
      const effectId = (card && card.effectId) ? String(card.effectId) : "";
      if(effectId && effectId !== "E_NONE"){
        if(enfantEffectChoice === "yes"){
          // CRITIQUE: cardTok de la main n'est pas l'inst, chercher le vrai inst dans le terrain
          const stNow = roomState || initialRoomState();
          const terrain = stNow.terrains?.[mySlot] || [];
          const lastCreature = terrain[terrain.length - 1];
          const actualToken = (lastCreature?.cardId === cardId && lastCreature?.inst) ? lastCreature.inst : cardTok;
          await triggerCardEffect(cardId, mySlot, actualToken); // résout + passe le tour
        } else {
          pushLog(`🚫 ${card?.name || cardId} : effet ignoré`);
          await autoPassTurn(mySlot);
        }
      } else {
        await autoPassTurn(mySlot);
      }
    }
  }catch(_e){ /* silent */ }

  
  // Fermer le modal de carte
  closeCardModal();
  
  // Rafraîchir
  renderHandCards();
  updateAllZoneCounters();
  updateLocalUI();
}
function getZoneConfig(zoneId) {
  const configs = {
    'oppDeck': { title: 'Deck Adversaire', count: oppDeckCount?.textContent || 0, canInteract: false },
    'oppChief': { title: 'Chef Adversaire', count: 1, canInteract: false },
    'oppTerrain': { title: 'Terrain Adversaire', count: gameState.oppTerrain.length, canInteract: false },
    'oppVestiaire': { title: 'Vestiaire Adversaire', count: gameState.oppVestiaireCount, canInteract: true },
    'oppBanch': { title: 'Banc Adversaire', count: gameState.oppBanchCount, canInteract: true },
    'oppRevealed': { title: 'Carte Révélée Adversaire', count: gameState.oppRevealedCount, canInteract: false },
    'oppBubble': { title: 'Bulle Adversaire', count: gameState.oppPassDie, canInteract: false },
    'myDeck': { title: 'Mon Deck', count: myDeckPile.length, canInteract: true },
    'myChief': { title: 'Mon Chef', count: 1, canInteract: true },
    'myTerrain': { title: 'Mon Terrain', count: gameState.myTerrain.length, canInteract: true },
    'myVestiaire': { title: 'Mon Vestiaire', count: gameState.myVestiaire.length, canInteract: true },
    'myBanch': { title: 'Mon Banc', count: gameState.myBanch.length, canInteract: true },
    'myRevealed': { title: 'Ma Carte Révélée', count: gameState.myRevealed.length, canInteract: true },
    'myBubble': { title: 'Ma Bulle', count: gameState.myPassDie, canInteract: true }
  };
  return configs[zoneId];
}

// ===== Zone Modals System =====
const zoneModal = $("zoneModal");
const zoneModalTitle = $("zoneModalTitle");
const zoneModalCount = $("zoneModalCount");
const zoneModalBody = $("zoneModalBody");

let currentOpenZone = null;

function openZoneModal(zoneId) {
  // Anti "click-through" : sur mobile, un tap qui ouvre un panel peut aussi déclencher
  // un bouton situé dessous. On bloque UNIQUEMENT l'ouverture des zones adverses
  // (ex: "Deck adversaire" en spam). Les zones du joueur doivent rester accessibles.
  try{
    const shieldOn = (window.__uiShieldActive && window.__uiShieldActive());
    if(shieldOn){
      const z = String(zoneId||"");
      if(z.startsWith("opp")) return;
    }
  }catch(_e){}
  // 🔧 Fermer toujours le tooltip pixi avant d'ouvrir un modal (évite l'élément bloqué en portrait)
  try{ const hv = document.getElementById('pixiHoverCard'); if(hv) hv.style.display='none'; }catch(_e){}

  try{ if(zoneId==="myTerrain" || zoneId==="oppTerrain") migrateTerrainInstances(zoneId); }catch(e){}

  if (!zoneModal) return;
  
  currentOpenZone = zoneId;
  
  // Titre et compteur selon la zone
  const zoneConfig = {
    // Adversaire
    'oppDeck': { title: 'Deck Adversaire', count: oppDeckCount?.textContent || 0, canInteract: false },
    'oppChief': { title: 'Chef Adversaire', count: 1, canInteract: false },
    'oppTerrain': { title: 'Terrain Adversaire', count: gameState.oppTerrain.length, canInteract: false },
    'oppVestiaire': { title: 'Vestiaire Adversaire', count: gameState.oppVestiaireCount, canInteract: true },
    'oppBanch': { title: 'Banc Adversaire', count: gameState.oppBanchCount, canInteract: true },
    'oppRevealed': { title: 'Carte Révélée Adversaire', count: gameState.oppRevealedCount, canInteract: false },
    'oppBubble': { title: 'Bulle Adversaire', count: gameState.oppPassDie, canInteract: false },
    
    // Joueur
    'myDeck': { title: 'Mon Deck', count: myDeckPile.length, canInteract: true },
    'myChief': { title: 'Mon Chef', count: 1, canInteract: true },
    'myTerrain': { title: 'Mon Terrain', count: gameState.myTerrain.length, canInteract: true },
    'myVestiaire': { title: 'Mon Vestiaire', count: gameState.myVestiaire.length, canInteract: true },
    'myBanch': { title: 'Mon Banc', count: gameState.myBanch.length, canInteract: true },
    'myRevealed': { title: 'Ma Carte Révélée', count: gameState.myRevealed.length, canInteract: true },
    'myBubble': { title: 'Ma Bulle', count: gameState.myPassDie, canInteract: true }
  };
  
  const config = zoneConfig[zoneId];
  if (!config) return;
  
  safeText(zoneModalTitle, config.title);
  safeText(zoneModalCount, config.count);
  
  // Générer contenu
  renderZoneContent(zoneId, config);
  
  // Ouvrir modal
  zoneModal.classList.add('open');
}

async function closeZoneModal() {
  if (!zoneModal) return;
  
  // Auto-mélanger SEULEMENT le deck quand on ferme le modal (PAS le vestiaire)
  if (currentOpenZone === 'myDeck' && !window.__deckJustShuffled) {
    console.log('🔀 [AUTO] Mélange automatique du deck à la fermeture');
    const st = roomState || initialRoomState();
    const slot = mySlotFromState(st);
    
    if (slot) {
      try {
        await updateRoomState((s) => {
          if (!s.deckPiles) s.deckPiles = { A: [], B: [] };
          
          const deck = s.deckPiles[slot] || [];
          
          if (deck.length > 0) {
            // Mélanger SEULEMENT le deck (PAS le vestiaire)
            const shuffled = shuffleInPlace(deck.slice());
            s.deckPiles[slot] = shuffled;
            
            // Update counts
            if (s.players?.[slot]) {
              s.players[slot].deckCount = shuffled.length;
            }
            
            console.log(`🔀 [AUTO] Deck mélangé: ${shuffled.length} cartes`);
          }
          
          return s;
        }, 'auto-shuffle-deck');
      } catch(e) {
        console.error("Erreur auto-shuffle:", e);
      }
    }
  }
  
  zoneModal.classList.remove('open');
  currentOpenZone = null;
}

function renderZoneContent(zoneId, config) {
  if (!zoneModalBody) return;
  
  zoneModalBody.innerHTML = '';
  
  // 1. BOUTONS D'ACTIONS DE ZONE (en haut)
  const actionsDiv = renderZoneActions(zoneId, config.canInteract);
  if (actionsDiv) {
    zoneModalBody.appendChild(actionsDiv);
  }
  
  // 2. CONTENU DE LA ZONE (cartes)
  switch(zoneId) {
    case 'myChief':
      renderChiefZone(gameState.myChief, gameState.myActionDie, true, 'myChief');
      break;
    case 'oppChief':
      renderChiefZone(gameState.oppChief, gameState.oppActionDie, false, 'oppChief');
      break;
    case 'myBubble':
      renderBubbleZone(gameState.myPassDie, true);
      break;
    case 'oppBubble':
      renderBubbleZone(gameState.oppPassDie, false);
      break;
    case 'myTerrain':
      renderTerrainZone(gameState.myTerrain, 'myTerrain');
      break;
    case 'oppTerrain':
      renderTerrainZone(gameState.oppTerrain, 'oppTerrain');
      break;
    case 'myVestiaire':
      renderCardListZone(gameState.myVestiaire, 'Vestiaire', true);
      break;
    case 'oppVestiaire':
      renderCardListZone(gameState.oppVestiaire, 'Vestiaire Adversaire', false);
      break;
    case 'myBanch':
      renderCardListZone(gameState.myBanch, 'Banc', true);
      break;
    case 'oppBanch':
      renderCardListZone(gameState.oppBanch, 'Banc Adversaire', false);
      break;
    case 'myRevealed':
      renderCardListZone(gameState.myRevealed, 'Révélée', true);
      break;
    case 'myDeck':
      renderDeckZone();
      break;
    default:
      renderEmptyZone(config.title);
  }
}

function renderZoneActions(zoneId, canInteract) {
  if (!canInteract) return null;
  
  const div = document.createElement('div');
  div.className = 'zone-actions';
  
  let buttons = [];
  
  switch(zoneId) {
    case 'myDeck':
      buttons = [
        { label: '📥 Piocher 1', onclick: 'drawCardsManual(1)' },
        { label: '🎴 Piocher X', onclick: 'promptDrawX()' },
        { label: '🔍 Voir deck', onclick: 'openDeckBrowser()' },
        { label: '👁️ Révéler dessus', onclick: 'revealTopDeck()' },
        { label: '🔀 Mélanger', onclick: 'shuffleDeck()' },
        { label: '✂️ Couper', onclick: 'cutDeck()' },
        { label: '♻️ Reformer', onclick: 'reformDeckFromVestiaire()' }
      ];
      break;
      
    case 'myTerrain':
      buttons = [
        { label: '🧹 Nettoyage', onclick: 'cleanupTerrain("myTerrain")' },
        { label: '↺ Redresser tout', onclick: 'untapAll("myTerrain")' },
        { label: '✨ Créer Token', onclick: 'promptCreateToken("myTerrain")' }
      ];
      break;

    case 'oppTerrain':
      buttons = [
        { label: '🧹 Nettoyage (adverse)', onclick: 'cleanupTerrain("oppTerrain")' },
        { label: '↺ Redresser tout (adverse)', onclick: 'untapAll("oppTerrain")' },
        { label: '✨ Créer Token (adverse)', onclick: 'promptCreateToken("oppTerrain")' }
      ];
      break;
      
    case 'myVestiaire':
      buttons = [
        { label: '♻️ Reformer deck', onclick: 'reformDeckFromVestiaire()' }
      ];
      break;
      
    case 'myRevealed':
      buttons = [
        { label: '👋 Tout → Main', onclick: 'moveAllCards(\"myRevealed\", \"myHand\")' },
        { label: '🗑️ Tout → Vestiaire', onclick: 'moveAllCards(\"myRevealed\", \"myVestiaire\")' },
        { label: '📚 Tout → Deck', onclick: 'moveAllCards(\"myRevealed\", \"myDeck\")' }
      ];
      break;
  }
  
  for (const btn of buttons) {
    const button = document.createElement('button');
    button.className = 'zone-action-btn';
    button.textContent = btn.label;
    button.onclick = new Function(btn.onclick);
    div.appendChild(button);
  }
  
  return buttons.length > 0 ? div : null;
}

function promptDrawX() {
  const count = prompt('Piocher combien de cartes ?', '3');
  if (count) {
    const n = parseInt(count, 10);
    if (n > 0) {
      drawCardsManual(n);
      closeZoneModal();
    }
  }
}

function promptCreateToken(zoneId = 'myTerrain') {
  // Liste des tokens disponibles
  const tokens = [];
  for (const [id, card] of cardsById.entries()) {
    if (isToken(card)) {
      tokens.push({ id, name: card.name });
    }
  }
  
  if (tokens.length === 0) {
    alert('Aucun token trouvé dans cards.json');
    return;
  }
  
  let message = 'Choisir un token :\n\n';
  tokens.forEach((t, i) => {
    message += `${i + 1}. ${t.name}\n`;
  });
  
  const choice = prompt(message, '1');
  if (choice) {
    const index = parseInt(choice, 10) - 1;
    if (index >= 0 && index < tokens.length) {
      createToken(tokens[index].id, zoneId);
      closeZoneModal();
    }
  }
}
function renderChiefZone(chiefId, actionDie, isMine, zoneId = (window.currentOpenZone || (isMine ? 'myChief' : 'oppChief'))) {
  const div = document.createElement('div');

  const _role = mySlotFromState(roomState);
  const canModify = (_role && _role !== 'spectator');

  if (!chiefId) {
    div.innerHTML = `<div class="zone-empty">
      <div class="zone-empty-icon">👑</div>
      <div class="zone-empty-text">Chef d'équipe non sélectionné</div>
    </div>`;
    zoneModalBody.appendChild(div);
    return;
  }

  const chief = cardsById.get(chiefId);
  if (!chief) return;

  // NOTE CHEF (persistante) : même logique que les notes de créature (source de vérité = roomState)
  // On évite de dépendre de gameState.myChiefNote/oppChiefNote qui peut être écrasé / non initialisé.
  let noteVal = '';
  try{
    const st = roomState || initialRoomState();
    const slot = slotForZone(zoneId);
    noteVal = (st.chiefNotes && slot) ? (st.chiefNotes[slot] || '') : '';
  }catch(_e){ noteVal = ''; }

  div.innerHTML = `
    <div class="game-card-list">
      <div class="game-card chief-card">
        <div class="card-name">${escapeHtml(chief.name)}</div>
        ${chief.cost != null ? `<div style="background:rgba(255,215,0,.2);border:2px solid rgba(255,215,0,.5);border-radius:50%;width:40px;height:40px;display:inline-flex;align-items:center;justify-content:center;font-size:18px;font-weight:900;color:#ffd700;margin:8px 0;">${chief.cost}</div>` : ''}
        <div class="card-type">${escapeHtml(chief.type || "Chef d'équipe")}</div>
        <div class="card-text">${escapeHtml(chief.text || '')}</div>
      </div>
    </div>

    <div class="action-die-display">
      <div class="die-value" id="modalActionDie">${actionDie}</div>
      ${canModify ? `
        <div class="die-controls">
          <button class="die-btn" onclick="modifyActionDie(1)" title="Ajouter 1">+</button>
          <button class="die-btn" onclick="modifyActionDie(-1)" title="Retirer 1">−</button>
        </div>
      ` : ''}
    </div>

    <div class="note-section">
      <div class="card-actions-title">📝 Note</div>
      <textarea class="note-input" placeholder="Note libre (Chef)"
        oninput="handleChiefNoteInput('${zoneId}', this.value)"
        onblur="handleSetChiefNote('${zoneId}', this.value)"
        onchange="handleSetChiefNote('${zoneId}', this.value)">${escapeHtml(noteVal)}</textarea>
    </div>
  `;

  zoneModalBody.appendChild(div);
}
function renderBubbleZone(passDie, isMine) {
  const div = document.createElement('div');

  const _role = mySlotFromState(roomState);
  const canModify = (_role && _role !== 'spectator');
  
  div.innerHTML = `
    <div class="action-die-display">
      <div class="die-value" id="modalPassDie">${passDie}</div>
      ${canModify ? `
        <div class="die-controls">
          <button class="die-btn" onclick="modifyPassDie(1)" title="Ajouter 1">+</button>
          <button class="die-btn" onclick="modifyPassDie(-1)" title="Retirer 1">−</button>
        </div>
      ` : ''}
    </div>
    <div style="text-align:center; opacity:0.8; margin-top:16px;">
      ${isMine ? 'Tes passes accumulées' : 'Passes adverses'}
    </div>
    ${isMine ? `
      <div style="margin-top:24px;">
        <div style="font-size:13px; font-weight:700; margin-bottom:8px; opacity:0.8;">État de la Bulle</div>
        <input type="text" 
          style="width:100%; padding:10px; border-radius:8px; border:1.5px solid rgba(255,255,255,.2); background:rgba(255,255,255,.08); color:#fff; font-size:13px; font-weight:600;"
          placeholder="Ex: glace, roche, eau..."
          value="${escapeHtml(gameState.bulleStateLabel || '')}"
          onchange="handleBulleStateChange(this.value)"
        />
      </div>
      <div style="margin-top:24px;">
        <div style="font-size:13px; font-weight:700; margin-bottom:8px; opacity:0.8;">Occurrences cette manche</div>
        <div style="display:flex; align-items:center; gap:10px;">
          <button class="die-btn" onclick="modifyOccurrences(-1)">−</button>
          <span style="font-size:20px; font-weight:900; color:#4ac3ff; min-width:40px; text-align:center;">${gameState.occurrencesThisRound || 0}</span>
          <button class="die-btn" onclick="modifyOccurrences(1)">+</button>
          <button class="zone-action-btn" style="margin-left:10px;" onclick="resetOccurrences()">Reset</button>
        </div>
      </div>
    ` : ''}
  `;
  
  zoneModalBody.appendChild(div);
}

function handleBulleStateChange(value) {
  gameState.bulleStateLabel = value;
  pushLog(`Bulle: ${value || '(vide)'}`);
  updateLocalUI();
}

function modifyOccurrences(delta) {
  gameState.occurrencesThisRound = Math.max(0, Math.min(999, (gameState.occurrencesThisRound || 0) + delta));
  
  // Rafraîchir le modal si ouvert
  if (currentOpenZone === 'myBubble') {
    renderZoneContent('myBubble', { title: 'Ma Bulle', count: gameState.myPassDie, canInteract: true });
  }
  
  pushLog(`Occurrences: ${gameState.occurrencesThisRound}`);
  updateLocalUI();
}

function resetOccurrences() {
  gameState.occurrencesThisRound = 0;
  
  // Rafraîchir le modal si ouvert
  if (currentOpenZone === 'myBubble') {
    renderZoneContent('myBubble', { title: 'Ma Bulle', count: gameState.myPassDie, canInteract: true });
  }
  
  pushLog(`Occurrences réinitialisées`);
  updateLocalUI();
}
function renderTerrainZone(terrain, zoneId) {
  const zoneSlot = slotForZone(zoneId);

  if (terrain.length === 0) {
    renderEmptyZone('Terrain');
    return;
  }

  const div = document.createElement('div');
  div.className = 'game-card-list';

  for (const creature of terrain) {
    const card = cardsById.get(creature.cardId);
    if (!card) continue;

    const cardDiv = document.createElement('div');
    cardDiv.className = `game-card ${creature.tapped ? 'tapped' : ''}`;
    cardDiv.dataset.cardId = creature.cardId;

    // Badge "modifié par" si dernier acteur différent du propriétaire de la zone
    let touchedBadge = '';

    // Badge "effets annulés"
    let nullifiedBadge = '';
    if (creature.nullified) {
      nullifiedBadge = `<span style="position:absolute;left:8px;top:8px;background:rgba(0,0,0,.38);border:1px solid rgba(255,255,255,.18);backdrop-filter: blur(6px);padding:2px 6px;border-radius:999px;font-size:10px;font-weight:900;">🚫</span>`;
    }
    if (creature.lastBy && zoneSlot && creature.lastBy !== zoneSlot) {
      touchedBadge = `<span style="position:absolute;right:8px;top:8px;background:rgba(0,0,0,.35);border:1px solid rgba(255,255,255,.18);backdrop-filter: blur(6px);padding:2px 6px;border-radius:999px;font-size:10px;font-weight:800;">✋${escapeHtml(creature.lastBy)}</span>`;
    }

    // Afficher les marqueurs s'ils existent
    let countersHTML = '';
    if (creature.counters) {
      const c = creature.counters;
      if (c.pass > 0) countersHTML += `<span style="background:rgba(255,215,0,.3);padding:2px 6px;border-radius:4px;font-size:10px;font-weight:700;margin-right:4px;">⚡${c.pass}</span>`;
      if (c.charge > 0) countersHTML += `<span style="background:rgba(100,149,237,.3);padding:2px 6px;border-radius:4px;font-size:10px;font-weight:700;margin-right:4px;">🔋${c.charge}</span>`;
      if (c.time > 0) countersHTML += `<span style="background:rgba(255,99,71,.3);padding:2px 6px;border-radius:4px;font-size:10px;font-weight:700;margin-right:4px;">⏱️${c.time}</span>`;
    }

    // Note
    let noteHTML = '';
    if (creature.note) {
      noteHTML = `<div style="background:rgba(255,255,255,.1);padding:4px 8px;border-radius:6px;font-size:10px;margin-top:6px;font-weight:600;">${escapeHtml(creature.note)}</div>`;
    }
	  	const isEnfant = (typeof GAME_MODE !== "undefined" && GAME_MODE === "enfant") || (roomState && roomState.gameMode === "enfant");
	  	if(isEnfant){
	  	  cardDiv.classList.add('enfantArtOnly');
	  	  const s = safeImageSrc(card.image || '');
	  	  const src = s || '/assets/cards/placeholder.jpg';
	  	  // Image + boutons utiles (tap + badges)
	  	  cardDiv.innerHTML = `
	  	    <div class="cardArt"><img src="${escapeHtml(src)}" alt="${escapeHtml(card.name || '')}" loading="lazy" decoding="async" onerror="this.onerror=null;this.src='/assets/cards/placeholder.jpg';"></div>
	  	    <div class="enfantCardName">${escapeHtml(card.name || '')}</div>
	  	    <button class="terrain-tap-btn" style="display:none" onclick="event.stopPropagation(); window.toggleCreatureTap('${(creature.inst || creature.cardId)}', '${zoneId}')" title="${creature.tapped ? 'Redresser' : 'Coucher'}">
	  	      ${creature.tapped ? '↺' : '↷'}
	  	    </button>
	  	    ${nullifiedBadge}
	  	    ${touchedBadge}
	  	    ${countersHTML ? `<div class="enfantCounters">${countersHTML}</div>` : ''}
	  	  `;
	  	} else {
	  	  cardDiv.innerHTML = `
	  	    ${card.cost != null ? `<div class="card-cost">${card.cost}</div>` : ''}
	  	    <div class="card-name">${escapeHtml(card.name)}</div>
	  	    <button class="terrain-tap-btn" style="display:none" onclick="event.stopPropagation(); window.toggleCreatureTap('${(creature.inst || creature.cardId)}', '${zoneId}')" title="${creature.tapped ? 'Redresser' : 'Coucher'}">
	  	      ${creature.tapped ? '↺' : '↷'}
	  	    </button>
	  	    ${nullifiedBadge}
	  	    ${touchedBadge}
	  	    <div class="card-type">${escapeHtml(card.type || 'Créature')}</div>
	  	    ${card.subtypes && card.subtypes.length ? `
	  	      <div class="card-subtypes">${card.subtypes.map(escapeHtml).join(' ')}</div>
	  	    ` : ''}
	  	    ${countersHTML ? `<div style="margin:6px 0;">${countersHTML}</div>` : ''}
	  	    ${noteHTML}
	  	    <div class="card-text" style="font-size:9px;margin-top:4px;opacity:0.8;">${escapeHtml((card.text || '').substring(0, 80))}${(card.text || '').length > 80 ? '...' : ''}</div>
	  	  `;
	  	}

    // Libre total : clic = ouvrir menu (moi OU adversaire)
    cardDiv.style.cursor = 'pointer';
    cardDiv.onclick = (e) => {
      e.stopPropagation();
      // Instance-safe: ouvrir le modal sur l'instance exacte si dispo
      const cardTok = (creature && (creature.inst || creature.cardId)) || creature.cardId;
      console.log('[TERRAIN CLICK] creature:', {inst: creature?.inst, cardId: creature?.cardId});
      console.log('[TERRAIN CLICK] Passing cardTok:', cardTok);
      openCardModal(cardTok, zoneId);
    };

    div.appendChild(cardDiv);
  }

  zoneModalBody.appendChild(div);

  // 🔧 Masquer les zone-actions (nettoyage, token, redresser tout)
  try {
    const actionsDiv = zoneModalBody.querySelector('.zone-actions');
    if(actionsDiv) actionsDiv.style.display = 'none';
  } catch(_e) {}

  // PixiJS bridge (read-only overlay)
  try { window.__pixiRenderTerrain && window.__pixiRenderTerrain(zoneId, terrain); } catch(e) {}
}
function renderCardListZone(cardList, zoneName, isMine) {
  if (cardList.length === 0) {
    renderEmptyZone(zoneName);
    return;
  }

  // Mode enfant: on préfère afficher les cartes en "full art" (comme la main)
  const isEnfant = (typeof GAME_MODE !== 'undefined' && GAME_MODE === 'enfant') || (roomState && roomState.gameMode === 'enfant');
  
  const div = document.createElement('div');
  div.className = 'game-card-list';
  
  // Déterminer la zone pour le modal
  let zoneId = null;
  if (zoneName === 'Vestiaire') zoneId = 'myVestiaire';
  else if (zoneName === 'Vestiaire Adversaire') zoneId = 'oppVestiaire';
  else if (zoneName === 'Banc') zoneId = 'myBanch';
  else if (zoneName === 'Banc Adversaire') zoneId = 'oppBanch';
  else if (zoneName === 'Révélée') zoneId = 'myRevealed';
  
  for (const cardTok of cardList) {
    const cardId = getCid(cardTok);
    const card = cardsById.get(cardId);
    if (!card) continue;

    const cardDiv = document.createElement('div');

    if (isEnfant) {
      // Même composant visuel que la main: image full + pas de texte
      cardDiv.className = 'handCard enfantArtOnly';
      const artWrap = document.createElement('div');
      artWrap.className = 'cardArt';
      const img = document.createElement('img');
      img.alt = card.name || 'Carte';
      img.loading = 'lazy';
      img.decoding = 'async';
      img.referrerPolicy = 'no-referrer';
      img.src = (function(){
        const raw = (card.image || card.img || card.thumbnail || '');
        const s = safeImageSrc(raw);
        // Prefer assets/... inside /public, else public/assets/...
        const inPublic = (location && location.pathname && location.pathname.includes('/public/'));
        let primary = s || (inPublic ? (raw || 'assets/cards/placeholder.jpg') : ('public/' + (raw || 'assets/cards/placeholder.jpg')));
        primary = String(primary).replace(/^\/+/, '');
        return primary;
      })();
      img.onerror = () => {
        img.onerror = null;
        // second chance: swap between assets/ and public/assets
        const cur = String(img.src || '');
        if (cur.includes('/public/assets/')) img.src = cur.replace('/public/assets/', '/assets/');
        else if (cur.includes('/assets/')) img.src = cur.replace('/assets/', '/public/assets/');
        else img.src = 'assets/cards/placeholder.jpg';
      };
artWrap.appendChild(img);
      cardDiv.appendChild(artWrap);
      // Nom de carte (enfant) — label transparent en bas
      const nameLabel = document.createElement("div");
      nameLabel.className = "enfantCardName";
      nameLabel.textContent = card.name || "";
      cardDiv.appendChild(nameLabel);
    } else {
      cardDiv.className = 'game-card';
      if (card.type && card.type.includes('Token')) {
        cardDiv.classList.add('token-card');
      }
      cardDiv.innerHTML = `
        ${card.cost != null ? `<div class="card-cost">${card.cost}</div>` : ''}
        <div class="card-name">${escapeHtml(card.name)}</div>
        <div class="card-type">${escapeHtml(card.type || 'Carte')}</div>
        ${card.subtypes && card.subtypes.length ? `
          <div class="card-subtypes">${card.subtypes.map(escapeHtml).join(' ')}</div>
        ` : ''}
        <div class="card-text" style="font-size:10px;">${escapeHtml((card.text || '').substring(0, 100))}${(card.text || '').length > 100 ? '...' : ''}</div>
      `;
    }
    
    // Clic pour ouvrir le modal de carte (permission même pour cartes adversaires en lecture seule)
    if (zoneId) {
      cardDiv.style.cursor = 'pointer';
      cardDiv.onclick = (e) => {
        e.stopPropagation();
        openCardModal(cardTok, zoneId);
      };
    }
    
    div.appendChild(cardDiv);
  }
  
  zoneModalBody.appendChild(div);
}
function renderDeckZone() {
  const div = document.createElement('div');
  div.innerHTML = `
    <div class="zone-empty">
      <div class="zone-empty-icon">🎴</div>
      <div class="zone-empty-text">
        ${myDeckPile.length} carte(s) dans le deck<br/>
        <small style="opacity:0.7;">(Face cachée — playtest)</small>
        <div style="margin-top:12px;">
          <button class="zone-action-btn" onclick="openDeckBrowser();">🔍 Parcourir le deck</button>
          <button class="zone-action-btn" onclick="shuffleMyDeck();" style="margin-top:8px;">🔀 Mélanger le deck</button>
        </div>
      </div>
    </div>
  `
  zoneModalBody.appendChild(div);
}

function renderEmptyZone(zoneName) {
  zoneModalBody.innerHTML = `
    <div class="zone-empty">
      <div class="zone-empty-text">${zoneName} vide</div>
    </div>
  `;
}

// ===== Mélanger le deck =====
async function shuffleMyDeck() {
  const st = roomState || initialRoomState();
  const slot = mySlotFromState(st);

  if (!slot) {
    pushLog("⚠️ Slot non défini");
    return;
  }

  try {
    await updateRoomState((s) => {
      if (!s.deckPiles) s.deckPiles = { A: [], B: [] };
      // IMPORTANT: on mélange uniquement le DECK — le Vestiaire reste intact
      const deck = Array.isArray(s.deckPiles[slot]) ? s.deckPiles[slot].slice() : [];
      if (deck.length === 0) return s;

      s.deckPiles[slot] = shuffleInPlace(deck);

      if (s.players?.[slot]) {
        s.players[slot].deckCount = s.deckPiles[slot].length;
      }
      return s;
    }, 'shuffle-deck');

    pushLog(`🔀 Deck mélangé`);
  } catch (e) {
    console.error("Erreur shuffle deck:", e);
    pushLog("❌ Erreur lors du mélange");
  }

  // Marquer qu'on vient de mélanger manuellement (évite l'auto-mélange à la fermeture)
  window.__deckJustShuffled = true;
  setTimeout(() => { window.__deckJustShuffled = false; }, 500);

  // Fermer le modal
  closeZoneModal();
}

// ===== Actions de dés =====
// Processing flags to prevent spam
let modifyingActionDie = false;
let modifyingPassDie = false;
let togglingCreature = false;

let terrainInstMigrationInFlight = false;
async function migrateTerrainInstances(zoneId){
  try{
    const slot = slotForZone(zoneId);
    if(!slot) return;
    const st = roomState || initialRoomState();
    const terr = st.terrains && st.terrains[slot];
    if(!Array.isArray(terr) || terr.length===0) return;
    if(!terr.some(c => c && typeof c==='object' && !c.inst)) return;
    if(terrainInstMigrationInFlight) return;
    terrainInstMigrationInFlight = true;
    await updateRoomState((s)=>{
      ensureTerrainInstances(s, slot);
      return s;
    }, 'migrate-terrain-inst');
    // force an immediate local refresh
    if(window.forceResync) await window.forceResync();
  }catch(e){
    // non-fatal
    try{ reportError(e,'migrate-terrain-inst'); }catch(_){ }
  }finally{
    terrainInstMigrationInFlight = false;
  }
}
window.migrateTerrainInstances = migrateTerrainInstances;

async function modifyActionDie(delta, zoneId = (window.currentOpenZone || 'myChief')) {
  if (modifyingActionDie) return;
  modifyingActionDie = true;
  
  try {
    const me = mySlotFromState(roomState);
    if(!me || me === 'spectator') return;

    // Déterminer quel joueur on modifie selon la zone ouverte
    const target = (String(zoneId).startsWith('opp')) ? (me === 'A' ? 'B' : 'A') : me;

    const current = (roomState?.actionDice?.[target] ?? (target === me ? gameState.myActionDie : gameState.oppActionDie) ?? 0);
    const newValue = Math.max(0, current + delta);

    await updateRoomState((s) => {
      if(!s.actionDice) s.actionDice = { A: 0, B: 0 };
      s.actionDice[target] = newValue;
      return s;
    }, "modify-action-die");

    // Sync from roomState (source of truth)
    if(roomState?.actionDice) {
      if(target === me) gameState.myActionDie = roomState.actionDice[target];
      else gameState.oppActionDie = roomState.actionDice[target];
    }

    pushLog(`Dé d'actions ${target === me ? '' : '(adverse)'}: ${newValue}`);
    addToHistory(`PA ${delta > 0 ? '+' : ''}${delta} → ${newValue}`);

    const modalActionDie = document.getElementById("modalActionDie");
    if(modalActionDie) modalActionDie.textContent = newValue;
    updateAllZoneCounters();
  } finally {
    modifyingActionDie = false;
  }
}

async function modifyPassDie(delta, zoneId = (window.currentOpenZone || 'myBubble')) {
  if (modifyingPassDie) return;
  modifyingPassDie = true;
  
  try {
    const me = mySlotFromState(roomState);
    if(!me || me === 'spectator') return;

    const target = (String(zoneId).startsWith('opp')) ? (me === 'A' ? 'B' : 'A') : me;

    const current = (roomState?.passDice?.[target] ?? (target === me ? gameState.myPassDie : gameState.oppPassDie) ?? 0);
    const newValue = Math.max(0, current + delta);

    await updateRoomState((s) => {
      if(!s.passDice) s.passDice = { A: 0, B: 0 };
      s.passDice[target] = newValue;
      return s;
    }, "modify-pass-die");

    // Sync from roomState (source of truth)
    if(roomState?.passDice) {
      if(target === me) gameState.myPassDie = roomState.passDice[target];
      else gameState.oppPassDie = roomState.passDice[target];
    }

    pushLog(`Dé de passes ${target === me ? '' : '(adverse)'}: ${newValue}`);
    addToHistory(`Passes ${delta > 0 ? '+' : ''}${delta} → ${newValue}`);

    const modalPassDie = document.getElementById("modalPassDie");
    if(modalPassDie) modalPassDie.textContent = newValue;
    updateAllZoneCounters();
  } finally {
    modifyingPassDie = false;
  }
}

// ===== Actions terrain =====
async function toggleCreatureTap(cardTok, zoneId = 'myTerrain') {
  if (togglingCreature) return;
  togglingCreature = true;

  try {
    const slot = slotForZone(zoneId);
    if (!slot) return;

    const tok = String(cardTok);
    const cid = getCid(tok);

    await updateRoomState((s) => {
      if (!s.terrains) s.terrains = { A: [], B: [] };
      if (!s.terrains[slot]) s.terrains[slot] = [];
      ensureTerrainInstances(s, slot);

      const creature = (s.terrains[slot] || []).find(c =>
        c && typeof c === 'object' &&
        ((c.inst && c.inst === tok) || (!c.inst && String(c.cardId) === String(cid)))
      );

      if (creature) {
        creature.tapped = !creature.tapped;
        const actor = mySlotFromState(roomState || s);
        if (actor && actor !== 'spectator') creature.lastBy = actor;
      }

      return s;
    }, 'toggle-tap');

    const card = cardsById.get(cid);
    pushLog((card?.name || cid) + (zoneIsOpp(zoneId) ? ' (adverse) ' : ' ') + '↷/↺');

    // Rafraîchir la zone si ouverte
    if (window.currentOpenZone === zoneId && window.renderZoneContent && window.getZoneConfig) {
      const cfg = window.getZoneConfig(zoneId);
      if (cfg) window.renderZoneContent(zoneId, cfg);
    }
  } finally {
    togglingCreature = false;
  }
}
// Redresser toutes les créatures d'un terrain (myTerrain / oppTerrain)
async function untapAll(zoneId = 'myTerrain') {
  const slot = slotForZone(zoneId);
  if(!slot) return;

  await updateRoomState((s)=>{
    if(!s.terrains) s.terrains = {A:[],B:[]};
    if(!s.terrains[slot]) s.terrains[slot] = [];
    ensureTerrainInstances(s, slot);
    ensureTerrainInstances(s, slot);
    for(const c of s.terrains[slot]) {
      if(c) c.tapped = false;
    }
    return s;
  }, 'untap-all');

  try{ updateAllZoneCounters(); }catch(e){}

  // Rafraîchir la zone si ouverte
  if(window.currentOpenZone === zoneId && window.renderZoneContent && window.getZoneConfig) {
    const cfg = window.getZoneConfig(zoneId);
    if(cfg) window.renderZoneContent(zoneId, cfg);
  }
}

// Déplacer toutes les cartes d'une zone vers une autre (DB-safe)
async function moveAllCards(fromZone, toZone) {
  const actor = mySlotFromState(roomState || initialRoomState());
  if(!actor || actor === 'spectator') return;

  const sourceSlot = slotForZone(fromZone);
  const destSlot   = slotForZone(toZone);
  if(!sourceSlot || !destSlot) return;

  await updateRoomState((s)=>{
    // init structures
    s.deckPiles = s.deckPiles || {A:[],B:[]};
    s.handPiles = s.handPiles || {A:[],B:[]};
    s.terrains  = s.terrains  || {A:[],B:[]};
    s.vestiaires= s.vestiaires|| {A:[],B:[]};
    s.banchs    = s.banchs    || {A:[],B:[]};
    s.revealed  = s.revealed  || {A:[],B:[]};

    
    // helpers
    const getZoneArr = (zone, slot) => {
      switch(zone){
        case 'myDeck':
        case 'oppDeck':
          return s.deckPiles[slot];
        case 'myHand':
        case 'oppHand':
          return s.handPiles[slot];
        case 'myVestiaire':
        case 'oppVestiaire':
          return s.vestiaires[slot];
        case 'myBanch':
        case 'oppBanch':
          return s.banchs[slot];
        case 'myRevealed':
        case 'oppRevealed':
          return s.revealed[slot];
        default:
          return null;
      }
    };

    const extractAllCardIds = (zone, slot) => {
      if(zone === 'myTerrain' || zone === 'oppTerrain'){
        // Instance-safe: on déplace des tokens (inst) si dispo, sinon fallback cardId
        return (s.terrains[slot]||[])
          .map(c => (c && typeof c === 'object') ? (c.inst || c.cardId) : c)
          .filter(x => x != null);
      }
      const arr = getZoneArr(zone, slot);
      return Array.isArray(arr) ? [...arr] : [];
    };

    const removeAllFrom = (zone, slot) => {
      if(zone === 'myTerrain' || zone === 'oppTerrain'){
        s.terrains[slot] = [];
        return;
      }
      const arr = getZoneArr(zone, slot);
      if(Array.isArray(arr)) arr.length = 0;
    };

    const addManyTo = (zone, slot, cardIds) => {
      if(zone === 'myTerrain' || zone === 'oppTerrain'){
        for(const tok of cardIds){
          const cid = (typeof tok === 'string' && tok.includes('::')) ? getCid(tok) : tok;
          s.terrains[slot].push({
            inst: (typeof tok === 'string' && tok.includes('::')) ? tok : null,
            cardId: cid,
            originalCardId: cid, // CRITIQUE: pour transformations
            tapped: false,
            counters: { pass: 0, charge: 0, time: 0 },
            note: '',
            lastBy: actor
          });
        }
        return;
      }
      if(zone === 'myDeck' || zone === 'oppDeck'){
        // convention: ajoute sur le dessus, dans l'ordre fourni
        s.deckPiles[slot].unshift(...cardIds);
        return;
      }
      const arr = getZoneArr(zone, slot);
      if(Array.isArray(arr)) arr.push(...cardIds);
    };

    const cardIds = extractAllCardIds(fromZone, sourceSlot);
    removeAllFrom(fromZone, sourceSlot);
    addManyTo(toZone, destSlot, cardIds);

    // sync counts (public)
    s.players = s.players || {A:{},B:{}};
    s.players.A = s.players.A || {};
    s.players.B = s.players.B || {};
    s.players.A.deckCount = (s.deckPiles.A||[]).length;
    s.players.B.deckCount = (s.deckPiles.B||[]).length;
    s.players.A.handCount = (s.handPiles.A||[]).length;
    s.players.B.handCount = (s.handPiles.B||[]).length;

    return s;
  }, 'move-all');
}
// ===== UI Updates =====
function updateActionDieUI() {
  const myActionDieEl = $("myActionDie");
  if (myActionDieEl) {
    safeText(myActionDieEl, gameState.myActionDie);
  }
  updatePABar();
  flashPAIfChanged();
}

function updatePassDieUI() {
  const myPassDieEl = $("myPassDie");
  if (myPassDieEl) {
    safeText(myPassDieEl, gameState.myPassDie);
  }
  updatePABar();
  flashPAIfChanged();
}

function updateTerrainCountUI() {
  const myTerrainCountEl = $("myTerrainCount");
  if (myTerrainCountEl) {
    safeText(myTerrainCountEl, gameState.myTerrain.length);
  }

  // Pixi overlay: garder les icônes terrain synchronisées même sans ouvrir le menu
  try{ syncPixiOverlays(); }catch(e){}
}

// Cached DOM refs for zone counters
let __c_zoneCountersCached = false;
let __c_myVestC = null, __c_myBanchC = null, __c_myRevC = null;
let __c_oppTerrC = null, __c_oppActD = null, __c_oppPassD = null;
function _ensureZoneCounterCache(){
  if(__c_zoneCountersCached) return;
  __c_myVestC = $("myVestiaireCount");
  __c_myBanchC = $("myBanchCount");
  __c_myRevC = $("myRevealedCount");
  __c_oppTerrC = $("oppTerrainCount");
  __c_oppActD = $("oppActionDie");
  __c_oppPassD = $("oppPassDie");
  __c_zoneCountersCached = true;
}

function updateAllZoneCounters() {
  // Joueur
  updateTerrainCountUI();
  updateActionDieUI();
  updatePassDieUI();
  
  _ensureZoneCounterCache();
  if (__c_myVestC) safeText(__c_myVestC, gameState.myVestiaire.length);
  if (__c_myBanchC) safeText(__c_myBanchC, gameState.myBanch.length);
  if (__c_myRevC) safeText(__c_myRevC, gameState.myRevealed.length);
  
  // Adversaire (sync via Supabase)
  if (__c_oppTerrC) safeText(__c_oppTerrC, gameState.oppTerrain.length);
  if (__c_oppActD) safeText(__c_oppActD, gameState.oppActionDie);
  if (__c_oppPassD) safeText(__c_oppPassD, gameState.oppPassDie);
}

// Mettre à jour la LED de tour (gauche) + le timer (droite)
// Cached DOM refs for updateTurnIndicators (avoid getElementById every 500ms)
let __c_dotA = null, __c_timerEl = null, __c_currentTurnEl = null, __c_myUndoBtn = null;
let __c_myTZ = null, __c_oppTZ = null;
let __c_domCached = false;
function _ensureTurnDomCache(){
  if(__c_domCached) return;
  __c_dotA = $("dotA");
  __c_timerEl = $("activeTimer");
  __c_currentTurnEl = $("currentTurn");
  __c_myUndoBtn = $("myUndoBtn");
  __c_myTZ = document.getElementById("myTerrainZone");
  __c_oppTZ = document.getElementById("oppTerrainZone");
  if(__c_dotA) __c_domCached = true;
}

function updateTurnIndicators() {
  _ensureTurnDomCache();
  const dotA = __c_dotA;
  const timerEl = __c_timerEl;
  const currentTurnEl = __c_currentTurnEl;
  if (!dotA) return;

  const st = roomState || initialRoomState();
  ensureTimersShape(st); // safe for local rendering (no write)

  // Déterminer mon rôle depuis roomState
  const myRole = mySlotFromState(roomState); // "A" | "B" | null
  const currentTurn = getTurnPlayer(st); // "A" | "B" | null

  const isMyTurn = (currentTurn && myRole) ? (currentTurn === myRole) : false;

  
  // Timer couleur: vert si c'est mon temps (mon tour), rouge si c'est le temps adverse
  if(timerEl){
    timerEl.classList.toggle('mine', !!currentTurn && !!myRole && (currentTurn === myRole));
    timerEl.classList.toggle('opponent', !!currentTurn && !!myRole && (currentTurn !== myRole));
  }

// LED gauche: verte si mon tour, rouge sinon
  if(currentTurn){
    if(isMyTurn){
      dotA.classList.remove('red');
      if (currentTurnEl) safeText(currentTurnEl, "À toi");
    } else {
      dotA.classList.add('red');
      if (currentTurnEl) safeText(currentTurnEl, "Adversaire");
    }
  } else {
    dotA.classList.remove('red');
    if (currentTurnEl) safeText(currentTurnEl, "—");
  }

  // Timer: affiche le temps restant du joueur actif
  if(timerEl){
    const now = (typeof Date !== 'undefined') ? Date.now() : 0;
    const active = currentTurn;
    if(active && st.timers?.[active]){
      const t = st.timers[active];
      const ms = calcMsLeft(t, now);
      timerEl.textContent = formatMMSS(ms);
      timerEl.classList.toggle('running', !!t.running && ms > 0 && !t.locked);
      timerEl.classList.toggle('paused', !(t.running && ms > 0) || !!t.locked);
      timerEl.classList.toggle('zero', ms <= 0 || !!t.locked);
    } else {
      timerEl.textContent = "--:--";
      timerEl.classList.remove('running','paused','zero');
    }
  }

  // Bouton undo : visible uniquement quand c'est mon tour, que j'ai un snapshot, et que je n'ai pas encore dit "Je m'arrête"
  if(__c_myUndoBtn){
    const hasStopped = st.stopped?.[myRole];
    const hasSnapshot = !!st.turnStartSnapshot;
    __c_myUndoBtn.style.display = (isMyTurn && hasSnapshot && !hasStopped) ? "" : "none";
  }

  // PendingEffect : mettre en valeur la zone cible
  {
    if(__c_myTZ) __c_myTZ.classList.remove("pendingTarget");
    if(__c_oppTZ) __c_oppTZ.classList.remove("pendingTarget");

    const pe = st.pendingEffect;
    if(pe && pe.by) {
      const allowed = pe.allowedZones || [];
      if(allowed.includes("myTerrain") && pe.by === myRole && __c_myTZ)  __c_myTZ.classList.add("pendingTarget");
      if(allowed.includes("oppTerrain") && pe.by === myRole && __c_oppTZ) __c_oppTZ.classList.add("pendingTarget");
    }
  }

  updateGamePanelDisplay();
}

// Refresh timer display even without state updates (no DB writes)
if(!window.__timerUiInterval){
  let __lastTimerHash = "";
  window.__timerUiInterval = setInterval(()=>{
    try{
      if(document && document.visibilityState === "hidden") return;
      // Skip if turn/timer state hasn't changed (avoid redundant DOM writes)
      const st = roomState || null;
      if(st){
        const turn = st.currentTurn || "";
        const tA = st.timers?.A?.remaining || 0;
        const tB = st.timers?.B?.remaining || 0;
        const running = st.timers?.[turn]?.running ? 1 : 0;
        const hash = `${turn}:${Math.floor(tA/1000)}:${Math.floor(tB/1000)}:${running}:${st.phase||""}`;
        if(hash === __lastTimerHash && !running) return; // nothing to update
        __lastTimerHash = hash;
      }
      updateTurnIndicators();
    }catch(_e){}
  }, 500);
}

function updateLocalUI() {
  // TODO: Synchroniser gameState avec Supabase
  updateAllZoneCounters();
  updateTurnIndicators();
}
// ===== Terrain cleanup (DB-safe) =====
async function cleanupTerrain(which){
  try {
    const st = roomState || initialRoomState();
    const mySlot = mySlotFromState(st);
    if(!mySlot){ pushLog('WARN: role not set'); return; }
    const targetSlot = (which === 'oppTerrain') ? otherSlot(mySlot) : mySlot;

    await updateRoomState((s)=>{
      if(!s.terrains) s.terrains = { A: [], B: [] };
      if(!s.vestiaires) s.vestiaires = { A: [], B: [] };
      if(!s.terrains[targetSlot]) s.terrains[targetSlot] = [];
      if(!s.vestiaires[targetSlot]) s.vestiaires[targetSlot] = [];

      const terr = Array.isArray(s.terrains[targetSlot]) ? s.terrains[targetSlot] : [];
      if(terr.length === 0) return s;

      // Instance-safe: on pousse des tokens (inst) si dispo. Si une créature n'a pas encore
      // d'inst (vieille room / vieux format), on mint une instance unique.
      if(!s.nextInstanceNum) s.nextInstanceNum = { A: 1, B: 1 };
      let n = s.nextInstanceNum[targetSlot] || 1;

      const toks = terr
        .map(c => {
          if(c && typeof c === 'object') {
            if(c.inst) return c.inst;
            if(c.cardId != null) {
              const tok = makeToken(targetSlot, n, String(c.cardId).padStart(3,'0'));
              n += 1;
              return tok;
            }
            return null;
          }
          // already a token or id
          if(typeof c === 'string' && c.includes('::')) return c;
          if(c != null) {
            const tok = makeToken(targetSlot, n, String(c).padStart(3,'0'));
            n += 1;
            return tok;
          }
          return null;
        })
        .filter(x => x != null);

      s.nextInstanceNum[targetSlot] = n;

      // Move all creatures to vestiaire as tokens
      s.vestiaires[targetSlot] = s.vestiaires[targetSlot].concat(toks);
      s.terrains[targetSlot] = [];

      // Keep counts in sync (best-effort)
      if(s.players && s.players[targetSlot]){
        s.players[targetSlot].vestiaireCount = (s.vestiaires[targetSlot] || []).length;
        s.players[targetSlot].terrainCount = 0;
      }
      return s;
    }, 'cleanup-terrain');

    try{ updateAllZoneCounters(); updateHandUI(); }catch(e){}

    // Rafraîchir la zone si ouverte (sinon l'utilisateur voit l'effet seulement après un autre bouton)
    try{
      const zid = (which === 'oppTerrain') ? 'oppTerrain' : 'myTerrain';
      if(window.currentOpenZone === zid && window.renderZoneContent && window.getZoneConfig) {
        const cfg = window.getZoneConfig(zid);
        if(cfg) window.renderZoneContent(zid, cfg);
      }
    }catch(e){}

    pushLog('Broom: terrain cleaned');
  } catch(e){
    reportError(e, 'cleanupTerrain');
  }
}

// ===== Exposer les fonctions nécessaires sur window pour les onclick =====
window.openPanel = openPanel;
window.closePanel = closePanel;
window.setPhase3Decision = setPhase3Decision;
window.declareWinGame = declareWinGame;
window.setFocusMode = setFocusMode;
window.undoPhaseStepDb = undoPhaseStepDb;
window.openZoneModal = openZoneModal;
window.closeZoneModal = closeZoneModal;
window.openCardModal = openCardModal;
window.closeCardModal = closeCardModal;
window.modifyActionDie = modifyActionDie;
window.modifyPassDie = modifyPassDie;
window.toggleCreatureTap = toggleCreatureTap;
window.untapAll = untapAll;
window.cleanupTerrain = cleanupTerrain;
window.playCreatureFromHand = playCreatureFromHand;
window.updateTurnIndicators = updateTurnIndicators;
window.undoLastAction = undoLastAction;
window.toggleHistoryPanel = toggleHistoryPanel;
window.drawCards = drawCards;
window.drawCardsManual = drawCardsManual;
window.revealTopDeck = revealTopDeck;
window.shuffleDeck = shuffleDeck;
window.shuffleMyDeck = shuffleMyDeck;
window.handleChiefNoteInput = handleChiefNoteInput;
window.handleSetChiefNote = handleSetChiefNote;
window.cutDeck = cutDeck;
window.reformDeckFromVestiaire = reformDeckFromVestiaire;
window.cleanupTerrain = cleanupTerrain;
window.untapAll = untapAll;
window.getZoneConfig = getZoneConfig;
window.renderZoneContent = renderZoneContent;
// Exposer currentOpenZone comme getter/setter
Object.defineProperty(window, 'currentOpenZone', {
  get: function() { return currentOpenZone; },
  set: function(val) { currentOpenZone = val; }
});
window.moveAllCards = moveAllCards;
window.createToken = createToken;
window.promptDrawX = promptDrawX;
window.promptCreateToken = promptCreateToken;
window.handleBulleStateChange = handleBulleStateChange;
window.modifyOccurrences = modifyOccurrences;
window.resetOccurrences = resetOccurrences;
window.handlePlayFromHand = handlePlayFromHand;
window.handlePlayFarce = handlePlayFarce;
window.handleMoveCard = handleMoveCard;
window.handleModifyCounter = handleModifyCounter;
window.handleSetNote = handleSetNote;

  // Initial UI state
  setConnectedUI(false);
  setRoleUI("—",0);
  safeText(cardsStatus, "—");
  safeText(deckStatus, "—");
  setReadyUI(false,false);
  setDiceUI("—");
  lockSetup(false);
  if(readyBtn) readyBtn.textContent = myReady ? "Je ne suis plus prêt" : "Je suis prêt";
  updateFlowNote("En attente : connecte-toi, importe ton deck, puis clique “Je suis prêt”.");
})();
